webpackJsonp([1],{

/***/ "++6F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStudents */
/* unused harmony export updateStudentSelectedIds */
/* unused harmony export checkUnsavedChanges */
/* unused harmony export getTeacherNotes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTopicsAndStandards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getFilteredStrandAndStandards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateStrandAndStandards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateStrands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeStandard; });
/* unused harmony export updateCount */
/* unused harmony export updateAssignmentStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAllLearningJourneys; });
/* unused harmony export updateGridCells */
/* unused harmony export updateUnAssignmentStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filterStandardByLJCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedStandardCount; });
/* harmony export (immutable) */ __webpack_exports__["a"] = sortStudentAssignmentsById;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateAssignmentsHidden;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return checkAccuracyCellSelectable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return checkProgressCellSelectable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return findSchemaByTopics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__ = __webpack_require__("lz7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entities_schema__ = __webpack_require__("FKcn");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



var UNASSIGNED = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["e" /* studentStatus */].UNASSIGNED,
  UNATTEMPTED = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["e" /* studentStatus */].UNATTEMPTED,
  ASSIGN_SELECTION = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["e" /* studentStatus */].ASSIGN_SELECTION,
  UNASSIGN_SELECTION = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["e" /* studentStatus */].UNASSIGN_SELECTION;
var REVIEWED = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["f" /* teacherStatus */].REVIEWED,
  SUBMITTED = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["f" /* teacherStatus */].SUBMITTED;
var getStudents = function getStudents(classrooms) {
  if (classrooms.length > 0) {
    var classroom = classrooms[0];
    var group = classroom.groups[0];
    return group.students;
  }
  return [];
};
var updateStudentSelectedIds = function updateStudentSelectedIds(studentAssignments, id, selectedStudentIds) {
  var isAllSelected = true;
  // if all of the unattempted and unassigned cells for a row are selected
  // student checkbox should be checked else unchecked
  var currentStudent = studentAssignments.filter(function (s) {
    return s.studentUserProfileId === id;
  });
  currentStudent.forEach(function (student) {
    if ((student.studentStatus === UNATTEMPTED || student.studentStatus === UNASSIGNED) && student.teacherStatus !== REVIEWED && student.teacherStatus !== SUBMITTED) {
      isAllSelected = false;
    }
  });
  if (isAllSelected) {
    selectedStudentIds = _toConsumableArray(new Set([].concat(_toConsumableArray(selectedStudentIds), [id])));
  } else {
    var index = selectedStudentIds.indexOf(id);
    if (index !== -1) {
      selectedStudentIds.splice(index, 1);
    }
  }
  return selectedStudentIds;
};
var checkUnsavedChanges = function checkUnsavedChanges(students) {
  var assignSelection = 0;
  var unassignSelection = 0;
  students.forEach(function (student) {
    switch (student.studentStatus) {
      case ASSIGN_SELECTION:
        assignSelection += 1;
        break;
      case UNASSIGN_SELECTION:
        unassignSelection += 1;
        break;
      default:
        break;
    }
  });
  if (assignSelection > 0 || unassignSelection > 0) {
    return true;
  }
  return false;
};
var getTeacherNotes = function getTeacherNotes(playLists, playListId, girlId) {
  var playList = playLists.find(function (pl) {
    return pl.id === playListId;
  });
  var teacherNotes = playList.psrs.find(function (pl) {
    return pl.girlId === girlId;
  });
  teacherNotes.girlId = girlId;
  return teacherNotes;
};
var getTopicsAndStandards = function getTopicsAndStandards(genericCourses) {
  if (genericCourses.length === 0) return [];
  var topicTree = [];
  var standardTopic = genericCourses.topics.filter(function (topic) {
    return topic.type.toLowerCase() === 'standard';
  });
  var strandTopic = genericCourses.topics.filter(function (topic) {
    return topic.type.toLowerCase() === 'strand';
  });
  if (standardTopic.length > 0) {
    standardTopic.forEach(function (st) {
      st.displayName = "".concat(st.externalKey.toUpperCase(), " ").concat(st.name).trim();
      st.selected = true;
    });
    topicTree.push({
      id: -1,
      displayName: 'All Standards',
      childTopics: standardTopic,
      selected: true
    });
  }
  strandTopic.forEach(function (strand) {
    strand.displayName = strand.name;
    strand.selected = true;
    strand.childTopics.forEach(function (st) {
      st.displayName = "".concat(st.externalKey.toUpperCase(), " ").concat(st.name).trim();
      st.selected = true;
    });
    strand.isExpand = !!strand.childTopics.find(function (s) {
      return s.selected;
    });
  });
  if (standardTopic.length === 0 && strandTopic.length > 0) {
    strandTopic[0].selected = true;
    strandTopic[0].childTopics.forEach(function (ct) {
      ct.selected = true;
    });
    strandTopic[0].isExpand = !!strandTopic[0].childTopics.find(function (s) {
      return s.selected;
    });
  }
  topicTree.push.apply(topicTree, _toConsumableArray(strandTopic));
  return topicTree;
};
var getMatchingStrands = function getMatchingStrands(strands, searchTerm) {
  var matchingStrands = [];
  strands.forEach(function (topic) {
    var matchedStandards = topic.childTopics.filter(function (ct) {
      return ct.displayName.toLowerCase().includes(searchTerm.toLowerCase());
    });
    if (matchedStandards.length) {
      topic.childTopics = matchedStandards;
      matchingStrands.push(topic);
    }
  });
  return matchingStrands;
};
var getFilteredStrandAndStandards = function getFilteredStrandAndStandards(searchTerm, topics) {
  var matchingStandards = getMatchingStrands(topics, searchTerm);
  if (matchingStandards.length > 0) {
    var matchingTopicId = matchingStandards.map(function (t) {
      return t.id;
    });
    var unMatchedTopics = topics.filter(function (t) {
      return matchingTopicId.indexOf(t.id) === -1;
    });
    var matchingTopics = unMatchedTopics.filter(function (t) {
      return t.displayName.toLowerCase().includes(searchTerm.toLowerCase());
    });
    return [].concat(_toConsumableArray(matchingStandards), _toConsumableArray(matchingTopics));
  }
  return topics.filter(function (t) {
    return t.displayName.toLowerCase().includes(searchTerm.toLowerCase());
  });
};
var updateStrandAndStandards = function updateStrandAndStandards(id, checked, topics) {
  if (id) {
    if (id.indexOf('#') !== -1) {
      var topic = topics.find(function (t) {
        return t.id.toString() === id.split('#')[0];
      });
      var childTopic = topic.childTopics.find(function (t) {
        return t.id.toString() === id.split('#')[1];
      });
      childTopic.selected = checked;
      topic.selected = !!topic.childTopics.find(function (s) {
        return s.selected;
      });
      topic.isExpand = topic.selected;
    } else {
      var _topic = topics.find(function (t) {
        return t.id.toString() === id;
      });
      _topic.selected = checked;
      _topic.childTopics.forEach(function (ct) {
        ct.selected = checked;
      });
      _topic.isExpand = !!_topic.childTopics.find(function (s) {
        return s.selected;
      });
    }
  }
  return topics;
};
var updateStrands = function updateStrands(checked, topics) {
  topics.forEach(function (topic) {
    topic.selected = checked;
    topic.childTopics.forEach(function (ct) {
      ct.selected = checked;
    });
    topic.isExpand = !!topic.childTopics.find(function (s) {
      return s.selected;
    });
  });
  return topics;
};
var removeStandard = function removeStandard(id, topics) {
  return topics.map(function (topic) {
    return _objectSpread(_objectSpread({}, topic), {}, {
      childTopics: topic.childTopics.map(function (ct) {
        return _objectSpread(_objectSpread({}, ct), {}, {
          selected: ct.id === id ? false : ct.selected
        });
      })
    });
  });
};
var updateCount = function updateCount(id) {
  var topics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var studentAssignments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var selectedTopic = [];
  var LJIds = [];
  topics.forEach(function (topic) {
    topic.childTopics.forEach(function (ct) {
      if (ct.id === id) {
        selectedTopic = ct;
      }
    });
  });
  LJIds = selectedTopic && selectedTopic.childTopics && selectedTopic.childTopics.map(function (ct) {
    return ct.id;
  });
  return studentAssignments.filter(function (assignment) {
    return !LJIds.includes(assignment.learningJourneyId);
  });
};
var updateAssignmentStatus = function updateAssignmentStatus(leaningJourneyId, studentId, assignmentStatuses) {
  var filteredAssignmentStatus = assignmentStatuses.find(function (a) {
    return a.studentProfileId === studentId && a.learningJourneyId === leaningJourneyId;
  });
  filteredAssignmentStatus.studentStatus = filteredAssignmentStatus.studentStatus === ASSIGN_SELECTION ? UNASSIGNED : ASSIGN_SELECTION;
  return assignmentStatuses;
};
var getAllLearningJourneys = function getAllLearningJourneys(selectedTopics) {
  var learningJourneyIds = [];
  selectedTopics.forEach(function (strands) {
    strands.childTopics.forEach(function (standards) {
      if (standards.selected) {
        standards.childTopics.forEach(function (learningJourney) {
          learningJourneyIds.push(learningJourney.id);
        });
      }
    });
  });
  return learningJourneyIds;
};
var updateGridCells = function updateGridCells(isLeaningJourney, studentId, leaningJourneyId, assignmentStatuses, studentAssignments, status, clonedSelectedLJIDs, clonedStudentIds, learningJourneyIds, studentUnAssignments) {
  var filteredArray = [];
  var filteredStudentAssignments = [];
  if (isLeaningJourney) {
    filteredArray = assignmentStatuses.filter(function (a) {
      return a.learningJourneyId === leaningJourneyId;
    });
  } else {
    filteredArray = assignmentStatuses.filter(function (a) {
      return a.studentProfileId === studentId;
    });
  }
  filteredArray.forEach(function (val) {
    if ((val.studentStatus === UNASSIGNED || val.studentStatus === UNATTEMPTED) && status === 'checked' && learningJourneyIds.includes(val.learningJourneyId)) {
      if (status === 'checked') {
        if (val.studentStatus === UNATTEMPTED && (val.stepsCount === 0 || val.stepsCompleted === 0)) {
          studentUnAssignments.push({
            studentUserProfileId: val.studentProfileId,
            learningJourneyId: val.learningJourneyId,
            assignmentId: val.assignmentId
          });
        }
        if (val.studentStatus === UNASSIGNED) {
          studentAssignments.push({
            studentUserProfileId: val.studentProfileId,
            learningJourneyId: val.learningJourneyId
          });
        }
      }
      val.studentStatus = val.studentStatus === UNATTEMPTED ? UNASSIGN_SELECTION : ASSIGN_SELECTION;
    } else if ((val.studentStatus === ASSIGN_SELECTION || val.studentStatus === UNASSIGN_SELECTION) && status === 'unchecked') {
      val.studentStatus = val.studentStatus === UNASSIGN_SELECTION ? UNATTEMPTED : UNASSIGNED;
    }
  });
  if (status !== 'checked') {
    if (studentAssignments.length > 0) {
      if (isLeaningJourney) {
        filteredStudentAssignments = studentAssignments.filter(function (a) {
          return a.learningJourneyId !== leaningJourneyId;
        });
      } else {
        filteredStudentAssignments = studentAssignments.filter(function (a) {
          return a.studentUserProfileId !== studentId;
        });
      }
      studentAssignments = filteredStudentAssignments;
    }
    if (studentUnAssignments.length > 0) {
      if (isLeaningJourney) {
        filteredStudentAssignments = studentUnAssignments.filter(function (a) {
          return a.learningJourneyId !== leaningJourneyId;
        });
      } else {
        filteredStudentAssignments = studentUnAssignments.filter(function (a) {
          return a.studentUserProfileId !== studentId;
        });
      }
      studentUnAssignments = filteredStudentAssignments;
    }
    if (isLeaningJourney) {
      clonedSelectedLJIDs.splice(clonedSelectedLJIDs.indexOf(leaningJourneyId), 1);
    } else {
      clonedStudentIds.splice(clonedStudentIds.indexOf(studentId), 1);
    }
  } else if (isLeaningJourney) {
    clonedSelectedLJIDs.push(leaningJourneyId);
  } else {
    clonedStudentIds.push(studentId);
  }
  return {
    assignmentStatuses: assignmentStatuses,
    studentAssignments: studentAssignments,
    clonedSelectedLJIDs: clonedSelectedLJIDs,
    clonedStudentIds: clonedStudentIds,
    studentUnAssignments: studentUnAssignments
  };
};
var updateUnAssignmentStatus = function updateUnAssignmentStatus(leaningJourneyId, studentId, assignmentStatuses, status) {
  var filteredAssignmentStatus = assignmentStatuses.find(function (a) {
    return a.studentProfileId === studentId && a.learningJourneyId === leaningJourneyId;
  });
  filteredAssignmentStatus.studentStatus = status ? UNASSIGN_SELECTION : UNATTEMPTED;
  return assignmentStatuses;
};
var filterStandardByLJCount = function filterStandardByLJCount() {
  var selectedTopics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var LJCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (selectedTopics.length === 0) return [];
  var count = 0;
  var standardwithLJCount = 0;
  selectedTopics.forEach(function (topic) {
    if (topic && topic.childTopics) {
      topic.childTopics.forEach(function (childTopic) {
        count += childTopic && childTopic.childTopics && childTopic.childTopics.length || 0;
        if (childTopic.childTopics.length) {
          standardwithLJCount += 1;
        }
        if (standardwithLJCount > 1) {
          childTopic.selected = !(count > LJCount);
          if (!childTopic.selected) topic.selected = false;
        }
      });
    }
  });
  return selectedTopics;
};
var getSelectedStandardCount = function getSelectedStandardCount(courses) {
  var selectedStandardCount = 0;
  var standardCount = 0;
  courses.forEach(function (val) {
    val.childTopics.forEach(function (st) {
      standardCount += 1;
      if (st.selected) {
        selectedStandardCount += 1;
      }
    });
  });
  return {
    selectedStandardCount: selectedStandardCount,
    standardCount: standardCount
  };
};
function sortStudentAssignmentsById(studentAssignments, sortedStudents) {
  var orderedArr = [];
  sortedStudents.forEach(function (sorted) {
    studentAssignments.forEach(function (currentStudent) {
      if (currentStudent.studentProfileId === sorted.id) {
        orderedArr.push(_objectSpread(_objectSpread({}, currentStudent), {}, {
          metaData: _objectSpread(_objectSpread({}, currentStudent === null || currentStudent === void 0 ? void 0 : currentStudent.metaData), {}, {
            student: sorted
          })
        }));
      }
    });
  });
  return orderedArr;
}
function updateAssignmentsHidden(studentAssignments, learningJourneys) {
  var orderedArr = studentAssignments.map(function (currentStudent) {
    if (!learningJourneys.includes(currentStudent.learningJourneyId)) {
      return _objectSpread(_objectSpread({}, currentStudent), {}, {
        metaData: _objectSpread(_objectSpread({}, currentStudent.metaData), {}, {
          isHidden: true
        })
      });
    }
    return _objectSpread(_objectSpread({}, currentStudent), {}, {
      metaData: _objectSpread(_objectSpread({}, currentStudent.metaData), {}, {
        isHidden: false
      })
    });
  });
  return orderedArr;
}
var checkAccuracyCellSelectable = function checkAccuracyCellSelectable(selectionType, learningJourneyResult) {
  var _ref = learningJourneyResult || {},
    stepsCompleted = _ref.stepsCompleted,
    accuracy = _ref.accuracy;
  var hasCompletedSteps = stepsCompleted > 0;
  var selectableType = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["b" /* SELECT_ALL */], true), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["c" /* CLEAR_SELECTION */], false), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["a" /* CURRENTLY_ASSIGNED */], stepsCompleted >= 0), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["d" /* ACCURACY0TO50 */], accuracy >= 0 && accuracy < 51 && hasCompletedSteps), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["e" /* ACCURACY51TO84 */], accuracy >= 51 && accuracy < 85 && hasCompletedSteps), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["f" /* ACCURACY85TO100 */], accuracy >= 85 && accuracy <= 100 && hasCompletedSteps);
  return selectableType[selectionType] || false;
};
var checkProgressCellSelectable = function checkProgressCellSelectable(selectionType, learningJourneyResult, stepsCount) {
  var stepsCompleted = learningJourneyResult === null || learningJourneyResult === void 0 ? void 0 : learningJourneyResult.stepsCompleted;

  // Don't need to calculate percentage when total steps are 0
  var completedPercentage = stepsCount > 0 ? stepsCompleted / stepsCount * 100 : 0;
  var hasCompletedSteps = stepsCompleted > 0;
  var selectableType = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["b" /* SELECT_ALL */], true), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["c" /* CLEAR_SELECTION */], false), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["a" /* CURRENTLY_ASSIGNED */], stepsCompleted >= 0), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["g" /* COMPLETED1TO20 */], completedPercentage >= 1 && completedPercentage < 21 && hasCompletedSteps), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["h" /* COMPLETED21TO40 */], completedPercentage >= 21 && completedPercentage < 41 && hasCompletedSteps), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["i" /* COMPLETED41TO60 */], completedPercentage >= 41 && completedPercentage < 61 && hasCompletedSteps), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["j" /* COMPLETED61TO80 */], completedPercentage >= 61 && completedPercentage < 81 && hasCompletedSteps), __WEBPACK_IMPORTED_MODULE_1__components_quick_selector_quick_selector_constants__["k" /* COMPLETED81TO100 */], completedPercentage >= 81 && completedPercentage <= 100 && hasCompletedSteps);
  return selectableType[selectionType] || false;
};
var findSchemaByTopics = function findSchemaByTopics() {
  var topics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var firstTopTopic = topics[0] || {};
  if (firstTopTopic.type === __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["g" /* TOPICS_TYPES */].STANDARD) return __WEBPACK_IMPORTED_MODULE_2__entities_schema__["a" /* default */].STANDARDS_ARRAY;
  return __WEBPACK_IMPORTED_MODULE_2__entities_schema__["a" /* default */].STRANDS_ARRAY;
};

/***/ }),

/***/ "+QKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_hooks_use_assignment_result_type__ = __webpack_require__("2yLB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_course_version__ = __webpack_require__("7QyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_fetch_resource__ = __webpack_require__("ETRU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_hooks_use_manage_assignments__ = __webpack_require__("9mrv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__attempt__ = __webpack_require__("Ir+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations__ = __webpack_require__("sWyC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled__ = __webpack_require__("WRtY");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }















var ContextualMenu = function ContextualMenu(props) {
  var selectCell = props.selectCell,
    isCellSelected = props.isCellSelected,
    studentId = props.studentId,
    learningJourneyId = props.learningJourneyId,
    hasOnlyResult = props.hasOnlyResult,
    assignmentId = props.assignmentId;
  /**
   * Hooks
   */
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var selectedProduct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.product;
  }, __WEBPACK_IMPORTED_MODULE_0_react__["shallowEqual"]);
  var _useAssignmentResultT = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_hooks_use_assignment_result_type__["a" /* default */])(),
    assignmentResultType = _useAssignmentResultT.assignmentResultType;
  var _useCourseVersion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_course_version__["a" /* default */])(),
    selectedClassroomId = _useCourseVersion.selectedClassroomId,
    selectedCourseId = _useCourseVersion.selectedCourseId,
    selectedCourseVersion = _useCourseVersion.selectedCourseVersion;
  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
      return state.entitiesReducer.students[studentId];
    }),
    firstName = _useSelector.firstName,
    lastName = _useSelector.lastName;
  var learningJourneyName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.learningJourneys[learningJourneyId].name;
  });
  var _useManageAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_hooks_use_manage_assignments__["a" /* default */])(),
    unassignAssignments = _useManageAssignments.unassignAssignments,
    assignAssignments = _useManageAssignments.assignAssignments;
  var _useFetchResource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_fetch_resource__["a" /* default */])({
      resourceCallback: function resourceCallback() {
        return __WEBPACK_IMPORTED_MODULE_5__helpers_resources__["a" /* default */].studentAssignmentsHistory.get({
          productId: selectedProduct.id,
          classId: selectedClassroomId,
          courseId: selectedCourseId,
          courseVersion: selectedCourseVersion,
          studentUserProfileId: studentId,
          learningJourneyId: learningJourneyId
        }).withParams({
          assignmentResultType: assignmentResultType
        }).send();
      },
      isReady: selectedProduct.id && selectedClassroomId && selectedCourseId
    }),
    _useFetchResource$dat = _useFetchResource.data,
    attempts = _useFetchResource$dat === void 0 ? [] : _useFetchResource$dat;

  /**
   * Translations
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__translations__["a" /* default */])({
      i18n: i18n
    }),
    SELECT_CELL_TEXT = _getTranslations.SELECT_CELL_TEXT,
    UNASSIGN_FROM_STUDENT_TEXT = _getTranslations.UNASSIGN_FROM_STUDENT_TEXT,
    REASSIGN_TEXT = _getTranslations.REASSIGN_TEXT,
    UNSELECT_CELL_TEXT = _getTranslations.UNSELECT_CELL_TEXT,
    ASSIGN_AND_REVIEW_TEXT = _getTranslations.ASSIGN_AND_REVIEW_TEXT,
    LEARNING_GAPS_TEXT = _getTranslations.LEARNING_GAPS_TEXT,
    VOLUNTARY_TEXT = _getTranslations.VOLUNTARY_TEXT,
    ATTEMPTS_TEXT = _getTranslations.ATTEMPTS_TEXT;

  /**
   * Functions
   */

  var handleReassign = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var REASSIGN_ASSIGNMENT, studentAssignments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            REASSIGN_ASSIGNMENT = true;
            studentAssignments = [{
              studentUserProfileId: studentId,
              learningJourneyId: learningJourneyId
            }];
            _context.n = 1;
            return assignAssignments({
              studentAssignments: studentAssignments,
              isReassignment: REASSIGN_ASSIGNMENT
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleReassign() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleUnassign = function handleUnassign() {
    if (!hasOnlyResult) {
      var requestData = [{
        learningJourneyId: learningJourneyId,
        assignmentId: assignmentId,
        studentUserProfileId: studentId
      }];
      unassignAssignments(requestData);
    }
  };
  var getAssignmentOrigin = function getAssignmentOrigin(assignmentAttempts) {
    var _assignmentAttempts$f;
    var ASSIGN_UPF = __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["b" /* assignmentFilterType */].ASSIGN_UPF,
      ASSIGN_LEARNING_GAPS = __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["b" /* assignmentFilterType */].ASSIGN_LEARNING_GAPS,
      VOLUNTARY = __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["b" /* assignmentFilterType */].VOLUNTARY;
    var assignmentType = (_assignmentAttempts$f = assignmentAttempts.filter(function (assignment) {
      return assignment.isFocusedResult;
    })[0]) === null || _assignmentAttempts$f === void 0 ? void 0 : _assignmentAttempts$f.assignmentType;
    var assignmentOriginsText = _defineProperty(_defineProperty(_defineProperty({}, ASSIGN_UPF, ASSIGN_AND_REVIEW_TEXT), ASSIGN_LEARNING_GAPS, LEARNING_GAPS_TEXT), VOLUNTARY, VOLUNTARY_TEXT);
    return assignmentOriginsText[assignmentType];
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["b" /* Heading */], {
    "data-testid": "student-fullname"
  }, "".concat(firstName, " ").concat(lastName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["b" /* Heading */], {
    "data-testid": "learning-journey-name"
  }, learningJourneyName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["c" /* SubHeading */], null, getAssignmentOrigin(attempts)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["d" /* AttemptsText */], null, ATTEMPTS_TEXT, ":"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["e" /* Attempts */], null, attempts.map(function (attempt) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__attempt__["a" /* default */], {
      key: attempt.assignedOn,
      attempt: attempt
    });
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["f" /* ActionWrapper */], {
    "data-testid": "select-cell",
    onClick: selectCell
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["m" /* Select */]
  }), isCellSelected ? UNSELECT_CELL_TEXT : SELECT_CELL_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["g" /* UnassignWrapper */], {
    "data-testid": "unassign-from-student",
    hasOnlyResult: hasOnlyResult,
    onClick: handleUnassign
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["n" /* UnassignIconDark */]
  }), UNASSIGN_FROM_STUDENT_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["f" /* ActionWrapper */], {
    "data-testid": "reassign-assignment",
    onClick: handleReassign
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["o" /* ReassignIconDark */]
  }), REASSIGN_TEXT));
};
ContextualMenu.propTypes = {
  studentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  learningJourneyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  assignmentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selectCell: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isCellSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  hasOnlyResult: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ContextualMenu);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "+vac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_hooks_use_learning_journeys__ = __webpack_require__("8Y5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__ = __webpack_require__("lS1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__grid_actions_scss__ = __webpack_require__("U+4P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__grid_actions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__grid_actions_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__standards__ = __webpack_require__("m4hy");









function GridActions(_ref) {
  var i18n = _ref.i18n;
  var learningJourneyIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_hooks_use_learning_journeys__["a" /* default */])();
  var girlIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["b" /* getConfiguration */])('girlIdsForInfoModal') || [];
  var invokeInfoModal = function invokeInfoModal() {
    __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__["a" /* default */].requestInfoModal(girlIds);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7__grid_actions_scss___default.a.buttonsContainer
  }, girlIds.length === 0 ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    className: __WEBPACK_IMPORTED_MODULE_7__grid_actions_scss___default.a.howThisWorks,
    onClick: invokeInfoModal,
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["J" /* VideoHelp */],
    text: i18n._("How this works"),
    primary: true,
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7__grid_actions_scss___default.a.bottomButtons
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    className: __WEBPACK_IMPORTED_MODULE_7__grid_actions_scss___default.a.key,
    disabled: !learningJourneyIds.length,
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["K" /* Expand */],
    onClick: function onClick() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__standards__["b" /* toggleStandardCollapse */])(false);
    },
    primary: true,
    text: i18n._("Expand All"),
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    className: __WEBPACK_IMPORTED_MODULE_7__grid_actions_scss___default.a.key,
    disabled: !learningJourneyIds.length,
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["L" /* Collapse */],
    onClick: function onClick() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__standards__["b" /* toggleStandardCollapse */])(true);
    },
    primary: true,
    text: i18n._("Collapse All"),
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE
  }))));
}
GridActions.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (GridActions);

/***/ }),

/***/ "//52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dropdownMenu", function() { return dropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "header", function() { return header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "button", function() { return button; });
var dropdownMenu = {
  menu: {
    optionPadding: '10px 8px'
  }
};
var header = {
  colours: {
    main: {
      background: '#dbe3e9'
    },
    subtitle: {
      text: '#4e5c67'
    }
  },
  spacing: 10,
  subtitle: {
    borderRadius: '0px',
    borderWidth: '0px',
    padding: '6px'
  }
};
var button = {
  borderRadius: '0px'
};

/***/ }),

/***/ "//jD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
var storage = window.localStorage;
var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }
  return _createClass(LocalStorage, null, [{
    key: "namespace",
    get: function get() {
      return this._namespace = this._namespace ? this._namespace : Date.now();
    },
    set: function set(name) {
      this._namespace = name;
    }
  }, {
    key: "getAllItems",
    value: function getAllItems() {
      try {
        return storage.getItem(this.namespace) === null ? {} : JSON.parse(storage.getItem(this.namespace));
      } catch (e) {
        return {};
      }
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var allItems = this.getAllItems();
      var values = _extends(allItems, _defineProperty({}, key, value));
      storage.setItem("".concat(this.namespace), JSON.stringify(values));
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var allItems = this.getAllItems();
      return allItems.hasOwnProperty(key) ? allItems[key] : '';
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      var values = _extends({}, this.getAllItems());
      delete values[key];
      storage.setItem(this.namespace, JSON.stringify(values));
    }
  }, {
    key: "removeAllItems",
    value: function removeAllItems() {
      storage.clear();
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (LocalStorage);

/***/ }),

/***/ "/A+b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("qmGw");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./footer-popup.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./footer-popup.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/vox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_entities_helpers__ = __webpack_require__("QR7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("6QRH");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


var useGetSortedCourse = function useGetSortedCourse(selectedPublication, publicationCourses) {
  var keywords = ["nivel"];
  var englishPriorityCurriculumIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["b" /* getConfiguration */])('englishPriorityCurriculumIds') || [];
  var courses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__containers_entities_helpers__["d" /* mapEntitiesToOptions */])(publicationCourses, {
    valueColumn: 'id',
    labelColumn: 'courseName'
  });
  if (englishPriorityCurriculumIds.includes(selectedPublication === null || selectedPublication === void 0 ? void 0 : selectedPublication.value)) {
    var sorted = _toConsumableArray(courses).sort(function (a, b) {
      var aHasKeyword = keywords.some(function (keyword) {
        return a.label.toLowerCase().includes(keyword);
      });
      var bHasKeyword = keywords.some(function (keyword) {
        return b.label.toLowerCase().includes(keyword);
      });
      if (!aHasKeyword && bHasKeyword) return -1; // Non-keyword goes first
      if (aHasKeyword && !bHasKeyword) return 1; // keyword goes after

      return a.label.localeCompare(b.label);
    });
    return sorted;
  }
  return courses;
};
/* harmony default export */ __webpack_exports__["a"] = (useGetSortedCourse);

/***/ }),

/***/ "/x5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TopFiltersWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FilterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AlignmentPdfWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AlignmentPdfText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var TopFiltersWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var FilterList = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  margin-right: 20px;\n\n  .dropdown {\n    flex-direction: row;\n    justify-content: space-between;\n    width: 300px;\n\n    @media (min-width: 1421px) {\n        width: 350px;\n    }\n\n    @media (min-width: 1521px) {\n        width: 400px;\n    }\n\n    div[class*=\"Menu\"]:nth-of-type(2) {\n        box-shadow: none !important;\n        outline: 1px solid #c2c2c2;\n        margin-top: 5px;\n        \n        ul {\n            border: none;\n        }\n\n        button {\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: normal;\n            -webkit-line-clamp: 2;\n            line-height: 1.5;\n            max-height: calc(1.9em * 2);\n            border-top: none;\n            border-left: none;\n            border-right: none;\n            border-bottom: 1px solid #c2c2c2;\n\n            &:hover {\n                background-color: #dbe3e9;\n            }\n        }\n    }\n  }\n"])));
var AlignmentPdfWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 10px 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  \n  div:first-child {\n    margin-right: 5px;\n    display: flex;\n    align-items: center;\n    width: 10px;\n  }\n"])));
var AlignmentPdfText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #415667;\n  text-decoration: underline;\n"])));

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0dbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UPDATE_ENTITIES */
/* unused harmony export DELETE_ENTITY_ITEMS */
/* unused harmony export RESET_GENERIC_COURSE_RELATIVE_ENTITIES */
/* unused harmony export RESET_ENTITY */
/* unused harmony export RESET_ENTITIES_ASSIGNMENTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resetGenericCourseRelativeEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetEntitiesAssignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteEntityItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetEntity; });
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mergeWith__ = __webpack_require__("zMR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mergeWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_mergeWith__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/*
 * Actions
 */
var PREFIX = 'ENTITIES';
var UPDATE_ENTITIES = "".concat(PREFIX, "/UPDATE_ENTITIES");
var DELETE_ENTITY_ITEMS = "".concat(PREFIX, "/DELETE_ENTITY_ITEMS");
var RESET_GENERIC_COURSE_RELATIVE_ENTITIES = "".concat(PREFIX, "/RESET_GENERIC_COURSE_RELATIVE_ENTITIES");
var RESET_ENTITY = "".concat(PREFIX, "/RESET_ENTITY");
var RESET_ENTITIES_ASSIGNMENTS = "".concat(PREFIX, "/RESET_ENTITIES_ASSIGNMENTS");

/*
 *  Action creators
 */

var resetGenericCourseRelativeEntities = function resetGenericCourseRelativeEntities() {
  return {
    type: RESET_GENERIC_COURSE_RELATIVE_ENTITIES
  };
};
var resetEntitiesAssignments = function resetEntitiesAssignments() {
  return {
    type: RESET_ENTITIES_ASSIGNMENTS
  };
};

/*
 * This action creator is handle the async data from backend and normalized by the normalizr
 * It will flat the nesting data structure to the same level
 */
var updateEntities = function updateEntities(payload) {
  return {
    type: UPDATE_ENTITIES,
    entities: _objectSpread({}, payload.entities)
  };
};
var deleteEntityItems = function deleteEntityItems(_ref) {
  var entityName = _ref.entityName,
    itemIds = _ref.itemIds;
  return {
    type: DELETE_ENTITY_ITEMS,
    entityName: entityName,
    itemIds: itemIds
  };
};
var resetEntity = function resetEntity(_ref2) {
  var entityName = _ref2.entityName;
  return {
    type: RESET_ENTITY,
    entityName: entityName
  };
};
var mergeEntities = function mergeEntities(state) {
  var entities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var updatedState = _objectSpread({}, state);
  Object.keys(entities).forEach(function (key) {
    updatedState[key] = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_0_lodash_mergeWith___default()(updatedState[key], entities[key], function (objValue, srcValue) {
      // Do not merge array created by normalizr schema
      if (Array.isArray(srcValue)) return srcValue;
      return undefined;
    }));
  });
  return updatedState;
};

/*
 * Reducer
 */
var initialState = {
  assignments: {},
  classrooms: {},
  courses: {},
  groups: {},
  learningJourneySteps: {},
  learningJourneys: {},
  lockedCourseVersions: {},
  publications: {},
  standards: {},
  strands: {},
  students: {}
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case UPDATE_ENTITIES:
      {
        return mergeEntities(state, action.entities);
      }
    case RESET_GENERIC_COURSE_RELATIVE_ENTITIES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: {},
          learningJourneySteps: {},
          learningJourneys: {},
          standards: {},
          strands: {}
        });
      }
    case RESET_ENTITIES_ASSIGNMENTS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: {}
        });
      }
    case DELETE_ENTITY_ITEMS:
      {
        var entityName = action.entityName,
          itemIds = action.itemIds;
        var updatedEntity = _objectSpread({}, state[entityName]);
        itemIds.forEach(function (id) {
          return delete updatedEntity[id];
        });
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, entityName, updatedEntity));
      }
    case RESET_ENTITY:
      {
        var _entityName = action.entityName;
        var updatedState = state[_entityName] ? _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _entityName, {})) : state;
        return updatedState;
      }
    default:
      break;
  }
  return state;
}

/***/ }),

/***/ "0uBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flexbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return inlineFlexbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flexDirection; });
/* unused harmony export flexWrap */
/* unused harmony export flexFlow */
/* unused harmony export order */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flexGrow; });
/* unused harmony export flexBasis */
/* unused harmony export flex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return justifyContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignItems; });
/* unused harmony export alignSelf */
/* unused harmony export alignContent */
/* unused harmony export flexShrink */
// Flexbox Mixins
// http://philipwalton.github.io/solved-by-flexbox/
// https://github.com/philipwalton/solved-by-flexbox
//
// Copyright (c) 2013 Brian Franco
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
// IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
// CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
// SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// This is a set of mixins for those who want to mess around with flexbox
// using the native support of current browsers. For full support table
// check: http://caniuse.com/flexbox
//
// Basically this will use:
//
// * Fallback, old syntax (IE10, mobile webkit browsers - no wrapping)
// * Final standards syntax (FF, Safari, Chrome, IE11, Opera)
//
// This was inspired by:
//
// * http://dev.opera.com/articles/view/advanced-cross-browser-flexbox/
//
// With need-help from:
//
// * http://w3.org/tr/css3-flexbox/
// * http://the-echoplex.net/flexyboxes/
// * http://msdn.microsoft.com/en-us/library/ie/hh772069(v=vs.85).aspx
// * http://css-tricks.com/using-flexbox/
// * http://dev.opera.com/articles/view/advanced-cross-browser-flexbox/
// * https://developer.mozilla.org/en-us/docs/web/guide/css/flexible_boxes

//----------------------------------------------------------------------

// Flexbox Containers
//
// The 'flex' value causes an element to generate a block-level flex
// container box.
//
// The 'inline-flex' value causes an element to generate a inline-level
// flex container box.
//
// display: flex | inline-flex
//
// http://w3.org/tr/css3-flexbox/#flex-containers
//
// (Placeholder selectors for each type, for those who rather @extend)

var flexbox = function flexbox() {
  return "\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n";
};
var inlineFlexbox = function inlineFlexbox() {
  return "\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n";
};

//----------------------------------------------------------------------

// Flexbox Direction
//
// The 'flex-direction' property specifies how flex items are placed in
// the flex container, by setting the direction of the flex container's
// main axis. This determines the direction that flex items are laid out in.
//
// Values: row | row-reverse | column | column-reverse
// Default: row
//
// http://w3.org/tr/css3-flexbox/#flex-direction-property

var flexDirection = function flexDirection(value) {
  var direction = String(value || 'row').toLowerCase();
  var styles = '';
  if (direction === 'row-reverse') {
    styles += "\n        -webkit-box-direction: reverse;\n        -webkit-box-orient: horizontal;\n        ";
  } else if (direction === 'column') {
    styles += "\n        -webkit-box-direction: normal;\n        -webkit-box-orient: vertical;\n        ";
  } else if (direction === 'column-reverse') {
    styles += "\n        -webkit-box-direction: reverse;\n        -webkit-box-orient: vertical;\n        ";
  } else {
    styles += "\n        -webkit-box-direction: normal;\n        -webkit-box-orient: horizontal;\n        ";
  }
  styles += "\n    -webkit-flex-direction: ".concat(direction, ";\n    -moz-flex-direction: ").concat(direction, ";\n    -ms-flex-direction: ").concat(direction, ";\n    flex-direction: ").concat(direction, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Wrap
//
// The 'flex-wrap' property controls whether the flex container is single-line
// or multi-line, and the direction of the cross-axis, which determines
// the direction new lines are stacked in.
//
// Values: nowrap | wrap | wrap-reverse
// Default: nowrap
//
// http://w3.org/tr/css3-flexbox/#flex-wrap-property

var flexWrap = function flexWrap() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nowrap';
  var givenValue = String(value).toLowerCase();
  var styles = '';
  if (givenValue === 'nowrap') {
    styles += "\n        -ms-flex-wrap: none;\n        ";
  } else {
    styles += "\n        -ms-flex-wrap: ".concat(givenValue, ";\n        ");
  }
  styles += "\n    flex-wrap: ".concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Flow (shorthand)
//
// The 'flex-flow' property is a shorthand for setting the 'flex-direction'
// and 'flex-wrap' properties, which together define the flex container's
// main and cross axes.
//
// Values: <flex-direction> | <flex-wrap>
// Default: row nowrap
//
// http://w3.org/tr/css3-flexbox/#flex-flow-property

// No Webkit Box fallback.
var flexFlow = function flexFlow() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'row nowrap';
  var givenValue = String(value).toLowerCase();
  var styles = '';
  styles += "\n    -webkit-flex-flow: ".concat(value, ";\n    -moz-flex-flow: ").concat(value, ";\n    -ms-flex-flow: ").concat(value, ";\n    flex-flow: ").concat(value, ";\n    ");
  return styles;
};

// Flexbox Order
//
// The 'order' property controls the order in which flex items appear within
// their flex container, by assigning them to ordinal groups.
//
// Default: 0
//
// http://w3.org/tr/css3-flexbox/#order-property

var order = function order() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n    -webkit-box-ordinal-group: ".concat(value, " + 1;\n    -webkit-order: ").concat(value, ";\n    -moz-order: ").concat(value, ";\n    -ms-flex-order: ").concat(value, ";\n    order: ").concat(value, ";\n    ");
};

// Flexbox Grow
//
// The 'flex-grow' property sets the flex grow factor. Negative numbers
// are invalid.
//
// Default: 0
//
// http://w3.org/tr/css3-flexbox/#flex-grow-property

var flexGrow = function flexGrow() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n    -webkit-box-flex: ".concat(value, ";\n    -webkit-flex-grow: ").concat(value, ";\n    -moz-flex-grow: ").concat(value, ";\n    -ms-flex-positive: ").concat(value, ";\n    flex-grow: ").concat(value, ";\n    ");
};

// Flexbox Shrink
//
// The 'flex-shrink' property sets the flex shrink factor. Negative numbers
// are invalid.
//
// Default: 1
//
// http://w3.org/tr/css3-flexbox/#flex-shrink-property

var flexShrink = function flexShrink() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return "\n    -webkit-flex-shrink: ".concat(value, ";\n    -moz-flex-shrink: ").concat(value, ";\n    -ms-flex-negative: ").concat(value, ";\n    flex-shrink: ").concat(value, ";\n    ");
};

//----------------------------------------------------------------------

// Flexbox Basis
//
// The 'flex-basis' property sets the flex basis. Negative lengths are invalid.
//
// Values: Like "width"
// Default: auto
//
// http://www.w3.org/TR/css3-flexbox/#flex-basis-property

var flexBasis = function flexBasis() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
  return "\n    -webkit-flex-basis: ".concat(value, ";\n    -moz-flex-basis: ").concat(value, ";\n    -ms-flex-preferred-size: ").concat(value, ";\n    flex-basis: ").concat(value, ";\n    ");
};

// Flexbox "Flex" (shorthand)
//
// The 'flex' property specifies the components of a flexible length: the
// flex grow factor and flex shrink factor, and the flex basis. When an
// element is a flex item, 'flex' is consulted instead of the main size
// property to determine the main size of the element. If an element is
// not a flex item, 'flex' has no effect.
//
// Values: none | <flex-grow> <flex-shrink> || <flex-basis>
// Default: See individual properties (1 1 0).
//
// http://w3.org/tr/css3-flexbox/#flex-property

var flex = function flex() {
  var fg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';
  var fs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var fb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  // Set a variable to be used by box-flex properties
  var fgBoxflex = fg;
  var fgArr = String(fg).split(' ');
  if (fgArr.length > 1) {
    fgBoxflex = fgArr[0];
  }
  return "\n    -webkit-box-flex: ".concat(fgBoxflex, ";\n    -webkit-flex: ").concat(fg, " ").concat(fs, " ").concat(fb, ";\n    -moz-box-flex: ").concat(fgBoxflex, ";\n    -moz-flex: ").concat(fg, " ").concat(fs, " ").concat(fb, "|;\n    -ms-flex: ").concat(fg, " ").concat(fs, " ").concat(fb, ";\n    flex: ").concat(fg, " ").concat(fs, " ").concat(fb, ";\n    ");
};

//----------------------------------------------------------------------

// Flexbox Justify Content
//
// The 'justify-content' property aligns flex items along the main axis
// of the current line of the flex container. This is done after any flexible
// lengths and any auto margins have been resolved. Typically it helps distribute
// extra free space leftover when either all the flex items on a line are
// inflexible, or are flexible but have reached their maximum size. It also
// exerts some control over the alignment of items when they overflow the line.
//
// Note: 'space-*' values not supported in older syntaxes.
//
// Values: flex-start | flex-end | center | space-between | space-around
// Default: flex-start
//
// http://w3.org/tr/css3-flexbox/#justify-content-property

var justifyContent = function justifyContent() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'flex-start';
  var givenValue = String(value).toLowerCase();
  var styles = '';
  if (givenValue === 'flex-start') {
    styles += "\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        ";
  } else if (givenValue === 'flex-end') {
    styles += "\n        -webkit-box-pack: end;\n        -ms-flex-pack: end;\n        ";
  } else if (givenValue === 'space-between') {
    styles += "\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        ";
  } else if (givenValue === 'space-around') {
    styles += "\n        -ms-flex-pack: distribute;\n        ";
  } else {
    styles += "\n        -webkit-box-pack: ".concat(givenValue, ";\n        -ms-flex-pack: ").concat(givenValue, ";\n        ");
  }
  styles += "\n    -webkit-justify-content: ".concat(givenValue, ";\n    -moz-justify-content: ").concat(givenValue, ";\n    justify-content: ").concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Align Items
//
// Flex items can be aligned in the cross axis of the current line of the
// flex container, similar to 'justify-content' but in the perpendicular
// direction. 'align-items' sets the default alignment for all of the flex
// container's items, including anonymous flex items. 'align-self' allows
// this default alignment to be overridden for individual flex items. (For
// anonymous flex items, 'align-self' always matches the value of 'align-items'
// on their associated flex container.)
//
// Values: flex-start | flex-end | center | baseline | stretch
// Default: stretch
//
// http://w3.org/tr/css3-flexbox/#align-items-property

var alignItems = function alignItems() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stretch';
  var givenValue = String(value).toLowerCase();
  var styles = '';
  if (givenValue === 'flex-start') {
    styles += "\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        ";
  } else if (givenValue === 'flex-end') {
    styles += "\n        -webkit-box-align: end;\n        -ms-flex-align: end;\n        ";
  } else {
    styles += "\n        -webkit-box-align: ".concat(givenValue, ";\n        -ms-flex-align: ").concat(givenValue, ";\n        ");
  }
  styles += "\n    -webkit-align-items: ".concat(givenValue, ";\n    -moz-align-items: ").concat(givenValue, ";\n    align-items: ").concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------

// Flexbox Align Self
//
// Values: auto | flex-start | flex-end | center | baseline | stretch
// Default: auto

var alignSelf = function alignSelf() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
  var givenValue = String(value).toLowerCase();
  // No Webkit Box Fallback.
  var styles = "\n    -webkit-align-self: ".concat(givenValue, ";\n    -moz-align-self: ").concat(givenValue, ";\n    ");
  if (givenValue === 'flex-start') {
    styles += "\n        -ms-flex-item-align: start;\n        ";
  } else if (givenValue === 'flex-end') {
    styles += "\n        -ms-flex-item-align: end;\n        ";
  } else {
    styles += "\n        -ms-flex-item-align: ".concat(givenValue, ";\n        ");
  }
  styles += "\n    align-self: ".concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Align Content
//
// The 'align-content' property aligns a flex container's lines within the
// flex container when there is extra space in the cross-axis, similar to
// how 'justify-content' aligns individual items within the main-axis. Note,
// this property has no effect when the flexbox has only a single line.
//
// Values: flex-start | flex-end | center | space-between | space-around | stretch
// Default: stretch
//
// http://w3.org/tr/css3-flexbox/#align-content-property

var alignContent = function alignContent() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stretch';
  var givenValue = String(value).toLowerCase();
  // No Webkit Box Fallback.
  var styles = "\n    -webkit-align-content: ".concat(givenValue, ";\n    -moz-align-content: ").concat(givenValue, ";\n    ");
  if (givenValue === 'flex-start') {
    styles += "\n        -ms-flex-line-pack: start;\n        ";
  } else if (givenValue === 'flex-end') {
    styles += "\n        -ms-flex-line-pack: end;\n        ";
  } else {
    styles += "\n        -ms-flex-line-pack: ".concat(givenValue, ";\n        ");
  }
  styles += "\n    align-content: ".concat(givenValue, ";\n    ");
  return styles;
};


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1B8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAssignments */
/* unused harmony export getLearningJourneys */
/* unused harmony export getCurrentFilter */
/* unused harmony export collapsedAccuracyResultsSelector */
/* unused harmony export collapsedProgressResultsSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return collapsedResultsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accuracy_progress_toggle_accuracy_progress_constants__ = __webpack_require__("yHtg");



var getAssignments = function getAssignments(state) {
  return state.entitiesReducer.assignments;
};
var getLearningJourneys = function getLearningJourneys(state) {
  return state.entitiesReducer.learningJourneys;
};
var getCurrentFilter = function getCurrentFilter(state) {
  return state.UPFAssignReducer.accuracyProgressToggle.currentFilter;
};
var collapsedAccuracyResultsSelector = function collapsedAccuracyResultsSelector(sortedStudentIds, learningJourneyIds) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAssignments], function (assignments) {
    return sortedStudentIds.map(function (studentId) {
      var accuracyTotal = 0;
      var resultCount = 0;
      learningJourneyIds.forEach(function (learningJourneyId) {
        var assignmentHashKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__status_cell_helpers__["d" /* getAssignmentHashKey */])(studentId, learningJourneyId);
        var assignment = assignments[assignmentHashKey];
        var _ref = assignment || {},
          _ref$resultStepsCompl = _ref.resultStepsCompleted,
          resultStepsCompleted = _ref$resultStepsCompl === void 0 ? 0 : _ref$resultStepsCompl,
          _ref$resultAccuracy = _ref.resultAccuracy,
          resultAccuracy = _ref$resultAccuracy === void 0 ? 0 : _ref$resultAccuracy;
        if (resultStepsCompleted > 0) {
          accuracyTotal += resultAccuracy;
          resultCount += 1;
        }
      });
      var averageAccuracy = resultCount > 0 ? Number((accuracyTotal / resultCount).toFixed(0)) : 0;
      return {
        id: studentId,
        value: "".concat(averageAccuracy, "%"),
        showResult: resultCount > 0
      };
    });
  });
};
var collapsedProgressResultsSelector = function collapsedProgressResultsSelector(sortedStudentIds, learningJourneyIds) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAssignments, getLearningJourneys], function (assignments, learningJourneys) {
    return sortedStudentIds.map(function (studentId) {
      var stepCountTotal = 0;
      var stepCompletedTotal = 0;
      learningJourneyIds.forEach(function (learningJourneyId) {
        var assignmentHashKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__status_cell_helpers__["d" /* getAssignmentHashKey */])(studentId, learningJourneyId);
        var assignment = assignments[assignmentHashKey];
        var _ref2 = assignment || {},
          _ref2$resultStepsComp = _ref2.resultStepsCompleted,
          resultStepsCompleted = _ref2$resultStepsComp === void 0 ? 0 : _ref2$resultStepsComp;
        var learningJourney = learningJourneys[learningJourneyId] || {};
        var _learningJourney$chil = learningJourney.childTopics,
          learningJourneyStepIds = _learningJourney$chil === void 0 ? [] : _learningJourney$chil;
        stepCountTotal += learningJourneyStepIds.length;
        stepCompletedTotal += resultStepsCompleted;
      });
      return {
        id: studentId,
        value: "".concat(stepCompletedTotal, "/").concat(stepCountTotal),
        showResult: stepCountTotal > 0
      };
    });
  });
};
var collapsedResultsSelector = function collapsedResultsSelector(sortedStudentIds, learningJourneyIds) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCurrentFilter, collapsedAccuracyResultsSelector(sortedStudentIds, learningJourneyIds), collapsedProgressResultsSelector(sortedStudentIds, learningJourneyIds)], function (currentFilter, accuracyResults, progressResults) {
    if (currentFilter === __WEBPACK_IMPORTED_MODULE_2__accuracy_progress_toggle_accuracy_progress_constants__["a" /* ACCURACY */]) {
      return accuracyResults;
    }
    return progressResults;
  });
};

/***/ }),

/***/ "1IMA":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Hwd/");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "1QGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return studentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return teacherStatus; });
/* unused harmony export assignmentType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MAX_STUDENT_NAME_LENGTH; });
/* unused harmony export MAX_ITEMS_TO_DISPLAY */
/* unused harmony export MAX_GROUP_NAME_LENGTH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAX_LEARNING_JOURNEY_COUNT; });
/* unused harmony export LOCALE_DEFAULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MAX_STUDENT_NAME_LENGTH_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MAX_STUDENT_GRADE_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return assignmentFilterType; });
/* unused harmony export ACCURACY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SORT_DIRECTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ASSIGNMENT_RESULT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOPICS_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOCAL_STORAGE_KEYS; });
/* unused harmony export REGION_IDS */
var studentStatus = {
  UNASSIGNED: 0,
  UNATTEMPTED: 1,
  ASSIGN_SELECTION: 2,
  PARTIAL: 3,
  CORRECT: 4,
  UNASSIGN_SELECTION: 6
};
var teacherStatus = {
  SUBMITTED: 1,
  REVIEWED: 2
};
var assignmentType = {
  RESTRICTED: 0,
  NON_RESTRICTED: 1
};
var MAX_STUDENT_NAME_LENGTH = 30;
var MAX_ITEMS_TO_DISPLAY = 14;
var MAX_GROUP_NAME_LENGTH = 20;
var MAX_LEARNING_JOURNEY_COUNT = 200;
var LOCALE_DEFAULT = 'en-AU';
var MAX_STUDENT_NAME_LENGTH_CONTEXT = 100;
var MAX_STUDENT_GRADE_LENGTH = 50;
var assignmentFilterType = {
  ASSIGN_UPF: 0,
  ASSIGN_LEARNING_GAPS: 1,
  VOLUNTARY: 2
};
var ACCURACY = 'accuracy';
var SORT_DIRECTION_TYPES = {
  DESC: 'desc',
  ASC: 'asc'
};
var ASSIGNMENT_RESULT_TYPES = {
  HIGHEST: 0,
  ASSIGNED: 1,
  VOLUNTARY: 2
};
var TOPICS_TYPES = {
  STANDARD: 'standard',
  STRAND: 'strand'
};
var SEARCH_PARAMS = {
  COUNTRY_CODE_PARAM: 'countryCode',
  REGION_CODE_PARAM: 'regionId'
};
var LOCAL_STORAGE_KEYS = {
  LAST_USED_PUBLICATION: 'LAST_USED_PUBLICATION',
  LAST_USED_COURSE: 'LAST_USED_COURSE',
  LAST_USED_CLASSROOM: 'LAST_USED_CLASSROOM',
  LAST_USED_GROUP: 'LAST_USED_GROUP',
  ACCURACY_PROGRESS_FILTER: 'ACCURACY_PROGRESS_FILTER'
};
var REGION_IDS = {
  AUSTRALIA: '8',
  NEW_ZEALAND: '14'
};

/***/ }),

/***/ "1lkb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FilterWrapper; });
/* unused harmony export AssignmentLoadingWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DropdownTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    min-height: 192px;\n    height: 192px;\n    padding: 0 4px;\n    border-right: none;\n    font-size: 14px;\n    width: 250px;\n    background-color: white;\n    border: 1px solid ".concat(colours.grey[400], ";\n    border-top: none;\n    border-left: none;\n");
});
var LoadingWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"])));
var FilterWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 3px 10px;\n"])));
var AssignmentLoadingWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  height: 14px;\n"])));
var DropdownTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("x4K0");


/***/ }),

/***/ "2HYC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("MH+t");





var HelpIcon = function HelpIcon(props) {
  var needAttentionStudentsCount = props.needAttentionStudentsCount;
  if (needAttentionStudentsCount === 0) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* Icon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["e" /* StandardDropdown */]
    }));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["p" /* MessageBubble */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["d" /* NumberWrapper */], null, needAttentionStudentsCount)));
};
HelpIcon.defaultProps = {
  needAttentionStudentsCount: 0
};
HelpIcon.propTypes = {
  needAttentionStudentsCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(HelpIcon));

/***/ }),

/***/ "2QI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_option_icon_option__ = __webpack_require__("IiE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("j7wZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters_constants__ = __webpack_require__("6coq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translations__ = __webpack_require__("yumT");






var FilterOptions = function FilterOptions(_ref) {
  var i18n = _ref.i18n,
    filter = _ref.filter,
    handleSelection = _ref.handleSelection;
  /**
   * TRANSLATIONS
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__translations__["a" /* default */])({
      i18n: i18n
    }),
    FILTER_TEACHER_ASSIGNED_TEXT = _getTranslations.FILTER_TEACHER_ASSIGNED_TEXT,
    FILTER_VOLUNTARY_ATTEMPT_TEXT = _getTranslations.FILTER_VOLUNTARY_ATTEMPT_TEXT,
    FILTER_ATTEMPTS_HEADING_TEXT = _getTranslations.FILTER_ATTEMPTS_HEADING_TEXT,
    FILTER_ALL_HIGHEST_TEXT = _getTranslations.FILTER_ALL_HIGHEST_TEXT,
    FILTER_INFO_HIGHEST_TEXT = _getTranslations.FILTER_INFO_HIGHEST_TEXT,
    FILTER_INFO_LATEST_TEXT = _getTranslations.FILTER_INFO_LATEST_TEXT,
    FILTER_INFO_VOLUNTARY_TEXT = _getTranslations.FILTER_INFO_VOLUNTARY_TEXT;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* FilterOptionsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* FilterOptionsHeading */], {
    "data-testid": "filter-options"
  }, FILTER_ATTEMPTS_HEADING_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__icon_option_icon_option__["a" /* default */], {
    filter: filter,
    handleSelection: handleSelection,
    id: __WEBPACK_IMPORTED_MODULE_4__filters_constants__["a" /* HIGHEST */],
    labelText: FILTER_ALL_HIGHEST_TEXT,
    infoText: FILTER_INFO_HIGHEST_TEXT
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__icon_option_icon_option__["a" /* default */], {
    filter: filter,
    handleSelection: handleSelection,
    id: __WEBPACK_IMPORTED_MODULE_4__filters_constants__["b" /* ASSIGNED */],
    labelText: FILTER_TEACHER_ASSIGNED_TEXT,
    infoText: FILTER_INFO_LATEST_TEXT
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__icon_option_icon_option__["a" /* default */], {
    filter: filter,
    handleSelection: handleSelection,
    id: __WEBPACK_IMPORTED_MODULE_4__filters_constants__["c" /* VOLUNTARY */],
    labelText: FILTER_VOLUNTARY_ATTEMPT_TEXT,
    infoText: FILTER_INFO_VOLUNTARY_TEXT
  }));
};
FilterOptions.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FilterOptions);

/***/ }),

/***/ "2l37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getAssignmentsManagementInitData; });
/* unused harmony export getStudentsAssignments */
/* unused harmony export updateSortStudents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getGenericCoursesV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateStrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return applyFilter; });
/* unused harmony export filteredStudents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateSortProps; });
/* unused harmony export updateSelectedCourse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayModalInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hideStandard; });
/* unused harmony export updateOnCellSelection */
/* unused harmony export assign */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return strandExpandCollapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setSelectedClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setSelectedGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setSelectedPublication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setSelectedCourseOption; });
/* unused harmony export restrictActivities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return clearCellSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectAssignmentHashKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectAssignmentHashKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unselectAssignmentHashKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetAssignmentHashKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return disableShowGridLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateSortedStudentIds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__("JeHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__entities_entities_reducer__ = __webpack_require__("0dbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__ = __webpack_require__("//jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_portal_comms__ = __webpack_require__("lS1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__entities_schema__ = __webpack_require__("FKcn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gateways_gateways_actions__ = __webpack_require__("i4yT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__upf_assign_util__ = __webpack_require__("++6F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__ = __webpack_require__("spZY");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }










var getAssignmentsManagementInitData = function getAssignmentsManagementInitData(productId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var response, normalizedClassrooms, normalizedPublications, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__gateways_gateways_actions__["d" /* fetchClassroomsRequest */])());
            _context.n = 1;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].getAssignmentInitData.get({
              productId: productId
            }).send();
          case 1:
            response = _context.v;
            normalizedClassrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["b" /* normalize */])(response.data.classrooms, __WEBPACK_IMPORTED_MODULE_6__entities_schema__["a" /* default */].CLASSROOMS_ARRAY);
            normalizedPublications = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["b" /* normalize */])(response.data.publicationCourses, __WEBPACK_IMPORTED_MODULE_6__entities_schema__["a" /* default */].PUBLICATION_ARRAY);
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__entities_entities_reducer__["c" /* updateEntities */])(normalizedClassrooms));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__entities_entities_reducer__["c" /* updateEntities */])(normalizedPublications));
            __WEBPACK_IMPORTED_MODULE_5__helpers_portal_comms__["a" /* default */].loadingSpinnerOff();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__gateways_gateways_actions__["e" /* fetchClassroomsSuccess */])());
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["f" /* ERROR_DETECTED */],
              payload: _t
            });
            throw _t;
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getStudentsAssignments = function getStudentsAssignments(_ref2) {
  var assignmentType = _ref2.assignmentType,
    learningJourneyIds = _ref2.learningJourneyIds,
    studentUserProfileIds = _ref2.studentUserProfileIds,
    productId = _ref2.productId,
    courseId = _ref2.courseId,
    courseVersion = _ref2.courseVersion;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["b" /* STUDENTS_ASSIGNMENTS_STATUSES_REQUEST */]
            });
            _context2.n = 1;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].studentassignments.post().withBody({
              assignmentType: assignmentType,
              learningJourneyIds: learningJourneyIds,
              studentUserProfileIds: studentUserProfileIds,
              productId: productId,
              courseId: courseId,
              courseVersion: courseVersion
            }).send();
          case 1:
            response = _context2.v;
            if (response.data) {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["c" /* STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS */],
                payload: response.data
              });
            } else {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["f" /* ERROR_DETECTED */],
                payload: response.data
              });
            }
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["f" /* ERROR_DETECTED */],
              payload: _t2
            });
            throw _t2;
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var updateSortStudents = function updateSortStudents(students) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["d" /* UPDATE_SORTED_STUDENTS_LIST */],
    students: students
  };
};
var getGenericCoursesV2 = function getGenericCoursesV2(_ref4) {
  var courseId = _ref4.courseId,
    productId = _ref4.productId,
    courseVersion = _ref4.courseVersion;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var DEFAULT_VERSION, versionId, response, key, savedFilter, data, topics, normalizedData, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            DEFAULT_VERSION = 0;
            _context3.p = 1;
            versionId = courseVersion || DEFAULT_VERSION;
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__entities_entities_reducer__["d" /* resetGenericCourseRelativeEntities */])());
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["h" /* GENERIC_COURSES_REQUEST */]
            });
            _context3.n = 2;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].genericCourses.get({
              courseId: courseId
            }).withParams({
              productId: productId,
              versionId: versionId
            }).send();
          case 2:
            response = _context3.v;
            if (response !== null && response !== void 0 && response.data) {
              key = "".concat(courseVersion, "_").concat(courseId, "_FILTER");
              savedFilter = __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__["a" /* default */].getItem(key);
              data = response.data, topics = response.data.topics;
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["i" /* GENERIC_COURSES_SUCCESS */],
                payload: data,
                courseId: courseId,
                courseVersion: courseVersion,
                savedFilter: savedFilter
              });
              normalizedData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["b" /* normalize */])(topics, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__upf_assign_util__["m" /* findSchemaByTopics */])(topics));
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__entities_entities_reducer__["c" /* updateEntities */])(normalizedData));
            } else {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["R" /* SHOW_TOAST */],
                isToastVisible: true,
                message: response === null || response === void 0 ? void 0 : response.message
              });
            }
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["f" /* ERROR_DETECTED */],
              payload: _t3
            });
            throw _t3;
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var updateStrand = function updateStrand(actionType, id, checked, searchTerm) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["k" /* UPDATE_STRANDS */],
              id: id,
              checked: checked,
              searchTerm: searchTerm,
              actionType: actionType
            });
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var applyFilter = function applyFilter() {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch) {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["l" /* APPLY_FILTER */]
            });
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var filteredStudents = function filteredStudents(students) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["a" /* FILTERED_STUDENTS */],
    payload: students
  };
};
var updateSortProps = function updateSortProps(direction, sortValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["e" /* UPDATE_SORT_PROPERTIES */],
    direction: direction,
    sortValue: sortValue
  };
};
var updateSelectedCourse = function updateSelectedCourse(selectedCourse, courseVersion) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["m" /* UPDATE_SELECTED_COURSE */],
    selectedCourse: {
      id: selectedCourse.value,
      version: courseVersion
    }
  };
};
var displayModalInfo = function displayModalInfo(key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["o" /* DISPLAY_MODAL_INFORMATION */],
    key: key
  };
};
var hideStandard = function hideStandard(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["p" /* HIDE_STANDARD */],
    id: id
  };
};
var updateOnCellSelection = function updateOnCellSelection(cellData, cellStatus) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["q" /* UPDATE_STUDENT_ASSIGNMENT */],
    cellData: cellData,
    cellStatus: cellStatus
  };
};
var assign = function assign(data, selectedTopics, i18n) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch) {
      var response, _t4;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["r" /* ASSIGN_REQUEST */]
            });
            _context6.n = 1;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].assign.post().withBody(data).send();
          case 1:
            response = _context6.v;
            if (response.data) {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["s" /* ASSIGN_SUCCESS_REQUEST */],
                payload: response.data
              });
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_toast_toast_action__["c" /* showToast */])(i18n._("Student activity assignments have been successfully updated"), 'success'));
              dispatch(getStudentsAssignments({
                learningJourneyIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__upf_assign_util__["f" /* getAllLearningJourneys */])(selectedTopics),
                studentUserProfileIds: data.filteredStudents.map(function (student) {
                  return student.id;
                }),
                productId: data.productId,
                courseId: data.courseId,
                courseVersion: data.courseVersion
              }));
            } else {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["t" /* ASSIGN_FAILURE_REQUEST */]
              });
            }
            _context6.n = 3;
            break;
          case 2:
            _context6.p = 2;
            _t4 = _context6.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["f" /* ERROR_DETECTED */],
              payload: _t4
            });
            throw _t4;
          case 3:
            return _context6.a(2);
        }
      }, _callee6, null, [[0, 2]]);
    }));
    return function (_x6) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var strandExpandCollapse = function strandExpandCollapse(strandId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["y" /* EXPAND_COLLAPSE_REQUEST */],
    strandId: strandId
  };
};
var setSelectedClass = function setSelectedClass(selectedClass) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["z" /* SET_SELECTED_CLASS */],
    selectedClass: selectedClass
  };
};
var setSelectedGroup = function setSelectedGroup(selectedGroup) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["A" /* SET_SELECTED_GROUP */],
    selectedGroup: selectedGroup
  };
};
var setSelectedPublication = function setSelectedPublication(selectedPublication) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["B" /* SET_SELECTED_PUBLICATION */],
    selectedPublication: selectedPublication
  };
};
var setSelectedCourseOption = function setSelectedCourseOption(selectedCourseOption) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["C" /* SET_SELECTED_COURSE_OPTION */],
    selectedCourseOption: selectedCourseOption
  };
};
var restrictActivities = function restrictActivities(isRestricted, classId, groupId) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch) {
      var response, _t5;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            response = null;
            _context7.p = 1;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["E" /* RESTRICT_ACCESS_REQUEST */]
            });
            _context7.n = 2;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].restrictActivities.put({
              isRestricted: isRestricted,
              classId: classId,
              groupId: groupId
            }).withBody({}).send();
          case 2:
            response = _context7.v;
            if (!(response.status === 200)) {
              _context7.n = 3;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["F" /* RESTRICT_ACCESS_SUCCESS */],
              payload: isRestricted
            });
            return _context7.a(2, response);
          case 3:
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["D" /* RESTRICT_ACCESS_FAILURE */]
            });
            return _context7.a(2, response);
          case 4:
            _context7.p = 4;
            _t5 = _context7.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["f" /* ERROR_DETECTED */],
              payload: _t5
            });
            throw _t5;
          case 5:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 4]]);
    }));
    return function (_x7) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var clearCellSelection = function clearCellSelection() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["G" /* SET_ASSIGNMENT_FILTER_TYPE */],
    payload: {
      selectionType: 'clearSelection'
    }
  };
};
var selectAssignmentHashKey = function selectAssignmentHashKey(_ref0) {
  var assignmentHashKey = _ref0.assignmentHashKey,
    learningJourneyId = _ref0.learningJourneyId,
    studentId = _ref0.studentId;
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["K" /* SELECT_ASSIGNMENT_HASH_KEY */],
    assignmentHashKey: assignmentHashKey,
    selectedValues: {
      learningJourneyId: learningJourneyId,
      studentId: studentId
    }
  };
};
var selectAssignmentHashKeys = function selectAssignmentHashKeys(assignmentHashKeys) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["L" /* SELECT_ASSIGNMENT_HASH_KEYS */],
    assignmentHashKeys: assignmentHashKeys
  };
};
var unselectAssignmentHashKeys = function unselectAssignmentHashKeys(assignmentHashKeys) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["M" /* UNSELECT_ASSIGNMENT_HASH_KEYS */],
    assignmentHashKeys: assignmentHashKeys
  };
};
var resetAssignmentHashKeys = function resetAssignmentHashKeys() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["O" /* RESET_SELECTED_ASSIGNMENT_HASH_KEYS */]
  };
};
var disableShowGridLoader = function disableShowGridLoader() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["P" /* DISABLE_SHOW_GRID_LOADER */]
  };
};
var updateSortedStudentIds = function updateSortedStudentIds(sortedStudentIds) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__upf_assign_action_types__["Q" /* UPDATE_SORTED_STUDENT_IDS */],
    sortedStudentIds: sortedStudentIds
  };
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "2yEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");


var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border: 1px solid ".concat(colours.grey[400], ";\n    background-color: ").concat(colours.grey[200], ";\n    min-width: 52px;\n    height: 45px;\n\n    > div {\n      margin: 0;\n    }\n");
});
/* unused harmony default export */ var _unused_webpack_default_export = (Root);

/***/ }),

/***/ "2yLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accuracy_progress_toggle_accuracy_progress_constants__ = __webpack_require__("yHtg");



var useAssignmentResultType = function useAssignmentResultType() {
  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
      return state.UPFAssignReducer.accuracyProgressToggle;
    }, __WEBPACK_IMPORTED_MODULE_0_react_redux__["d" /* shallowEqual */]),
    accuracySubFilter = _useSelector.accuracySubFilter,
    currentFilter = _useSelector.currentFilter,
    progressSubFilter = _useSelector.progressSubFilter;
  var subFilter = currentFilter === __WEBPACK_IMPORTED_MODULE_2__components_accuracy_progress_toggle_accuracy_progress_constants__["b" /* PROGRESS */] ? progressSubFilter : accuracySubFilter;
  var assignmentResultType = __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* ASSIGNMENT_RESULT_TYPES */][subFilter === null || subFilter === void 0 ? void 0 : subFilter.toUpperCase()];
  return {
    assignmentResultType: assignmentResultType
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useAssignmentResultType);

/***/ }),

/***/ "2z6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// For local development, we can use mock-rest-server (or a similar REST server like json-server)
//
// You should be able to use this code as is, apart from perhaps changing MOCK_SERVICE_PORT to whatever
// port you're using for your mock server.

// const MOCK_SERVICES_PORT = 4321; // TODO: 2. DEFINE THE PORT YOUR MOCK SERVER IS LISTENING ON

// const MOCK_SERVICES_HOST = 'localhost';
// const MOCK_SERVICES_URL = `http://${MOCK_SERVICES_HOST}:${MOCK_SERVICES_PORT}`;

// The app's configuration will have a base URL for each service we use.  For local testing, we define
// the configuration to point to our local server.
//
// For each resource, we have a constant for the base URL, as it would be in production. For example,
// below we have "AvatarAdminBaseUrl" which represents the base of the URL for access to all of
// the Avatar Admin application's resources.  Replace that with the resource(s) your application uses.

var localConfig = {
  BaseName: ''
};
/* harmony default export */ __webpack_exports__["a"] = (localConfig);

/***/ }),

/***/ "3IFr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("eag5");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./svg-icon.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./svg-icon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3PI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].layout), {}, {
  borderRadius: '6px',
  spacing: 8
}));

/***/ }),

/***/ "3gQ+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".toast---kgiAS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: \"column\";\n  -ms-flex-direction: \"column\";\n  flex-direction: \"column\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 51px;\n  visibility: visible;\n  opacity: 0;\n  -webkit-animation: fadeIn---2PfM_ 5s;\n          animation: fadeIn---2PfM_ 5s;\n  font-size: 17px;\n  z-index: 99999; }\n  .toastContent---1l5Gr {\n    padding: 15px;\n    width: 100%; }\n  .message---ryA0O {\n  -webkit-box-pack: \"center\";\n  -ms-flex-pack: \"center\";\n  -moz-justify-content: \"center\";\n  justify-content: \"center\";\n  -webkit-box-align: \"center\";\n  -ms-flex-align: \"center\";\n  -moz-align-items: \"center\";\n  align-items: \"center\";\n  color: white;\n  margin: auto;\n  cursor: pointer; }\n  @-webkit-keyframes fadeIn---2PfM_ {\n  0% {\n    opacity: 0; }\n  15% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @keyframes fadeIn---2PfM_ {\n  0% {\n    opacity: 0; }\n  15% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @media print {\n  .empty---m-1l8 {\n    display: none !important;\n    height: 0.001px !important; } }\n", ""]);

// exports
exports.locals = {
	"toast": "toast---kgiAS",
	"fadeIn": "fadeIn---2PfM_",
	"toastContent": "toastContent---1l5Gr",
	"message": "message---ryA0O",
	"empty": "empty---m-1l8"
};

/***/ }),

/***/ "4HFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilterOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptionWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InfoTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InfoIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return InfoTooltipText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var FilterOption = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  color: ", ";\n  width: 165px;\n  border: 1px solid white;\n  border-radius: 10px;\n  box-shadow: 0 0 0 1px #3b4e5e inset;\n  box-sizing: border-box;\n  font-size: 13px;\n  margin: 5px 10px 5px 0;\n  padding: 1px;\n  background-color: ", ";\n  cursor: pointer;\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) {
  return props.selected ? '#3b4e5e' : 'white';
}, function (props) {
  return props.selected ? 'white' : '#3b4e5e';
}, function (props) {
  return props.selected ? '#3b4e5e' : 'white';
});
var OptionWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  [class^='svgIconComponent'] {\n    width: 23px !important;\n    margin-top: 5px;\n\n    path {\n      fill: white !important;\n    }\n  }\n"])));
var InfoTooltip = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0.2s, opacity 0.2s;\n  position: absolute;\n  top: 0;\n  left: 45px;\n  background: white;\n  width: 190px;\n  border: 1px grey solid;\n  border-radius: 5px;\n  transform: translate(0, -30%);\n\n  &:before,\n  &:after {\n    bottom: 100%;\n    border: solid transparent;\n    content: ' ';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    transform: rotate(-90deg) translate(50%, 0);\n  }\n\n  &:before {\n    border-color: rgba(194, 194, 194, 0);\n    border-bottom-color: grey;\n    border-width: 11px;\n    right: 191px;\n    top: 50%;\n  }\n\n  &:after {\n    top: 50%;\n    right: 189px;\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: white;\n    border-width: 11px;\n\n    @media screen and (max-width: 1300px) {\n      right: 190px;\n    }\n  }\n"])));
var InfoIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: help;\n\n  &:hover ", " {\n    visibility: visible;\n    opacity: 1;\n  }\n"])), InfoTooltip);
var InfoTooltipText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background: white;\n  color: black;\n  margin: 5px 10px;\n"])));

/***/ }),

/***/ "4YSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("qmda");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("IzlY");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var Checkbox = function Checkbox(props) {
  var state = props.state,
    checkboxHandler = props.checkboxHandler,
    id = props.id;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(state),
    _useState2 = _slicedToArray(_useState, 2),
    currentState = _useState2[0],
    setcurrentState = _useState2[1];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setcurrentState(state);
  }, [state]);
  var handleChange = function handleChange() {
    if (state === __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* DISABLED */]) return;
    if (currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* UNCHECKED */] || currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INDETERMINATE */]) {
      setcurrentState(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CHECKED */]);
      checkboxHandler(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CHECKED */], id);
    } else {
      setcurrentState(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* UNCHECKED */]);
      checkboxHandler(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* UNCHECKED */], id);
    }
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* CheckboxContainer */], {
    "data-testid": "checkbox-container",
    onClick: handleChange
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* HiddenCheckbox */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* CustomCheckbox */], {
    currentState: currentState
  }, currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CHECKED */] && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["d" /* IconChecked */], {
    "data-testid": "checked",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })), currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* UNCHECKED */] && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["e" /* IconUnchecked */], {
    "data-testid": "unchecked",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
    points: "0 0"
  })), currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INDETERMINATE */] && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["f" /* IconIntermediate */], {
    "data-testid": "indeterminate",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
    points: "4 11 20 11 20 14 4 14 4 11"
  })), currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* DISABLED */] && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["g" /* IconDisabled */], {
    "data-testid": "disabled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
    points: "0 0"
  }))));
};
Checkbox.propTypes = {
  state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  checkboxHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
Checkbox.defaultProps = {
  state: __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* UNCHECKED */],
  checkboxHandler: function checkboxHandler() {},
  id: null
};
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),

/***/ "4Z4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pulse_loader__ = __webpack_require__("oWNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assignment_components_due_date_info_due_date_info__ = __webpack_require__("GBeY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__no_data_view__ = __webpack_require__("KABN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_actions__ = __webpack_require__("6l1r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assignment__ = __webpack_require__("j+A/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled__ = __webpack_require__("vFbg");














var AssignedList = function AssignedList() {
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var assignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.currentAssignmentsModalReducer.assignments;
  });
  var loading = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.currentAssignmentsModalReducer.loading;
  });
  var sortDirection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.currentAssignmentsModalReducer.sortDirection;
  });
  var selectedAssignmentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.currentAssignmentsModalReducer.selectedAssignmentIds;
  });
  var sortedAssignments = __WEBPACK_IMPORTED_MODULE_3_lodash_orderBy___default()(assignments, 'learningJourneyName', sortDirection);
  var arrowIcon = sortDirection === 'asc' ? __WEBPACK_IMPORTED_MODULE_8__helpers_icon_dictionary__["B" /* DownArrow */] : __WEBPACK_IMPORTED_MODULE_8__helpers_icon_dictionary__["C" /* UpArrow */];
  var assignmentsCount = assignments.length;
  var isSelectedAll = assignmentsCount > 0 && selectedAssignmentIds.length === assignmentsCount;
  var updateSortDirection = function updateSortDirection() {
    dispatch({
      type: sortDirection === 'asc' ? __WEBPACK_IMPORTED_MODULE_11__redux_actions__["f" /* UPDATE_SORT_DIRECTION_TO_DESC */] : __WEBPACK_IMPORTED_MODULE_11__redux_actions__["e" /* UPDATE_SORT_DIRECTION_TO_ASC */]
    });
  };
  var handleSelectAll = function handleSelectAll() {
    dispatch({
      type: isSelectedAll ? __WEBPACK_IMPORTED_MODULE_11__redux_actions__["g" /* UNSELECT_ALL_ASSIGNMENTS */] : __WEBPACK_IMPORTED_MODULE_11__redux_actions__["h" /* SELECT_ALL_ASSIGNMENTS */]
    });
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["b" /* Header */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["c" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__checkbox__["a" /* default */], {
    checkboxHandler: handleSelectAll,
    state: isSelectedAll ? __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__["a" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__["b" /* UNCHECKED */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["d" /* SortableHeader */], {
    onClick: updateSortDirection
  }, i18n._("Skill Quest"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["e" /* IconContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__["a" /* default */], {
    icon: arrowIcon
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["f" /* HeaderTitle */], {
    width: "35%"
  }, i18n._("Course")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["f" /* HeaderTitle */], null, i18n._("Accuracy")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["f" /* HeaderTitle */], null, i18n._("Progress")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["f" /* HeaderTitle */], null, i18n._("Assigned")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["f" /* HeaderTitle */], null, i18n._("DueDate"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__assignment_components_due_date_info_due_date_info__["a" /* default */], null))), loading && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["g" /* LoaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__pulse_loader__["a" /* default */], null)), !loading && assignmentsCount === 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["g" /* LoaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__no_data_view__["a" /* default */], null)), !loading && assignmentsCount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["h" /* Body */], null, sortedAssignments.map(function (assignment) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__assignment__["a" /* default */], {
      key: assignment.assignmentId,
      assignment: assignment
    });
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (AssignedList);

/***/ }),

/***/ "5IT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var UnassignWarningModalInner = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 10px;\n  width: 320px;\n  height: 200px;\n  background-color: white;\n  border-radius: 4px;\n  margin: auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  text-align: center;\n\n  & div[class*=\"ButtonWrapper\"] {\n    height: 30px;\n  }\n  \n  h1 {\n    font-size: 18px;\n  }\n"])));
/* harmony default export */ __webpack_exports__["a"] = (UnassignWarningModalInner);

/***/ }),

/***/ "5ttS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("r+Ri");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("ef/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translations__ = __webpack_require__("dEfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resize_icon__ = __webpack_require__("OsCZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assign_button__ = __webpack_require__("u8BE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__unassign_button__ = __webpack_require__("umfI");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }









var Footer = function Footer() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var prevSelectedAssignmentsCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_4__selectors__["a" /* groupAssignAndUnAssignAssignmentsSelector */]),
    selectedCellsCount = _useSelector.selectedCellsCount;
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__translations__["a" /* default */])({
      i18n: i18n
    }),
    CELLS_SELECTED_TEXT = _getTranslations.CELLS_SELECTED_TEXT,
    CELL_SELECTED_TEXT = _getTranslations.CELL_SELECTED_TEXT;
  var manageCollapsed = function manageCollapsed() {
    var firstAssignmentSelected = prevSelectedAssignmentsCount.current === 0 && selectedCellsCount > 0;
    var lastAssignmentDeselected = prevSelectedAssignmentsCount.current > 0 && selectedCellsCount === 0;
    if (firstAssignmentSelected) {
      setIsCollapsed(false);
    } else if (lastAssignmentDeselected) {
      setIsCollapsed(true);
    }
    prevSelectedAssignmentsCount.current = selectedCellsCount;
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    manageCollapsed();
  }, [selectedCellsCount, prevSelectedAssignmentsCount]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Root */], {
    isCollapsed: isCollapsed
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__resize_icon__["a" /* default */], {
    isCollapsed: isCollapsed,
    onClickCallback: setIsCollapsed
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* PanelWrapper */], null, isCollapsed && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* CollapsedPanel */], {
    "data-testid": "footer-collapsed-panel"
  }, "".concat(selectedCellsCount, " ").concat(selectedCellsCount > 1 ? CELLS_SELECTED_TEXT : CELL_SELECTED_TEXT)), !isCollapsed && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* ExpandedPanel */], {
    "data-testid": "footer-expended-panel"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__unassign_button__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__assign_button__["a" /* default */], null))));
};
/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ "6KtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product_enum__ = __webpack_require__("avc1");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var productService = /*#__PURE__*/function () {
  function productService() {
    _classCallCheck(this, productService);
  }
  return _createClass(productService, null, [{
    key: "Configure",
    value: function Configure() {
      var selectedProductId;
      var productIdInQueryString = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
      if (productIdInQueryString.productId) {
        selectedProductId = Number.parseInt(productIdInQueryString.productId, 10);
      }
      var initialState = {
        product: {
          id: selectedProductId,
          name: this.getProductNameById(selectedProductId)
        }
      };
      return initialState;
    }
  }, {
    key: "getProductNameById",
    value: function getProductNameById(id) {
      var productName = '';
      if (id) {
        for (var key in __WEBPACK_IMPORTED_MODULE_1__product_enum__["a" /* default */]) {
          if (__WEBPACK_IMPORTED_MODULE_1__product_enum__["a" /* default */][key].id === id) {
            productName = __WEBPACK_IMPORTED_MODULE_1__product_enum__["a" /* default */][key].name;
            break;
          }
        }
      }
      return productName;
    }
  }]);
}();


/***/ }),

/***/ "6QRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleDefaults;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConfiguration;
/* unused harmony export log */
/* harmony export (immutable) */ __webpack_exports__["d"] = getContextCoords;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return findCountryCodeFromQueryParams; });
/* unused harmony export findRegionCodeFromQueryParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return findOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isDefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getQueryParam; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("1QGX");



/**
 *  utitlity functions
 */

function handleDefaults(defaultObj, dynamicObj) {
  for (var key in dynamicObj) {
    defaultObj[key] = dynamicObj[key];
  }
  return defaultObj;
}
function getConfiguration(name) {
  if (window._env_) {
    return window._env_[name];
  }
  return '';
}
function log() {}
function getContextCoords(position, modalWidth) {
  var leftAlign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var leftOffset = position.left || position.x || position.clientX;
  var innerOffsetRight = window.innerWidth - (position.right || position.clientX);
  var innerOffsetLeft = leftOffset - modalWidth;
  var coords = {};
  coords.height = position.height;
  if (leftAlign) {
    var mid = (position.top + position.bottom) / 2;
    coords.posX = position.right + 11;
    coords.posArrow = position.right + 8;
    coords.posArrowY = mid - 8;
    coords.posY = innerHeight - position.bottom < 85 ? position.bottom - 150 : position.bottom - 75;
    return coords;
  }
  coords.posY = (position.bottom || position.clientY) + 5;
  coords.posArrow = leftOffset + (position.width || 2) / 2;
  if (innerOffsetRight > modalWidth && innerOffsetLeft > modalWidth) {
    coords.posX = coords.posArrow - modalWidth / 2; // center aligned
  } else if (innerOffsetLeft < modalWidth && innerOffsetRight > modalWidth) {
    coords.posX = coords.posArrow - 15; // left aligned
  } else {
    coords.posX = coords.posArrow - modalWidth + 15; // right aligned
  }
  return coords;
}
var findCountryCodeFromQueryParams = function findCountryCodeFromQueryParams() {
  var queryStringSearch = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
  return queryStringSearch[__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SEARCH_PARAMS */].COUNTRY_CODE_PARAM] || 'AUS';
};
var findRegionCodeFromQueryParams = function findRegionCodeFromQueryParams() {
  var queryStringSearch = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);
  return queryStringSearch[__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SEARCH_PARAMS */].REGION_CODE_PARAM] || null;
};
var findOption = function findOption(options, selectedOption) {
  return options.find(function (option) {
    return option.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value);
  });
};
var isDefined = function isDefined(value) {
  return ![null, undefined].includes(value);
};
var getQueryParam = function getQueryParam(param) {
  var searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(param);
};

/***/ }),

/***/ "6coq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIGHEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ASSIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VOLUNTARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACCURACY_SUB_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROGRESS_SUB_FILTER; });
var HIGHEST = 'highest';
var ASSIGNED = 'assigned';
var VOLUNTARY = 'voluntary';
var ACCURACY_SUB_FILTER = 'ACCURACY_SUB_FILTER';
var PROGRESS_SUB_FILTER = 'PROGRESS_SUB_FILTER';

/***/ }),

/***/ "6dLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var UnassignButtonWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: 20px;\n  position: relative;\n"])));
/* harmony default export */ __webpack_exports__["a"] = (UnassignButtonWrapper);

/***/ }),

/***/ "6l1r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STUDENT_ASSIGNMENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STUDENT_ASSIGNMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STUDENT_ASSIGNMENTS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_STUDENT_ASSIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_SORT_DIRECTION_TO_ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_SORT_DIRECTION_TO_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SELECT_ALL_ASSIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNSELECT_ALL_ASSIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_SELECTED_ASSIGNMENT_IDS; });
/* unused harmony export fetchStudentAssignmentsRequest */
/* unused harmony export fetchStudentAssignmentsSuccess */
/* unused harmony export fetchStudentAssignmentsFailure */
/* harmony export (immutable) */ __webpack_exports__["l"] = toggleAssignmentIds;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getStudentAssignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetAssignments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_resources__ = __webpack_require__("viEY");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var STUDENT_ASSIGNMENTS_REQUEST = 'STUDENT_ASSIGNMENTS_REQUESTED';
var STUDENT_ASSIGNMENTS_SUCCESS = 'STUDENT_ASSIGNMENTS_SUCCESS';
var STUDENT_ASSIGNMENTS_ERROR = 'STUDENT_ASSIGNMENTS_ERROR';
var RESET_STUDENT_ASSIGNMENTS = 'RESET_STUDENT_ASSIGNMENTS';
var UPDATE_SORT_DIRECTION_TO_ASC = 'UPDATE_SORT_DIRECTION_TO_ASC';
var UPDATE_SORT_DIRECTION_TO_DESC = 'UPDATE_SORT_DIRECTION_TO_DESC';
var SELECT_ALL_ASSIGNMENTS = 'SELECT_ALL_ASSIGNMENTS';
var UNSELECT_ALL_ASSIGNMENTS = 'UNSELECT_ALL_ASSIGNMENTS';
var TOGGLE_SELECTED_ASSIGNMENT_IDS = 'TOGGLE_SELECTED_ASSIGNMENT_IDS';
function fetchStudentAssignmentsRequest() {
  return {
    type: STUDENT_ASSIGNMENTS_REQUEST
  };
}
function fetchStudentAssignmentsSuccess(payload) {
  return {
    type: STUDENT_ASSIGNMENTS_SUCCESS,
    assignments: payload.assignments
  };
}
function fetchStudentAssignmentsFailure() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    type: STUDENT_ASSIGNMENTS_ERROR,
    errors: errors
  };
}
function toggleAssignmentIds(assignmentId) {
  return {
    type: TOGGLE_SELECTED_ASSIGNMENT_IDS,
    assignmentId: assignmentId
  };
}
var getStudentAssignments = function getStudentAssignments(studentProfileId, productId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            dispatch(fetchStudentAssignmentsRequest());
            _context.p = 1;
            _context.n = 2;
            return __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].assignmentsByStudent.get().withParams({
              studentProfileId: studentProfileId,
              productId: productId
            }).send();
          case 2:
            response = _context.v;
            if (response.data) {
              _context.n = 3;
              break;
            }
            throw response;
          case 3:
            dispatch(fetchStudentAssignmentsSuccess(response.data));
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            dispatch(fetchStudentAssignmentsFailure(_t));
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var resetAssignments = function resetAssignments() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch({
              type: RESET_STUDENT_ASSIGNMENTS
            });
            dispatch({
              type: UNSELECT_ALL_ASSIGNMENTS
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "6uc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StudentListItemWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var width = '259px';
var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    typography = _ThemeHelper$getTheme.typography;
  return "\n    min-width: ".concat(width, ";\n    max-width: ").concat(width, ";\n    font-family: ").concat(typography.family, ";\n    font-size: 14px;\n    left: 0;\n    background-color: white;\n    z-index: 4;\n    overflow: hidden;\n    position: -webkit-sticky;\n    position: sticky;\n    border-bottom: 15px solid transparent;\n");
});
var HeaderContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n    position: sticky;\n    top: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    border: 1px solid ".concat(colours.grey[400], ";\n    border-left: none;\n    border-top: none;\n    background-color: white;\n    height: 46px;\n    width: ").concat(width, ";\n  ");
});
var StudentListItemWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 0.01px;\n"])));

/***/ }),

/***/ "74Tg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapUnassignAssignmentHashKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateUnassignedAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSIGN_DATE_MODAL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNASSIGN_WARNING_MODAL_ID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__status_cell_helpers__ = __webpack_require__("clGU");

var mapUnassignAssignmentHashKeys = function mapUnassignAssignmentHashKeys() {
  var requestData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return requestData.map(function (_ref) {
    var learningJourneyId = _ref.learningJourneyId,
      studentUserProfileId = _ref.studentUserProfileId;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__status_cell_helpers__["d" /* getAssignmentHashKey */])(studentUserProfileId, learningJourneyId);
  });
};
var generateUnassignedAssignment = function generateUnassignedAssignment(_ref2) {
  var learningJourneyId = _ref2.learningJourneyId,
    assignmentId = _ref2.assignmentId,
    studentUserProfileId = _ref2.studentUserProfileId;
  return {
    learningJourneyId: learningJourneyId,
    assignmentId: assignmentId,
    studentUserProfileId: studentUserProfileId
  };
};
var ASSIGN_DATE_MODAL_ID = 6;
var UNASSIGN_WARNING_MODAL_ID = 7;
/* unused harmony default export */ var _unused_webpack_default_export = (mapUnassignAssignmentHashKeys);

/***/ }),

/***/ "7QyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_entities_helpers__ = __webpack_require__("QR7b");


var useCourseVersion = function useCourseVersion() {
  /**
   * Store
   */
  var selectedClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedClass;
  }, __WEBPACK_IMPORTED_MODULE_0_react_redux__["d" /* shallowEqual */]);
  var selectedCourseOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedCourseOption;
  }, __WEBPACK_IMPORTED_MODULE_0_react_redux__["d" /* shallowEqual */]);
  var genericCourses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.genericCourses;
  }, __WEBPACK_IMPORTED_MODULE_0_react_redux__["d" /* shallowEqual */]);
  var lockedCourseVersions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.lockedCourseVersions;
  });

  /**
   * Local variables
   */
  var _ref = genericCourses || {},
    genericCourseId = _ref.id,
    genericCourseVersion = _ref.version;
  var _ref2 = selectedClass || {},
    classroomId = _ref2.value;
  var _ref3 = selectedCourseOption || {},
    courseId = _ref3.value;
  var courseVersion = genericCourseId === Number(courseId) ? genericCourseVersion : null;
  var lockedCourseVersionHashKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__containers_entities_helpers__["b" /* getClassroomCourseVersionHashKey */])({
    classroomId: classroomId,
    courseId: courseId
  });
  var lockedCourseVersion = lockedCourseVersions[lockedCourseVersionHashKey];
  var selectedCourseVersion = (lockedCourseVersion === null || lockedCourseVersion === void 0 ? void 0 : lockedCourseVersion.version) || courseVersion;
  return {
    selectedClassroomId: classroomId,
    selectedCourseId: courseId,
    selectedCourseVersion: selectedCourseVersion
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useCourseVersion);

/***/ }),

/***/ "7j7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_context_modal__ = __webpack_require__("OmdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_hooks_use_course_version__ = __webpack_require__("7QyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_locale__ = __webpack_require__("ZhO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_gateways_gateways_actions__ = __webpack_require__("i4yT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__standard_info__ = __webpack_require__("LBir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__need_help__ = __webpack_require__("RzZa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__upf_assign_preview_modal_upf_assign_preview_modal__ = __webpack_require__("C6s9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors__ = __webpack_require__("mO2z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers__ = __webpack_require__("zNkj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__translations__ = __webpack_require__("OD1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__help_icon__ = __webpack_require__("2HYC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styled__ = __webpack_require__("EemT");
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }




















var LearningJourney = function LearningJourney(props) {
  var learningJourneyId = props.learningJourneyId;

  /**
   * Store
   */
  var learningJourneys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.learningJourneys;
  });
  var standards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.standards;
  });
  var productId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.product.id;
  });
  var needAttentionStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__selectors__["a" /* filterNeedAttentionStudentsSelector */])(learningJourneyId));

  /**
   * Local variables
   */
  var _ref = learningJourneys[learningJourneyId] || {},
    learningJourneyName = _ref.name,
    externalKey = _ref.externalKey,
    description = _ref.description,
    _ref$childTopics = _ref.childTopics,
    learningJourneyStepIds = _ref$childTopics === void 0 ? [] : _ref$childTopics,
    standardId = _ref.standardId;
  var _ref2 = standards[standardId] || {},
    standardName = _ref2.name;
  var needAttentionStudentsCount = needAttentionStudents.length;

  /**
   * Hooks
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _useContextModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_context_modal__["a" /* default */])(),
    showContextModal = _useContextModal.showContextModal,
    closeContextMenu = _useContextModal.closeContextMenu,
    targetRef = _useContextModal.targetRef,
    contentModalProps = _useContextModal.contentModalProps;
  var _useContextModal2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_context_modal__["a" /* default */])({
      defaultTargetRef: targetRef
    }),
    showNameContextModal = _useContextModal2.showContextModal,
    closeNameContextMenu = _useContextModal2.closeContextMenu,
    nameContentModalProps = _useContextModal2.contentModalProps;
  var _useCourseVersion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_hooks_use_course_version__["a" /* default */])(),
    selectedCourseId = _useCourseVersion.selectedCourseId,
    selectedCourseVersion = _useCourseVersion.selectedCourseVersion;

  /**
   * Translations
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__translations__["a" /* default */])({
      i18n: i18n
    }),
    PREVIEW_TEXT = _getTranslations.PREVIEW_TEXT,
    DEFAULT_PREVIEW_ERROR_TEXT = _getTranslations.DEFAULT_PREVIEW_ERROR_TEXT;

  /**
   * Functions
   */
  var viewDemo = function viewDemo(assignmentId) {
    var assignmentPreviewUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers__["a" /* getAssignmentPreviewUrl */])(assignmentId);
    window.open(assignmentPreviewUrl, '_blank');
  };
  var handlePreview = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var responseData, errorMessage, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__upf_assign_preview_modal_upf_assign_preview_modal__["a" /* createAssignModal */])(null, i18n, function () {
              return {};
            }, true)));
            _context.p = 1;
            _context.n = 2;
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_gateways_gateways_actions__["f" /* postPreviewAssignment */])({
              productId: productId,
              courseId: selectedCourseId,
              courseVersion: selectedCourseVersion,
              locale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_locale__["a" /* getLocale */])(),
              learningJourneyId: learningJourneyId
            }));
          case 2:
            responseData = _context.v;
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["c" /* dismissModal */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__upf_assign_preview_modal_upf_assign_preview_modal__["a" /* createAssignModal */])(responseData, i18n, function () {
              return viewDemo(responseData.assignmentId);
            }, false)));
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            errorMessage = _t.message || DEFAULT_PREVIEW_ERROR_TEXT;
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["c" /* dismissModal */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__upf_assign_preview_modal_upf_assign_preview_modal__["a" /* createAssignModal */])(null, i18n, function () {
              return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__toast_toast_action__["c" /* showToast */])(errorMessage, 'error'));
            }, false, errorMessage)));
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handlePreview() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styled__["a" /* Root */], {
    "data-testid": "learning-journey",
    ref: targetRef,
    onClick: showContextModal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__help_icon__["a" /* default */], {
    needAttentionStudentsCount: needAttentionStudentsCount
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styled__["b" /* Name */], {
    "data-testid": "learning-journey-name",
    onMouseEnter: showNameContextModal,
    onMouseLeave: closeNameContextMenu
  }, learningJourneyName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: closeContextMenu,
    forButton: "showContextModal_".concat(learningJourneyId)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__context_modal__["b" /* default */], contentModalProps, needAttentionStudentsCount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__need_help__["a" /* default */], {
    i18n: i18n,
    helpSeekingStudents: needAttentionStudents
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styled__["c" /* Preview */], {
    role: "button",
    tabIndex: "-1",
    onClick: handlePreview
  }, PREVIEW_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__standard_info__["a" /* default */], {
    count: learningJourneyStepIds.length,
    description: description,
    displayHideOption: false,
    externalKey: externalKey,
    i18n: i18n,
    ljName: learningJourneyName,
    standardName: standardName
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__context_modal__["b" /* default */], _extends({}, nameContentModalProps, {
    name: learningJourneyName,
    contextTheme: "learningJourney"
  }))));
};
LearningJourney.propTypes = {
  learningJourneyId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LearningJourney);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "8Qrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STUDENTS_ASSIGNMENTS_STATUSES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ASSIGN_ASSIGNMENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ASSIGN_ASSIGNMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNASSIGN_ASSIGNMENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UNASSIGN_ASSIGNMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PREVIEW_ASSIGNMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PREVIEW_ASSIGNMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLASSROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLASSROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ERROR_DETECTED; });
/*
 * Action Types
 */

var PREFIX = 'GATEWAYS';
var STUDENTS_ASSIGNMENTS_STATUSES_REQUEST = "".concat(PREFIX, "/STUDENTS_ASSIGNMENTS_STATUSES_REQUEST");
var STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS = "".concat(PREFIX, "/STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS");
var ASSIGN_ASSIGNMENTS_REQUEST = "".concat(PREFIX, "/ASSIGN_ASSIGNMENTS_REQUEST");
var ASSIGN_ASSIGNMENTS_SUCCESS = "".concat(PREFIX, "/ASSIGN_ASSIGNMENTS_SUCCESS");
var UNASSIGN_ASSIGNMENTS_REQUEST = "".concat(PREFIX, "/UNASSIGN_ASSIGNMENTS_REQUEST");
var UNASSIGN_ASSIGNMENTS_SUCCESS = "".concat(PREFIX, "/UNASSIGN_ASSIGNMENTS_SUCCESS");
var PREVIEW_ASSIGNMENT_REQUEST = "".concat(PREFIX, "/PREVIEW_ASSIGNMENT_REQUEST");
var PREVIEW_ASSIGNMENT_SUCCESS = "".concat(PREFIX, "/PREVIEW_ASSIGNMENT_SUCCESS");
var CLASSROOMS_REQUEST = "".concat(PREFIX, "/CLASSROOMS_REQUEST");
var CLASSROOMS_SUCCESS = "".concat(PREFIX, "/CLASSROOMS_SUCCESS");
var ERROR_DETECTED = "".concat(PREFIX, "/ERROR_DETECTED");

/***/ }),

/***/ "8Y5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_util__ = __webpack_require__("++6F");



var useLearningJourneys = function useLearningJourneys(standardName, options) {
  var getLearningJourneyIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function (state) {
    return state.UPFAssignReducer.selectedTopics;
  }, function (topics) {
    var ljs = [];
    if (topics !== null && topics !== void 0 && topics.length) {
      if (standardName) {
        var _topics$find;
        ljs = (_topics$find = topics.find(function (topic) {
          return (topic === null || topic === void 0 ? void 0 : topic.selected) && (topic === null || topic === void 0 ? void 0 : topic.childTopics.find(function (childTopic) {
            return childTopic.name === standardName;
          }));
        })) === null || _topics$find === void 0 ? void 0 : _topics$find.childTopics;
      } else {
        ljs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_util__["f" /* getAllLearningJourneys */])(topics);
      }
      if (options !== null && options !== void 0 && options.id) {
        var _ljs, _ljs$find;
        return (_ljs = ljs) !== null && _ljs !== void 0 && _ljs.length ? (_ljs$find = ljs.find(function (lj) {
          return lj.name === standardName;
        })) === null || _ljs$find === void 0 ? void 0 : _ljs$find.childTopics.map(function (lj) {
          return lj.id;
        }) : [];
      }
    }
    return ljs;
  });
  var learningJourneys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(getLearningJourneyIds, __WEBPACK_IMPORTED_MODULE_0_react_redux__["d" /* shallowEqual */]);
  return learningJourneys || [];
};
/* harmony default export */ __webpack_exports__["a"] = (useLearningJourneys);

/***/ }),

/***/ "8qms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAssignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStudents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSortedStudentIds; });
var getAssignments = function getAssignments(state) {
  return state.entitiesReducer.assignments;
};
var getStudents = function getStudents(state) {
  return state.entitiesReducer.students;
};
var getSortedStudentIds = function getSortedStudentIds(state) {
  return state.UPFAssignReducer.sortedStudentIds;
};

/***/ }),

/***/ "8wgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return truncateStringEllipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findStudentFullName; });
var truncateStringEllipsis = function truncateStringEllipsis() {
  var stringValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var stringLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return stringValue.length > stringLength ? "".concat(stringValue.substr(0, stringLength), "...") : stringValue;
};
var findStudentFullName = function findStudentFullName(student) {
  if (!student) return '';
  return "".concat(student.lastName, ", ").concat(student.firstName);
};

/***/ }),

/***/ "9mrv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__use_assignment_result_type__ = __webpack_require__("2yLB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__use_course_version__ = __webpack_require__("7QyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_footer_helpers__ = __webpack_require__("74Tg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_entities_constants__ = __webpack_require__("ezD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_entities_entities_reducer__ = __webpack_require__("0dbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_gateways_gateways_actions__ = __webpack_require__("i4yT");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }










var getTranslations = function getTranslations(_ref) {
  var i18n = _ref.i18n;
  return {
    UNASSIGN_SUCCESS_TEXT: i18n._("Student Quests have been unassigned"),
    ASSIGN_SUCCESS_TEXT: i18n._("Student activity assignments have been successfully updated"),
    REASSIGN_SUCCESS_TEXT: i18n._("Activity reassignment successful")
  };
};
var useManageAssignments = function useManageAssignments() {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _useAssignmentResultT = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__use_assignment_result_type__["a" /* default */])(),
    assignmentResultType = _useAssignmentResultT.assignmentResultType;
  var selectedProduct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.product;
  }, __WEBPACK_IMPORTED_MODULE_0_react__["shallowEqual"]);
  var _useCourseVersion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__use_course_version__["a" /* default */])(),
    selectedClassroomId = _useCourseVersion.selectedClassroomId,
    selectedCourseId = _useCourseVersion.selectedCourseId,
    selectedCourseVersion = _useCourseVersion.selectedCourseVersion;
  var getAssignmentData = {
    assignmentResultType: assignmentResultType,
    classId: selectedClassroomId,
    courseId: selectedCourseId,
    courseVersion: selectedCourseVersion,
    productId: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id
  };
  var _getTranslations = getTranslations({
      i18n: i18n
    }),
    UNASSIGN_SUCCESS_TEXT = _getTranslations.UNASSIGN_SUCCESS_TEXT,
    ASSIGN_SUCCESS_TEXT = _getTranslations.ASSIGN_SUCCESS_TEXT,
    REASSIGN_SUCCESS_TEXT = _getTranslations.REASSIGN_SUCCESS_TEXT;
  var unassignAssignments = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(assignmentsToUnAssign) {
      var successToastText,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            successToastText = _args.length > 1 && _args[1] !== undefined ? _args[1] : UNASSIGN_SUCCESS_TEXT;
            _context.n = 1;
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_gateways_gateways_actions__["a" /* deleteUnAssignAssignments */])(assignmentsToUnAssign)).then(function () {
              var deleteAssignmentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_footer_helpers__["b" /* mapUnassignAssignmentHashKeys */])(assignmentsToUnAssign);
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_entities_entities_reducer__["b" /* deleteEntityItems */])({
                entityName: __WEBPACK_IMPORTED_MODULE_7__containers_entities_constants__["a" /* ENTITY_NAMES */].ASSIGNMENTS,
                itemIds: deleteAssignmentIds
              }));
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_gateways_gateways_actions__["b" /* getAssignments */])(getAssignmentData));
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_toast_toast_action__["c" /* showToast */])(successToastText, 'success'));
            })["catch"](function () {
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_toast_toast_action__["c" /* showToast */])(i18n._("Unable to unassign selected student assignments"), 'error'));
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function unassignAssignments(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var assignAssignments = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3) {
      var studentAssignments, _ref3$isReassignment, isReassignment, _ref3$startDate, startDate, _ref3$dueDate, dueDate, assignmentsToAssign;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            studentAssignments = _ref3.studentAssignments, _ref3$isReassignment = _ref3.isReassignment, isReassignment = _ref3$isReassignment === void 0 ? false : _ref3$isReassignment, _ref3$startDate = _ref3.startDate, startDate = _ref3$startDate === void 0 ? null : _ref3$startDate, _ref3$dueDate = _ref3.dueDate, dueDate = _ref3$dueDate === void 0 ? null : _ref3$dueDate;
            assignmentsToAssign = {
              studentAssignments: studentAssignments,
              productId: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id,
              courseId: selectedCourseId,
              courseVersion: selectedCourseVersion,
              classroomId: selectedClassroomId
            };
            if (startDate && dueDate) {
              assignmentsToAssign = _objectSpread(_objectSpread({}, assignmentsToAssign), {}, {
                startDate: startDate,
                dueDate: dueDate
              });
            }
            _context2.n = 1;
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_gateways_gateways_actions__["c" /* postAssignAssignments */])(assignmentsToAssign)).then(function () {
              if (isReassignment) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_toast_toast_action__["c" /* showToast */])(REASSIGN_SUCCESS_TEXT, 'success'));
              } else {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_toast_toast_action__["c" /* showToast */])(ASSIGN_SUCCESS_TEXT, 'success'));
              }
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_gateways_gateways_actions__["b" /* getAssignments */])(getAssignmentData));
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function assignAssignments(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  return {
    unassignAssignments: unassignAssignments,
    assignAssignments: assignAssignments
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useManageAssignments);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "ATr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translations__ = __webpack_require__("jnaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__("8wgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("Ucei");








var ContextModalContent = function ContextModalContent(props) {
  var classroomName = props.classroomName,
    groupName = props.groupName,
    i18n = props.i18n,
    onClickCurrentAssignmentModalCallback = props.onClickCurrentAssignmentModalCallback,
    onClickStudentCallback = props.onClickStudentCallback,
    studentFullName = props.studentFullName;

  /**
   * Translations
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__translations__["a" /* default */])({
      i18n: i18n
    }),
    CLASS_TEXT = _getTranslations.CLASS_TEXT,
    SELECT_STUDENT_TEXT = _getTranslations.SELECT_STUDENT_TEXT,
    GROUP_TEXT = _getTranslations.GROUP_TEXT,
    CURRENT_ASSIGNMENTS_TEXT = _getTranslations.CURRENT_ASSIGNMENTS_TEXT;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "data-testid": "student-context-modal-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* List */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["b" /* ListItemTitle */], null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* truncateStringEllipsis */])(studentFullName, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["j" /* MAX_STUDENT_NAME_LENGTH_CONTEXT */])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ListItem */], null, "".concat(CLASS_TEXT, ": ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* truncateStringEllipsis */])(classroomName, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["k" /* MAX_STUDENT_GRADE_LENGTH */]))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ListItem */], null, "".concat(GROUP_TEXT, ": ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* truncateStringEllipsis */])(groupName, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["k" /* MAX_STUDENT_GRADE_LENGTH */])))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* List */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["d" /* Link */], {
    "data-testid": "student-context-modal-select-student",
    onClick: onClickStudentCallback
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["e" /* Icon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["F" /* SelectStudentIcon */]
  })), SELECT_STUDENT_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["d" /* Link */], {
    "data-testid": "student-context-modal-select-current-assignment",
    onClick: onClickCurrentAssignmentModalCallback
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["e" /* Icon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["A" /* AllAssigned */]
  })), CURRENT_ASSIGNMENTS_TEXT)));
};
ContextModalContent.propTypes = {
  classroomName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  groupName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickCurrentAssignmentModalCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClickStudentCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  studentFullName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContextModalContent);

/***/ }),

/***/ "AgQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_manager_actions__ = __webpack_require__("WnpN");


function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__modal_manager_actions__["a" /* ACTIVATE_MODAL */]:
      {
        var newState = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(state);
        newState.push(action.modal);
        return newState;
      }
    case __WEBPACK_IMPORTED_MODULE_1__modal_manager_actions__["b" /* DISMISS_MODAL */]:
      {
        var _newState = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(state);
        _newState.pop();
        return _newState;
      }
    default:
      break;
  }
  return state;
}

/***/ }),

/***/ "Avnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    CURRICULUM_TEXT: i18n._("Curriculum"),
    COURSE_TEXT: i18n._("Grade/Course"),
    PDF_TEXT: i18n._(
    /*i18n*/
    {
      id: "CourseFilters.pdf",
      defaults: "Curriculum Alignment PDF available"
    })
  };
});

/***/ }),

/***/ "B7He":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("awYd");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./entry-app.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./entry-app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "C6s9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAssignModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("FWAL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_utils__ = __webpack_require__("6QRH");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }









function UpfAssignModal(_ref) {
  var previewInfo = _ref.previewInfo,
    i18n = _ref.i18n,
    viewDemo = _ref.viewDemo,
    isLoading = _ref.isLoading,
    previewError = _ref.previewError;
  if (isLoading) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
  if (previewError) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, previewError);
  var baseUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["b" /* getConfiguration */])('UPFBaseUrl');
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
    _useState2 = _slicedToArray(_useState, 2),
    activeClass = _useState2[0],
    setActiveClass = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPreviewCallout = _useState4[0],
    setPreviewCallout = _useState4[1];
  var gems = [];
  var stepsIntialAndIncrement = 1;
  var _ref2 = previewInfo || {},
    _ref2$learningJourney = _ref2.learningJourneyName,
    learningJourneyName = _ref2$learningJourney === void 0 ? '' : _ref2$learningJourney,
    _ref2$standardCode = _ref2.standardCode,
    standardCode = _ref2$standardCode === void 0 ? '' : _ref2$standardCode,
    _ref2$standardDescrip = _ref2.standardDescription,
    standardDescription = _ref2$standardDescrip === void 0 ? '' : _ref2$standardDescrip,
    _ref2$standardName = _ref2.standardName,
    standardName = _ref2$standardName === void 0 ? '' : _ref2$standardName,
    _ref2$steps = _ref2.steps,
    steps = _ref2$steps === void 0 ? [] : _ref2$steps;
  var _ref3 = steps && steps[activeClass - 1] && steps[activeClass - 1].spines && steps[activeClass - 1].spines[0] || {},
    _ref3$spineName = _ref3.spineName,
    spineName = _ref3$spineName === void 0 ? '' : _ref3$spineName,
    _ref3$subNodeNames = _ref3.subNodeNames,
    subNodeNames = _ref3$subNodeNames === void 0 ? [] : _ref3$subNodeNames;
  // eslint-disable-next-line max-len
  var iframeSrc = "".concat(baseUrl.replace('?', ''), "qtc-preview?authToken=").concat(__WEBPACK_IMPORTED_MODULE_7__helpers_resources__["a" /* default */].env.authToken, "&locale=").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["e" /* getQueryParam */])('locale') || 'en-AU', "&girlId=").concat(steps[activeClass - 1].spines[0].exampleGirlId) || '';
  var _loop = function _loop(count) {
    var stepIcon = null;
    switch (count) {
      case 1:
        stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["q" /* Gem1 */];
        break;
      case 2:
        stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["r" /* Gem2 */];
        break;
      case 3:
        stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["s" /* Gem3 */];
        break;
      case 4:
        stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["t" /* Gem4 */];
        break;
      case 5:
        stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["u" /* Gem5 */];
        break;
      default:
        break;
    }
    gems.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      className: activeClass === count ? 'active' : '',
      onClick: function onClick() {
        return setActiveClass(count);
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
      icon: stepIcon
    })));
  };
  for (var count = stepsIntialAndIncrement; count <= steps.length; count += stepsIntialAndIncrement) {
    _loop(count);
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* ModalBody */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title"
  }, learningJourneyName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Tabs */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "subTitle"
  }, i18n._("STEP")), gems), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    className: "previewButton",
    icon: __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["v" /* PreviewInfoIcon */],
    onClick: function onClick() {
      return setPreviewCallout(true);
    },
    primary: true,
    text: i18n._("Whats's this"),
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setPreviewCallout(false);
    },
    forButton: "previewButton"
  }, showPreviewCallout && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "whatsThisCallout"
  }, i18n._("The activity name displayed top-left is  the name of the Skill Quest. Each Skill Quest has a number of steps (referred to as Levels in the student view)."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), i18n._("Click on the Step tabs to view the types of questions for each step.  To see the interactive student view of the Step you are viewing,  click on the \"View demo in new tab\" button."))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Content */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* Description */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    onClick: viewDemo,
    role: "button",
    tabIndex: "0",
    className: "demo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    className: "previewButton",
    icon: __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["w" /* PreviewDemoIcon */],
    onClick: function onClick() {},
    primary: true,
    text: i18n._("View demo in new tab"),
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "stepDetails"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "heading"
  }, i18n._("Step {activeClass} Covers:", {
    activeClass: activeClass
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subHeading"
  }, spineName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "list"
  }, subNodeNames && subNodeNames.map(function (node) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, node);
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "descriptions"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "heading"
  }, i18n._("Activity Description")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subHeading"
  }, standardName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subHeading"
  }, standardCode ? "".concat(standardCode, ": ") : '', standardDescription), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subHeading"
  }, learningJourneyName))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["e" /* Questions */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", {
    src: iframeSrc,
    title: "UPF single question example",
    width: "100%",
    height: "100%",
    frameBorder: "0",
    allowFullScreen: true,
    sandbox: "allow-scripts allow-same-origin"
  }))));
}
function createAssignModal(previewInfo, i18n, viewDemo, isLoading, previewError) {
  return {
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpfAssignModal, {
      previewInfo: previewInfo,
      i18n: i18n,
      viewDemo: viewDemo,
      isLoading: isLoading,
      previewError: previewError
    }),
    id: 0,
    buttons: []
  };
}
UpfAssignModal.propTypes = {
  previewInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  viewDemo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previewError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* unused harmony default export */ var _unused_webpack_default_export = (UpfAssignModal);

/***/ }),

/***/ "CQXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SummaryRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Count; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 77px;\n  width: 223px;\n  background-color: #F8FBFC;\n  border-radius: 8px;\n  padding: 8px 16px;\n  color: #515C66;\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 15px;\n\n"])));
var SummaryRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  gap: 13px;\n  line-height: 25px;\n  letter-spacing: -0.2px;\n"])));
var Count = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: #515C66;\n  font-weight: 600;\n"])));

/***/ }),

/***/ "CWg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// https://www.py4u.net/discuss/322092

var preserveQueryParameters = function preserveQueryParameters(history, preserve, location) {
  var currentQuery = __WEBPACK_IMPORTED_MODULE_0_query_string__["parse"](history.location.search);
  if (currentQuery) {
    var preservedQuery = {};
    var _iterator = _createForOfIteratorHelper(preserve),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var p = _step.value;
        var currentValue = currentQuery[p];
        if (currentValue) {
          preservedQuery[p] = currentValue;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (location.search) {
      _extends(preservedQuery, __WEBPACK_IMPORTED_MODULE_0_query_string__["parse"](location.search));
    }
    location.search = __WEBPACK_IMPORTED_MODULE_0_query_string__["stringify"](preservedQuery);
  }
  return location;
};
var createLocationDescriptorObject = function createLocationDescriptorObject(location, state) {
  return typeof location === 'string' ? {
    pathname: location,
    state: state
  } : location;
};
var createPreserveQueryHistory = function createPreserveQueryHistory(createHistory, queryParameters) {
  return function (options) {
    var history = createHistory(options);
    var oldPush = history.push;
    var oldReplace = history.replace;
    history.push = function (path, state) {
      return oldPush.apply(history, [preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))]);
    };
    history.replace = function (path, state) {
      return oldReplace.apply(history, [preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))]);
    };
    return history;
  };
};
/* harmony default export */ __webpack_exports__["a"] = (createPreserveQueryHistory);

/***/ }),

/***/ "D4qU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    DUE_DATE_INFO: i18n._("Assignment Modal - Due date info")
  };
});

/***/ }),

/***/ "DTWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_context_modal__ = __webpack_require__("OmdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__current_assignment_modal__ = __webpack_require__("Za/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers__ = __webpack_require__("8wgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__context_modal_content__ = __webpack_require__("ATr5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled__ = __webpack_require__("Vz/w");
















var StudentListItem = function StudentListItem(props) {
  var studentId = props.studentId,
    i18n = props.i18n;

  /**
   * Store
   */
  var students = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.students;
  });
  var groups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.groups;
  });
  var classrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.classrooms;
  });
  var selectedLearningJourneyIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedLearningJourneyIds;
  });
  var selectedAssignmentHashKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedAssignmentHashKeys;
  });

  /**
   * Hooks
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var _useContextModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_context_modal__["a" /* default */])({
      leftAlign: true
    }),
    targetRef = _useContextModal.targetRef,
    contentModalProps = _useContextModal.contentModalProps,
    closeContextMenu = _useContextModal.closeContextMenu,
    showContextModal = _useContextModal.showContextModal;

  /**
   * Local variables
   */
  var student = students[studentId] || {};
  var group = groups[student.groupId] || {};
  var classroom = classrooms[group === null || group === void 0 ? void 0 : group.classroomId] || {};
  var _student$incompleteAs = student.incompleteAssignmentsCount,
    incompleteAssignmentsCount = _student$incompleteAs === void 0 ? 0 : _student$incompleteAs,
    _student$studentUnava = student.studentUnavailableOverdueAssignmentsCount,
    studentUnavailableOverdueAssignmentsCount = _student$studentUnava === void 0 ? 0 : _student$studentUnava;
  var groupName = group.name;
  var classroomName = classroom.name;
  var studentFullName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers__["a" /* findStudentFullName */])(student);
  var studentAssignmentHashKeys = selectedLearningJourneyIds.map(function (learningJourneyId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__status_cell_helpers__["d" /* getAssignmentHashKey */])(studentId, learningJourneyId);
  });

  /**
   * Functions
   */
  var handleOnClick = function handleOnClick(checkboxState) {
    var isSelected = checkboxState === __WEBPACK_IMPORTED_MODULE_9__checkbox_constants__["a" /* CHECKED */];
    var assignmentHashKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__status_cell_helpers__["k" /* buildAssignmentHashKeys */])({
      studentIds: [studentId],
      learningJourneyIds: selectedLearningJourneyIds
    });
    closeContextMenu();
    if (isSelected) return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["f" /* selectAssignmentHashKeys */])(assignmentHashKeys));
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["g" /* unselectAssignmentHashKeys */])(assignmentHashKeys));
  };
  var getState = function getState() {
    var selectedAssignmentCount = studentAssignmentHashKeys.filter(function (assignmentHashKey) {
      return !!selectedAssignmentHashKeys[assignmentHashKey];
    }).length;
    var studentAssignmentCount = studentAssignmentHashKeys.length;
    if (selectedAssignmentCount === 0) return __WEBPACK_IMPORTED_MODULE_9__checkbox_constants__["b" /* UNCHECKED */];
    if (selectedAssignmentCount === studentAssignmentCount) return __WEBPACK_IMPORTED_MODULE_9__checkbox_constants__["a" /* CHECKED */];
    if (selectedAssignmentCount < studentAssignmentCount) return __WEBPACK_IMPORTED_MODULE_9__checkbox_constants__["c" /* INDETERMINATE */];
    return __WEBPACK_IMPORTED_MODULE_9__checkbox_constants__["b" /* UNCHECKED */];
  };
  var assignmentCount = incompleteAssignmentsCount - studentUnavailableOverdueAssignmentsCount;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["b" /* StudentItem */], {
    "data-testid": "student-item",
    ref: targetRef,
    onClick: showContextModal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers__["b" /* truncateStringEllipsis */])(studentFullName, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["i" /* MAX_STUDENT_NAME_LENGTH */])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["c" /* AssignmentCountText */], null, assignmentCount)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["d" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__checkbox__["a" /* default */], {
    checkboxHandler: handleOnClick,
    state: getState()
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: closeContextMenu,
    forButton: "studentItem_".concat(studentId)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__context_modal__["b" /* default */], contentModalProps, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__context_modal_content__["a" /* default */], {
    classroomName: classroomName,
    groupName: groupName,
    i18n: i18n,
    onClickCurrentAssignmentModalCallback: function onClickCurrentAssignmentModalCallback() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__current_assignment_modal__["a" /* viewCurrentAssignmentsModal */])(student, {
        label: classroomName
      })));
    },
    onClickStudentCallback: function onClickStudentCallback() {
      return handleOnClick(__WEBPACK_IMPORTED_MODULE_9__checkbox_constants__["a" /* CHECKED */]);
    },
    studentFullName: studentFullName
  }))));
};
StudentListItem.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  studentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (StudentListItem);

/***/ }),

/***/ "ETRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var useFetchResource = function useFetchResource(_ref) {
  var resourceCallback = _ref.resourceCallback,
    _ref$isReady = _ref.isReady,
    isReady = _ref$isReady === void 0 ? false : _ref$isReady;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
    _useState8 = _slicedToArray(_useState7, 2),
    errors = _useState8[0],
    setErrors = _useState8[1];
  var fetchResource = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _yield$resourceCallba, fetchData;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsLoading(true);
            _context.n = 1;
            return resourceCallback();
          case 1:
            _yield$resourceCallba = _context.v;
            fetchData = _yield$resourceCallba.data;
            if (fetchData) {
              _context.n = 2;
              break;
            }
            return _context.a(2, setErrors('Fetch Failed'));
          case 2:
            setIsLoading(false);
            setIsLoaded(true);
            return _context.a(2, setData(fetchData));
        }
      }, _callee);
    }));
    return function fetchResource() {
      return _ref2.apply(this, arguments);
    };
  }();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (resourceCallback && !errors && !isLoading && !isLoaded && isReady) {
      fetchResource();
    }
  }, [isReady]);
  return {
    isLoaded: isLoaded,
    data: data,
    errors: errors
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useFetchResource);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "EVvD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---15KyJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  width: calc(100% - 25px);\n  height: calc(100% - 142px);\n  border: 1px solid #cfd2d4; }\n\n.psr---1toIF {\n  width: 100%; }\n\n.standards---2GP-s {\n  width: 100%; }\n\n.studentGridContainer---1OLxf {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100% - 240px);\n  width: calc(100% - 17px);\n  overflow-y: auto;\n  overflow-x: auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 1px solid #cfd2d4;\n  border-top: none; }\n\n.fitContentContainer---MqQ6P {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content; }\n\n.footer---2K-Y_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  padding-right: 10px;\n  z-index: 9; }\n\n.confirmFooter---2Vuug {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: absolute;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 99%;\n  height: 51px;\n  padding-right: 10px;\n  background-color: #cfd2d4;\n  z-index: 9999; }\n\n.leftSection---1JgCv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 259px; }\n\n.rightSection---2yWDH {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: scroll;\n  width: calc(100% - 260px); }\n\n.gridContainer---3-T8K {\n  height: auto;\n  min-height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0; }\n\n.filterBar---GrGhn {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: auto;\n  width: 100%; }\n\n.filterBar---GrGhn .search---3-4Od {\n    width: 525px; }\n\n@media screen and (max-width: 1220px) {\n    .filterBar---GrGhn {\n      margin-bottom: 5px; } }\n\n.filterModalStyle > div {\n  width: 500px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---15KyJ",
	"psr": "psr---1toIF",
	"standards": "standards---2GP-s",
	"studentGridContainer": "studentGridContainer---1OLxf",
	"fitContentContainer": "fitContentContainer---MqQ6P",
	"footer": "footer---2K-Y_",
	"confirmFooter": "confirmFooter---2Vuug",
	"leftSection": "leftSection---1JgCv",
	"rightSection": "rightSection---2yWDH",
	"gridContainer": "gridContainer---3-T8K",
	"filterBar": "filterBar---GrGhn",
	"search": "search---3-4Od"
};

/***/ }),

/***/ "EcDV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__ = __webpack_require__("Q0m1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_use_quick_selector__ = __webpack_require__("ZKG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("wL8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translations__ = __webpack_require__("OJ4i");









var ProgressModalContent = function ProgressModalContent(props) {
  var closeContextMenu = props.closeContextMenu;

  /**
   * Hooks
   */
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _useQuickSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks_use_quick_selector__["a" /* default */])({
      closeContextMenu: closeContextMenu
    }),
    cleanAssignmentHashKeys = _useQuickSelector.cleanAssignmentHashKeys,
    selectProgressPercentageBetween = _useQuickSelector.selectProgressPercentageBetween,
    selectAllAssignments = _useQuickSelector.selectAllAssignments,
    selectCurrentAssigned = _useQuickSelector.selectCurrentAssigned;

  /**
   * Translations
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__translations__["a" /* default */])({
      i18n: i18n
    }),
    SELECT_TEXT = _getTranslations.SELECT_TEXT,
    ALL_CELLS_TEXT = _getTranslations.ALL_CELLS_TEXT,
    ALL_CURRENTLY_ASSIGN_TEXT = _getTranslations.ALL_CURRENTLY_ASSIGN_TEXT,
    PROGRESS_1_TO_20_TEXT = _getTranslations.PROGRESS_1_TO_20_TEXT,
    PROGRESS_21_TO_40_TEXT = _getTranslations.PROGRESS_21_TO_40_TEXT,
    PROGRESS_41_TO_60_TEXT = _getTranslations.PROGRESS_41_TO_60_TEXT,
    PROGRESS_61_TO_80_TEXT = _getTranslations.PROGRESS_61_TO_80_TEXT,
    PROGRESS_81_TO_100_TEXT = _getTranslations.PROGRESS_81_TO_100_TEXT,
    CLEAN_SELECTION_TEXT = _getTranslations.CLEAN_SELECTION_TEXT;

  // eslint-disable-next-line react/prop-types
  var renderModalContentRow = function renderModalContentRow(_ref) {
    var dataTestId = _ref.dataTestId,
      onClickHandler = _ref.onClickHandler,
      color = _ref.color,
      text = _ref.text;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
      "data-testid": dataTestId,
      onClick: onClickHandler,
      role: "button",
      tabIndex: "-1"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["d" /* ColorBlock */], {
      bgColor: color
    }), text);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["e" /* ModalContentHeader */], null, SELECT_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
    "data-testid": "select-all",
    onClick: selectAllAssignments,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["f" /* AllCellsIcon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["m" /* Select */]
  })), ALL_CELLS_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
    role: "button",
    tabIndex: "-1",
    onClick: selectCurrentAssigned
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["d" /* ColorBlock */], {
    "data-testid": "select-current-assigned",
    bgColor: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["c" /* ProgressColors */].currentlyAssigned
  }), ALL_CURRENTLY_ASSIGN_TEXT), renderModalContentRow({
    dataTestId: 'select-progress-1-to-20',
    onClickHandler: function onClickHandler() {
      return selectProgressPercentageBetween(1, 20);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed1to20["default"],
    text: PROGRESS_1_TO_20_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-progress-21-to-40',
    onClickHandler: function onClickHandler() {
      return selectProgressPercentageBetween(21, 40);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed21to40["default"],
    text: PROGRESS_21_TO_40_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-progress-41-to-60',
    onClickHandler: function onClickHandler() {
      return selectProgressPercentageBetween(41, 60);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed41to60["default"],
    text: PROGRESS_41_TO_60_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-progress-61-to-80',
    onClickHandler: function onClickHandler() {
      return selectProgressPercentageBetween(61, 80);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed61to80["default"],
    text: PROGRESS_61_TO_80_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-progress-81-to-100',
    onClickHandler: function onClickHandler() {
      return selectProgressPercentageBetween(81, 100);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed81to100["default"],
    text: PROGRESS_81_TO_100_TEXT
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
    "data-testid": "select-clean-cells",
    onClick: cleanAssignmentHashKeys,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["f" /* AllCellsIcon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["H" /* Cross */]
  })), CLEAN_SELECTION_TEXT));
};
ProgressModalContent.propTypes = {
  closeContextMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ProgressModalContent);

/***/ }),

/***/ "EemT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Preview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");


var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    position: relative;\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n    background-color: #eaf9f9;\n    border-right: 1px solid ".concat(colours.grey[400], ";\n    height: 100%;\n    min-width: 53px;\n    max-width: 53px;\n    cursor: pointer;\n  ");
});
var Name = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme2.palette;
  return "\n    box-sizing: border-box;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    padding-left: 7px;\n    padding-right: 5px;\n    height: 52px;\n    width: 128px;\n    margin: 38px -45px;\n    font-size: 12px;\n    color: ".concat(palette.primary.dark, ";\n\n    transform: rotate(-90deg);\n    transform-origin: (0,0);\n    overflow: hidden;\n");
});
var Preview = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours,
    palette = _ThemeHelper$getTheme3.palette;
  return "\n    display: flex;\n    align-items: center;\n\n    cursor: pointer;\n    width: 100%;\n    height: 30px;\n    padding-left: 10px;\n    color: ".concat(palette.primary.dark, ";\n    border-bottom: 1px solid ").concat(colours.grey[400], ";\n\n    &:hover {\n      color: ").concat(palette.secondary.dark, ";\n    } \n  ");
});

/***/ }),

/***/ "EgB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].colours), {}, {
  grey: {
    100: '#ffffff',
    200: '#eaf9f9',
    300: '#e6e9ea',
    400: '#c2c2c2',
    500: '#c3d5e1',
    600: '#94b4c9',
    700: '#94b4c9',
    800: '#3b4e5e',
    900: '#000000'
  },
  proficiency: {
    unassigned: '#fff',
    assigned: '#dae7d3',
    20: '#031c73',
    40: '#314eb5',
    60: '#0c8a03',
    80: '#0fc2a8',
    100: '#4bda40'
  },
  upf: {
    100: '#eaf9f9',
    200: '#c3d5e1',
    300: '#94b4c9',
    400: '#7fa7c2',
    500: '#3b4e5e',
    600: '#000'
  }
}));

/***/ }),

/***/ "F50Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accuracy_progress_toggle_accuracy_progress_toggle__ = __webpack_require__("OEzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_upf_assign_upf_assign_action_types__ = __webpack_require__("spZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__translations__ = __webpack_require__("yumT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters_constants__ = __webpack_require__("6coq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__accuracy_progress_toggle_accuracy_progress_constants__ = __webpack_require__("yHtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_local_storage__ = __webpack_require__("//jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled__ = __webpack_require__("rkBr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filter_options_filter_options__ = __webpack_require__("2QI4");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

















var AssignmentFilters = function AssignmentFilters(_ref) {
  var i18n = _ref.i18n;
  /**
   * STORE
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var currentFilterSelected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.accuracyProgressToggle.currentFilter;
  });

  /**
   * TRANSLATIONS
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__translations__["a" /* default */])({
      i18n: i18n
    }),
    ASSIGNED_ATTEMPT_TEXT = _getTranslations.ASSIGNED_ATTEMPT_TEXT,
    VOLUNTARY_ATTEMPT_TEXT = _getTranslations.VOLUNTARY_ATTEMPT_TEXT,
    HIGHEST_ATTEMPT_TEXT = _getTranslations.HIGHEST_ATTEMPT_TEXT,
    FILTER_LABEL_HOVER_TEXT = _getTranslations.FILTER_LABEL_HOVER_TEXT;

  /**
   * REFS
   */
  var filterMenuRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  /**
   * LOCAL STORAGE
   */
  var accuracySubFilterSelected = __WEBPACK_IMPORTED_MODULE_14__helpers_local_storage__["a" /* default */].getItem(__WEBPACK_IMPORTED_MODULE_12__filters_constants__["d" /* ACCURACY_SUB_FILTER */]) || __WEBPACK_IMPORTED_MODULE_12__filters_constants__["b" /* ASSIGNED */];
  var progressSubFilterSelected = __WEBPACK_IMPORTED_MODULE_14__helpers_local_storage__["a" /* default */].getItem(__WEBPACK_IMPORTED_MODULE_12__filters_constants__["e" /* PROGRESS_SUB_FILTER */]) || __WEBPACK_IMPORTED_MODULE_12__filters_constants__["b" /* ASSIGNED */];

  /**
   * STATE
   */
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(accuracySubFilterSelected),
    _useState2 = _slicedToArray(_useState, 2),
    accuracySubFilter = _useState2[0],
    setAccuracySubFilter = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(progressSubFilterSelected),
    _useState4 = _slicedToArray(_useState3, 2),
    progressSubFilter = _useState4[0],
    setProgressSubFilter = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionX = _useState6[0],
    setPositionX = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionY = _useState8[0],
    setPositionY = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState0 = _slicedToArray(_useState9, 2),
    positionArrow = _useState0[0],
    setPositionArrow = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showContextMenu = _useState10[0],
    setContextMenu = _useState10[1];

  /**
   * VARIABLES
   */
  var isAccuracySelected = currentFilterSelected === __WEBPACK_IMPORTED_MODULE_13__accuracy_progress_toggle_accuracy_progress_constants__["a" /* ACCURACY */];
  var handleSelection = isAccuracySelected ? setAccuracySubFilter : setProgressSubFilter;
  var subFilterText = isAccuracySelected ? accuracySubFilter : progressSubFilter;

  /**
   * FUNCTIONS
   */
  var showContextModal = function showContextModal() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["d" /* getContextCoords */])(filterMenuRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_6__context_modal__["a" /* contextModalWidth */]),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow;
    setPositionY(posY);
    setPositionX(posX - __WEBPACK_IMPORTED_MODULE_6__context_modal__["a" /* contextModalWidth */] / 2.5);
    setPositionArrow(posArrow);
    setContextMenu(!showContextMenu);
  };
  var getFilterText = function getFilterText(filter) {
    switch (filter) {
      case __WEBPACK_IMPORTED_MODULE_12__filters_constants__["a" /* HIGHEST */]:
        return HIGHEST_ATTEMPT_TEXT;
      case __WEBPACK_IMPORTED_MODULE_12__filters_constants__["b" /* ASSIGNED */]:
        return ASSIGNED_ATTEMPT_TEXT;
      case __WEBPACK_IMPORTED_MODULE_12__filters_constants__["c" /* VOLUNTARY */]:
        return VOLUNTARY_ATTEMPT_TEXT;
      default:
        return '';
    }
  };

  /**
   * EFFECTS
   */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_14__helpers_local_storage__["a" /* default */].setItem(__WEBPACK_IMPORTED_MODULE_12__filters_constants__["d" /* ACCURACY_SUB_FILTER */], accuracySubFilter);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_8__containers_upf_assign_upf_assign_action_types__["I" /* SELECT_ACCURACY_SUB_FILTER */],
      accuracySubFilter: accuracySubFilter
    });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_upf_assign_upf_assign_actions__["m" /* clearCellSelection */])());
  }, [accuracySubFilter]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_14__helpers_local_storage__["a" /* default */].setItem(__WEBPACK_IMPORTED_MODULE_12__filters_constants__["e" /* PROGRESS_SUB_FILTER */], progressSubFilter);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_8__containers_upf_assign_upf_assign_action_types__["J" /* SELECT_PROGRESS_SUB_FILTER */],
      progressSubFilter: progressSubFilter
    });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_upf_assign_upf_assign_actions__["m" /* clearCellSelection */])());
  }, [progressSubFilter]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__accuracy_progress_toggle_accuracy_progress_toggle__["a" /* default */], {
    i18n: i18n
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["a" /* AssignmentFiltersWrapper */], {
    ref: filterMenuRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setContextMenu(false);
    },
    forButton: "assignment-filter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context_modal__["b" /* default */], {
    borderRadius: 1,
    color: "#3b4e5e",
    show: showContextMenu,
    positionArrow: positionArrow,
    positionX: positionX,
    positionY: positionY,
    overflow: "visible"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__filter_options_filter_options__["a" /* default */], {
    filter: subFilterText,
    handleSelection: handleSelection,
    i18n: i18n
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["b" /* FilerRow */], {
    onClick: showContextModal,
    title: FILTER_LABEL_HOVER_TEXT
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["c" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["I" /* FilterDefault */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled__["d" /* FilterLabel */], {
    "data-testid": "sub-filter-label"
  }, getFilterText(subFilterText)))));
};
AssignmentFilters.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (AssignmentFilters);

/***/ }),

/***/ "FFsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var useToolTip = function useToolTip() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$defaultShow = _ref.defaultShow,
    defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow;
  var targetRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultShow),
    _useState2 = _slicedToArray(_useState, 2),
    showToolTip = _useState2[0],
    setShowToolTip = _useState2[1];
  var onMouseEnter = function onMouseEnter() {
    setShowToolTip(true);
  };
  var onMouseLeave = function onMouseLeave() {
    setShowToolTip(false);
  };
  return {
    targetRef: targetRef,
    showToolTip: showToolTip,
    onHoverHandlers: {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useToolTip);

/***/ }),

/***/ "FKcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assignment */
/* unused harmony export studentWithAssignments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__("JeHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("ezD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__("QR7b");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var assignment = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].ASSIGNMENTS, undefined, {
  idAttribute: function idAttribute(value, parent) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_status_cell_helpers__["d" /* getAssignmentHashKey */])(parent.studentUserProfileId, value.learningJourneyId);
  }
});
var studentWithAssignments = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].STUDENTS, {
  assignments: [assignment]
}, {
  idAttribute: 'studentUserProfileId'
});
var learningJourneyStep = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].LEARNING_JOURNEY_STEPS);
var learningJourney = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].LEARNING_JOURNEYS, {
  childTopics: [learningJourneyStep]
}, {
  processStrategy: function processStrategy(value, parent) {
    return _objectSpread(_objectSpread({}, value), {}, {
      standardId: parent.id
    });
  }
});
var standard = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].STANDARDS, {
  childTopics: [learningJourney]
});
var strand = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].STRANDS, {
  childTopics: [standard]
});
var student = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].STUDENTS, {}, {
  processStrategy: function processStrategy(value, parent) {
    return _objectSpread(_objectSpread({}, value), {}, {
      groupId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* getGroupHashKey */])({
        classroomId: parent.classroomId,
        groupId: parent.id
      })
    });
  }
});
var group = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].GROUPS, {
  students: [student]
}, {
  // The group id only unique in the classroom level, so we give it a unique id with classroom id
  idAttribute: function idAttribute(value, parent) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* getGroupHashKey */])({
      classroomId: parent.id,
      groupId: value.id
    });
  },
  processStrategy: function processStrategy(value, parent) {
    return _objectSpread(_objectSpread({}, value), {}, {
      classroomId: parent.id
    });
  }
});
var lockedCourseVersion = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].LOCKED_COURSE_VERSIONS, undefined, {
  idAttribute: function idAttribute(value, parent) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* getClassroomCourseVersionHashKey */])({
      courseId: value.id,
      classroomId: parent.id
    });
  }
});
var classrooms = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].CLASSROOMS, {
  groups: [group],
  lockedCourseVersions: [lockedCourseVersion]
});
var course = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].COURSES);
var publication = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["a" /* schema */].Entity(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ENTITY_NAMES */].PUBLICATIONS, {
  courses: [course]
});
var Schema = {
  CLASSROOMS_ARRAY: [classrooms],
  PUBLICATION_ARRAY: [publication],
  STANDARDS_ARRAY: [standard],
  STRANDS_ARRAY: [strand],
  STUDENT_WITH_ASSIGNMENTS_ARRAY: [studentWithAssignments]
};
/* harmony default export */ __webpack_exports__["a"] = (Schema);

/***/ }),

/***/ "FQuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("wfv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectable_list_item__ = __webpack_require__("VioT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_error_boundary__ = __webpack_require__("whwL");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }












var SearchableDropDownList = function SearchableDropDownList(props) {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var i18n = props.i18n;
  var topics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.topics;
  });
  var selectedStandardCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedStandardCount;
  });
  var standardCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.standardCount;
  });
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var searchTextbox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSearchPanel = _useState4[0],
    setShowSearchPanel = _useState4[1];
  var label = i18n._("Filter by Standard - showing {selectedStandardCount} of {standardCount} standards", {
    selectedStandardCount: selectedStandardCount,
    standardCount: standardCount
  });
  var handleClick = function handleClick() {
    if (topics.length) {
      setShowSearchPanel(true);
      searchTextbox.current.placeholder = i18n._("Type here to search for Standards");
    }
  };
  var updateStrands = function updateStrands(actionType, id, checked) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__containers_upf_assign_upf_assign_actions__["n" /* updateStrand */])(actionType, id, checked, searchTerm));
  };
  var handleOnChange = function handleOnChange(e) {
    var searchText = e.target.value;
    setSearchTerm(searchText);
    updateStrands('onSearch', '', false, searchText);
    if (!searchText) {
      searchTextbox.current.placeholder = i18n._("Type here to search for Standards");
    }
  };
  var uncheckAll = function uncheckAll() {
    updateStrands('uncheckAll');
  };
  var apply = function apply() {
    setShowSearchPanel(false);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__containers_upf_assign_upf_assign_actions__["o" /* applyFilter */])());
    searchTextbox.current.placeholder = label;
  };
  var onSelect = function onSelect(id, checked) {
    updateStrands('selection', id, checked, searchTerm);
  };
  var getChildTopics = function getChildTopics(item) {
    return item.childTopics.map(function (std) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "spacer",
        key: "".concat(item.id, "#").concat(std.id)
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__selectable_list_item__["a" /* default */], {
        id: "".concat(item.id, "#").concat(std.id),
        checked: std.selected ? __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["a" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["b" /* UNCHECKED */],
        name: std.displayName,
        onChange: onSelect
      }));
    });
  };
  var onStrandIconClick = function onStrandIconClick(id) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__containers_upf_assign_upf_assign_actions__["p" /* strandExpandCollapse */])(id));
  };
  var getCheckedState = function getCheckedState(item) {
    var selectedChildLength = item.childTopics.filter(function (childTopic) {
      return childTopic.selected;
    }).length;
    if (!selectedChildLength) return __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["b" /* UNCHECKED */];
    if (item.childTopics.length === selectedChildLength) return __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["a" /* CHECKED */];
    return __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["c" /* INDETERMINATE */];
  };
  var renderStrandItems = function renderStrandItems() {
    if (topics) {
      return topics.map(function (item) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {
          key: item.id
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "strand"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "wrapper"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "Description"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__selectable_list_item__["a" /* default */], {
          id: item.id,
          checked: getCheckedState(item),
          name: item.displayName,
          onChange: onSelect
        })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "icon",
          tabIndex: 0,
          onClick: function onClick() {
            return onStrandIconClick(item.id);
          },
          role: "button"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__["a" /* default */], {
          icon: item.isExpand ? __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["C" /* UpArrow */] : __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["B" /* DownArrow */]
        }))), item.isExpand ? getChildTopics(item) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", {
          className: "line"
        }));
      });
    }
    return null;
  };
  var focusSearchTextbox = function focusSearchTextbox() {
    searchTextbox.current.placeholder = label;
  };
  var logoTitle = selectedStandardCount === standardCount ? i18n._("No filters have been applied - entire curriculum grade is shown") : i18n._("Filters have been applied - click search bar to see which standards have been excluded");
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return showSearchPanel && setShowSearchPanel(false);
    },
    forButton: "SearchableDropDownList"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__containers_error_boundary__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: focusSearchTextbox,
    forButton: "searchPanel"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    id: "searchPanel"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* SearchContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* FilterWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "filter"
  }, i18n._("Filter")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["d" /* SearchableListWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "searchText"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* InputWrapper */], {
    ref: searchTextbox,
    type: "text",
    onClick: handleClick,
    onChange: handleOnChange,
    value: searchTerm,
    placeholder: label,
    "data-name": "filter"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "searchLogo",
    title: logoTitle
  }, selectedStandardCount === standardCount ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["M" /* FilterOutlineIcon */]
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["e" /* FilteredListWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["N" /* FilterIcon */]
  })))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["f" /* SelectPanelWrapper */], {
    style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__styled__["g" /* showElement */])(showSearchPanel)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "panelBody"
  }, renderStrandItems()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "panelFooter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "uncheck"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    className: "unCheckAllButton",
    disabled: !topics.length,
    text: i18n._("Unselect all"),
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    onClick: uncheckAll
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "apply"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    className: "applyButton",
    disabled: !topics.length,
    primary: true,
    text: i18n._("Apply filter"),
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    onClick: apply
  }))))))))));
};
SearchableDropDownList.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (SearchableDropDownList);

/***/ }),

/***/ "FWAL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Tabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Questions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__ = __webpack_require__("0uBZ");



var ModalBody = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["b" /* alignItems */])('flex-start'), ";\n\n  * {\n    color: ").concat(colours.grey[900], "\n  }\n\n  .title{\n    margin-bottom: 15px;\n    font-size: 18px;\n  }\n\n  .previewButton {\n    background-color: #c3d5e1 !important;\n    border: 1px solid #c3d5e1 !important;\n    color: #3b4e5e !important;\n    margin-top: 10px;\n    padding: 2px 16px;\n  }\n  ");
});
var Tabs = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function () {
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* flexDirection */])('row'), ";\n\n    width: 100%;\n    justify-content: space-between;\n    \n    .subTitle {\n      font-size: 14px;\n      margin-right: 12px;\n      font-weight: 600;\n      vertical-align: 14px;\n    }\n\n    button {\n      margin-right: 12px;\n      border: 1px solid #E6E9EA;\n      border-bottom: none\n      outline: none;\n      cursor: pointer;\n      padding: 10px 10px 13px;\n      font-size: 17px;\n      border-top-right-radius: 10px;\n      border-top-left-radius: 10px;\n      background: #E6E9EA\n      width: 70px;\n      height: 56px;\n      position: relative;\n    }\n\n    .active {\n      background: white;\n      border: 1px solid #E6E9EA;\n\n      ::after {\n        content: '';\n        position: absolute;\n        background: white;\n        width: 68px;\n        height: 6px;\n        bottom: -3px;\n        left: 0;\n      }\n    }\n\n    .whatsThisCallout {\n      position: absolute;\n      padding: 10px;\n      width: 265px;\n      border-radius: 5px;\n      top: 120px;\n      font-size: 14px;\n      right: 40px;\n      box-shadow: 4px 2px 6px;\n      background: white;\n      z-index: 8;\n\n      ::after {\n        width: 0; \n        height: 0; \n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;        \n        border-bottom: 15px solid white;\n        position: fixed;\n        top: 106px;\n        right: 92px;\n        content: ' '\n      }\n    }\n  ");
});
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function () {
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* flexDirection */])('row'), ";\n\n    min-height: 250px;\n    max-height: 450px;\n    border: 1px solid #E6E9EA;\n    width: 97%;\n    border-radius: 10px;\n    padding: 15px;\n    text-align: left;\n    font-size: 15px;\n    overflow-y: auto;\n\n    .heading {\n      font-weight:600;\n      margin-top: 25px\n    }\n    .subHeading{\n      margin: 8px 0\n    }\n    .list {\n      list-style-type: disc;\n      list-style-position: outside;\n      margin-left: 18px;\n      line-height: 22px;\n    }\n    .demo {\n      display: inline-flex\n    }\n  ");
});
var Description = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function () {
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n    \n    width: 40%;\n  ");
});
var Questions = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function () {
  return "\n    width: 60%;\n    margin: 20px 0 0 50px;\n    border: 1px solid #E6E9EA;\n  ";
});


/***/ }),

/***/ "Fvqa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contextModalWidth; });
/* unused harmony export contextModalHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return arrowHeight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("Zbcq");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var contextModalWidth = 213;
var contextModalHeight = '100%';
var arrowHeight = 15;
var findPositionArrowY = function findPositionArrowY(_ref) {
  var isOutOfWindowX = _ref.isOutOfWindowX,
    positionY = _ref.positionY,
    positionArrowY = _ref.positionArrowY,
    targetHeight = _ref.targetHeight,
    leftAlign = _ref.leftAlign;
  if (!isOutOfWindowX || leftAlign) return positionArrowY || positionY - 10;

  // Adjust arrow position to top
  return positionY - targetHeight - arrowHeight;
};
var ContextModal = function ContextModal(props) {
  var color = props.color,
    overflow = props.overflow,
    contextTheme = props.contextTheme,
    show = props.show,
    borderRadius = props.borderRadius,
    leftAlign = props.leftAlign,
    positionArrow = props.positionArrow,
    positionX = props.positionX,
    positionY = props.positionY,
    positionArrowY = props.positionArrowY,
    modalHeight = props.modalHeight,
    targetHeight = props.targetHeight,
    name = props.name,
    overflowWrap = props.overflowWrap,
    children = props.children;
  var bgColor = contextTheme ? '#3B4E5E' : color;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState2 = _slicedToArray(_useState, 2),
    modalBottom = _useState2[0],
    setModalBottom = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOutOfWindowX = _useState4[0],
    setIsOutOfWindowX = _useState4[1];
  var adjustedPositionArrowY = findPositionArrowY({
    isOutOfWindowX: isOutOfWindowX,
    positionY: positionY,
    positionArrowY: positionArrowY,
    targetHeight: targetHeight
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var isDefaultModalHeight = modalHeight === contextModalHeight;
    var targetToBottomHeight = innerHeight - positionY;
    if (show && !isDefaultModalHeight && targetToBottomHeight < modalHeight) {
      setModalBottom(targetToBottomHeight + targetHeight + 10);
      setIsOutOfWindowX(true);
    }
  }, [show]);
  return show && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* ModalWrapper */], {
    overflow: overflow,
    overflowWrap: overflowWrap,
    borderRadius: borderRadius,
    positionArrow: positionArrow - 8,
    positionX: positionX,
    positionY: positionY,
    positionArrowY: adjustedPositionArrowY,
    modalWidth: contextModalWidth,
    bgColor: bgColor,
    leftAlign: leftAlign,
    modalBottom: modalBottom,
    isOutOfWindowX: isOutOfWindowX
  }, contextTheme ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* ContentTheme */], null, name) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* Content */], null, children));
};
ContextModal.defaultProps = {
  color: 'white',
  overflow: 'hidden',
  overflowWrap: 'normal',
  modalHeight: contextModalHeight,
  leftAlign: false
};
ContextModal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionArrowY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  contextTheme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  borderRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  overflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overflowWrap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  leftAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modalHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  targetHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
/* harmony default export */ __webpack_exports__["b"] = (ContextModal);

/***/ }),

/***/ "GBeY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_due_date_info_icon__ = __webpack_require__("Sunr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations__ = __webpack_require__("D4qU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("QjCE");





var DueDateInfo = function DueDateInfo() {
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__translations__["a" /* default */])({
      i18n: i18n
    }),
    DUE_DATE_INFO = _getTranslations.DUE_DATE_INFO;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* InfoIcon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_due_date_info_icon__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* InfoTooltip */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* InfoTooltipText */], null, DUE_DATE_INFO)));
};
/* harmony default export */ __webpack_exports__["a"] = (DueDateInfo);

/***/ }),

/***/ "Gkxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toast_action__ = __webpack_require__("fbOh");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var initialState = {
  isToastVisible: false,
  message: '',
  messageType: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__toast_action__["a" /* SHOW_TOAST */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isToastVisible: action.isToastVisible,
        message: action.message,
        messageType: action.messageType
      });
    case __WEBPACK_IMPORTED_MODULE_0__toast_action__["b" /* HIDE_TOAST */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isToastVisible: action.isToastVisible
      });
    default:
      return _objectSpread({}, state);
  }
}

/***/ }),

/***/ "Gylf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_current_assignment_modal_redux_reducer__ = __webpack_require__("ZMXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast_toast_reducer__ = __webpack_require__("Gkxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__upf_assign_upf_assign_reducer__ = __webpack_require__("L/SN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ducs_reducer__ = __webpack_require__("TQs3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entities_entities_reducer__ = __webpack_require__("0dbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gateways_gateways_reducer__ = __webpack_require__("fEk+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_manager_modal_manager_reducer__ = __webpack_require__("AgQo");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var CombinedReducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  UPFAssignReducer: __WEBPACK_IMPORTED_MODULE_3__upf_assign_upf_assign_reducer__["a" /* default */],
  currentAssignmentsModalReducer: __WEBPACK_IMPORTED_MODULE_1__components_current_assignment_modal_redux_reducer__["a" /* default */],
  ducsReducer: __WEBPACK_IMPORTED_MODULE_4__ducs_reducer__["a" /* default */],
  entitiesReducer: __WEBPACK_IMPORTED_MODULE_5__entities_entities_reducer__["a" /* default */],
  gatewaysReducer: __WEBPACK_IMPORTED_MODULE_6__gateways_gateways_reducer__["a" /* default */],
  modalContainerReducer: __WEBPACK_IMPORTED_MODULE_7__modal_manager_modal_manager_reducer__["a" /* default */],
  product: function product(state) {
    return _objectSpread({}, state);
  },
  toastReducer: __WEBPACK_IMPORTED_MODULE_2__components_toast_toast_reducer__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (CombinedReducers);

/***/ }),

/***/ "HKwf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__student_access_student_access__ = __webpack_require__("mr6W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_heading_scss__ = __webpack_require__("uXqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_heading_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__app_heading_scss__);





var AppHeading = function AppHeading() {
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Header"], {
    title: i18n._("Assign & Review"),
    subtitle: i18n._("Skill Quests"),
    className: __WEBPACK_IMPORTED_MODULE_4__app_heading_scss___default.a.header
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__app_heading_scss___default.a.buttonsContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__student_access_student_access__["a" /* default */], {
    i18n: i18n
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (AppHeading);

/***/ }),

/***/ "HkKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_tool_tip__ = __webpack_require__("FFsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accuracy_progress_toggle_accuracy_progress_constants__ = __webpack_require__("yHtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tooltip_tooltip__ = __webpack_require__("I2I3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_hooks_use_context_modal__ = __webpack_require__("OmdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__contextual_menu_contextual_menu__ = __webpack_require__("+QKo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__translations__ = __webpack_require__("sWyC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styled__ = __webpack_require__("d32L");
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }


















var StatusCell = function StatusCell(props) {
  var assignment = props.assignment,
    assignmentHashKey = props.assignmentHashKey,
    currentResultFilter = props.currentResultFilter,
    isSelected = props.isSelected,
    learningJourneyId = props.learningJourneyId,
    studentId = props.studentId;

  /**
   * Hooks
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _useToolTip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_tool_tip__["a" /* default */])(),
    targetRef = _useToolTip.targetRef,
    showToolTip = _useToolTip.showToolTip,
    onHoverHandlers = _useToolTip.onHoverHandlers;
  var _useContextModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_hooks_use_context_modal__["a" /* default */])({
      defaultTargetRef: targetRef
    }),
    showContextModal = _useContextModal.showContextModal,
    closeContextMenu = _useContextModal.closeContextMenu,
    contentModalProps = _useContextModal.contentModalProps,
    isContextModalOpen = _useContextModal.contentModalProps.show;

  /**
   * Local variables
   */
  var _ref = assignment || {},
    currentAssignmentId = _ref.currentAssignmentId,
    resultAccuracy = _ref.resultAccuracy,
    resultStepsCompleted = _ref.resultStepsCompleted,
    currentAssignmentUnavailableForStudent = _ref.currentAssignmentUnavailableForStudent;
  var progressPercentage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers__["f" /* getProgressPercentage */])(assignment);
  var isProgressFilter = currentResultFilter === __WEBPACK_IMPORTED_MODULE_8__accuracy_progress_toggle_accuracy_progress_constants__["b" /* PROGRESS */];
  var isCompleted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers__["g" /* checkIsAssignmentCompleted */])(assignment);
  var resultText = isProgressFilter ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers__["h" /* getProgressResultText */])(assignment) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers__["i" /* getAccuracyResultText */])(assignment);
  var backgroundColorCheckValue = isProgressFilter ? progressPercentage : resultAccuracy;
  var hasCurrentAssigned = !!currentAssignmentId;
  var showCurrentAssignmentTriangle = hasCurrentAssigned && !!resultText;
  var showCurrentAssigned = hasCurrentAssigned && resultStepsCompleted === null;
  var showResult = progressPercentage > 0;

  /**
   * Translations
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__translations__["a" /* default */])({
      i18n: i18n
    }),
    CURRENTLY_ASSIGNED_TEXT = _getTranslations.CURRENTLY_ASSIGNED_TEXT,
    OVERDUE_ASSIGNMENT_REMOVED = _getTranslations.OVERDUE_ASSIGNMENT_REMOVED;

  /**
   * Functions
   */
  var selectCell = function selectCell() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__containers_upf_assign_upf_assign_actions__["e" /* selectAssignmentHashKey */])({
      assignmentHashKey: assignmentHashKey,
      learningJourneyId: learningJourneyId,
      studentId: studentId
    }));
  };
  var onClickHandle = function onClickHandle() {
    if (hasCurrentAssigned || showResult) {
      onHoverHandlers.onMouseLeave();
      return showContextModal();
    }
    return selectCell();
  };
  var renderResult = function renderResult() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["a" /* Result */], null, resultText);
  };
  var renderProgressResults = function renderProgressResults() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, isCompleted && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__svg_icon_svg_icon__["a" /* default */], {
      dataTestId: "status-completed-icon",
      icon: __WEBPACK_IMPORTED_MODULE_13__helpers_icon_dictionary__["l" /* CrownMedium */]
    }), !isCompleted && renderResult());
  };
  var getDateFormat = function getDateFormat(date) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('DD/MM/YY');
  };
  var getTooltipContent = function getTooltipContent() {
    if (currentAssignmentUnavailableForStudent) {
      return OVERDUE_ASSIGNMENT_REMOVED;
    } else if (hasCurrentAssigned) {
      return "".concat(CURRENTLY_ASSIGNED_TEXT, " ").concat(getDateFormat(assignment.currentAssignmentStartDate));
    }
    return '';
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["b" /* Cell */], _extends({
    ref: targetRef,
    backgroundColorCheckValue: backgroundColorCheckValue,
    "data-testid": "status-cell",
    isSelected: isSelected,
    showCurrentAssigned: showCurrentAssigned,
    showCurrentAssignmentTriangle: showCurrentAssignmentTriangle,
    showResult: showResult,
    onClick: onClickHandle
  }, onHoverHandlers), hasCurrentAssigned && showToolTip && !isContextModalOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__tooltip_tooltip__["a" /* default */], {
    variant: "dark",
    targetRef: targetRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["c" /* HoverWrapper */], null, getTooltipContent())), showResult && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["d" /* ResultWrapper */], {
    "data-testid": "status-result"
  }, isProgressFilter && renderProgressResults(), !isProgressFilter && renderResult()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: closeContextMenu,
    forButton: "contextualMenu"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__context_modal__["b" /* default */], _extends({}, contentModalProps, {
    borderRadius: 3,
    modalHeight: 212,
    overflow: "visible"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__contextual_menu_contextual_menu__["a" /* default */], {
    assignmentId: currentAssignmentId,
    hasOnlyResult: showResult && !hasCurrentAssigned,
    studentId: studentId,
    learningJourneyId: learningJourneyId,
    isCellSelected: isSelected,
    selectCell: selectCell
  }))));
};
StatusCell.propTypes = {
  assignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  assignmentHashKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  currentResultFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_8__accuracy_progress_toggle_accuracy_progress_constants__["b" /* PROGRESS */], __WEBPACK_IMPORTED_MODULE_8__accuracy_progress_toggle_accuracy_progress_constants__["a" /* ACCURACY */], '']).isRequired,
  learningJourneyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  studentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
StatusCell.defaultProps = {
  assignment: {}
};
/* harmony default export */ __webpack_exports__["a"] = (StatusCell);

/***/ }),

/***/ "HlnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StudentCountText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SvgWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HeaderRight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 5px;\n    height: 47px;\n    width: 80%;\n    border-right: 2px solid ".concat(colours.grey[400], ";\n    font-weight: 600;\n    user-select: none;\n  ");
});
var HeaderLeft = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: flex-start;\n  padding: 5px;\n  width: 120px;\n  max-height: 10px;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n"])));
var StudentCountText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-left: 5px;\n  width: 100px;\n"])));
var SvgWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  path {\n    fill: '#1981c4';\n  }\n"])));
var HeaderRight = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 5px;\n  width: 100px;\n  font-size: 12px;\n  font-weight: 400;\n  text-align: right;\n"])));

/***/ }),

/***/ "Hwd/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".pulseLoader---1hT4p {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  min-height: 15px; }\n  .pulseLoader---1hT4p div {\n    position: absolute;\n    top: 35%;\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n    background: #d7dbdd;\n    -webkit-animation-timing-function: cubic-bezier(0, 1, 1, 0);\n            animation-timing-function: cubic-bezier(0, 1, 1, 0); }\n  .pulseLoader---1hT4p div:nth-child(1) {\n    left: 6px;\n    -webkit-animation: lds-ellipsis1---1ols3 0.6s infinite;\n            animation: lds-ellipsis1---1ols3 0.6s infinite; }\n  .pulseLoader---1hT4p div:nth-child(2) {\n    left: 6px;\n    -webkit-animation: lds-ellipsis2---2Y-4_ 0.6s infinite;\n            animation: lds-ellipsis2---2Y-4_ 0.6s infinite; }\n  .pulseLoader---1hT4p div:nth-child(3) {\n    left: 26px;\n    -webkit-animation: lds-ellipsis2---2Y-4_ 0.6s infinite;\n            animation: lds-ellipsis2---2Y-4_ 0.6s infinite; }\n  .pulseLoader---1hT4p div:nth-child(4) {\n    left: 45px;\n    -webkit-animation: lds-ellipsis3---Udi2C 0.6s infinite;\n            animation: lds-ellipsis3---Udi2C 0.6s infinite; }\n  @-webkit-keyframes lds-ellipsis1---1ols3 {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n  @keyframes lds-ellipsis1---1ols3 {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n  @-webkit-keyframes lds-ellipsis3---Udi2C {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); } }\n  @keyframes lds-ellipsis3---Udi2C {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); } }\n  @-webkit-keyframes lds-ellipsis2---2Y-4_ {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  100% {\n    -webkit-transform: translate(19px, 0);\n            transform: translate(19px, 0); } }\n  @keyframes lds-ellipsis2---2Y-4_ {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  100% {\n    -webkit-transform: translate(19px, 0);\n            transform: translate(19px, 0); } }\n", ""]);

// exports
exports.locals = {
	"pulseLoader": "pulseLoader---1hT4p",
	"lds-ellipsis1": "lds-ellipsis1---1ols3",
	"lds-ellipsis2": "lds-ellipsis2---2Y-4_",
	"lds-ellipsis3": "lds-ellipsis3---Udi2C"
};

/***/ }),

/***/ "I2I3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("TJmL");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable no-mixed-operators */



var ToolTip = function ToolTip(props) {
  var targetRef = props.targetRef,
    children = props.children,
    margin = props.margin,
    variant = props.variant;
  var toolTipRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState2 = _slicedToArray(_useState, 2),
    top = _useState2[0],
    setTop = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    left = _useState4[0],
    setLeft = _useState4[1];
  var isReady = top > 0 && left > 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (targetRef.current && toolTipRef.current) {
      var _toolTipRef$current$g = toolTipRef.current.getBoundingClientRect(),
        toolTipWidth = _toolTipRef$current$g.width;
      var _ref = targetRef.current.getBoundingClientRect() || {},
        targetLeft = _ref.left,
        targetTop = _ref.top,
        targetWidth = _ref.width,
        targetHeight = _ref.height;
      var halfToolTipWidth = toolTipWidth / 2;
      var halfTargetWidth = targetWidth / 2;
      var calculatedTop = targetTop + targetHeight + margin + window.scrollY;
      setTop(calculatedTop);
      setLeft(targetLeft - halfToolTipWidth + halfTargetWidth + window.scrollX);
    }
  }, [toolTipRef.current, targetRef.current, window.scrollX, window.scrollY]);
  if (!targetRef.current || !children) return null;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* Root */], {
    variant: variant,
    left: left,
    ref: toolTipRef,
    show: isReady,
    top: top
  }, children);
};
ToolTip.defaultProps = {
  margin: 8,
  variant: 'light'
};
ToolTip.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  margin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  targetRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['light', 'dark'])
};
/* harmony default export */ __webpack_exports__["a"] = (ToolTip);

/***/ }),

/***/ "ISnF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".dueDateInfoIcon---3Y13v {\n  display: block;\n  pointer-events: none;\n  width: 17px;\n  height: 17px;\n  background: transparent !important; }\n  .dueDateInfoIcon---3Y13v > span {\n    background: transparent; }\n  .dueDateInfoIcon---3Y13v > span > svg {\n      background: transparent; }\n", ""]);

// exports
exports.locals = {
	"dueDateInfoIcon": "dueDateInfoIcon---3Y13v"
};

/***/ }),

/***/ "IiE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("4HFy");





var IconOption = function IconOption(_ref) {
  var handleSelection = _ref.handleSelection,
    filter = _ref.filter,
    id = _ref.id,
    labelText = _ref.labelText,
    infoText = _ref.infoText;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* OptionWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* FilterOption */], {
    "data-testid": id,
    onClick: function onClick() {
      return handleSelection(id);
    },
    selected: filter === id
  }, labelText), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* InfoIcon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["E" /* Info */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["d" /* InfoTooltip */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["e" /* InfoTooltipText */], null, infoText))));
};
IconOption.propTypes = {
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  infoText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (IconOption);

/***/ }),

/***/ "Ir+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translations__ = __webpack_require__("WPT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("NBPs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var Attempt = function Attempt(_ref) {
  var attempt = _ref.attempt;
  var assignmentType = attempt.assignmentType,
    assignedOn = attempt.assignedOn,
    isCurrentlyAssigned = attempt.isCurrentlyAssigned,
    resultAccuracy = attempt.resultAccuracy,
    isFocusedResult = attempt.isFocusedResult;
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__translations__["a" /* default */])({
      i18n: i18n
    }),
    ASSIGNED_TEXT = _getTranslations.ASSIGNED_TEXT,
    VOLUNTARY_TEXT = _getTranslations.VOLUNTARY_TEXT,
    CURRENT_ASSIGNED_TEXT = _getTranslations.CURRENT_ASSIGNED_TEXT;

  /**
   * Functions
   */
  var getAssignText = function getAssignText() {
    if (isCurrentlyAssigned) return CURRENT_ASSIGNED_TEXT;
    var assignTypeTexts = _defineProperty(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["h" /* ASSIGNMENT_RESULT_TYPES */].ASSIGNED, ASSIGNED_TEXT), __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["h" /* ASSIGNMENT_RESULT_TYPES */].VOLUNTARY, VOLUNTARY_TEXT);
    return assignTypeTexts[assignmentType] || ASSIGNED_TEXT;
  };

  /**
   * Local Variables
   */
  var assignedText = getAssignText();
  var formattedDate = assignedOn ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(assignedOn).format('DD/MM/YY') : '';
  var hasAccuracyResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["c" /* isDefined */])(resultAccuracy);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["b" /* Circle */], {
    isFocusedResult: isFocusedResult,
    resultAccuracy: resultAccuracy
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ConnectBlock */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["d" /* ToolTipWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["e" /* AssignInfo */], {
    hasAccuracyResult: hasAccuracyResult
  }, "".concat(assignedText, " ").concat(formattedDate)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["f" /* AccuracyInfo */], {
    resultAccuracy: resultAccuracy,
    hasAccuracyResult: hasAccuracyResult
  }, hasAccuracyResult && "".concat(resultAccuracy, "%"))));
};
Attempt.propTypes = {
  attempt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Attempt);

/***/ }),

/***/ "Ivgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ThemeHelper = /*#__PURE__*/function () {
  function ThemeHelper() {
    _classCallCheck(this, ThemeHelper);
  }
  return _createClass(ThemeHelper, null, [{
    key: "getTheme",
    value: function getTheme(props) {
      if (props.theme && Object.keys(props.theme).length > 0) {
        return props.theme;
      }
      return __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"];
    }
  }, {
    key: "getDefaultTheme",
    value: function getDefaultTheme() {
      return __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"];
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (ThemeHelper);

/***/ }),

/***/ "IzlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNCHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INDETERMINATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISABLED; });
var CHECKED = 'checked';
var UNCHECKED = 'unchecked';
var INDETERMINATE = 'indeterminate';
var DISABLED = 'disabled';

/***/ }),

/***/ "JLXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("xazg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__standard_info__ = __webpack_require__("LBir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }











var StandardCollapsed = function StandardCollapsed(_ref) {
  var handleOnExpand = _ref.handleOnExpand,
    externalKey = _ref.externalKey,
    topicName = _ref.topicName,
    description = _ref.description,
    learningJourney = _ref.learningJourney,
    id = _ref.id,
    i18n = _ref.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var myRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInfo = _useState2[0],
    setInfo = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    positionX = _useState4[0],
    setPositionX = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionY = _useState6[0],
    setPositionY = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionArrow = _useState8[0],
    setPositionArrow = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState0 = _slicedToArray(_useState9, 2),
    positionXCallout = _useState0[0],
    setPositionXCallout = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState10 = _slicedToArray(_useState1, 2),
    positionYCallout = _useState10[0],
    setPositionYCallout = _useState10[1];
  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState12 = _slicedToArray(_useState11, 2),
    positionArrowCallout = _useState12[0],
    setPositionArrowCallout = _useState12[1];
  var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState14 = _slicedToArray(_useState13, 2),
    callOut = _useState14[0],
    setCallOut = _useState14[1];
  var standardRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState16 = _slicedToArray(_useState15, 2),
    contextTheme = _useState16[0],
    setContextTheme = _useState16[1];
  var showDropdown = function showDropdown() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["d" /* getContextCoords */])(myRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_6__context_modal__["a" /* contextModalWidth */]),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow;
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setCallOut(false);
    if (showInfo) {
      setInfo(false);
    } else {
      setInfo(true);
    }
  };
  var hideStandardBlock = function hideStandardBlock() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_upf_assign_upf_assign_actions__["c" /* hideStandard */])(id));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_upf_assign_upf_assign_actions__["d" /* displayModalInfo */])(-1));
  };
  var showCallOut = function showCallOut() {
    var _getContextCoords2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["d" /* getContextCoords */])(standardRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_6__context_modal__["a" /* contextModalWidth */]),
      posX = _getContextCoords2.posX,
      posY = _getContextCoords2.posY,
      posArrow = _getContextCoords2.posArrow;
    setPositionYCallout(posY);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('standard');
    setCallOut(true);
  };
  var hideCallOut = function hideCallOut() {
    setCallOut(false);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Collapse */], {
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      return handleOnExpand(false);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__["x" /* ExpandButton */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Info */], {
    role: "button",
    onClick: showDropdown,
    lj: learningJourney.length,
    ref: standardRef,
    onMouseEnter: showCallOut,
    onMouseLeave: hideCallOut
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* Content */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["e" /* ExternalKey */], null, externalKey), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["f" /* TopicName */], null, topicName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["g" /* Icon */], {
    ref: myRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__["e" /* StandardDropdown */]
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setInfo(false);
    },
    forButton: "showContextModal_".concat(id)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context_modal__["b" /* default */], {
    show: showInfo,
    positionArrow: positionArrow,
    positionX: positionX,
    positionY: positionY
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__standard_info__["a" /* default */], {
    standardName: topicName,
    externalKey: externalKey,
    description: description,
    hideStrand: hideStandardBlock,
    displayHideOption: true,
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context_modal__["b" /* default */], {
    show: callOut,
    positionArrow: positionArrowCallout,
    positionX: positionXCallout,
    positionY: positionYCallout,
    contextTheme: contextTheme,
    name: "".concat(externalKey, " : ").concat(topicName)
  })));
};
StandardCollapsed.propTypes = {
  handleOnExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  externalKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  topicName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  learningJourney: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
StandardCollapsed.defaultProps = {
  handleOnExpand: function handleOnExpand() {},
  externalKey: '',
  topicName: '',
  description: ''
};
/* harmony default export */ __webpack_exports__["a"] = (StandardCollapsed);

/***/ }),

/***/ "JT4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__status_cell__ = __webpack_require__("HkKr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__grid_header__ = __webpack_require__("Vmzb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__("TQbn");







var Grid = function Grid(props) {
  var standardId = props.standardId;

  /**
   * Store
   */
  var standards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.standards;
  });
  var assignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.assignments;
  });
  var selectedAssignmentHashKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedAssignmentHashKeys;
  });
  var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudentIds;
  });
  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
      return state.UPFAssignReducer.accuracyProgressToggle;
    }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]),
    currentFilter = _useSelector.currentFilter;

  /**
   * Local variables
   */
  var _ref = standards[standardId] || {},
    _ref$childTopics = _ref.childTopics,
    learningJourneyIds = _ref$childTopics === void 0 ? [] : _ref$childTopics;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["a" /* GridContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["b" /* Header */], null, learningJourneyIds.map(function (learningJourneyId) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_header__["a" /* default */], {
      key: learningJourneyId,
      learningJourneyId: learningJourneyId,
      sortedStudentIds: sortedStudentIds
    });
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["c" /* CellContainer */], null, learningJourneyIds.map(function (learningJourneyId) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["d" /* GridColumn */], {
      key: learningJourneyId
    }, sortedStudentIds.map(function (studentId) {
      var assignmentHashKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__status_cell_helpers__["d" /* getAssignmentHashKey */])(studentId, learningJourneyId);
      var assignment = assignments[assignmentHashKey];
      var isSelected = !!selectedAssignmentHashKeys[assignmentHashKey];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__status_cell__["a" /* default */], {
        assignment: assignment,
        assignmentHashKey: assignmentHashKey,
        currentResultFilter: currentFilter,
        isSelected: isSelected,
        key: assignmentHashKey,
        learningJourneyId: learningJourneyId,
        studentId: studentId
      });
    }));
  })));
};
Grid.propTypes = {
  standardId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),

/***/ "JpTX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_DUCS_CONFIG_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_DUCS_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_DUCS_CONFIG_ERROR; });
/* unused harmony export SET_DUCS_INSTANCE_ID */
/* unused harmony export getDucsConfigRequested */
/* unused harmony export getDucsConfigSuccess */
/* unused harmony export getDucsConfigError */
/* unused harmony export getDucsConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_resources__ = __webpack_require__("viEY");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var GET_DUCS_CONFIG_REQUESTED = 'GET_DUCS_CONFIG_REQUESTED';
var GET_DUCS_CONFIG_SUCCESS = 'GET_DUCS_CONFIG_SUCCESS';
var GET_DUCS_CONFIG_ERROR = 'GET_DUCS_CONFIG_ERROR';
var SET_DUCS_INSTANCE_ID = 'SET_DUCS_INSTANCE_ID';
var getDucsConfigRequested = function getDucsConfigRequested() {
  return {
    type: GET_DUCS_CONFIG_REQUESTED
  };
};
var getDucsConfigSuccess = function getDucsConfigSuccess(payload) {
  return _objectSpread({
    type: GET_DUCS_CONFIG_SUCCESS
  }, payload);
};
var getDucsConfigError = function getDucsConfigError() {
  return {
    type: GET_DUCS_CONFIG_ERROR
  };
};
var getDucsConfig = function getDucsConfig() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var _yield$Promise$all, _yield$Promise$all2, url, config, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            dispatch(getDucsConfigRequested());
            _context.p = 1;
            _context.n = 2;
            return Promise.all([__WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].env.substituteConfigurationItems('@DUCSLibraryUrl'), __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].env.substituteConfigurationItems('@DUCSConfiguration')]);
          case 2:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            url = _yield$Promise$all2[0];
            config = _yield$Promise$all2[1];
            dispatch(getDucsConfigSuccess({
              url: url,
              config: JSON.parse(config)
            }));
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            dispatch(getDucsConfigError());
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "KABN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("V/lH");




var NoDataView = function NoDataView() {
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Icon */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["D" /* StudentIcon */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Paragraph */], null, i18n._("There are currently no Skill Quests assigned to this student")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Paragraph */], null, i18n._("Once assigned you can quickly monitor the status of activities here.")));
};
/* harmony default export */ __webpack_exports__["a"] = (NoDataView);

/***/ }),

/***/ "KH1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upf_theme__ = __webpack_require__("TCs3");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__upf_theme__["a" /* default */]);

/***/ }),

/***/ "KgEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapStudentIdsFromGroups; });
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var mapStudentIdsFromGroups = function mapStudentIdsFromGroups(groups) {
  var filteredStudentIds = Object.values(groups).reduce(function (accumulator, group) {
    var _ref = group || {},
      _ref$students = _ref.students,
      studentIds = _ref$students === void 0 ? [] : _ref$students;
    return accumulator.concat(studentIds);
  }, []);
  return _toConsumableArray(new Set(filteredStudentIds));
};
/* unused harmony default export */ var _unused_webpack_default_export = (mapStudentIdsFromGroups);

/***/ }),

/***/ "KtId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_gateways_gateways_actions__ = __webpack_require__("i4yT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_entities_entities_reducer__ = __webpack_require__("0dbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_entities_constants__ = __webpack_require__("ezD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__use_course_version__ = __webpack_require__("7QyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__use_assignment_result_type__ = __webpack_require__("2yLB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__use_interval__ = __webpack_require__("SbbG");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }










var usePollingV2 = function usePollingV2() {
  var DEFAULT_POLL_DELAY = 10000;
  var POLL_DELAY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* getConfiguration */])('pollDelay') || DEFAULT_POLL_DELAY;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(POLL_DELAY),
    _useState2 = _slicedToArray(_useState, 2),
    pollingTime = _useState2[0],
    setPollingTime = _useState2[1];

  /**
   * Store
   */
  var isLoadingAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.gatewaysReducer.isLoadingAssignments;
  });
  var isLoadingGenericCourses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.isLoadingGenericCourses;
  });
  var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudentIds;
  });
  var selectedProduct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.product;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var selectedLearningJourneyIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedLearningJourneyIds;
  });
  var selectedAssignmentHashKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedAssignmentHashKeys;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);

  /**
   * Local variables
   */
  var pausePolling = Object.values(selectedAssignmentHashKeys).length > 0;
  var studentUserProfileIds = _toConsumableArray(sortedStudentIds).sort();

  /**
   * Hooks
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useCourseVersion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__use_course_version__["a" /* default */])(),
    selectedClassroomId = _useCourseVersion.selectedClassroomId,
    selectedCourseId = _useCourseVersion.selectedCourseId,
    selectedCourseVersion = _useCourseVersion.selectedCourseVersion;
  var _useAssignmentResultT = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__use_assignment_result_type__["a" /* default */])(),
    assignmentResultType = _useAssignmentResultT.assignmentResultType;

  /**
   * Functions
   */
  var getAssignmentsHandler = function getAssignmentsHandler() {
    var shouldFetching = !pausePolling && !isLoadingAssignments && !isLoadingGenericCourses && selectedClassroomId && selectedCourseId && selectedCourseVersion && selectedProduct.id;
    if (shouldFetching) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__containers_gateways_gateways_actions__["b" /* getAssignments */])({
        assignmentResultType: assignmentResultType,
        classId: selectedClassroomId,
        courseId: selectedCourseId,
        courseVersion: selectedCourseVersion,
        productId: selectedProduct.id
      }));
    }
  };

  /**
   * Effects
   */

  // get the initial data
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["s" /* getAssignmentsManagementInitData */])(selectedProduct.id));
  }, []);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var stopPolling = pausePolling || isLoadingAssignments || isLoadingGenericCourses;
    setPollingTime(stopPolling ? null : POLL_DELAY);
  }, [pausePolling, isLoadingAssignments, isLoadingGenericCourses]);

  // dispatch action to poll result data in very POLL_DELAY secs
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__use_interval__["a" /* default */])(function () {
    getAssignmentsHandler();
  }, pollingTime);

  // once we have the initial data then go and fetch student assignments
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    getAssignmentsHandler();
  }, [selectedLearningJourneyIds.toString(), studentUserProfileIds.toString(), isLoadingGenericCourses, selectedClassroomId, selectedCourseId, selectedCourseVersion]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__containers_entities_entities_reducer__["f" /* resetEntity */])({
      entityName: __WEBPACK_IMPORTED_MODULE_5__containers_entities_constants__["a" /* ENTITY_NAMES */].ASSIGNMENTS
    }));
    getAssignmentsHandler();
  }, [assignmentResultType]);
};
/* harmony default export */ __webpack_exports__["a"] = (usePollingV2);

/***/ }),

/***/ "L/SN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_student_list_utils__ = __webpack_require__("vAAw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_accuracy_progress_toggle_accuracy_progress_constants__ = __webpack_require__("yHtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_assignment_filters_filters_constants__ = __webpack_require__("6coq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_quick_selector_quick_selector_constants__ = __webpack_require__("lz7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_portal_comms__ = __webpack_require__("lS1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__ = __webpack_require__("//jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__upf_assign_util__ = __webpack_require__("++6F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__ = __webpack_require__("spZY");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }













var initialState = {
  accuracyProgressToggle: {
    accuracySubFilter: __WEBPACK_IMPORTED_MODULE_5__components_assignment_filters_filters_constants__["a" /* HIGHEST */],
    currentFilter: __WEBPACK_IMPORTED_MODULE_4__components_accuracy_progress_toggle_accuracy_progress_constants__["a" /* ACCURACY */],
    progressSubFilter: __WEBPACK_IMPORTED_MODULE_5__components_assignment_filters_filters_constants__["a" /* HIGHEST */]
  },
  actionInProgress: false,
  assignmentStatuses: [],
  classrooms: [],
  displayModalKey: -1,
  filteredStudents: [],
  genericCourses: {},
  isLoadingAssignmentStatuses: false,
  isLoadingGenericCourses: false,
  isRestricted: true,
  pausePolling: false,
  publicationCourses: [],
  publications: [],
  selectedAssignmentFilterType: __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* assignmentFilterType */].ASSIGN_UPF,
  selectedAssignmentHashKeys: {},
  selectedCells: [],
  selectedClass: {
    value: '',
    label: ''
  },
  selectedGroup: {
    value: '',
    label: ''
  },
  selectedLearningJourneyIds: [],
  selectedPublication: {
    value: '',
    label: ''
  },
  selectedCourseOption: {
    value: '',
    label: ''
  },
  selectedStandardCount: 0,
  selectedStudentIds: [],
  selectedTopics: [],
  selectedCourse: {
    id: null,
    version: null
  },
  showGridLoader: true,
  showSearchPanel: false,
  sortDirection: __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["c" /* SORT_DIRECTION_TYPES */].ASC,
  sortValue: 'lastName',
  sortedStudents: [],
  sortedStudentIds: [],
  standardCount: 0,
  strands: [],
  studentAssignments: [],
  studentUnAssignments: [],
  studentsAssignmentCount: [],
  studentsAssignmentStatus: [],
  topics: [],
  unsavedChanges: false
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["a" /* FILTERED_STUDENTS */]:
      {
        var sortDirection = state.sortDirection,
          sortValue = state.sortValue,
          studentsAssignmentStatus = state.studentsAssignmentStatus;
        var filteredStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_student_list_utils__["a" /* customSort */])(action.payload, sortValue, sortDirection);
        return _objectSpread(_objectSpread({}, state), {}, {
          filteredStudents: filteredStudents,
          selectedStudentIds: [],
          studentAssignments: [],
          studentUnAssignments: [],
          sortedStudents: filteredStudents,
          studentsAssignmentStatus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["a" /* sortStudentAssignmentsById */])(studentsAssignmentStatus, filteredStudents),
          pausePolling: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["b" /* STUDENTS_ASSIGNMENTS_STATUSES_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingAssignmentStatuses: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["c" /* STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS */]:
      {
        var unsavedChanges = state.unsavedChanges;
        if (unsavedChanges) {
          return _objectSpread(_objectSpread({}, state), {}, {
            showGridLoader: false,
            unsavedChanges: true
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          assignmentStatuses: action.payload.assignmentStatuses,
          studentsAssignmentStatus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["b" /* updateAssignmentsHidden */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["a" /* sortStudentAssignmentsById */])(action.payload.assignmentStatuses, state.sortedStudents), state.selectedLearningJourneyIds),
          isLoadingAssignmentStatuses: false,
          pausePolling: false,
          psrQuestionSummaries: action.payload.psrQuestionSummaries || [],
          selectedPSRs: [],
          selectedStudentIds: [],
          showGridLoader: false,
          studentAssignments: [],
          studentUnAssignments: [],
          studentsAssignmentCount: action.payload.studentAssignmentCounts,
          unsavedChanges: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["d" /* UPDATE_SORTED_STUDENTS_LIST */]:
      {
        var _sortDirection = state.sortDirection,
          _sortValue = state.sortValue,
          _studentsAssignmentStatus = state.studentsAssignmentStatus;
        var newStudentOrder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_student_list_utils__["a" /* customSort */])(action.students, _sortValue, _sortDirection);
        return _objectSpread(_objectSpread({}, state), {}, {
          sortedStudents: newStudentOrder,
          studentsAssignmentStatus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["a" /* sortStudentAssignmentsById */])(_studentsAssignmentStatus, newStudentOrder)
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["e" /* UPDATE_SORT_PROPERTIES */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          sortDirection: action.direction,
          sortValue: action.sortValue
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["f" /* ERROR_DETECTED */]:
      {
        var message = 'Oops an error has occurred. '.concat("\n      ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          href: "http://www.3plearning.com/contact/"
        }, "Please contact Tech Support"), "\n      ", ' with details of what happened and we will work to get you back on track.');
        __WEBPACK_IMPORTED_MODULE_9__helpers_portal_comms__["a" /* default */].serverError(message);
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingAssignmentStatuses: false,
          isLoadingGenericCourses: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["g" /* PUBLICATIONS_ACQUIRED */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          publications: action.payload || []
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["h" /* GENERIC_COURSES_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingGenericCourses: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["i" /* GENERIC_COURSES_SUCCESS */]:
      {
        var genericCourses = action.payload || [];
        var topicsAndStandards = [];
        topicsAndStandards = action.savedFilter || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["c" /* getTopicsAndStandards */])(genericCourses);
        var selectedTopics = action.savedFilter ? topicsAndStandards : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["d" /* filterStandardByLJCount */])(topicsAndStandards, __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["d" /* MAX_LEARNING_JOURNEY_COUNT */]);
        var _getSelectedStandardC = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["e" /* getSelectedStandardCount */])(selectedTopics),
          selectedStandardCount = _getSelectedStandardC.selectedStandardCount,
          standardCount = _getSelectedStandardC.standardCount;
        return _objectSpread(_objectSpread({}, state), {}, {
          genericCourses: genericCourses,
          isLoadingGenericCourses: false,
          selectedLearningJourneyIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["f" /* getAllLearningJourneys */])(selectedTopics),
          selectedStandardCount: selectedStandardCount,
          selectedTopics: selectedTopics,
          standardCount: standardCount,
          strands: topicsAndStandards,
          studentAssignments: [],
          selectedAssignmentHashKeys: {},
          topics: selectedTopics,
          selectedCourse: {
            id: action.courseId,
            version: action.courseVersion
          }
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["j" /* CLASSROOMS_ACQUIRED */]:
      {
        __WEBPACK_IMPORTED_MODULE_9__helpers_portal_comms__["a" /* default */].loadingSpinnerOff();
        return _objectSpread(_objectSpread({}, state), {}, {
          classrooms: action.payload || []
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["k" /* UPDATE_STRANDS */]:
      {
        var strands = state.strands;
        var id = action.id,
          checked = action.checked,
          searchTerm = action.searchTerm,
          actionType = action.actionType;
        var clonedStrands = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(strands);
        var updatedTopicData = [];
        var updatedStrandAndStandards = [];
        switch (actionType) {
          case 'selection':
            {
              updatedStrandAndStandards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["g" /* updateStrandAndStandards */])(id, checked, clonedStrands);
              if (searchTerm && searchTerm !== '') {
                var clonedData = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(updatedStrandAndStandards);
                updatedTopicData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["h" /* getFilteredStrandAndStandards */])(searchTerm, clonedData);
              } else {
                updatedTopicData = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(updatedStrandAndStandards);
              }
              break;
            }
          case 'uncheckAll':
            updatedStrandAndStandards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["i" /* updateStrands */])(false, clonedStrands);
            updatedTopicData = updatedStrandAndStandards;
            break;
          case 'reset':
            updatedStrandAndStandards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["i" /* updateStrands */])(true, clonedStrands);
            updatedTopicData = updatedStrandAndStandards;
            break;
          default:
            {
              updatedStrandAndStandards = strands;
              var clonedStrandData = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(updatedStrandAndStandards);
              updatedTopicData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["h" /* getFilteredStrandAndStandards */])(searchTerm, clonedStrandData);
            }
            break;
        }
        var _getSelectedStandardC2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["e" /* getSelectedStandardCount */])(updatedTopicData),
          _selectedStandardCount = _getSelectedStandardC2.selectedStandardCount,
          _standardCount = _getSelectedStandardC2.standardCount;
        return _objectSpread(_objectSpread({}, state), {}, {
          strands: updatedStrandAndStandards,
          topics: updatedTopicData,
          selectedStandardCount: _selectedStandardCount,
          standardCount: _standardCount
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["l" /* APPLY_FILTER */]:
      {
        var selectedCourse = state.selectedCourse,
          _strands = state.strands,
          _selectedStandardCount2 = state.selectedStandardCount,
          _standardCount2 = state.standardCount;
        var _id = selectedCourse.id,
          version = selectedCourse.version;
        var key = "".concat(version, "_").concat(_id, "_FILTER");
        var savedFilter = __WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__["a" /* default */].getItem(key);
        if (savedFilter) {
          __WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__["a" /* default */].removeItem(key);
        }
        __WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__["a" /* default */].setItem(key, _strands);
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedTopics: _strands,
          selectedLearningJourneyIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["f" /* getAllLearningJourneys */])(_strands),
          selectedStandardCount: _selectedStandardCount2,
          selectedAssignmentHashKeys: {},
          standardCount: _standardCount2
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["m" /* UPDATE_SELECTED_COURSE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedCourse: action.selectedCourse,
          studentAssignments: [],
          selectedStudentIds: [],
          studentUnAssignments: [],
          pausePolling: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["n" /* SHOW_HIDE_SEARCH_PANEL */]:
      {
        var _strands2 = state.strands;
        _strands2.forEach(function (strand) {
          strand.isExpand = !!strand.childTopics.find(function (s) {
            return s.selected;
          });
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          showSearchPanel: action.status,
          strands: _strands2,
          topics: _strands2
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["o" /* DISPLAY_MODAL_INFORMATION */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          displayModalKey: action.key
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["p" /* HIDE_STANDARD */]:
      {
        var _selectedTopics = state.selectedTopics,
          _studentsAssignmentStatus2 = state.studentsAssignmentStatus,
          _strands3 = state.strands;
        var updatedSelectedTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["j" /* removeStandard */])(action.id, _selectedTopics);
        var _getSelectedStandardC3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["e" /* getSelectedStandardCount */])(updatedSelectedTopics),
          _selectedStandardCount3 = _getSelectedStandardC3.selectedStandardCount;
        var learningJourneys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["f" /* getAllLearningJourneys */])(updatedSelectedTopics);
        var topic = _strands3.map(function (strand) {
          return _objectSpread(_objectSpread({}, strand), {}, {
            childTopics: strand.childTopics.map(function (t) {
              if (t.id === action.id) {
                var _t$childTopics;
                return _objectSpread(_objectSpread({}, t), {}, {
                  selected: false,
                  isExpand: false,
                  childTopics: (_t$childTopics = t.childTopics) === null || _t$childTopics === void 0 ? void 0 : _t$childTopics.map(function (c) {
                    return _objectSpread(_objectSpread({}, c), {}, {
                      selected: false
                    });
                  })
                });
              }
              return t;
            })
          });
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          topics: updatedSelectedTopics,
          strands: topic,
          selectedTopics: updatedSelectedTopics,
          selectedLearningJourneyIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["f" /* getAllLearningJourneys */])(updatedSelectedTopics),
          studentsAssignmentStatus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["b" /* updateAssignmentsHidden */])(_studentsAssignmentStatus2, learningJourneys),
          selectedStandardCount: _selectedStandardCount3
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["q" /* UPDATE_STUDENT_ASSIGNMENT */]:
      {
        var _assignmentStatus$met;
        var _studentsAssignmentStatus3 = state.studentsAssignmentStatus,
          selectedCells = state.selectedCells;
        var newSelectedCells = Number(selectedCells) || 0;
        var statusIndex = action.payload.index;
        var assignmentStatus = _studentsAssignmentStatus3[statusIndex];
        var updatedStudentsAssignmentStatus = _toConsumableArray(_studentsAssignmentStatus3);
        var updatedIsSelected = !(assignmentStatus !== null && assignmentStatus !== void 0 && (_assignmentStatus$met = assignmentStatus.metaData) !== null && _assignmentStatus$met !== void 0 && _assignmentStatus$met.isSelected);
        updatedStudentsAssignmentStatus[statusIndex] = _objectSpread(_objectSpread({}, assignmentStatus), {}, {
          metaData: _objectSpread(_objectSpread({}, assignmentStatus === null || assignmentStatus === void 0 ? void 0 : assignmentStatus.metaData), {}, {
            isSelected: updatedIsSelected
          })
        });
        if (updatedIsSelected) {
          newSelectedCells += 1;
        } else {
          newSelectedCells -= 1;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          studentsAssignmentStatus: updatedStudentsAssignmentStatus,
          selectedCells: newSelectedCells,
          pausePolling: newSelectedCells > 0
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["r" /* ASSIGN_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["s" /* ASSIGN_SUCCESS_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false,
          studentAssignments: [],
          studentUnAssignments: [],
          selectedStudentIds: []
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["t" /* ASSIGN_FAILURE_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["u" /* GRID_CELL_SELECTION */]:
      {
        var _action$payload = action.payload,
          _action$payload$index = _action$payload.indexes,
          indexes = _action$payload$index === void 0 ? [] : _action$payload$index,
          status = _action$payload.status;
        var _studentsAssignmentStatus4 = state.studentsAssignmentStatus,
          _selectedCells = state.selectedCells;
        var _updatedStudentsAssignmentStatus = _toConsumableArray(_studentsAssignmentStatus4);
        var isSelected = status === __WEBPACK_IMPORTED_MODULE_3__components_checkbox_constants__["a" /* CHECKED */];
        var numberSelectedCells = Number(_selectedCells) || 0;
        var changeCount = indexes.length;
        var _newSelectedCells = isSelected ? numberSelectedCells + changeCount : numberSelectedCells - changeCount;

        // Minor mutation to significantly reduce computation expense
        indexes.forEach(function (index) {
          var studentAssignmentStatus = _studentsAssignmentStatus4[index];
          var _ref = studentAssignmentStatus || {},
            learningJourneyResults = _ref.learningJourneyResults,
            stepsCount = _ref.stepsCount;
          var learningJourneyResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_status_cell_helpers__["a" /* getLearningJourneyResultByProgressFilter */])(learningJourneyResults, __WEBPACK_IMPORTED_MODULE_5__components_assignment_filters_filters_constants__["b" /* ASSIGNED */]);
          if (stepsCount === (learningJourneyResult === null || learningJourneyResult === void 0 ? void 0 : learningJourneyResult.stepsCompleted)) {
            return;
          }
          if (studentAssignmentStatus) {
            _updatedStudentsAssignmentStatus[index].metaData.isSelected = isSelected;
          }
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          studentsAssignmentStatus: _updatedStudentsAssignmentStatus,
          selectedCells: _newSelectedCells,
          pausePolling: _newSelectedCells > 0
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["v" /* UNASSIGN_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["w" /* UNASSIGN_SUCCESS_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false,
          studentUnAssignments: [],
          studentAssignments: []
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["x" /* UNASSIGN_FAILURE_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["y" /* EXPAND_COLLAPSE_REQUEST */]:
      {
        var topics = state.topics;
        var cloneTopics = _toConsumableArray(topics);
        var _topic = cloneTopics.find(function (t) {
          return t.id === action.strandId;
        });
        _topic.isExpand = !_topic.isExpand;
        return _objectSpread(_objectSpread({}, state), {}, {
          topics: cloneTopics
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["z" /* SET_SELECTED_CLASS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedClass: action.selectedClass,
          selectedAssignmentHashKeys: {}
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["A" /* SET_SELECTED_GROUP */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedGroup: action.selectedGroup,
          selectedAssignmentHashKeys: {}
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["B" /* SET_SELECTED_PUBLICATION */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedPublication: action.selectedPublication,
          selectedAssignmentHashKeys: {}
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["C" /* SET_SELECTED_COURSE_OPTION */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedCourseOption: action.selectedCourseOption,
          selectedAssignmentHashKeys: {}
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["D" /* RESTRICT_ACCESS_FAILURE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["E" /* RESTRICT_ACCESS_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["F" /* RESTRICT_ACCESS_SUCCESS */]:
      {
        var selectedGroup = state.selectedGroup;
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false,
          isRestricted: action.payload,
          selectedGroup: _objectSpread(_objectSpread({}, selectedGroup), {}, {
            isRestricted: action.payload
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["G" /* SET_ASSIGNMENT_FILTER_TYPE */]:
      {
        var _studentsAssignmentStatus5 = state.studentsAssignmentStatus.map(function (status) {
          return _objectSpread(_objectSpread({}, status), {}, {
            metaData: _objectSpread(_objectSpread({}, status.metaData), {}, {
              isSelected: false
            })
          });
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedAssignmentFilterType: action.assignmentType,
          studentsAssignmentStatus: _studentsAssignmentStatus5,
          studentAssignments: [],
          studentUnAssignments: [],
          selectedStudentIds: [],
          selectedCells: 0,
          pausePolling: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["H" /* SELECT_ACCURACY_PROGRESS_TOGGLE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          accuracyProgressToggle: _objectSpread(_objectSpread({}, state.accuracyProgressToggle), {}, {
            currentFilter: action.selectedFilter
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["I" /* SELECT_ACCURACY_SUB_FILTER */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          accuracyProgressToggle: _objectSpread(_objectSpread({}, state.accuracyProgressToggle), {}, {
            accuracySubFilter: action.accuracySubFilter
          }),
          selectedAssignmentHashKeys: {}
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["J" /* SELECT_PROGRESS_SUB_FILTER */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          accuracyProgressToggle: _objectSpread(_objectSpread({}, state.accuracyProgressToggle), {}, {
            progressSubFilter: action.progressSubFilter
          }),
          selectedAssignmentHashKeys: {}
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["K" /* SELECT_ASSIGNMENT_HASH_KEY */]:
      {
        var assignmentHashKey = action.assignmentHashKey,
          selectedValues = action.selectedValues;
        var updatedSelectedAssignmentHashKeys = _objectSpread({}, state.selectedAssignmentHashKeys);
        if (updatedSelectedAssignmentHashKeys[assignmentHashKey]) {
          delete updatedSelectedAssignmentHashKeys[assignmentHashKey];
        } else {
          updatedSelectedAssignmentHashKeys[assignmentHashKey] = selectedValues;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedAssignmentHashKeys: updatedSelectedAssignmentHashKeys
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["L" /* SELECT_ASSIGNMENT_HASH_KEYS */]:
      {
        var assignmentHashKeys = action.assignmentHashKeys;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedAssignmentHashKeys: _objectSpread(_objectSpread({}, state.selectedAssignmentHashKeys), assignmentHashKeys)
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["M" /* UNSELECT_ASSIGNMENT_HASH_KEYS */]:
      {
        var _assignmentHashKeys = action.assignmentHashKeys;
        var _updatedSelectedAssignmentHashKeys = _objectSpread({}, state.selectedAssignmentHashKeys);
        Object.keys(_assignmentHashKeys).forEach(function (assignmentHashKey) {
          if (_updatedSelectedAssignmentHashKeys[assignmentHashKey]) {
            delete _updatedSelectedAssignmentHashKeys[assignmentHashKey];
          }
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedAssignmentHashKeys: _updatedSelectedAssignmentHashKeys
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["N" /* QUICK_SELECTION */]:
      {
        var selectionType = action.payload.selectionType;
        var _state$accuracyProgre = state.accuracyProgressToggle,
          currentFilter = _state$accuracyProgre.currentFilter,
          accuracySubFilter = _state$accuracyProgre.accuracySubFilter,
          progressSubFilter = _state$accuracyProgre.progressSubFilter;
        var updatedSelection;
        var totalCellSelected = 0;
        var isProgressFilterSelected = currentFilter === __WEBPACK_IMPORTED_MODULE_4__components_accuracy_progress_toggle_accuracy_progress_constants__["b" /* PROGRESS */];
        var getLearningJourneyResult = isProgressFilterSelected ? __WEBPACK_IMPORTED_MODULE_7__components_status_cell_helpers__["a" /* getLearningJourneyResultByProgressFilter */] : __WEBPACK_IMPORTED_MODULE_7__components_status_cell_helpers__["b" /* getLearningJourneyResultByAccuracyFilter */];
        var selectedSubFilter = isProgressFilterSelected ? progressSubFilter : accuracySubFilter;
        var updatedStudents = state.studentsAssignmentStatus.map(function (studentAssignmentStatus) {
          var learningJourneyResults = studentAssignmentStatus.learningJourneyResults,
            stepsCount = studentAssignmentStatus.stepsCount;
          /*
            For currently assigned, the subfilter doesn't matter
            So, we need to get the learningJourneyResults without applying filter
          */
          var learningJourneyResult = selectionType === __WEBPACK_IMPORTED_MODULE_6__components_quick_selector_quick_selector_constants__["a" /* CURRENTLY_ASSIGNED */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_status_cell_helpers__["c" /* findVoluntaryAndAssignedLearningJourneyResult */])(learningJourneyResults) : getLearningJourneyResult(learningJourneyResults, selectedSubFilter);
          var isSelectable = isProgressFilterSelected ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["k" /* checkProgressCellSelectable */])(selectionType, learningJourneyResult, stepsCount) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__upf_assign_util__["l" /* checkAccuracyCellSelectable */])(selectionType, learningJourneyResult);
          totalCellSelected = isSelectable ? totalCellSelected + 1 : totalCellSelected;
          updatedSelection = _objectSpread(_objectSpread({}, studentAssignmentStatus.metaData), {}, {
            isSelected: isSelectable
          });
          return _objectSpread(_objectSpread({}, studentAssignmentStatus), {}, {
            metaData: updatedSelection
          });
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          studentsAssignmentStatus: updatedStudents,
          pausePolling: totalCellSelected > 0
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["O" /* RESET_SELECTED_ASSIGNMENT_HASH_KEYS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedAssignmentHashKeys: {}
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["P" /* DISABLE_SHOW_GRID_LOADER */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          showGridLoader: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_12__upf_assign_action_types__["Q" /* UPDATE_SORTED_STUDENT_IDS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          sortedStudentIds: _toConsumableArray(action.sortedStudentIds)
        });
      }
    default:
      return _objectSpread({}, state);
  }
});

/***/ }),

/***/ "LBir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("X9I8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__ = __webpack_require__("vIo2");





var StandardInfo = function StandardInfo(props) {
  var standardName = props.standardName,
    ljName = props.ljName,
    externalKey = props.externalKey,
    description = props.description,
    hideStrand = props.hideStrand,
    count = props.count,
    displayHideOption = props.displayHideOption,
    i18n = props.i18n;
  var stepIcon = null;
  switch (count) {
    case 1:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["g" /* Step1 */];
      break;
    case 2:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["h" /* Step2 */];
      break;
    case 3:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["i" /* Step3 */];
      break;
    case 4:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["j" /* Step4 */];
      break;
    case 5:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["k" /* Step5 */];
      break;
    default:
      break;
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* InfoWrapper */], {
    count: count
  }, displayHideOption && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* Hide */], {
    onClick: hideStrand
  }, i18n._("Hide")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "headerWrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, standardName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subTitle"
  }, externalKey), ljName && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subTitle"
  }, ljName)), count ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* Icon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
    className: "steps",
    icon: stepIcon
  })) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "description"
  }, description));
};
StandardInfo.propTypes = {
  standardName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ljName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  externalKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideStrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  displayHideOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (StandardInfo);

/***/ }),

/***/ "LFcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__palette__ = __webpack_require__("c77w");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].typography), {}, {
  title: {
    size: '30px',
    weight: 500
  },
  subtitle: {
    size: '16px',
    weight: 600,
    colour: __WEBPACK_IMPORTED_MODULE_1__palette__["a" /* default */].primary.main
  },
  heading: {
    size: '21px'
  },
  modalTitle: {
    size: '20px'
  },
  body: {
    size: '14px'
  },
  button: {
    size: '11px'
  },
  info: {
    size: '10px'
  },
  cell: {
    size: '9px'
  }
}));

/***/ }),

/***/ "LHK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var AssignDateModalInner = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 0;\n  width: 320px;\n  height: 200px;\n  background-color: white;\n  border-radius: 4px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  & div[class*='ButtonWrapper'] {\n    border-radius: 4px;\n  }\n"])));
/* harmony default export */ __webpack_exports__["a"] = (AssignDateModalInner);

/***/ }),

/***/ "LZW0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var AssignButtonWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
/* harmony default export */ __webpack_exports__["a"] = (AssignButtonWrapper);

/***/ }),

/***/ "MH+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NumberWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  cursor: pointer;\n  width: 100%;\n  height: 20px;\n  text-align: center;\n\n  [class^='svgIconComponent'] {\n    width: 23px;\n  }\n"])));
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n"])));
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  height: 20px;\n  cursor: pointer;\n"])));
var NumberWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  color: red;\n  font-weight: 600;\n  text-align: center;\n  left: -14px;\n  top: 1px;\n"])));
/* unused harmony default export */ var _unused_webpack_default_export = (Root);

/***/ }),

/***/ "N5/L":
/***/ (function(module, exports) {

module.exports = {
  // The application name, to be used when asking the configuration system for settings
  appName: 'UpfAssignHost',
  // TODO: 1. Set this to the name of the host application
  // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them
  childApplications: []
};

/***/ }),

/***/ "NBPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getScoreBandColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ToolTipWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AssignInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AccuracyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Circle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConnectBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__ = __webpack_require__("Q0m1");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var HOVER = __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["a" /* SCORE_BAND_TYPES */].HOVER,
  DEFAULT = __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["a" /* SCORE_BAND_TYPES */].DEFAULT;
var getScoreBandColor = function getScoreBandColor(range, type) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* getScoreBands */])({
    currentlyAssigned: type === DEFAULT ? '#CBE8BC' : '#DAE7D3',
    completed1to20: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed1to20[type],
    completed21to40: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed21to40[type],
    completed41to60: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed41to60[type],
    completed61to80: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed61to80[type],
    completed81to100: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed81to100[type],
    range: range
  });
};
var ToolTipWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  top: 20px;\n  left: -3px;\n  color: white;\n  font-size: 10px;\n  height: 23px;\n\n  &:before {\n    display: none;\n    bottom: 95%;\n    left: 10px;\n    content: '';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border: 5px solid transparent;\n    border-bottom-color: #3b4e5e;\n    margin-left: -5px;\n  }\n"])));
var AssignInfo = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var hasAccuracyResult = props.hasAccuracyResult;
  return "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding: 0 5px;\n    white-space: nowrap;\n    height: 100%;\n    background-color: #3b4e5e;\n    color: white;\n    border-radius: ".concat(hasAccuracyResult ? '5px 0 0 5px' : '5px', ";\n  ");
});
var AccuracyInfo = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var resultAccuracy = props.resultAccuracy,
    hasAccuracyResult = props.hasAccuracyResult;
  var bgColor = hasAccuracyResult ? getScoreBandColor(resultAccuracy, DEFAULT) : '#3b4e5e';
  return "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: ".concat(hasAccuracyResult ? '30px' : '0px', ";\n    height: 100%;\n    background-color: ").concat(bgColor, ";\n    border-radius: 0 5px 5px 0;\n    color: white;\n  ");
});
var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover ", " {\n    display: flex;\n\n    &:before {\n      display: flex;\n    }\n  }\n"])), ToolTipWrapper);
var Circle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var isFocusedResult = props.isFocusedResult,
    resultAccuracy = props.resultAccuracy;
  var circleSize = isFocusedResult ? 10 : 12;
  var scoreBandColorDefault = getScoreBandColor(resultAccuracy, DEFAULT);
  var scoreBandColorHover = getScoreBandColor(resultAccuracy, HOVER);
  return "\n    margin-right: ".concat(isFocusedResult ? '1px' : '0px', ";\n    width: ").concat(circleSize, "px;\n    height: ").concat(circleSize, "px;\n    border-radius: 50%;\n    background-color: ").concat(isFocusedResult ? scoreBandColorDefault : scoreBandColorHover, ";\n\n    ").concat(isFocusedResult ? "\n          border: 2px solid #fff;\n          box-shadow: 0 0 0 1px #3b4e5e;\n        " : '', "\n\n    &:hover {\n      background-color: ").concat(scoreBandColorDefault, ";\n      ").concat(isFocusedResult ? "box-shadow: 0 0 0 1px ".concat(scoreBandColorDefault) : '', "\n    }\n  ");
});
var ConnectBlock = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: #cfcfcf;\n  width: 5.5px;\n  height: 2.5px;\n"])));

/***/ }),

/***/ "OD1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getTranslations = function getTranslations(_ref) {
  var i18n = _ref.i18n;
  return {
    PREVIEW_TEXT: i18n._("Preview"),
    DEFAULT_PREVIEW_ERROR_TEXT: i18n._("Preview not available at this moment.")
  };
};
/* harmony default export */ __webpack_exports__["a"] = (getTranslations);

/***/ }),

/***/ "OEzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_upf_assign_upf_assign_action_types__ = __webpack_require__("spZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip_tooltip__ = __webpack_require__("I2I3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_tool_tip__ = __webpack_require__("FFsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_hooks_use_manage_local_storage__ = __webpack_require__("tCg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__accuracy_progress_toggle_styled__ = __webpack_require__("YUC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__accuracy_progress_constants__ = __webpack_require__("yHtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations__ = __webpack_require__("eKQ2");
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }














var AccuracyProgressToggle = function AccuracyProgressToggle(_ref) {
  var i18n = _ref.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var currentSelection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.accuracyProgressToggle.currentFilter;
  });
  var _useToolTip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_tool_tip__["a" /* default */])(),
    targetRef = _useToolTip.targetRef,
    showToolTip = _useToolTip.showToolTip,
    onHoverHandlers = _useToolTip.onHoverHandlers;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_hooks_use_manage_local_storage__["a" /* default */])({
    key: __WEBPACK_IMPORTED_MODULE_10__helpers_constants__["l" /* LOCAL_STORAGE_KEYS */].ACCURACY_PROGRESS_FILTER,
    value: currentSelection,
    defaultValue: __WEBPACK_IMPORTED_MODULE_12__accuracy_progress_constants__["a" /* ACCURACY */],
    updateValueFromLocalStorage: function updateValueFromLocalStorage(updatedValue) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__containers_upf_assign_upf_assign_action_types__["H" /* SELECT_ACCURACY_PROGRESS_TOGGLE */],
        selectedFilter: updatedValue
      });
    }
  });
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__translations__["a" /* default */])({
      i18n: i18n
    }),
    ACCURACY_BUTTON_TEXT = _getTranslations.ACCURACY_BUTTON_TEXT,
    ACCURACY_BUTTON_TITLE = _getTranslations.ACCURACY_BUTTON_TITLE,
    ACCURACY_INFO_TEXT = _getTranslations.ACCURACY_INFO_TEXT,
    PROGRESS_BUTTON_TEXT = _getTranslations.PROGRESS_BUTTON_TEXT,
    PROGRESS_BUTTON_TITLE = _getTranslations.PROGRESS_BUTTON_TITLE,
    PROGRESS_INFO_TEXT = _getTranslations.PROGRESS_INFO_TEXT;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__accuracy_progress_toggle_styled__["a" /* AccuracyProgressWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__accuracy_progress_toggle_styled__["b" /* AccuracyWrapper */], {
    selected: currentSelection === __WEBPACK_IMPORTED_MODULE_12__accuracy_progress_constants__["a" /* ACCURACY */],
    "data-testid": "accuracy-wrapper",
    title: ACCURACY_BUTTON_TITLE,
    onClick: function onClick() {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__containers_upf_assign_upf_assign_action_types__["H" /* SELECT_ACCURACY_PROGRESS_TOGGLE */],
        selectedFilter: __WEBPACK_IMPORTED_MODULE_12__accuracy_progress_constants__["a" /* ACCURACY */]
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__containers_upf_assign_upf_assign_actions__["m" /* clearCellSelection */])());
    }
  }, ACCURACY_BUTTON_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__accuracy_progress_toggle_styled__["c" /* ProgressWrapper */], {
    title: PROGRESS_BUTTON_TITLE,
    selected: currentSelection === __WEBPACK_IMPORTED_MODULE_12__accuracy_progress_constants__["b" /* PROGRESS */],
    "data-testid": "progress-wrapper",
    onClick: function onClick() {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__containers_upf_assign_upf_assign_action_types__["H" /* SELECT_ACCURACY_PROGRESS_TOGGLE */],
        selectedFilter: __WEBPACK_IMPORTED_MODULE_12__accuracy_progress_constants__["b" /* PROGRESS */]
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__containers_upf_assign_upf_assign_actions__["m" /* clearCellSelection */])());
    }
  }, PROGRESS_BUTTON_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__accuracy_progress_toggle_styled__["d" /* IconWrapper */], _extends({
    ref: targetRef
  }, onHoverHandlers), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["E" /* Info */]
  }), showToolTip && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__tooltip_tooltip__["a" /* default */], {
    variant: "light",
    targetRef: targetRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__accuracy_progress_toggle_styled__["e" /* ToolTipInfo */], null, currentSelection === __WEBPACK_IMPORTED_MODULE_12__accuracy_progress_constants__["a" /* ACCURACY */] ? ACCURACY_INFO_TEXT : PROGRESS_INFO_TEXT))));
};
AccuracyProgressToggle.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (AccuracyProgressToggle);

/***/ }),

/***/ "OJ4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// todo: Update naming to better reflect... remove redundant text
var getTranslations = function getTranslations(_ref) {
  var i18n = _ref.i18n;
  return {
    ALL_CELLS_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.allCells",
      defaults: "All Cells"
    }),
    ALL_CURRENTLY_ASSIGN_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.allCurrentlyAssigned",
      defaults: "All Currently Assigned"
    }),
    CLEAN_SELECTION_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.clearSelections",
      defaults: "Clear Selections"
    }),
    PROGRESS_1_TO_20_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.results20",
      defaults: "1 - 20% Complete"
    }),
    PROGRESS_21_TO_40_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.results40",
      defaults: "21 - 40% Complete"
    }),
    PROGRESS_41_TO_60_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.results60",
      defaults: "41 - 60% Complete"
    }),
    PROGRESS_61_TO_80_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.results80",
      defaults: "61 - 80% Complete"
    }),
    PROGRESS_81_TO_100_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.results100",
      defaults: "81 - 100% Complete"
    }),
    ACCURACY_1_TO_20_TEXT: i18n._(
    /*i18n*/
    {
      id: "accuracyQuickSelector.results20",
      defaults: "1 - 20% Accuracy"
    }),
    ACCURACY_21_TO_40_TEXT: i18n._(
    /*i18n*/
    {
      id: "accuracyQuickSelector.results40",
      defaults: "21 - 40% Accuracy"
    }),
    ACCURACY_41_TO_60_TEXT: i18n._(
    /*i18n*/
    {
      id: "accuracyQuickSelector.results60",
      defaults: "41 - 60% Accuracy"
    }),
    ACCURACY_61_TO_80_TEXT: i18n._(
    /*i18n*/
    {
      id: "accuracyQuickSelector.results80",
      defaults: "61 - 80% Accuracy"
    }),
    ACCURACY_81_TO_100_TEXT: i18n._(
    /*i18n*/
    {
      id: "accuracyQuickSelector.results100",
      defaults: "81 - 100% Accuracy"
    }),
    SELECT_TEXT: i18n._(
    /*i18n*/
    {
      id: "progressQuickSelector.select",
      defaults: "Select..."
    })
  };
};
/* harmony default export */ __webpack_exports__["a"] = (getTranslations);

/***/ }),

/***/ "OmdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_context_modal__ = __webpack_require__("Fvqa");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var useContextModal = function useContextModal() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    defaultTargetRef = _ref.defaultTargetRef,
    _ref$defaultPositionX = _ref.defaultPositionX,
    defaultPositionX = _ref$defaultPositionX === void 0 ? 0 : _ref$defaultPositionX,
    _ref$defaultPositionY = _ref.defaultPositionY,
    defaultPositionY = _ref$defaultPositionY === void 0 ? 0 : _ref$defaultPositionY,
    _ref$defaultPositionA = _ref.defaultPositionArrow,
    defaultPositionArrow = _ref$defaultPositionA === void 0 ? 0 : _ref$defaultPositionA,
    _ref$defaultPositionA2 = _ref.defaultPositionArrowY,
    defaultPositionArrowY = _ref$defaultPositionA2 === void 0 ? 0 : _ref$defaultPositionA2,
    _ref$defaultShowConte = _ref.defaultShowContextMenu,
    defaultShowContextMenu = _ref$defaultShowConte === void 0 ? false : _ref$defaultShowConte,
    _ref$leftAlign = _ref.leftAlign,
    leftAlign = _ref$leftAlign === void 0 ? false : _ref$leftAlign,
    _ref$overflowWrap = _ref.overflowWrap,
    overflowWrap = _ref$overflowWrap === void 0 ? 'anywhere' : _ref$overflowWrap;
  var targetRef = defaultTargetRef || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultPositionX),
    _useState2 = _slicedToArray(_useState, 2),
    positionX = _useState2[0],
    setPositionX = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultPositionY),
    _useState4 = _slicedToArray(_useState3, 2),
    positionY = _useState4[0],
    setPositionY = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultPositionArrow),
    _useState6 = _slicedToArray(_useState5, 2),
    positionArrow = _useState6[0],
    setPositionArrow = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultPositionArrowY),
    _useState8 = _slicedToArray(_useState7, 2),
    positionArrowY = _useState8[0],
    setPositionArrowY = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultShowContextMenu),
    _useState0 = _slicedToArray(_useState9, 2),
    showContextMenu = _useState0[0],
    setContextMenu = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('100%'),
    _useState10 = _slicedToArray(_useState1, 2),
    targetHeight = _useState10[0],
    setTargetHeight = _useState10[1];
  var showContextModal = function showContextModal() {
    if (targetRef.current) {
      var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getContextCoords */])(targetRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_2__components_context_modal__["a" /* contextModalWidth */], leftAlign),
        posX = _getContextCoords.posX,
        posY = _getContextCoords.posY,
        posArrow = _getContextCoords.posArrow,
        posArrowY = _getContextCoords.posArrowY,
        height = _getContextCoords.height;
      setPositionY(posY);
      setPositionX(posX);
      setPositionArrow(posArrow);
      setPositionArrowY(posArrowY);
      setContextMenu(!showContextMenu);
      setTargetHeight(height);
    }
    return null;
  };
  var closeContextMenu = function closeContextMenu() {
    return setContextMenu(false);
  };
  return {
    showContextModal: showContextModal,
    contentModalProps: {
      show: showContextMenu,
      positionArrow: positionArrow,
      positionArrowY: positionArrowY,
      positionX: positionX,
      positionY: positionY,
      leftAlign: leftAlign,
      targetHeight: targetHeight,
      overflowWrap: overflowWrap
    },
    closeContextMenu: closeContextMenu,
    targetRef: targetRef
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useContextModal);

/***/ }),

/***/ "OsCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__ = __webpack_require__("5i5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg__ = __webpack_require__("cLZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg__ = __webpack_require__("Do0+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__("bLeE");






var ResizeIcon = function ResizeIcon(props) {
  var isCollapsed = props.isCollapsed,
    onClickCallback = props.onClickCallback;
  var icon = isCollapsed ? __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg___default.a : __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg___default.a;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* Root */], {
    "data-testid": "footer-resize-icon",
    isCollapsed: isCollapsed,
    onClick: function onClick() {
      return onClickCallback(!isCollapsed);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__["default"], {
    src: icon,
    cacheRequests: true
  }));
};
ResizeIcon.propTypes = {
  isCollapsed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onClickCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ResizeIcon);

/***/ }),

/***/ "Q0m1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AccuracyColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProgressColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCORE_BAND_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScoreBandColors; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Unused in all v2 components
var AccuracyColors = {
  currentlyAssigned: '#dae7d3',
  accuracy0to50: '#900012',
  accuracy51to84: '#2452bb',
  accuracy85to100: '#008902'
};
var ProgressColors = {
  currentlyAssigned: '#dae7d3',
  completed1to20: '#031c73',
  completed21to40: '#314eb5',
  completed41to60: '#0c80a3',
  completed61to80: '#0fc2a8',
  completed81to100: '#4bda40'
};
var SCORE_BAND_TYPES = {
  DEFAULT: 'default',
  HOVER: 'hover'
};
var ScoreBandColors = {
  currentlyAssigned: _defineProperty(_defineProperty({}, SCORE_BAND_TYPES.DEFAULT, '#dae7d3'), SCORE_BAND_TYPES.HOVER, 'rgb(229,229,229)'),
  completed1to20: _defineProperty(_defineProperty({}, SCORE_BAND_TYPES.DEFAULT, '#c53902'), SCORE_BAND_TYPES.HOVER, '#DAA18E'),
  completed21to40: _defineProperty(_defineProperty({}, SCORE_BAND_TYPES.DEFAULT, '#e06d3f'), SCORE_BAND_TYPES.HOVER, '#E8B9A4'),
  completed41to60: _defineProperty(_defineProperty({}, SCORE_BAND_TYPES.DEFAULT, '#e89e13'), SCORE_BAND_TYPES.HOVER, '#EECF9D'),
  completed61to80: _defineProperty(_defineProperty({}, SCORE_BAND_TYPES.DEFAULT, '#81daab'), SCORE_BAND_TYPES.HOVER, '#CAEBD6'),
  completed81to100: _defineProperty(_defineProperty({}, SCORE_BAND_TYPES.DEFAULT, '#37c97c'), SCORE_BAND_TYPES.HOVER, '#B3E2C1')
};

/***/ }),

/***/ "QBF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchable_dropdownlist_styled__ = __webpack_require__("wfv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




var ClassFilters = function ClassFilters(_ref) {
  var classroomOptions = _ref.classroomOptions,
    onClassroomChange = _ref.onClassroomChange,
    selectedClass = _ref.selectedClass;
  /**
   * VARIABLES
   */
  var hasSingleClass = classroomOptions.length === 1;

  /**
   * RENDER
   */
  if (hasSingleClass) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__searchable_dropdownlist_styled__["a" /* InputWrapper */], {
      type: 'text',
      value: classroomOptions[0].label,
      readOnly: true
    });
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["DropdownMenu"], {
    options: classroomOptions,
    selectedOption: selectedClass || classroomOptions[0],
    onSelectOption: onClassroomChange
  });
};
ClassFilters.propTypes = {
  classroomOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  onClassroomChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  selectedClass: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ClassFilters);

/***/ }),

/***/ "QR7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClassroomCourseVersionHashKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGroupHashKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapEntitiesToOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sortEntitiesByIds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var getClassroomCourseVersionHashKey = function getClassroomCourseVersionHashKey(_ref) {
  var classroomId = _ref.classroomId,
    courseId = _ref.courseId;
  return "classroomId#".concat(classroomId, "_courseId#").concat(courseId);
};
var getGroupHashKey = function getGroupHashKey(_ref2) {
  var classroomId = _ref2.classroomId,
    groupId = _ref2.groupId;
  return "classroomId#".concat(classroomId, "_groupId#").concat(groupId);
};
var mapEntitiesToOptions = function mapEntitiesToOptions(entities) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$valueColumn = _ref3.valueColumn,
    valueColumn = _ref3$valueColumn === void 0 ? 'id' : _ref3$valueColumn,
    _ref3$labelColumn = _ref3.labelColumn,
    labelColumn = _ref3$labelColumn === void 0 ? 'name' : _ref3$labelColumn;
  return Object.values(entities).map(function (entity) {
    return {
      value: entity[valueColumn],
      label: entity[labelColumn]
    };
  });
};
var sortEntitiesByIds = function sortEntitiesByIds(_ref4) {
  var entities = _ref4.entities,
    ids = _ref4.ids,
    _ref4$direction = _ref4.direction,
    direction = _ref4$direction === void 0 ? 'asc' : _ref4$direction,
    sortKey = _ref4.sortKey;
  var sortedIds = _toConsumableArray(ids);
  var findEntityKeyById = function findEntityKeyById(id) {
    var _entities$id;
    return entities === null || entities === void 0 || (_entities$id = entities[id]) === null || _entities$id === void 0 ? void 0 : _entities$id[sortKey];
  };
  return __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default()(sortedIds, findEntityKeyById, [direction]);
};
/* unused harmony default export */ var _unused_webpack_default_export = (getClassroomCourseVersionHashKey);

/***/ }),

/***/ "Qipw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grid__ = __webpack_require__("JT4Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__grid_collapsed__ = __webpack_require__("UgNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__learning_journey__ = __webpack_require__("7j7a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__standard_info__ = __webpack_require__("LBir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__collapsed__ = __webpack_require__("JLXX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled__ = __webpack_require__("uG5p");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }















var Standard = function Standard(_ref) {
  var collapseAllStandards = _ref.collapseAllStandards,
    description = _ref.description,
    externalKey = _ref.externalKey,
    i18n = _ref.i18n,
    id = _ref.id,
    isStandardDirty = _ref.isStandardDirty,
    learningJourney = _ref.learningJourney,
    setIsStandardDirty = _ref.setIsStandardDirty,
    topicName = _ref.topicName;
  var iconRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var infoRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContextMenu = _useState2[0],
    setContextMenu = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCallOutMenu = _useState4[0],
    setCallOutMenu = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionX = _useState6[0],
    setPositionX = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionY = _useState8[0],
    setPositionY = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(collapseAllStandards),
    _useState0 = _slicedToArray(_useState9, 2),
    isCollapsed = _useState0[0],
    setIsCollapsed = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState10 = _slicedToArray(_useState1, 2),
    positionArrow = _useState10[0],
    setPositionArrow = _useState10[1];
  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState12 = _slicedToArray(_useState11, 2),
    positionXCallout = _useState12[0],
    setPositionXCallout = _useState12[1];
  var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState14 = _slicedToArray(_useState13, 2),
    positionYCallout = _useState14[0],
    setPositionYCallout = _useState14[1];
  var _useState15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState16 = _slicedToArray(_useState15, 2),
    positionArrowCallout = _useState16[0],
    setPositionArrowCallout = _useState16[1];
  var _useState17 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState18 = _slicedToArray(_useState17, 2),
    contextTheme = _useState18[0],
    setContextTheme = _useState18[1];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!isStandardDirty) {
      setIsCollapsed(collapseAllStandards);
    }
  }, [collapseAllStandards, isStandardDirty]);
  var showDropdown = function showDropdown() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["d" /* getContextCoords */])(iconRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_9__context_modal__["a" /* contextModalWidth */]),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow;
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setContextTheme(null);
    setCallOutMenu(false);
    if (showContextMenu) {
      setContextMenu(false);
    } else {
      setContextMenu(true);
    }
  };
  var hideStandardBlock = function hideStandardBlock() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__containers_upf_assign_upf_assign_actions__["c" /* hideStandard */])(id));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__containers_upf_assign_upf_assign_actions__["d" /* displayModalInfo */])(-1));
  };
  var handleExpandCollapse = function handleExpandCollapse(state) {
    setIsStandardDirty(true);
    setIsCollapsed(state);
  };
  var showCallOut = function showCallOut(e) {
    var _getContextCoords2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["d" /* getContextCoords */])(e, __WEBPACK_IMPORTED_MODULE_9__context_modal__["a" /* contextModalWidth */]),
      posX = _getContextCoords2.posX,
      posArrow = _getContextCoords2.posArrow;
    var _infoRef$current$getB = infoRef.current.getBoundingClientRect(),
      bottom = _infoRef$current$getB.bottom;
    setPositionYCallout(bottom + 12);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('standard');
    setCallOutMenu(true);
  };
  var hideCallOut = function hideCallOut() {
    setCallOutMenu(false);
  };
  if (isCollapsed) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["a" /* CollapsedWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__collapsed__["a" /* default */], {
      externalKey: externalKey,
      handleOnExpand: function handleOnExpand() {
        return handleExpandCollapse(false);
      },
      topicName: topicName,
      learningJourney: learningJourney,
      id: id,
      description: description,
      i18n: i18n
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_collapsed__["a" /* default */], {
      standardId: id
    }));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["b" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["c" /* FixedWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["d" /* StandardWrapper */], {
    lj: learningJourney.length,
    className: "standard",
    id: "showContextModal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["e" /* Info */], {
    role: "button",
    tabIndex: "-1",
    onClick: showDropdown,
    lj: learningJourney.length,
    onMouseEnter: showCallOut,
    onMouseLeave: hideCallOut,
    ref: infoRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["f" /* Content */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["g" /* ExternalKey */], null, externalKey), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["h" /* TopicName */], null, topicName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["i" /* Icon */], {
    ref: iconRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["e" /* StandardDropdown */]
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["i" /* Icon */], {
    role: "button",
    tabIndex: "-1",
    onClick: function onClick() {
      return handleExpandCollapse(true);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["f" /* CollapseButton */]
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled__["j" /* LearningJourneyWrapper */], null, learningJourney.map(function (lj) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__learning_journey__["a" /* default */], {
      key: lj.id,
      learningJourneyId: lj.id
    });
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__grid__["a" /* default */], {
    standardId: id
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setContextMenu(false);
    },
    forButton: "showContextModal_".concat(id)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_modal__["b" /* default */], {
    show: showContextMenu,
    positionArrow: positionArrow,
    positionX: positionX,
    positionY: positionY
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__standard_info__["a" /* default */], {
    standardName: topicName,
    externalKey: externalKey,
    description: description,
    hideStrand: hideStandardBlock,
    displayHideOption: true,
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_modal__["b" /* default */], {
    show: showCallOutMenu,
    positionArrow: positionArrowCallout,
    positionX: positionXCallout,
    positionY: positionYCallout,
    contextTheme: contextTheme,
    name: externalKey !== '' ? "".concat(externalKey, " : ").concat(topicName) : "".concat(topicName)
  })));
};
Standard.propTypes = {
  externalKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  topicName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  learningJourney: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  collapseAllStandards: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isStandardDirty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  setIsStandardDirty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Standard.defaultProps = {
  externalKey: '',
  setIsStandardDirty: function setIsStandardDirty() {}
};
Standard.whyDidYouRender = false;
/* harmony default export */ __webpack_exports__["a"] = (Standard);

/***/ }),

/***/ "QjCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InfoTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InfoTooltipText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  justify-content: center;\n  align-items: center;\n  margin-left: 6px;\n  height: 20px;\n  width: 20px;\n  \n  &:hover {\n    background-color: #dcf4fd;\n  \tborder-radius: 60px;\n\tcursor: pointer;\n  }\n"])));
var InfoTooltip = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  visibility: hidden;\n  opacity: 1;\n  position: absolute;\n  top: 60px;\n  left: -320px;\n  background: white;\n  width: 368px;\n  min-height: 104px;\n  border: 1px grey solid;\n  border-radius: 12px;\n  transform: translate(0, -30%);\n  white-space: normal;\n\n  &:before,\n  &:after {\n    bottom: 100%;\n    border: solid transparent;\n    content: ' ';\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:before {\n    border-color: rgba(194, 194, 194, 0);\n    border-bottom-color: grey;\n    border-width: 12px;\n\tleft: 318px;\n  }\n\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: white;\n    border-width: 11px;\n\tleft: 319px;\n\ttop: -21px;\n  }\n"])));
var InfoTooltipText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: left;\n  background: white;\n  color: black;\n  margin: 5px 10px;\n"])));
var InfoIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-left: 5px;\n  margin-bottom: 1px;\n\n  &:hover {\n\tbackground-color: #dcf4fd;\n  \tborder-radius: 60px;\n  }\n  \n  &:hover ", " {\n\tcursor: pointer;\n    visibility: visible;\n    opacity: 1;\n  }\n"])), InfoTooltip);

/***/ }),

/***/ "QpMW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".buttonsContainer---2brtY {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-pack: distribute;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  -moz-align-items: flex-end;\n  align-items: flex-end;\n  height: 70px;\n  margin-left: auto; }\n  .buttonsContainer---2brtY .howThisWorks---1yVNU {\n    height: 30px;\n    margin-bottom: 8px;\n    background-color: #c3d5e1 !important;\n    border: 1px solid #c3d5e1 !important;\n    color: #3b4e5e !important; }\n  .buttonsContainer---2brtY .howThisWorks---1yVNU:hover {\n      background: #415667 !important;\n      border: 1px solid #415667 !important;\n      color: #fff !important; }\n  .buttonsContainer---2brtY .bottomButtons---2_POw {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    -moz-justify-content: space-between;\n    justify-content: space-between; }\n  .buttonsContainer---2brtY .bottomButtons---2_POw .button---2tSfB {\n      width: 142px;\n      height: 30px; }\n  .buttonsContainer---2brtY .bottomButtons---2_POw .key---2ux5c {\n      height: 30px;\n      background-color: #c3d5e1 !important;\n      border: 1px solid #c3d5e1 !important;\n      color: #3b4e5e !important;\n      margin-right: 8px;\n      white-space: nowrap; }\n  .buttonsContainer---2brtY .bottomButtons---2_POw .key---2ux5c:hover {\n        background: #415667 !important;\n        border: 1px solid #415667 !important;\n        color: #fff !important; }\n  .buttonsContainer---2brtY .bottomButtons---2_POw .keySelected---2-9M0 {\n      height: 30px;\n      margin-right: 8px;\n      background: #415667 !important;\n      border: 1px solid #415667 !important;\n      color: #fff !important; }\n  @media screen and (max-width: 1690px) {\n  .key---2ux5c {\n    width: 50px;\n    text-indent: -999999px;\n    white-space: nowrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding-right: 14px !important;\n    font-size: 0 !important;\n    margin-right: 0 !important;\n    margin-left: 8px; }\n    .key---2ux5c div[class^='css'] {\n      padding: 0; }\n  .howThisWorks---1yVNU {\n    width: 50px !important;\n    text-indent: -999999px;\n    padding-right: 14px !important;\n    font-size: 0 !important;\n    margin-right: 0; }\n    .howThisWorks---1yVNU div[class^='css'] {\n      padding: 0; }\n  .buttonsContainer---2brtY .bottomButtons---2_POw {\n    width: 105px !important; } }\n", ""]);

// exports
exports.locals = {
	"buttonsContainer": "buttonsContainer---2brtY",
	"howThisWorks": "howThisWorks---1yVNU",
	"bottomButtons": "bottomButtons---2_POw",
	"button": "button---2tSfB",
	"key": "key---2ux5c",
	"keySelected": "keySelected---2-9M0"
};

/***/ }),

/***/ "R8DK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("LHK0");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }








var defaultDateFormat = 'YYYY-MM-DD';
var getTranslations = function getTranslations(_ref) {
  var i18n = _ref.i18n;
  return {
    START_TIME_TEXT: i18n._("START TIME"),
    END_TIME_TEXT: i18n._("END TIME"),
    ACCEPT_BUTTON_TEXT: i18n._("Accept"),
    CANCEL_BUTTON_TEXT: i18n._("Cancel"),
    START_DATE_PLACEHOLDER_TEXT: i18n._("Start date"),
    END_DATE_PLACEHOLDER_TEXT: i18n._("End date")
  };
};
var AssignDateModal = function AssignDateModal(_ref2) {
  var callback = _ref2.callback;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* useDispatch */])();
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale(i18n.language);
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])({
      startDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format(defaultDateFormat),
      endDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'day').format(defaultDateFormat)
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dateSelected = _useState2[0],
    setDateSelected = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(),
    _useState4 = _slicedToArray(_useState3, 2),
    timeSelected = _useState4[0],
    setTimeSelected = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(true),
    _useState6 = _slicedToArray(_useState5, 2),
    enableAccept = _useState6[0],
    setEnableAccept = _useState6[1];
  var splitPeriod = function splitPeriod(time) {
    return "".concat(time.slice(0, time.length - 2), " ").concat(time.slice(time.length - 2));
  };
  var formatReturnedDate = function formatReturnedDate(_ref3) {
    var date = _ref3.date,
      time = _ref3.time;
    var MOMENT_DATE_FORMAT = 'YYYY-MM-DD h:mm A';
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()("".concat(date, " ").concat(splitPeriod(time)), [MOMENT_DATE_FORMAT]).toISOString();
  };
  var _getTranslations = getTranslations({
      i18n: i18n
    }),
    START_TIME_TEXT = _getTranslations.START_TIME_TEXT,
    END_TIME_TEXT = _getTranslations.END_TIME_TEXT,
    ACCEPT_BUTTON_TEXT = _getTranslations.ACCEPT_BUTTON_TEXT,
    CANCEL_BUTTON_TEXT = _getTranslations.CANCEL_BUTTON_TEXT,
    START_DATE_PLACEHOLDER_TEXT = _getTranslations.START_DATE_PLACEHOLDER_TEXT,
    END_DATE_PLACEHOLDER_TEXT = _getTranslations.END_DATE_PLACEHOLDER_TEXT;
  var onDateChangeHandler = function onDateChangeHandler(startDate, endDate) {
    return setDateSelected({
      startDate: startDate,
      endDate: endDate
    });
  };
  var onTimeChangeHandler = function onTimeChangeHandler(newTime) {
    return setTimeSelected(newTime);
  };
  var onSubmit = function onSubmit() {
    setEnableAccept(false);
    var startDate = formatReturnedDate({
      date: dateSelected.startDate,
      time: timeSelected[0]
    });
    var dueDate = formatReturnedDate({
      date: dateSelected.endDate,
      time: timeSelected[1]
    });
    callback(startDate, dueDate);
  };
  var defaultProps = {
    range: {
      startDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format(defaultDateFormat),
      endDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'year').format(defaultDateFormat)
    },
    closedOnLoad: true,
    enableAccept: enableAccept,
    includeTimeRange: true,
    onClose: function onClose() {},
    onDatesPicked: onDateChangeHandler,
    onTimesPicked: onTimeChangeHandler,
    onDateTimeSubmit: function onDateTimeSubmit() {
      return onSubmit();
    },
    onDateTimeClose: function onDateTimeClose() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_modal_manager_modal_manager_actions__["c" /* dismissModal */])());
    },
    weeklyRangeOnly: false,
    reactDatesConfig: {
      startDatePlaceholderText: START_DATE_PLACEHOLDER_TEXT,
      endDatePlaceholderText: END_DATE_PLACEHOLDER_TEXT
    },
    labels: {
      buttons: {
        accept: ACCEPT_BUTTON_TEXT,
        cancel: CANCEL_BUTTON_TEXT
      },
      timeRange: {
        start: START_TIME_TEXT,
        end: END_TIME_TEXT
      }
    }
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Calendar"], defaultProps));
};
AssignDateModal.propTypes = {
  callback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (AssignDateModal);

/***/ }),

/***/ "RzZa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("g2YJ");



var NeedHelp = function NeedHelp(props) {
  var helpSeekingStudents = props.helpSeekingStudents,
    i18n = props.i18n;
  var studentText = helpSeekingStudents.length > 1 ? i18n._("students need help") : i18n._("student needs help");
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* HelpWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "heading"
  }, "".concat(helpSeekingStudents.length, " ").concat(studentText))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* StudentListWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, helpSeekingStudents.map(function (s) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: s.id,
      className: "list"
    }, "".concat(s.lastName, " ").concat(s.firstName));
  }))));
};
NeedHelp.propTypes = {
  helpSeekingStudents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
NeedHelp.defaultProps = {
  helpSeekingStudents: []
};
/* harmony default export */ __webpack_exports__["a"] = (NeedHelp);

/***/ }),

/***/ "S0Yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_styleable__ = __webpack_require__("KJcn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_styleable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_styleable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__("5i5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_core_scss__ = __webpack_require__("nIya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_core_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_core_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_scss__ = __webpack_require__("3IFr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_icon_scss__);






var SvgIcon = function SvgIcon(_ref) {
  var _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? '' : _ref$icon,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  var svg = icon ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["default"], {
    src: icon,
    uniquifyIDs: true,
    cacheRequests: true
  }) : '';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "data-testid": dataTestId,
    className: className || __WEBPACK_IMPORTED_MODULE_5__svg_icon_scss___default.a.svgIconComponent
  }, svg);
};
SvgIcon.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  dataTestId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_styleable___default()(__WEBPACK_IMPORTED_MODULE_5__svg_icon_scss___default.a)(SvgIcon));

/***/ }),

/***/ "SDtc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    CLASS_LABEL_TEXT: i18n._("Class"),
    GROUP_LABEL_TEXT: i18n._("Group"),
    WHOLE_CLASS_TEXT: i18n._("Whole class")
  };
});

/***/ }),

/***/ "SFqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_hooks_use_context_modal__ = __webpack_require__("OmdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accuracy_progress_toggle_accuracy_progress_constants__ = __webpack_require__("yHtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__progress_modal_content__ = __webpack_require__("EcDV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accuracy_modal_content__ = __webpack_require__("dXA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled__ = __webpack_require__("wL8n");











var QuickSelector = function QuickSelector() {
  /**
   * Store
   */
  var currentSelectedFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.accuracyProgressToggle.currentFilter;
  });

  /**
   * Hooks
   */
  var _useContextModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_hooks_use_context_modal__["a" /* default */])(),
    showContextModal = _useContextModal.showContextModal,
    contentModalProps = _useContextModal.contentModalProps,
    closeContextMenu = _useContextModal.closeContextMenu,
    targetRef = _useContextModal.targetRef;

  /**
   * Local variables
   */
  var isProgressFilterSelected = currentSelectedFilter === __WEBPACK_IMPORTED_MODULE_7__accuracy_progress_toggle_accuracy_progress_constants__["b" /* PROGRESS */];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled__["b" /* ToggleButton */], {
    "data-testid": "toggle-quick-selector",
    ref: targetRef,
    onClick: showContextModal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["G" /* Bolt */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: closeContextMenu,
    forButton: "quickSelector"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context_modal__["b" /* default */], contentModalProps, isProgressFilterSelected ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__progress_modal_content__["a" /* default */], {
    closeContextMenu: closeContextMenu
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__accuracy_modal_content__["a" /* default */], {
    closeContextMenu: closeContextMenu
  }))));
};
/* harmony default export */ __webpack_exports__["a"] = (QuickSelector);

/***/ }),

/***/ "SbbG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function useInterval(callback, delay) {
  var savedCallback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

  // Remember the latest function.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    savedCallback.current = callback;
  }, [callback]);

  /* eslint-disable consistent-return */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    // Set up the interval.
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

/***/ }),

/***/ "SgkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasicApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__("bEzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__combined_reducers__ = __webpack_require__("Gylf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_product_service__ = __webpack_require__("6KtE");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-console */











var BasicApp = /*#__PURE__*/function () {
  function BasicApp(element, dynamicOptions) {
    _classCallCheck(this, BasicApp);
    BasicApp.configure();
    this.element = element;
    this.options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["a" /* handleDefaults */])({}, dynamicOptions);
    this.renderElement();
  }
  return _createClass(BasicApp, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, " You should define a render() method for your subclass of BasicApp ");
    }

    // Implementation details.  You should not need to change any code past this point.
  }, {
    key: "renderElement",
    value: function renderElement() {
      var _this = this;
      var env = "production" || 'development';

      // Create the store with middlewares
      var middlewares = [__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */]];
      if (env === 'development') {
        // eslint-disable-next-line global-require
        var whyDidYouUpdate = __webpack_require__("CqNl");
        whyDidYouUpdate(__WEBPACK_IMPORTED_MODULE_0_react___default.a);
      }
      var enhancers = [__WEBPACK_IMPORTED_MODULE_5_redux__["a" /* applyMiddleware */].apply(void 0, middlewares)];

      // If Redux DevTools Extension is installed use it, otherwise use Redux compose
      /* eslint-disable no-underscore-dangle */
      var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* compose */];
      /* eslint-enable */
      var initialState = __WEBPACK_IMPORTED_MODULE_9__helpers_product_service__["a" /* default */].Configure();
      var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["c" /* createStore */])(__WEBPACK_IMPORTED_MODULE_7__combined_reducers__["a" /* default */], initialState, composeEnhancers.apply(void 0, enhancers));
      var linguiCdnBaseUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["b" /* getConfiguration */])('LocalisationCdnBaseUrl');
      function linguiLocales() {
        var query = window.location.search.slice(1);
        var match = query.match(/\blocale=([-a-zA-Z]+)\b/);
        var locale = match ? match[1] : 'en-AU';
        return [locale];
      }
      var locales = linguiLocales();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__3plearning_lingui_cdn__["getI18N"])(linguiCdnBaseUrl, locales).then(function (i18n) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(_this.render(store, i18n), document.querySelector(_this.element));
      });
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(this.render(store), document.querySelector(this.element));
    }
  }], [{
    key: "configure",
    value: function configure() {
      // How we want to configure things depends on where this app is running,
      // and where the services we want to access live.
      //
      // 1. When running on a developer's machine, using a mock server, we want
      //    to use a hard-coded config from
      //
      //       helpers/local-resource-config.js
      //
      // 2. When running on a developer's machine, but we want to use back-end
      //    services on demo, QA or live, we want to get the configuration from
      //    the configuration of the host app.
      //
      // 3. When running on demo, QA or live, the configuration will be injected
      //    based on the host app's configuration, but can be overridden by query
      //    parameters.
      //
      // We determine which situation we have by looking at the window location
      // URL and the query parameters, and whether there is a pppAppConfig property
      // on the window object.

      var location = window.location;
      var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
      var queryParams = location.search;
      var query = queryParams.replace('?', '');
      var params = __WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(query);
      if (runningOnDeveloperMachine) {
        BasicApp.configureForDeveloperMachine(params);
      } else {
        BasicApp.configureForRemoteHost(params);
      }
    }
  }, {
    key: "configureForDeveloperMachine",
    value: function configureForDeveloperMachine(params) {
      var envName = params.env;
      if (!envName) {
        // eslint-disable-next-line no-console
        console.log('BasicApp.configureForDeveloperMachine() - you did not provide an "env" query' + ' parameter, so I am assuming you want to talk to live.');
        envName = 'live';
      }
      var credentials = BasicApp.getCredentials(params);
      if (envName === 'local' || BasicApp.weHaveUsableCredentials(credentials)) {
        __WEBPACK_IMPORTED_MODULE_8__helpers_resources__["a" /* default */].initialise(envName, credentials);
      }
    }
  }, {
    key: "configureForRemoteHost",
    value: function configureForRemoteHost(params) {
      var config = window._env_;
      var envName = config.env || 'live';
      var credentials = BasicApp.getCredentials(params);
      if (!config.BaseName) {
        // eslint-disable-next-line no-console
        console.log('BasicApp.configureForRemoteHost() - your pppAppConfig does not' + ' include a BaseName item; we will assume it should be blank.');
        config.BaseName = '';
      }
      if (BasicApp.weHaveUsableCredentials(credentials)) {
        __WEBPACK_IMPORTED_MODULE_8__helpers_resources__["a" /* default */].initialise(envName, credentials);
        __WEBPACK_IMPORTED_MODULE_8__helpers_resources__["a" /* default */].env.setConfiguration(config);
      }
    }
  }, {
    key: "getCredentials",
    value: function getCredentials(params) {
      var credentials = {};
      var items = ['authToken', 'username', 'password'];
      for (var paramName in params) {
        var value = params[paramName];
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (paramName.toLowerCase() === item.toLowerCase()) {
              credentials[item] = value;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return credentials;
    }
  }, {
    key: "weHaveUsableCredentials",
    value: function weHaveUsableCredentials(credentials) {
      var usableCredentials = false;
      if (credentials.authToken) {
        usableCredentials = true;
      } else if (credentials.username && credentials.password) {
        usableCredentials = true;
      }
      if (!usableCredentials) {
        // eslint-disable-next-line no-console
        console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' + ' a username/password pair.  After combining data from window.pppAppConfig and the query' + ' parameters, I still do not have what I need. The app will probably not function correctly if' + ' it requires any 3P resources.');
      }
      return usableCredentials;
    }
  }]);
}();


/***/ }),

/***/ "ShnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useGetDefaultCourse = function useGetDefaultCourse(_ref) {
  var courseOptions = _ref.courseOptions,
    defaultUpfCourseId = _ref.defaultUpfCourseId,
    selectedClass = _ref.selectedClass,
    selectedGroup = _ref.selectedGroup,
    isCurriculumOrCourseChanged = _ref.isCurriculumOrCourseChanged;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (!(selectedClass.value && selectedGroup.value || isCurriculumOrCourseChanged)) return null;
    return defaultUpfCourseId && courseOptions.find(function (course) {
      return (course === null || course === void 0 ? void 0 : course.value) === defaultUpfCourseId;
    }) || courseOptions[0];
  }, [selectedClass.value, selectedGroup.value, defaultUpfCourseId, courseOptions.length, isCurriculumOrCourseChanged]);
};
/* harmony default export */ __webpack_exports__["a"] = (useGetDefaultCourse);

/***/ }),

/***/ "Sunr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_styleable__ = __webpack_require__("KJcn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_styleable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_styleable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__due_date_info_icon_scss__ = __webpack_require__("v46A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__due_date_info_icon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__due_date_info_icon_scss__);





var DueDateInfoIcon = function DueDateInfoIcon() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["E" /* Info */],
    className: __WEBPACK_IMPORTED_MODULE_4__due_date_info_icon_scss___default.a.dueDateInfoIcon
  });
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_styleable___default()(__WEBPACK_IMPORTED_MODULE_4__due_date_info_icon_scss___default.a)(DueDateInfoIcon));

/***/ }),

/***/ "T5O/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("ef/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__("5IT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__translations__ = __webpack_require__("dEfS");








var UnassignWarningModal = function UnassignWarningModal(_ref) {
  var callback = _ref.callback;
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__translations__["a" /* default */])({
      i18n: i18n
    }),
    UNASSIGN_MODAL_HEADER_TEXT = _getTranslations.UNASSIGN_MODAL_HEADER_TEXT,
    UNASSIGN_MODAL_CONTENT_TEXT = _getTranslations.UNASSIGN_MODAL_CONTENT_TEXT,
    UNASSIGN_MODAL_SUBMIT_TEXT = _getTranslations.UNASSIGN_MODAL_SUBMIT_TEXT;
  var isAssigningOrUnAssigning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_5__selectors__["b" /* selectIsAssigningOrUnAssigning */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h1", null, UNASSIGN_MODAL_HEADER_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", null, UNASSIGN_MODAL_CONTENT_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    onClick: function onClick() {
      return callback();
    },
    className: "button",
    primary: true,
    text: UNASSIGN_MODAL_SUBMIT_TEXT,
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    disabled: isAssigningOrUnAssigning
  }));
};
UnassignWarningModal.propTypes = {
  callback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (UnassignWarningModal);

/***/ }),

/***/ "TCs3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__palette__ = __webpack_require__("c77w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__("LFcU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colours__ = __webpack_require__("EgB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout__ = __webpack_require__("3PI2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__overrides__ = __webpack_require__("//52");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"]), {}, {
  palette: __WEBPACK_IMPORTED_MODULE_1__palette__["a" /* default */],
  typography: __WEBPACK_IMPORTED_MODULE_2__typography__["a" /* default */],
  colours: __WEBPACK_IMPORTED_MODULE_3__colours__["a" /* default */],
  layout: __WEBPACK_IMPORTED_MODULE_4__layout__["a" /* default */],
  overrides: __WEBPACK_IMPORTED_MODULE_5__overrides__
}));

/***/ }),

/***/ "TJmL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");

var VARIANT_TYPES = {
  dark: {
    bgColor: '#3B4E5E',
    color: 'white',
    borderColor: '#3B4E5E'
  },
  light: {
    bgColor: 'white',
    color: 'black',
    borderColor: '#cfd2d4'
  }
};
var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var show = props.show,
    top = props.top,
    left = props.left,
    variant = props.variant;
  var _VARIANT_TYPES$varian = VARIANT_TYPES[variant],
    bgColor = _VARIANT_TYPES$varian.bgColor,
    color = _VARIANT_TYPES$varian.color,
    borderColor = _VARIANT_TYPES$varian.borderColor;
  return "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    top: ".concat(top, "px;\n    left: ").concat(left, "px;\n    min-height: 20px;\n    padding: 5px 8px;\n    z-index: 99;\n    width: max-content;\n    color: ").concat(color, ";\n    background-color: ").concat(bgColor, ";\n    border-radius: 5px;\n    border: 1px solid ").concat(borderColor, ";\n    box-shadow: 2px 2px 6px grey;\n    visibility: ").concat(show ? 'visible' : 'hidden', ";\n\n    &:before,\n    &:after {\n      bottom: 100%;\n      left: 50%;\n      border: solid transparent;\n      content: \"\";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      visibility: ").concat(show ? 'visible' : 'hidden', ";\n    }\n\n    &:after {\n      border-bottom-color: ").concat(bgColor, ";\n      border-width: 5px;\n      margin-left: -5px;\n    }\n\n    &:before {\n      border-bottom-color: ").concat(borderColor, ";\n      border-width: 7px;\n      margin-left: -7px;\n    }\n  ");
});
/* unused harmony default export */ var _unused_webpack_default_export = (Root);

/***/ }),

/***/ "TQbn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CellContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GridColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var CellContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    display: flex;\n    position: relative;\n    top: 0;\n    border-bottom: 1px solid ".concat(colours.grey[400], ";\n  ");
});
var Header = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].header(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n    display: flex;\n    position: sticky;\n    top: 192px;\n    z-index: 1;\n    height: 47px;\n    min-height: 47px;\n    background-color: ".concat(colours.grey[200], ";\n  ");
});
var GridContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: fit-content;\n"])));
var GridColumn = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));

/***/ }),

/***/ "TQs3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("JpTX");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var initialState = {
  isFetching: false,
  url: null,
  config: null
};
var ducsReducer = function ducsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GET_DUCS_CONFIG_REQUESTED */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* GET_DUCS_CONFIG_SUCCESS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false,
        url: action.url,
        config: action.config
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* GET_DUCS_CONFIG_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ducsReducer);

/***/ }),

/***/ "Tj2k":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "/* React Core CSS */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: '';\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\nbody {\n  font-family: poppins, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.42857143;\n  background-color: #eef2f5;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; }\nbutton:focus,\n[role=\"button\"]:focus {\n  outline: 0; }\n.text-center {\n  text-align: center; }\nh1 {\n  font-size: 30px;\n  font-weight: 500; }\n@font-face {\n  font-family: 'poppins';\n  src: url(\"//west.cdn.mathletics.com/html/fonts/Poppins/Poppins_400.ttf\") format(\"truetype\"); }\n", ""]);

// exports


/***/ }),

/***/ "U+4P":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("QpMW");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./grid-actions.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./grid-actions.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Ucei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListItemTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var List = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    padding: 0 6px;\n    border-bottom: 1px solid ".concat(colours.grey[400], ";\n\n    &:last-child {\n      border-bottom: none;\n    }\n  ");
});
var ListItem = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding-top: 3px;\n  width: 100%;\n"])));
var ListItemTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 600;\n"])));
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n"])));
var Link = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n    display: flex;\n    align-items: center;\n\n    padding: 6px;\n    border-bottom: 1px solid ".concat(colours.grey[400], ";\n    cursor: pointer;\n\n    &:nth-last-child(1) {\n      border-bottom: none;\n    }\n\n    &:hover {\n      background-color: ").concat(colours.grey[100], ";\n\n      span {\n        background-color: transparent;\n      }\n    }\n  ");
});

/***/ }),

/***/ "UgNX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__("1B8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("aiz3");





var CollapsedGrid = function CollapsedGrid(props) {
  var standardId = props.standardId;
  var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudentIds;
  });
  var standards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.standards;
  });
  var _ref = standards[standardId] || {},
    _ref$childTopics = _ref.childTopics,
    learningJourneyIds = _ref$childTopics === void 0 ? [] : _ref$childTopics;
  var results = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__selectors__["a" /* collapsedResultsSelector */])(sortedStudentIds, learningJourneyIds));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* Header */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* GridColumn */], null, results.map(function (result) {
    var id = result.id,
      value = result.value,
      showResult = result.showResult;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["d" /* Cell */], {
      key: id
    }, showResult && value, " ");
  })));
};
CollapsedGrid.propTypes = {
  standardId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (CollapsedGrid);

/***/ }),

/***/ "V/lH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Paragraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_common__ = __webpack_require__("ZmnC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }





var Icon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__svg_icon_svg_icon__["a" /* default */])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: auto;\n"])));
var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_4__themes_theme_helper__["a" /* default */].getTheme(props),
    typography = _ThemeHelper$getTheme.typography,
    colours = _ThemeHelper$getTheme.colours;
  return "\n      ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), "\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* flexDirection */])('column'), "\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__styles_helpers_common__["a" /* widthFillAvailable */])(), "\n\n      font-family: ").concat(typography.family, ";\n      font-size: 14px;\n  \n      svg {\n        margin-top: 20px;\n        width: 50px;\n        height: 50px;\n        path {\n          fill: ").concat(colours.grey[400], ";\n        }\n      }\n  ");
});
var Paragraph = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  width: auto;\n\n  :nth-of-type(2) {\n    width: 40%;\n    margin-top: 20px;\n  }\n"])));

/***/ }),

/***/ "VioT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss__ = __webpack_require__("xnkI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox__ = __webpack_require__("4YSV");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var SelectableListItem = /*#__PURE__*/function (_Component) {
  function SelectableListItem(props) {
    var _this;
    _classCallCheck(this, SelectableListItem);
    _this = _callSuper(this, SelectableListItem, [props]);
    _defineProperty(_this, "onSelection", function (cbState, id) {
      var checked = cbState === 'checked';
      _this.setState({
        checked: checked
      });
      _this.props.onChange(id, checked);
    });
    var _checked = props.checked;
    _this.state = {
      checked: _checked
    };
    return _this;
  }
  _inherits(SelectableListItem, _Component);
  return _createClass(SelectableListItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.checked !== this.props.checked) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        name = _this$props.name;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: id
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2__index_scss___default.a.info
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2__index_scss___default.a.checkbox
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__checkbox__["a" /* default */], {
        state: this.state.checked,
        checkboxHandler: function checkboxHandler(cbState, cbId) {
          return _this2.onSelection(cbState, cbId);
        },
        id: id.toString()
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_2__index_scss___default.a.description
      }, name))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
SelectableListItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (SelectableListItem);

/***/ }),

/***/ "Vmzb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("2yEz");








var GridHeader = function GridHeader(props) {
  var sortedStudentIds = props.sortedStudentIds,
    learningJourneyId = props.learningJourneyId;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var selectedAssignmentHashKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedAssignmentHashKeys;
  });
  var learningJourneyAssignmentHashKeys = sortedStudentIds.map(function (studentId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__status_cell_helpers__["d" /* getAssignmentHashKey */])(studentId, learningJourneyId);
  });
  var handleOnClick = function handleOnClick(checkboxState) {
    var isSelected = checkboxState === __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["a" /* CHECKED */];
    var assignmentHashKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__status_cell_helpers__["k" /* buildAssignmentHashKeys */])({
      studentIds: sortedStudentIds,
      learningJourneyIds: [learningJourneyId]
    });
    if (isSelected) return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__containers_upf_assign_upf_assign_actions__["f" /* selectAssignmentHashKeys */])(assignmentHashKeys));
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__containers_upf_assign_upf_assign_actions__["g" /* unselectAssignmentHashKeys */])(assignmentHashKeys));
  };
  var getState = function getState() {
    var selectedAssignmentCount = learningJourneyAssignmentHashKeys.filter(function (assignmentHashKey) {
      return !!selectedAssignmentHashKeys[assignmentHashKey];
    }).length;
    var learningJourneyAssignmentCount = learningJourneyAssignmentHashKeys.length;
    if (selectedAssignmentCount === 0) return __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["b" /* UNCHECKED */];
    if (selectedAssignmentCount === learningJourneyAssignmentCount) return __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["a" /* CHECKED */];
    if (selectedAssignmentCount < learningJourneyAssignmentCount) return __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["c" /* INDETERMINATE */];
    return __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["b" /* UNCHECKED */];
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__checkbox__["a" /* default */], {
    checkboxHandler: handleOnClick,
    state: getState()
  }));
};
GridHeader.propTypes = {
  learningJourneyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  sortedStudentIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (GridHeader);

/***/ }),

/***/ "VrhK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("CQXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translations__ = __webpack_require__("fjUD");





var AssignmentsSummary = function AssignmentsSummary(_ref) {
  var currentlyAssignedAssignmentsCount = _ref.currentlyAssignedAssignmentsCount,
    totalAssignments = _ref.totalAssignments;
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__translations__["a" /* default */])({
      i18n: i18n
    }),
    CURRENTLY_ASSIGNED = _getTranslations.CURRENTLY_ASSIGNED,
    OVERDUE = _getTranslations.OVERDUE,
    TOTAL_ASSIGNMENTS = _getTranslations.TOTAL_ASSIGNMENTS;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* SummaryRow */], null, CURRENTLY_ASSIGNED, ": ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Count */], null, currentlyAssignedAssignmentsCount)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* SummaryRow */], null, OVERDUE, ": ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Count */], null, totalAssignments - currentlyAssignedAssignmentsCount)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* SummaryRow */], null, TOTAL_ASSIGNMENTS, ":", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Count */], null, totalAssignments)));
};
AssignmentsSummary.propTypes = {
  currentlyAssignedAssignmentsCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  totalAssignments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AssignmentsSummary);

/***/ }),

/***/ "Vz/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StudentItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AssignmentCountText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CheckboxWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");


var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    border: 1px solid ".concat(colours.grey[400], ";\n    border-left: none;\n    border-top: none;\n    height: 33px;\n    background-color: white;\n  ");
});
var StudentItem = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme2.palette,
    colours = _ThemeHelper$getTheme2.colours;
  return "\n    display: flex;\n    justify-content: space-between;\n    align-items: center\n    width: 80%;\n    height: 22px;\n    padding: 5px;\n    font-weight: 400;\n    border-right: 2px solid ".concat(colours.grey[400], ";\n    color: ").concat(palette.primary.dark, ";\n    cursor: pointer;\n\tline-height: 14px;\n  ");
});
var AssignmentCountText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme3.palette;
  return "\n    color: ".concat(palette.primary.dark, ";\n  ");
});
var CheckboxWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme4 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme4.colours;
  return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    width: 40px;\n    height: 100%;\n    background-color: ".concat(colours.grey[200], ";\n\n    > div {\n      margin: 0;\n    }\n");
});

/***/ }),

/***/ "WPT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getTranslations = function getTranslations(_ref) {
  var i18n = _ref.i18n;
  return {
    ASSIGNED_TEXT: i18n._("Assigned"),
    VOLUNTARY_TEXT: i18n._("Voluntary"),
    CURRENT_ASSIGNED_TEXT: i18n._("Currently Assigned")
  };
};
/* harmony default export */ __webpack_exports__["a"] = (getTranslations);

/***/ }),

/***/ "WRtY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ActionWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UnassignWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SubHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AttemptsText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Attempts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 3px 0 0 0;\n"])));
var ActionWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 4px 5px;\n  border-top: 1px solid grey;\n  cursor: pointer;\n\n  >div:first-child {\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n    height: 18px;\n    width: 18px;\n}"])));
var UnassignWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(ActionWrapper)(function (props) {
  if (props.hasOnlyResult) {
    return "\n      cursor: not-allowed;\n      color: #d4d4d4;\n\n      &:hover {\n        cursor: not-allowed;\n        color: #d4d4d4;\n      }\n\n      >div {\n        color: #d4d4d4;\n      }\n    ";
  }
  return null;
});
var Heading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 2px 6px;\n  font-weight: 800;\n  color: black;\n"])));
var SubHeading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: black;\n  padding: 2px 6px;\n  font-weight: 100;\n  font-size: 11px;\n"])));
var AttemptsText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: black;\n  padding: 2px 6px;\n  font-weight: 600;\n  font-size: 11px;\n"])));
var Attempts = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 5px 6px 10px 6px;\n"])));

/***/ }),

/***/ "WnpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVATE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISMISS_MODAL; });
/* harmony export (immutable) */ __webpack_exports__["d"] = activateModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = dismissModal;
var ACTIVATE_MODAL = 'ACTIVATE_MODAL';
var DISMISS_MODAL = 'DISMISS_MODAL';
function activateModal(modal) {
  return {
    type: ACTIVATE_MODAL,
    modal: modal
  };
}
function dismissModal() {
  return {
    type: DISMISS_MODAL
  };
}

/***/ }),

/***/ "X9I8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Hide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var InfoWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme.palette;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('flex-start'), ";\n        flex-direction: column;\n        background: ").concat(palette.primary.text, ";\n        color: ").concat(palette.primary.dark, ";\n        width: 100%;\n        \n        div {\n          padding: 10px;\n          font-family: inherit;\n          font-size: 12px;\n          width: 100%;\n          box-sizing: border-box;\n        }\n        .description {\n          padding-top: 0;\n        }\n        .headerWrapper {\n          ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n          ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('row'), ";\n          font-weight: 600;\n          \n          .title {\n            ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n          }\n          .subTitle {\n            padding-top: 5px;\n          }\n          * {\n            padding: 0;\n          }\n        }\n");
});
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 37px;\n  min-height: 37px;\n  padding-left: 15px !important;\n  margin-top: 5px;\n  text-align: right;\n"])));
var Hide = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('left'), ";  \n  \n  cursor: pointer;\n  border-bottom: 1px solid ").concat(colours.grey[400], ";\n  padding: 8px;\n  font-family: inherit;\n  font-size: 12px;\n  width: 100%;\n  box-sizing: border-box;\n  ");
});


/***/ }),

/***/ "Xjxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DueDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EllipsisText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CheckboxWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  min-width: 0;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('center'));
var Text = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? '20%' : _props$width,
    _props$alignHorizonta = props.alignHorizontal,
    alignHorizontal = _props$alignHorizonta === void 0 ? 'center' : _props$alignHorizonta;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])(alignHorizontal), ";\n    padding: 3px 8px;\n    margin: 0px 5px;\n    width: ").concat(width, ";\n    font-size: 14px;\n    overflow: hidden;\n  ");
});
var DueDate = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _props$width2 = props.width,
    width = _props$width2 === void 0 ? '20%' : _props$width2,
    _props$alignHorizonta2 = props.alignHorizontal,
    alignHorizontal = _props$alignHorizonta2 === void 0 ? 'center' : _props$alignHorizonta2,
    currentAssignmentUnavailableForStudent = props.currentAssignmentUnavailableForStudent;
  var color = '#4e5c67';
  var backgroundColor = '#fff';
  if (currentAssignmentUnavailableForStudent) {
    color = '#C51B29';
    backgroundColor = '#FDEEEF';
  }
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])(alignHorizontal), ";\n    padding: 3px 8px;\n    margin: 0px 5px;\n    width: ").concat(width, ";\n    font-size: 14px;\n    overflow: hidden;\n\tcolor: ").concat(color, "\n\tbackground-color: ").concat(backgroundColor, ";\n\tborder-radius: 20px;\n  ");
  ;
});
var EllipsisText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));
var CheckboxWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n      padding: 2px 8px;\n      margin: 0px 5px;\n\n      div {\n        border: 1px solid ".concat(colours.grey[200], ";\n        border-radius: 2px;\n      }\n  ");
});

/***/ }),

/***/ "XvmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkIsInBetween; });
var checkIsInBetween = function checkIsInBetween(number, start, end) {
  return number >= start && number <= end;
};
/* unused harmony default export */ var _unused_webpack_default_export = (checkIsInBetween);

/***/ }),

/***/ "YUC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccuracyProgressWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AccuracyWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProgressWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ToolTipInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var AccuracyProgressWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  height: 25px;\n  margin: 3px 0;\n"])));
var AccuracyWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var borderColor = props.selected ? '#166da5' : '#9a9a9a';
  return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-size: 13px;\n    font-weight: ".concat(props.selected ? 'bold' : 'normal', ";\n    border: 1px solid ").concat(borderColor, ";\n    border-radius: 15px 0 0 15px;\n    width: 40%;\n   \n    color: ").concat(props.selected ? '#166da5' : '#9a9a9a', ";\n    background-color: ").concat(props.selected ? '#d6eaf6' : 'white', ";\n    border-right: ").concat(!props.selected && 'none', ";\n    cursor: pointer;\n    padding-top: 3px;\n  ");
});
var ProgressWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(AccuracyWrapper)(function (props) {
  return "\n  border-radius: 0 15px 15px 0;\n  border-left: ".concat(!props.selected && 'none', ";\n  border-right: 1px solid; \n");
});
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 10px;\n  padding-top: 3px;\n"])));
var ToolTipInfo = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: 150px;\n  font-size: 12px;\n  padding: 2px;\n"])));

/***/ }),

/***/ "ZKG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__ = __webpack_require__("6PBa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__("XvmN");





var useQuickSelector = function useQuickSelector(_ref) {
  var closeContextMenu = _ref.closeContextMenu;
  /**
   * Store
   */
  var assignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.assignments;
  });
  var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudentIds;
  });
  var selectedLearningJourneyIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedLearningJourneyIds;
  });
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* useDispatch */])();

  /**
   * Local variables
   */
  var assignmentHashKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__status_cell_helpers__["k" /* buildAssignmentHashKeys */])({
    studentIds: sortedStudentIds,
    learningJourneyIds: selectedLearningJourneyIds
  });

  /**
   * Functions
   */
  var selectAllAssignments = function selectAllAssignments() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["b" /* resetAssignmentHashKeys */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["f" /* selectAssignmentHashKeys */])(assignmentHashKeys));
    closeContextMenu();
  };
  var selectCurrentAssigned = function selectCurrentAssigned() {
    var updatedHashKeys = __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default()(assignmentHashKeys, function (_, key) {
      var assignment = assignments[key] || {};
      return !!assignment.currentAssignmentId;
    });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["b" /* resetAssignmentHashKeys */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["f" /* selectAssignmentHashKeys */])(updatedHashKeys));
    closeContextMenu();
  };
  var selectProgressPercentageBetween = function selectProgressPercentageBetween(start, end) {
    var updatedHashKeys = __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default()(assignmentHashKeys, function (_, key) {
      var assignment = assignments[key] || {};
      var percentage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__status_cell_helpers__["f" /* getProgressPercentage */])(assignment);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* checkIsInBetween */])(percentage, start, end);
    });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["b" /* resetAssignmentHashKeys */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["f" /* selectAssignmentHashKeys */])(updatedHashKeys));
    closeContextMenu();
  };
  var selectAccuracyBetween = function selectAccuracyBetween(start, end) {
    var updatedHashKeys = __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default()(assignmentHashKeys, function (_, key) {
      var _ref2 = assignments[key] || {},
        resultAccuracy = _ref2.resultAccuracy;
      if (!resultAccuracy) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* checkIsInBetween */])(resultAccuracy, start, end);
    });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["b" /* resetAssignmentHashKeys */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["f" /* selectAssignmentHashKeys */])(updatedHashKeys));
    closeContextMenu();
  };
  var cleanAssignmentHashKeys = function cleanAssignmentHashKeys() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_upf_assign_upf_assign_actions__["b" /* resetAssignmentHashKeys */])());
    closeContextMenu();
  };
  return {
    cleanAssignmentHashKeys: cleanAssignmentHashKeys,
    selectAllAssignments: selectAllAssignments,
    selectCurrentAssigned: selectCurrentAssigned,
    selectProgressPercentageBetween: selectProgressPercentageBetween,
    selectAccuracyBetween: selectAccuracyBetween
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useQuickSelector);

/***/ }),

/***/ "ZMXI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_xor__ = __webpack_require__("h3km");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_xor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_xor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("6l1r");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var initialState = {
  assignments: [],
  loading: false,
  selectedAssignmentIds: [],
  sortDirection: 'asc'
};
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* STUDENT_ASSIGNMENTS_REQUEST */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* STUDENT_ASSIGNMENTS_SUCCESS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        assignments: action.assignments,
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* STUDENT_ASSIGNMENTS_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        assignments: [],
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* RESET_STUDENT_ASSIGNMENTS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        assignments: []
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* UPDATE_SORT_DIRECTION_TO_ASC */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        sortDirection: 'asc'
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* UPDATE_SORT_DIRECTION_TO_DESC */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        sortDirection: 'desc'
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* UNSELECT_ALL_ASSIGNMENTS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedAssignmentIds: []
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* SELECT_ALL_ASSIGNMENTS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedAssignmentIds: state.assignments.map(function (a) {
          return a.assignmentId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* TOGGLE_SELECTED_ASSIGNMENT_IDS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedAssignmentIds: __WEBPACK_IMPORTED_MODULE_0_lodash_xor___default()(_toConsumableArray(state.selectedAssignmentIds), [action.assignmentId])
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),

/***/ "Za/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = viewCurrentAssignmentsModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_manage_assignments__ = __webpack_require__("9mrv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__footer_selectors__ = __webpack_require__("ef/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_assignments_summary_assignments_summary__ = __webpack_require__("VrhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assign_list__ = __webpack_require__("4Z4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_actions__ = __webpack_require__("6l1r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled__ = __webpack_require__("vZCb");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable max-len */














var CurrentAssignmentsModal = function CurrentAssignmentsModal(props) {
  var _props$student = props.student,
    studentProfileId = _props$student.id,
    firstName = _props$student.firstName,
    lastName = _props$student.lastName,
    classText = props.selectedClass.label;
  var studentFullName = "".concat(firstName, " ").concat(lastName);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var isAssigningOrUnAssigning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_9__footer_selectors__["b" /* selectIsAssigningOrUnAssigning */]);
  var assignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.currentAssignmentsModalReducer.assignments;
  });
  var selectedAssignmentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.currentAssignmentsModalReducer.selectedAssignmentIds;
  });
  var selectedProduct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.product;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var _useManageAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_manage_assignments__["a" /* default */])(),
    unassignAssignments = _useManageAssignments.unassignAssignments;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__redux_actions__["j" /* resetAssignments */])());
  }, []);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__redux_actions__["k" /* getStudentAssignments */])(studentProfileId, selectedProduct.id));
  }, [studentProfileId]);
  var getToastText = function getToastText(studentUnAssignments) {
    var i18nMessage = i18n._("Activities are unassigned from this student");
    return "(".concat(studentUnAssignments.length, ") ").concat(i18nMessage, " (").concat(studentFullName, ")");
  };
  var handleUnassignAssignments = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var studentUnAssignments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            studentUnAssignments = selectedAssignmentIds.map(function (assignmentId) {
              var selectedAssignment = assignments.find(function (assignment) {
                return assignment.assignmentId === assignmentId;
              });
              return {
                studentUserProfileId: studentProfileId,
                assignmentId: assignmentId,
                learningJourneyId: selectedAssignment.learningJourneyId
              };
            });
            _context.n = 1;
            return unassignAssignments(studentUnAssignments, getToastText(studentUnAssignments));
          case 1:
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__containers_modal_manager_modal_manager_actions__["b" /* DISMISS_MODAL */]
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__redux_actions__["j" /* resetAssignments */])());
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleUnassignAssignments() {
      return _ref.apply(this, arguments);
    };
  }();
  var currentlyAssignedAssignmentsCount = assignments.filter(function (assignment) {
    return !assignment.currentAssignmentUnavailableForStudent;
  }).length;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["a" /* ModalBody */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["b" /* StudentDetails */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["c" /* StudentName */], null, "".concat(studentFullName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["d" /* CourseDetails */], null, classText)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_assignments_summary_assignments_summary__["a" /* default */], {
    currentlyAssignedAssignmentsCount: currentlyAssignedAssignmentsCount,
    totalAssignments: assignments.length
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["e" /* TabHeading */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["A" /* AllAssigned */]
  }), i18n._("Assigned ({currentlyAssignedAssignmentsCount})", {
    currentlyAssignedAssignmentsCount: currentlyAssignedAssignmentsCount
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["f" /* ResultsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__assign_list__["a" /* default */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled__["g" /* Footer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"], {
    className: "unassign",
    disabled: selectedAssignmentIds.length === 0 || isAssigningOrUnAssigning,
    onClick: handleUnassignAssignments,
    primary: true,
    text: i18n._("Unassign"),
    type: __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"], {
    primary: true,
    text: i18n._("OK"),
    type: __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__containers_modal_manager_modal_manager_actions__["b" /* DISMISS_MODAL */]
      });
    }
  })));
};
CurrentAssignmentsModal.defaultProps = {
  "class": {},
  selectedClass: {}
};
CurrentAssignmentsModal.propTypes = {
  student: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectedClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
function viewCurrentAssignmentsModal(student, selectedClass) {
  return {
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentAssignmentsModal, {
      student: student,
      selectedClass: selectedClass
    }),
    id: 0,
    buttons: []
  };
}
/* unused harmony default export */ var _unused_webpack_default_export = (CurrentAssignmentsModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "Zbcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("Fvqa");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var getArrowTransformRotateDegree = function getArrowTransformRotateDegree(props) {
  var leftAlign = props.leftAlign,
    isOutOfWindowX = props.isOutOfWindowX;
  if (leftAlign) return 'rotate(-90deg)';
  if (isOutOfWindowX) return 'rotate(-180deg)';
  return 'none';
};
var ModalWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  var bgColor = props.bgColor,
    _props$borderRadius = props.borderRadius,
    borderRadius = _props$borderRadius === void 0 ? 8 : _props$borderRadius;
  return "\n        display: flex;\n        align-items: center;\n        background: ".concat(bgColor, ";\n        position: fixed;\n        left: ").concat(props.positionX, "px\n        border-radius: ").concat(borderRadius, "px;\n        z-index: 99;\n        box-shadow: 4px 2px 6px;\n        overflow: ").concat(props.overflow, "\n        overflow-wrap: ").concat(props.overflowWrap, "\n        width:").concat(props.modalWidth, "px\n        min-height: 50px;\n        cursor: default;\n        border: 1px solid ").concat(bgColor, "\n        ").concat(props.modalBottom ? "bottom: ".concat(props.modalBottom, "px;") : "top: ".concat(props.positionY, "px"), "\n\n        ::after {\n                width: 0; \n                height: 0; \n                border-left: 8px solid transparent;\n                border-right: 8px solid transparent;        \n                border-bottom: ").concat(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* arrowHeight */], "px solid ").concat(bgColor, ";\n                position: fixed;\n                top: ").concat(props.positionArrowY, "px;\n                left: ").concat(props.positionArrow, "px;\n                content: ' ';\n                transform: ").concat(getArrowTransformRotateDegree(props), ";\n        }\n        * {\n                color: ").concat(colours.grey[900], "\n                background: ").concat(bgColor, "\n                &:hover {\n                        color: ").concat(colours.grey[900], "\n                }\n        }\n\n        ");
});
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-direction: column;\n  width: 100%;\n"])));
var ContentTheme = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  width: 100%;\n  padding: 10px;\n  color: white;\n"])));


/***/ }),

/***/ "ZhO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export i18nSetup */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lingui_core__ = __webpack_require__("mbfA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lingui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lingui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);


function i18nSetup(catalogs, localeOverride) {
  // get locale from query parameter, default to en-AU
  var locale = localeOverride || getLocale() || 'en-AU';
  if (catalogs[locale] === undefined) {
    locale = 'en-AU';
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lingui_core__["setupI18n"])({
    language: locale,
    catalogs: catalogs
  });
}
function getLocale() {
  var queryParams = window.location.search;
  var query = queryParams.replace('?', '');
  var params = __WEBPACK_IMPORTED_MODULE_1_querystring___default.a.parse(query);
  return params.locale;
}

/***/ }),

/***/ "ZmnC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export borderRadius */
/* unused harmony export borderShadow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return widthFillAvailable; });
var borderRadius = function borderRadius() {
  var $value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1px';
  return "\n    -webkit-border-radius: ".concat(value, ";\n    -moz-border-radius: ").concat(value, ";\n    border-radius: ").concat(value, ";\n");
};
var borderShadow = function borderShadow(top, left, blur, color) {
  var inset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  return "\n    -webkit-box-shadow:".concat(top, " ").concat(left, " ").concat(blur, " ").concat(color, " #{").concat(inset, "};\n    -moz-box-shadow:").concat(top, " ").concat(left, " ").concat(blur, " ").concat(color, " #{").concat(inset, "};\n    box-shadow:").concat(top, " ").concat(left, " ").concat(blur, " ").concat(color, " #{").concat(inset, "};\n");
};
var widthFillAvailable = function widthFillAvailable() {
  return "\n    width: 100%;\n    width: -webkit-fill-available;\n    width: -moz-available;\n    width: fill-available;\n";
};


/***/ }),

/***/ "aFup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Description; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    width: 400px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('space-between'));
var Text = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n\n    margin-left: 65px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var Heading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 18px;\n    font-weight: 400;\n    margin-bottom: 15px;\n"])));
var Description = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 13px;\n    width: 295px;\n"])));


/***/ }),

/***/ "aiz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GridColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Cell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    display: flex;\n    flex-direction: column;\n    min-height: calc(100% - 192px);\n    border: 1px solid ".concat(colours.grey[400], ";;\n    background-color: ").concat(colours.grey[200], ";\n  ");
});
var Header = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].header(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n      display: flex;\n      position: sticky;\n      top: 192px;\n      z-index: 1;\n      width: 54px;\n      height: 47px;\n      min-height: 47px;\n      background-color: ".concat(colours.grey[400], ";\n      border-right: 1px solid ").concat(colours.grey[500], ";\n      box-sizing: border-box;\n  ");
});
var GridColumn = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var Cell = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours;
  return "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    border: ".concat("1px solid ".concat(colours.grey[400]), ";\n    width: 54px;\n    height: 33px;\n    box-sizing: border-box;\n    font-size: 14px;\n    background-color: ", colours.grey[100], ";\n  ");
});

/***/ }),

/***/ "avc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productEnum; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var productEnum = /*#__PURE__*/_createClass(function productEnum() {
  _classCallCheck(this, productEnum);
});
_defineProperty(productEnum, "MATHLETICS", {
  id: 1,
  name: 'Mathletics'
});
_defineProperty(productEnum, "SPELLODROME", {
  id: 3,
  name: 'Spellodrome'
});
_defineProperty(productEnum, "INTOSICENCE", {
  id: 6,
  name: 'Intoscience'
});
_defineProperty(productEnum, "PHONICS", {
  id: 8,
  name: 'Phonics'
});
_defineProperty(productEnum, "MATLETICA", {
  id: 9,
  name: 'Mathletics Play'
});


/***/ }),

/***/ "awYd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".app---3vTSy {\n  height: 100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.footer---NcHZ2 {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n\n.footer---NcHZ2 p {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    padding-top: 5px;\n    padding-left: 6px !important; }\n\n.container-wrapper---3U5Hh {\n  height: calc(100vh - 120px);\n  position: relative;\n  margin-bottom: 0.01px !important;\n  border-radius: 5px 5px 0.01px 0.01px;\n  min-width: 1242px; }\n\n@media screen and (max-width: 1220px) {\n    .container-wrapper---3U5Hh {\n      margin: 0.001px !important; } }\n\n.footer---NcHZ2 > * {\n  margin: 0 8px; }\n", ""]);

// exports
exports.locals = {
	"app": "app---3vTSy",
	"footer": "footer---NcHZ2",
	"container-wrapper": "container-wrapper---3U5Hh"
};

/***/ }),

/***/ "b3EP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quick_selector__ = __webpack_require__("SFqr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__student_header__ = __webpack_require__("il2q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__student_list_item__ = __webpack_require__("DTWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__("6uc1");







var StudentList = function StudentList(props) {
  var i18n = props.i18n;

  /**
   * Store
   */
  var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudentIds;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["a" /* Root */], {
    id: "studentList"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["b" /* HeaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__student_header__["a" /* default */], {
    i18n: i18n
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__quick_selector__["a" /* default */], {
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["c" /* StudentListItemWrapper */], null, sortedStudentIds.map(function (studentId) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__student_list_item__["a" /* default */], {
      key: studentId,
      studentId: studentId,
      i18n: i18n
    });
  })));
};
StudentList.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (StudentList);

/***/ }),

/***/ "bLeE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");

var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var isCollapsed = props.isCollapsed;
  return "\n    position: absolute;\n    top: 8px;\n    left: ".concat(isCollapsed ? '10px' : 'auto', ";\n    right: ").concat(isCollapsed ? '' : '10px', "\n\n    min-width: 16px;\n    min-height: 16px;\n    cursor: pointer;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  ");
});
/* unused harmony default export */ var _unused_webpack_default_export = (Root);

/***/ }),

/***/ "c77w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].palette), {}, {
  primary: {
    light: '#eaf9f9',
    main: '#415667',
    dark: '#415667',
    text: '#ffffff'
  },
  secondary: {
    light: '#ffffff',
    main: '#7fa7c2',
    dark: '#3b4e5e',
    text: '#ffffff'
  },
  error: {
    light: '#bf2c30',
    main: '#b01e22',
    dark: '#6f1315',
    text: '#fff'
  },
  warning: {
    light: '#cb4b1a',
    main: '#c63a04',
    dark: '#942c04',
    text: '#fff'
  }
}));

/***/ }),

/***/ "clGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAssignmentHashKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return buildAssignmentHashKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return destructureAssignmentHashKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkIsAssignmentCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProgressResultText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAccuracyResultText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getProgressPercentage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getScoreBands; });
/* unused harmony export checkIsVoluntaryResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findVoluntaryAndAssignedLearningJourneyResult; });
/* unused harmony export findVoluntaryLearningJourneyResult */
/* unused harmony export findLatestAssignedLearningJourneyResult */
/* unused harmony export findHighestProgressLearningJourneyResult */
/* unused harmony export findHighestAccuracyLearningJourneyResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLearningJourneyResultByProgressFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLearningJourneyResultByAccuracyFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assignment_filters_filters_constants__ = __webpack_require__("6coq");





var getAssignmentHashKey = function getAssignmentHashKey(studentId, learningJourneyId) {
  return "studentId#".concat(studentId, "_learningJourneyId#").concat(learningJourneyId);
};
var buildAssignmentHashKeys = function buildAssignmentHashKeys(_ref) {
  var _ref$studentIds = _ref.studentIds,
    studentIds = _ref$studentIds === void 0 ? [] : _ref$studentIds,
    _ref$learningJourneyI = _ref.learningJourneyIds,
    learningJourneyIds = _ref$learningJourneyI === void 0 ? [] : _ref$learningJourneyI;
  var assignmentHashKeys = {};
  studentIds.forEach(function (studentId) {
    learningJourneyIds.forEach(function (learningJourneyId) {
      var assignmentHashKey = getAssignmentHashKey(studentId, learningJourneyId);
      assignmentHashKeys[assignmentHashKey] = {
        studentId: studentId,
        learningJourneyId: learningJourneyId
      };
    });
  });
  return assignmentHashKeys;
};
var destructureAssignmentHashKey = function destructureAssignmentHashKey(key) {
  var returnedValue = {};
  var items = key.split('_');
  items.forEach(function (item) {
    var keyValuePair = item.split('#');
    returnedValue[keyValuePair[0]] = keyValuePair[1];
  });
  return returnedValue;
};
var checkIsAssignmentCompleted = function checkIsAssignmentCompleted() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    resultStepsTotal = _ref2.resultStepsTotal,
    resultStepsCompleted = _ref2.resultStepsCompleted;
  return resultStepsTotal > 0 && resultStepsCompleted === resultStepsTotal;
};
var getProgressResultText = function getProgressResultText(_ref3) {
  var resultStepsTotal = _ref3.resultStepsTotal,
    resultStepsCompleted = _ref3.resultStepsCompleted;
  if (!resultStepsTotal || !resultStepsCompleted) return '';
  return "".concat(resultStepsCompleted, "/").concat(resultStepsTotal);
};
var getAccuracyResultText = function getAccuracyResultText(_ref4) {
  var resultAccuracy = _ref4.resultAccuracy;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* isDefined */])(resultAccuracy) ? "".concat(resultAccuracy, "%") : '';
};
var getProgressPercentage = function getProgressPercentage(_ref5) {
  var resultStepsCompleted = _ref5.resultStepsCompleted,
    resultStepsTotal = _ref5.resultStepsTotal;
  if (!resultStepsTotal || !resultStepsCompleted) return 0;
  return resultStepsCompleted / resultStepsTotal * 100;
};
var getScoreBands = function getScoreBands(_ref6) {
  var range = _ref6.range,
    currentlyAssigned = _ref6.currentlyAssigned,
    completed1to20 = _ref6.completed1to20,
    completed21to40 = _ref6.completed21to40,
    completed41to60 = _ref6.completed41to60,
    completed61to80 = _ref6.completed61to80,
    completed81to100 = _ref6.completed81to100;
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* isDefined */])(range)) return currentlyAssigned;
  if (range > 0 && range <= 20) return completed1to20;
  if (range > 20 && range <= 40) return completed21to40;
  if (range > 40 && range <= 60) return completed41to60;
  if (range > 60 && range <= 80) return completed61to80;
  if (range > 80 && range <= 100) return completed81to100;
  return currentlyAssigned;
};
/* unused harmony default export */ var _unused_webpack_default_export = (getAssignmentHashKey);
var checkIsVoluntaryResult = function checkIsVoluntaryResult(learningJourneyResult) {
  return (learningJourneyResult === null || learningJourneyResult === void 0 ? void 0 : learningJourneyResult.assignmentType) === __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["b" /* assignmentFilterType */].VOLUNTARY;
};
var findVoluntaryAndAssignedLearningJourneyResult = function findVoluntaryAndAssignedLearningJourneyResult(ljResults) {
  var assignedResults = ljResults.filter(function (r) {
    return r.assignmentType === __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["b" /* assignmentFilterType */].VOLUNTARY || r.stepsCompleted === 0;
  });
  var sorted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(assignedResults, ['assignmentType'], ['desc']);
  return sorted[0];
};
var findVoluntaryLearningJourneyResult = function findVoluntaryLearningJourneyResult(ljResults) {
  return ljResults.find(function (r) {
    return r.assignmentType === __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["b" /* assignmentFilterType */].VOLUNTARY;
  });
};
var findLatestAssignedLearningJourneyResult = function findLatestAssignedLearningJourneyResult(ljResults) {
  var assignedResults = ljResults.filter(function (r) {
    return r.assignmentType !== __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["b" /* assignmentFilterType */].VOLUNTARY;
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["maxBy"])(assignedResults, function (result) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(result.assignedDateTime);
  });
};
var findHighestProgressLearningJourneyResult = function findHighestProgressLearningJourneyResult(ljResults) {
  var sorted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(ljResults, ['stepsCompleted', 'assignmentType'], ['desc', 'asc']);
  return sorted[0];
};
var findHighestAccuracyLearningJourneyResult = function findHighestAccuracyLearningJourneyResult(ljResults) {
  var sorted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(ljResults, ['accuracy', 'assignmentType'], ['desc', 'asc']);
  return sorted[0];
};
var getLearningJourneyResultByProgressFilter = function getLearningJourneyResultByProgressFilter() {
  var ljResults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var progressSubFilter = arguments.length > 1 ? arguments[1] : undefined;
  if (progressSubFilter === __WEBPACK_IMPORTED_MODULE_4__assignment_filters_filters_constants__["c" /* VOLUNTARY */]) {
    return findVoluntaryLearningJourneyResult(ljResults);
  }
  if (progressSubFilter === __WEBPACK_IMPORTED_MODULE_4__assignment_filters_filters_constants__["a" /* HIGHEST */]) {
    return findHighestProgressLearningJourneyResult(ljResults);
  }
  return findLatestAssignedLearningJourneyResult(ljResults);
};
var getLearningJourneyResultByAccuracyFilter = function getLearningJourneyResultByAccuracyFilter() {
  var ljResults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var accuracySubFilter = arguments.length > 1 ? arguments[1] : undefined;
  if (accuracySubFilter === __WEBPACK_IMPORTED_MODULE_4__assignment_filters_filters_constants__["c" /* VOLUNTARY */]) {
    return findVoluntaryLearningJourneyResult(ljResults);
  }
  if (accuracySubFilter === __WEBPACK_IMPORTED_MODULE_4__assignment_filters_filters_constants__["a" /* HIGHEST */]) {
    return findHighestAccuracyLearningJourneyResult(ljResults);
  }
  return findLatestAssignedLearningJourneyResult(ljResults);
};

/***/ }),

/***/ "d32L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backgroundColorTypes */
/* unused harmony export backgroundHoverColorTypes */
/* unused harmony export getBackgroundColorByAccuracy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Cell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ResultWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Result; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HoverWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__ = __webpack_require__("Q0m1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }




var backgroundColorTypes = {
  cellDefault: '#fff',
  cellSelected: '#b2e4ff'
};
var backgroundHoverColorTypes = {
  cellSelected: '#9fcce5',
  cellAssigned: '#c3cfbd',
  "default": '#e5e5e5'
};
var getBackgroundColorByAccuracy = function getBackgroundColorByAccuracy(range) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* getScoreBands */])({
    currentlyAssigned: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].currentlyAssigned["default"],
    completed1to20: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed1to20["default"],
    completed21to40: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed21to40["default"],
    completed41to60: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed41to60["default"],
    completed61to80: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed61to80["default"],
    completed81to100: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed81to100["default"],
    range: range
  });
};
var getBackgroundHoverColor = function getBackgroundHoverColor(_ref) {
  var backgroundColorCheckValue = _ref.backgroundColorCheckValue,
    isSelected = _ref.isSelected;
  if (isSelected) return backgroundHoverColorTypes.cellSelected;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* getScoreBands */])({
    currentlyAssigned: isSelected ? backgroundHoverColorTypes.cellSelected : __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].currentlyAssigned.hover,
    completed1to20: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed1to20.hover,
    completed21to40: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed21to40.hover,
    completed41to60: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed41to60.hover,
    completed61to80: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed61to80.hover,
    completed81to100: __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["b" /* ScoreBandColors */].completed81to100.hover,
    range: backgroundColorCheckValue
  });
};
var getBackgroundColorByIsProgressFilter = function getBackgroundColorByIsProgressFilter(_ref2) {
  var isSelected = _ref2.isSelected,
    backgroundColorCheckValue = _ref2.backgroundColorCheckValue;
  if (isSelected) return backgroundColorTypes.cellSelected;
  if (!backgroundColorCheckValue) return backgroundColorTypes.cellDefault;
  return getBackgroundColorByAccuracy(backgroundColorCheckValue);
};
var getCellBackgroundColor = function getCellBackgroundColor(props) {
  var showCurrentAssigned = props.showCurrentAssigned,
    isSelected = props.isSelected,
    backgroundColorCheckValue = props.backgroundColorCheckValue;
  if (showCurrentAssigned) return __WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["c" /* ProgressColors */].currentlyAssigned;
  return getBackgroundColorByIsProgressFilter({
    isSelected: isSelected,
    backgroundColorCheckValue: backgroundColorCheckValue
  });
};
var Cell = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var isSelected = props.isSelected,
    backgroundColorCheckValue = props.backgroundColorCheckValue,
    showCurrentAssignmentTriangle = props.showCurrentAssignmentTriangle;
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    position: relative;\n    width: 54px;\n    min-height: 33px;\n    max-height: 33px;\n    box-sizing: border-box;\n    border: ".concat(isSelected ? '1px solid #00A5FF' : "1px solid ".concat(colours.grey[400]), ";\n    border-top: ").concat(!isSelected && 'none', ";\n    border-right: ").concat(!isSelected && 'none', ";\n    cursor: pointer;\n    background-color: ").concat(getCellBackgroundColor(props), ";\n    \n    &:last-child {\n      border-bottom: ").concat(isSelected ? '1px solid #00A5FF' : 'none', ";\n    }\n\n    &:hover {\n      background-color: ").concat(getBackgroundHoverColor({
    backgroundColorCheckValue: backgroundColorCheckValue,
    isSelected: isSelected
  }), ";\n    }\n\n    &:before {\n      display: ").concat(showCurrentAssignmentTriangle ? 'block' : 'none', ";\n      position: absolute;\n      content: '';\n      right: 0;\n      bottom: 0;\n      width: 0;\n      height: 0;\n      border-top: 16.5px solid transparent;\n      border-left: 16.5px solid transparent;\n      border-bottom: 16.5px solid ").concat(__WEBPACK_IMPORTED_MODULE_2__view_key_view_key_colors__["c" /* ProgressColors */].currentlyAssigned, ";\n    }\n");
});
var ResultWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  [class^='svgIconComponent'] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n  }\n"])));
var Result = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: white;\n  font-size: 14px;\n\n  &:hover {\n    font-size: 15px;\n  }\n"])));
var HoverWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 250px;\n  font-weight: 400;\n  padding: 4px;\n"])));

/***/ }),

/***/ "dEfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    ASSIGN_TEXT: i18n._("Assign"),
    ASSIGN_BUTTON_TEXT: function ASSIGN_BUTTON_TEXT(assignAssignmentCount) {
      return "".concat(i18n._("Assign"), " (").concat(assignAssignmentCount, ")");
    },
    UNASSIGN_TEXT: i18n._("Unassign"),
    UNASSIGN_BUTTON_TEXT: function UNASSIGN_BUTTON_TEXT(unassignAssignmentCount) {
      return "".concat(i18n._("Unassign"), " (").concat(unassignAssignmentCount, ")");
    },
    CELL_SELECTED_TEXT: i18n._("cell selected"),
    CELLS_SELECTED_TEXT: i18n._("cells selected"),
    ASSIGN_NO_DUE_DATE_TEXT: i18n._("Assign with no due date"),
    ASSIGN_LATER_TEXT: i18n._("Assign later"),
    MODIFY_ASSIGN_DATES_TEXT: i18n._("Modify assign dates"),
    ASSIGN_NOW_TEXT: i18n._("Assign Now"),
    UNASSIGN_POPUP_TEXT: i18n._("Selected student Quests"),
    UNASSIGN_ALL_TEXT: i18n._("Unassign All"),
    UNASSIGN_ALL_CONFIRMATION_TEXT: i18n._("Unassign All - Confirmation"),
    UNASSIGN_ALL_POPUP_TEXT: i18n._("Everything for this class and group"),
    UNASSIGN_MODAL_HEADER_TEXT: i18n._("Unassign all?"),
    UNASSIGN_MODAL_CONTENT_TEXT: i18n._("Unassign.modal.content"),
    UNASSIGN_MODAL_SUBMIT_TEXT: i18n._("submit")
  };
});

/***/ }),

/***/ "dXA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__ = __webpack_require__("Q0m1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_use_quick_selector__ = __webpack_require__("ZKG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("wL8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translations__ = __webpack_require__("OJ4i");









var AccuracyModalContent = function AccuracyModalContent(props) {
  var closeContextMenu = props.closeContextMenu;
  /**
   * Hooks
   */
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _useQuickSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks_use_quick_selector__["a" /* default */])({
      closeContextMenu: closeContextMenu
    }),
    cleanAssignmentHashKeys = _useQuickSelector.cleanAssignmentHashKeys,
    selectAccuracyBetween = _useQuickSelector.selectAccuracyBetween,
    selectAllAssignments = _useQuickSelector.selectAllAssignments,
    selectCurrentAssigned = _useQuickSelector.selectCurrentAssigned;

  /**
   * Translations
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__translations__["a" /* default */])({
      i18n: i18n
    }),
    SELECT_TEXT = _getTranslations.SELECT_TEXT,
    ALL_CELLS_TEXT = _getTranslations.ALL_CELLS_TEXT,
    ALL_CURRENTLY_ASSIGN_TEXT = _getTranslations.ALL_CURRENTLY_ASSIGN_TEXT,
    ACCURACY_1_TO_20_TEXT = _getTranslations.ACCURACY_1_TO_20_TEXT,
    ACCURACY_21_TO_40_TEXT = _getTranslations.ACCURACY_21_TO_40_TEXT,
    ACCURACY_41_TO_60_TEXT = _getTranslations.ACCURACY_41_TO_60_TEXT,
    ACCURACY_61_TO_80_TEXT = _getTranslations.ACCURACY_61_TO_80_TEXT,
    ACCURACY_81_TO_100_TEXT = _getTranslations.ACCURACY_81_TO_100_TEXT,
    CLEAN_SELECTION_TEXT = _getTranslations.CLEAN_SELECTION_TEXT;

  // eslint-disable-next-line react/prop-types
  var renderModalContentRow = function renderModalContentRow(_ref) {
    var dataTestId = _ref.dataTestId,
      onClickHandler = _ref.onClickHandler,
      color = _ref.color,
      text = _ref.text;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
      "data-testid": dataTestId,
      onClick: onClickHandler,
      role: "button",
      tabIndex: "-1"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["d" /* ColorBlock */], {
      bgColor: color
    }), text);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["e" /* ModalContentHeader */], null, SELECT_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
    "data-testid": "select-all",
    onClick: selectAllAssignments,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["f" /* AllCellsIcon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["m" /* Select */]
  })), ALL_CELLS_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
    role: "button",
    tabIndex: "-1",
    onClick: selectCurrentAssigned
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["d" /* ColorBlock */], {
    "data-testid": "select-current-assigned",
    bgColor: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["d" /* AccuracyColors */].currentlyAssigned
  }), ALL_CURRENTLY_ASSIGN_TEXT), renderModalContentRow({
    dataTestId: 'select-accuracy-1-to-20',
    onClickHandler: function onClickHandler() {
      return selectAccuracyBetween(0, 20);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed1to20["default"],
    text: ACCURACY_1_TO_20_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-accuracy-21-to-40',
    onClickHandler: function onClickHandler() {
      return selectAccuracyBetween(21, 40);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed21to40["default"],
    text: ACCURACY_21_TO_40_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-accuracy-41-to-60',
    onClickHandler: function onClickHandler() {
      return selectAccuracyBetween(41, 60);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed41to60["default"],
    text: ACCURACY_41_TO_60_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-accuracy-61-to-80',
    onClickHandler: function onClickHandler() {
      return selectAccuracyBetween(61, 80);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed61to80["default"],
    text: ACCURACY_61_TO_80_TEXT
  }), renderModalContentRow({
    dataTestId: 'select-accuracy-81-to-100',
    onClickHandler: function onClickHandler() {
      return selectAccuracyBetween(81, 100);
    },
    color: __WEBPACK_IMPORTED_MODULE_4__view_key_view_key_colors__["b" /* ScoreBandColors */].completed81to100["default"],
    text: ACCURACY_81_TO_100_TEXT
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["c" /* ModalContentRow */], {
    "data-testid": "select-clean-cells",
    onClick: cleanAssignmentHashKeys,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["f" /* AllCellsIcon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["H" /* Cross */]
  })), CLEAN_SELECTION_TEXT));
};
AccuracyModalContent.propTypes = {
  closeContextMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AccuracyModalContent);

/***/ }),

/***/ "eKQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getTranslations = function getTranslations(_ref) {
  var i18n = _ref.i18n;
  return {
    ACCURACY_BUTTON_TEXT: i18n._(
    /*i18n*/
    {
      id: "AccuracyProgressToggle.Accuracy",
      defaults: "Accuracy"
    }),
    PROGRESS_BUTTON_TEXT: i18n._(
    /*i18n*/
    {
      id: "AccuracyProgressToggle.Progress",
      defaults: "Progress"
    }),
    ACCURACY_BUTTON_TITLE: i18n._(
    /*i18n*/
    {
      id: "AccuracyProgressToggle.Accuracy.HoverTitle",
      defaults: "View student attempts by the average accuracy of their answers"
    }),
    PROGRESS_BUTTON_TITLE: i18n._(
    /*i18n*/
    {
      id: "AccuracyProgressToggle.Progress.HoverTitle",
      defaults: "View student attempts by the progress made"
    }),
    ACCURACY_INFO_TEXT: i18n._(
    /*i18n*/
    {
      id: "AccuracyProgressToggle.Accuracy.Info",
      defaults: "Accuracy is calculated by total correct responses divided by attempts and multiplied by 100"
    }),
    PROGRESS_INFO_TEXT: i18n._(
    /*i18n*/
    {
      id: "AccuracyProgressToggle.Progress.Info",
      defaults: "Progress shows the ratio of complete vs incomplete steps for each Skill Quest"
    })
  };
};
/* harmony default export */ __webpack_exports__["a"] = (getTranslations);

/***/ }),

/***/ "eag5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".svgIconComponent---qOa8m {\n  display: block;\n  pointer-events: none;\n  width: 12px;\n  background: transparent !important; }\n  .svgIconComponent---qOa8m > span {\n    background: transparent; }\n  .svgIconComponent---qOa8m > span > svg {\n      background: transparent; }\n  .dueDateInfoIcon---1OcNj {\n  display: block;\n  pointer-events: none;\n  width: 17px;\n  height: 17px;\n  background: transparent !important; }\n  .dueDateInfoIcon---1OcNj > span {\n    background: transparent; }\n  .dueDateInfoIcon---1OcNj > span > svg {\n      background: transparent; }\n", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---qOa8m",
	"dueDateInfoIcon": "dueDateInfoIcon---1OcNj"
};

/***/ }),

/***/ "ef/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAssignments */
/* unused harmony export getSelectedAssignmentHashKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return groupAssignAndUnAssignAssignmentsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAllAssignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsAssigningOrUnAssigning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectHasAssignments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("74Tg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status_cell_helpers__ = __webpack_require__("clGU");



var getIsAssigningAssignments = function getIsAssigningAssignments(state) {
  return state.gatewaysReducer.isAssigningAssignments;
};
var getIsUnAssigningAssignments = function getIsUnAssigningAssignments(state) {
  return state.gatewaysReducer.isUnAssigningAssignments;
};
var getAssignments = function getAssignments(state) {
  return state.entitiesReducer.assignments;
};
var getSelectedAssignmentHashKeys = function getSelectedAssignmentHashKeys(state) {
  return state.UPFAssignReducer.selectedAssignmentHashKeys;
};
var groupAssignAndUnAssignAssignmentsSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getSelectedAssignmentHashKeys, getAssignments], function (selectedAssignmentHashKeys, assignments) {
  var assignmentsToAssign = [];
  var assignmentsToUnAssign = [];
  var keys = Object.keys(selectedAssignmentHashKeys);
  var selectedCellsCount = keys.length;
  keys.forEach(function (key) {
    var selectedAssignment = selectedAssignmentHashKeys[key];
    var studentId = selectedAssignment.studentId,
      learningJourneyId = selectedAssignment.learningJourneyId;
    var assignment = assignments[key];
    var _ref = assignment || {},
      currentAssignmentId = _ref.currentAssignmentId;
    if (currentAssignmentId) {
      var generatedAssignmentToUnassign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* generateUnassignedAssignment */])({
        learningJourneyId: learningJourneyId,
        assignmentId: currentAssignmentId,
        studentUserProfileId: studentId
      });
      assignmentsToUnAssign.push(generatedAssignmentToUnassign);
    }
    assignmentsToAssign.push({
      studentUserProfileId: studentId,
      learningJourneyId: learningJourneyId
    });
  });
  return {
    assignmentsToAssign: assignmentsToAssign,
    assignmentsToUnAssign: assignmentsToUnAssign,
    selectedCellsCount: selectedCellsCount
  };
});
var selectAllAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAssignments], function (assignments) {
  var allAssignments = [];
  var keys = Object.keys(assignments);
  keys.forEach(function (key) {
    var currentAssignmentId = assignments[key].currentAssignmentId;
    var _destructureAssignmen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__status_cell_helpers__["e" /* destructureAssignmentHashKey */])(key),
      studentId = _destructureAssignmen.studentId;
    if (currentAssignmentId !== null) {
      var generatedAssignmentToUnassign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* generateUnassignedAssignment */])({
        assignmentId: currentAssignmentId,
        studentUserProfileId: studentId
      });
      allAssignments.push(generatedAssignmentToUnassign);
    }
  });
  return allAssignments;
});
var selectIsAssigningOrUnAssigning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getIsAssigningAssignments, getIsUnAssigningAssignments], function (isAssigningAssignments, isUnAssigningAssignments) {
  return isAssigningAssignments || isUnAssigningAssignments;
});
var selectHasAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAssignments], function (assignments) {
  return Object.keys(assignments).length > 0;
});

/***/ }),

/***/ "ezD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTITY_NAMES; });
var ENTITY_NAMES = {
  ASSIGNMENTS: 'assignments',
  CLASSROOMS: 'classrooms',
  COURSES: 'courses',
  GROUPS: 'groups',
  LEARNING_JOURNEYS: 'learningJourneys',
  LEARNING_JOURNEY_STEPS: 'learningJourneySteps',
  LOCKED_COURSE_VERSIONS: 'lockedCourseVersions',
  PUBLICATIONS: 'publications',
  STANDARDS: 'standards',
  STRANDS: 'strands',
  STUDENTS: 'students'
};
/* unused harmony default export */ var _unused_webpack_default_export = (ENTITY_NAMES);

/***/ }),

/***/ "fEk+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_connection_error__ = __webpack_require__("zQTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__ = __webpack_require__("8Qrj");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var initialState = {
  isLoadingAssignments: false,
  isAssigningAssignments: false,
  isUnAssigningAssignments: false,
  isLoadingPreviewAssignment: false,
  isLoadingClassrooms: false
};
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["a" /* STUDENTS_ASSIGNMENTS_STATUSES_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingAssignments: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["b" /* STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingAssignments: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["c" /* ASSIGN_ASSIGNMENTS_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isAssigningAssignments: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["d" /* ASSIGN_ASSIGNMENTS_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isAssigningAssignments: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["e" /* UNASSIGN_ASSIGNMENTS_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isUnAssigningAssignments: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["f" /* UNASSIGN_ASSIGNMENTS_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isUnAssigningAssignments: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["g" /* PREVIEW_ASSIGNMENT_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingPreviewAssignment: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["h" /* PREVIEW_ASSIGNMENT_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingPreviewAssignment: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["i" /* CLASSROOMS_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingClassrooms: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["j" /* CLASSROOMS_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingClassrooms: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__gateways_action_types__["k" /* ERROR_DETECTED */]:
      {
        // don't like be in here, but will refactor later
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_connection_error__["a" /* default */])();
        return _objectSpread({}, initialState);
      }
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),

/***/ "fbOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideToast; });
var SHOW_TOAST = 'SHOW_TOAST';
var showToast = function showToast(message, messageType) {
  return {
    type: SHOW_TOAST,
    isToastVisible: true,
    message: message,
    messageType: messageType
  };
};
var HIDE_TOAST = 'HIDE_TOAST';
var hideToast = function hideToast() {
  return {
    type: HIDE_TOAST,
    isToastVisible: false
  };
};

/***/ }),

/***/ "fjUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    CURRENTLY_ASSIGNED: i18n._("AssignmentsSummary - Currently assigned"),
    OVERDUE: i18n._("AssignmentsSummary - Overdue"),
    TOTAL_ASSIGNMENTS: i18n._("AssignmentsSummary - Total assignments")
  };
});

/***/ }),

/***/ "g2YJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelpWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StudentListWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__ = __webpack_require__("Ivgr");



var HelpWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function () {
  return "\n   ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n   \n   color: #C53B04;\n   width: 100%;\n   padding: 5px 1px 1px 8px;\n   \n   path {\n    fill: #C53B04 !important;\n   }\n   \n   .heading {\n     width: 88%;\n   }\n   \n   .arrow {\n     cursor: pointer;\n   }\n");
});
var StudentListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n     color: #C53B04;\n     width: 100%;\n     overflow: auto;\n     padding: 5px 0px 0px 25px;\n     \n     .list {\n       height: 24px;\n       line-height: 16px;\n       list-style-type: square;\n     }\n\n     border-bottom: 1px solid ".concat(colours.grey[400], ";\n");
});


/***/ }),

/***/ "gdXn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".info---2W9_S {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.checkbox---1MPHD {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 98%;\n  padding-left: 5px; }\n\n.checkbox---1MPHD .chklabel---2gVYc {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #cdcdcd;\n  margin-top: 4px; }\n\n.checkbox---1MPHD .name---2pP0F {\n  display: none; }\n\n.checkbox---1MPHD .description---2LbkP {\n  padding-left: 10px;\n  padding-top: 3px;\n  color: #555;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: normal;\n  white-space: initial;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.name---2pP0F + label {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px;\n  -moz-appearance: none;\n       appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  width: 5%; }\n\n.name---2pP0F:checked + label::after {\n  background-color: white !important;\n  content: \"\\F00C\";\n  color: black;\n  font-family: \"FontAwesome\";\n  font-size: 16px; }\n", ""]);

// exports
exports.locals = {
	"info": "info---2W9_S",
	"checkbox": "checkbox---1MPHD",
	"chklabel": "chklabel---2gVYc",
	"name": "name---2pP0F",
	"description": "description---2LbkP"
};

/***/ }),

/***/ "i4yT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* unused harmony export fetchErrorDetected */
/* unused harmony export fetchStudentAssignmentsStatusesRequest */
/* unused harmony export fetchStudentAssignmentsStatusesSuccess */
/* unused harmony export fetchAssignAssignmentsRequest */
/* unused harmony export fetchAssignAssignmentsSuccess */
/* unused harmony export fetchUnAssignAssignmentsRequest */
/* unused harmony export fetchUnAssignAssignmentsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAssignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postAssignAssignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteUnAssignAssignments; });
/* unused harmony export fetchPreviewAssignmentRequest */
/* unused harmony export fetchPreviewAssignmentSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postPreviewAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchClassroomsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchClassroomsSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__("JeHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__entities_schema__ = __webpack_require__("FKcn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__entities_entities_reducer__ = __webpack_require__("0dbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__ = __webpack_require__("8Qrj");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }






var fetchErrorDetected = function fetchErrorDetected() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["k" /* ERROR_DETECTED */]
  };
};

/**
 * Assignments
 */

var fetchStudentAssignmentsStatusesRequest = function fetchStudentAssignmentsStatusesRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["a" /* STUDENTS_ASSIGNMENTS_STATUSES_REQUEST */]
  };
};
var fetchStudentAssignmentsStatusesSuccess = function fetchStudentAssignmentsStatusesSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["b" /* STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS */]
  };
};
var fetchAssignAssignmentsRequest = function fetchAssignAssignmentsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["c" /* ASSIGN_ASSIGNMENTS_REQUEST */]
  };
};
var fetchAssignAssignmentsSuccess = function fetchAssignAssignmentsSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["d" /* ASSIGN_ASSIGNMENTS_SUCCESS */]
  };
};
var fetchUnAssignAssignmentsRequest = function fetchUnAssignAssignmentsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["e" /* UNASSIGN_ASSIGNMENTS_REQUEST */]
  };
};
var fetchUnAssignAssignmentsSuccess = function fetchUnAssignAssignmentsSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["f" /* UNASSIGN_ASSIGNMENTS_SUCCESS */]
  };
};
var getAssignments = function getAssignments(_ref) {
  var productId = _ref.productId,
    classId = _ref.classId,
    courseId = _ref.courseId,
    courseVersion = _ref.courseVersion,
    assignmentResultType = _ref.assignmentResultType;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var _yield$Resources$assi, data, normalizedData, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            dispatch(fetchStudentAssignmentsStatusesRequest());
            _context.n = 1;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].assignments.get({
              productId: productId,
              classId: classId,
              courseId: courseId,
              version: courseVersion
            }).withParams({
              assignmentResultType: assignmentResultType
            }).send();
          case 1:
            _yield$Resources$assi = _context.v;
            data = _yield$Resources$assi.data;
            if (data) {
              _context.n = 2;
              break;
            }
            throw new Error('GET Students assignments Failed');
          case 2:
            normalizedData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["b" /* normalize */])(data, __WEBPACK_IMPORTED_MODULE_3__entities_schema__["a" /* default */].STUDENT_WITH_ASSIGNMENTS_ARRAY);
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__entities_entities_reducer__["c" /* updateEntities */])(normalizedData));
            dispatch(fetchStudentAssignmentsStatusesSuccess());
            return _context.a(2, dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__upf_assign_upf_assign_actions__["a" /* disableShowGridLoader */])()));
          case 3:
            _context.p = 3;
            _t = _context.v;
            dispatch(fetchErrorDetected());
            return _context.a(2, null);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var postAssignAssignments = function postAssignAssignments(requestData) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            dispatch(fetchAssignAssignmentsRequest());
            _context2.n = 1;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].assign.post().withBody(requestData).send();
          case 1:
            response = _context2.v;
            if (response.data) {
              _context2.n = 2;
              break;
            }
            throw new Error('POST Assign assignments failed');
          case 2:
            dispatch(fetchAssignAssignmentsSuccess());
            return _context2.a(2, dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__upf_assign_upf_assign_actions__["b" /* resetAssignmentHashKeys */])()));
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            dispatch(fetchErrorDetected());
            return _context2.a(2, null);
        }
      }, _callee2, null, [[0, 3]]);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var deleteUnAssignAssignments = function deleteUnAssignAssignments() {
  var requestData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var response, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            dispatch(fetchUnAssignAssignmentsRequest());
            _context3.n = 1;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].unassign["delete"]().withBody(requestData).send();
          case 1:
            response = _context3.v;
            if (response.data) {
              _context3.n = 2;
              break;
            }
            throw new Error('DELETE Unassign assignments failed');
          case 2:
            dispatch(fetchUnAssignAssignmentsSuccess());
            return _context3.a(2, dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__upf_assign_upf_assign_actions__["b" /* resetAssignmentHashKeys */])()));
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            dispatch(fetchErrorDetected());
            return _context3.a(2, null);
        }
      }, _callee3, null, [[0, 3]]);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var fetchPreviewAssignmentRequest = function fetchPreviewAssignmentRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["g" /* PREVIEW_ASSIGNMENT_REQUEST */]
  };
};
var fetchPreviewAssignmentSuccess = function fetchPreviewAssignmentSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["h" /* PREVIEW_ASSIGNMENT_SUCCESS */]
  };
};
var postPreviewAssignment = function postPreviewAssignment(_ref5) {
  var productId = _ref5.productId,
    courseId = _ref5.courseId,
    courseVersion = _ref5.courseVersion,
    learningJourneyId = _ref5.learningJourneyId,
    locale = _ref5.locale;
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch) {
      var response, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            dispatch(fetchPreviewAssignmentRequest());
            _context4.n = 1;
            return __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].previewAssignment.post().headers({
              Locale: locale
            }).withBody({
              productId: productId,
              courseId: courseId,
              courseVersion: courseVersion,
              learningJourneyId: learningJourneyId
            }).send();
          case 1:
            response = _context4.v;
            if (response.data) {
              _context4.n = 2;
              break;
            }
            throw new Error(response === null || response === void 0 ? void 0 : response.message);
          case 2:
            dispatch(fetchPreviewAssignmentSuccess());
            return _context4.a(2, response.data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            return _context4.a(2, Promise.reject(_t4));
        }
      }, _callee4, null, [[0, 3]]);
    }));
    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var fetchClassroomsRequest = function fetchClassroomsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["i" /* CLASSROOMS_REQUEST */]
  };
};
var fetchClassroomsSuccess = function fetchClassroomsSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__gateways_action_types__["j" /* CLASSROOMS_SUCCESS */]
  };
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "iV3T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_resource__ = __webpack_require__("P7H2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__local_resource_config__ = __webpack_require__("2z6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_app_app_config__ = __webpack_require__("N5/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_app_app_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_app_app_config__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-console */




var BasicResources = /*#__PURE__*/function () {
  function BasicResources() {
    _classCallCheck(this, BasicResources);
  }
  return _createClass(BasicResources, null, [{
    key: "initialise",
    value: function initialise(envName, credentials) {
      var env = __WEBPACK_IMPORTED_MODULE_0__3plearning_resource___default()({
        name: envName,
        application: __WEBPACK_IMPORTED_MODULE_2__containers_app_app_config__["appName"],
        // eslint-disable-next-line no-underscore-dangle
        config: window._env_
      });
      var location = window.location;
      var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
      if (runningOnDeveloperMachine) {
        if (envName === 'local') {
          // This implies we'll be hitting the mock REST server,
          // which does not require authentication.

          env.bypassAuthentication();
          env.setConfiguration(__WEBPACK_IMPORTED_MODULE_1__local_resource_config__["a" /* default */]);
        } else if (credentials.authToken) {
          env.authToken = credentials.authToken;
        } else {
          env.setCredentials(credentials.username, credentials.password);
        }
      } else if (credentials.authToken) {
        env.authToken = credentials.authToken;
      } else if (credentials.username && credentials.password) {
        env.username = credentials.username;
        env.password = credentials.password;
      } else {
        // The caller should have provided a valid set of credentials, so
        // hopefully this will never happen.

        console.log('BasicResources.initialise() - to execute, we need either an authToken or' + ' a username/password pair.  The credentials object that was provided does not' + ' contain either.  So, expect things to fail badly :-(.');
      }
      return env;
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (BasicResources);

/***/ }),

/***/ "il2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_entities_helpers__ = __webpack_require__("QR7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translations__ = __webpack_require__("jnaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled__ = __webpack_require__("HlnF");










var DEFAULT_SORT_STUDENT_COLUMN = 'lastName';
var StudentHeader = function StudentHeader(_ref) {
  var i18n = _ref.i18n;
  /**
   * STORE
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudentIds;
  });
  var sortDirection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortDirection;
  });
  var sortValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortValue;
  });
  var students = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.students;
  });
  var isSortedByASC = sortDirection === __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["c" /* SORT_DIRECTION_TYPES */].ASC;
  var icon = isSortedByASC ? __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["B" /* DownArrow */] : __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["C" /* UpArrow */];

  /**
   * FUNCTIONS
   */
  var handleOnClick = function handleOnClick() {
    var updatedDirection = isSortedByASC ? __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["c" /* SORT_DIRECTION_TYPES */].DESC : __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["c" /* SORT_DIRECTION_TYPES */].ASC;
    var updatedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_entities_helpers__["c" /* sortEntitiesByIds */])({
      entities: students,
      ids: sortedStudentIds,
      direction: updatedDirection,
      sortKey: sortValue
    });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__containers_upf_assign_upf_assign_actions__["h" /* updateSortedStudentIds */])(updatedStudentIds));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__containers_upf_assign_upf_assign_actions__["i" /* updateSortProps */])(updatedDirection, DEFAULT_SORT_STUDENT_COLUMN));
  };

  /**
   * LOKALISE
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__translations__["a" /* default */])({
      i18n: i18n
    }),
    STUDENTS_TEXT = _getTranslations.STUDENTS_TEXT,
    CURRENTLY_ASSIGNED_TEXT = _getTranslations.CURRENTLY_ASSIGNED_TEXT;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled__["b" /* HeaderLeft */], {
    role: "button",
    tabIndex: "-1",
    onClick: handleOnClick,
    "data-testid": "sort-student-list"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled__["c" /* SvgWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__["a" /* default */], {
    icon: icon
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled__["d" /* StudentCountText */], null, "".concat(STUDENTS_TEXT, " (").concat(sortedStudentIds.length, ")"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled__["e" /* HeaderRight */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, CURRENTLY_ASSIGNED_TEXT)));
};
StudentHeader.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (StudentHeader);

/***/ }),

/***/ "j+A/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions__ = __webpack_require__("6l1r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__("Xjxe");









var Assignment = function Assignment(props) {
  var _props$assignment = props.assignment,
    accuracy = _props$assignment.accuracy,
    assigned = _props$assignment.assigned,
    assignmentId = _props$assignment.assignmentId,
    courseName = _props$assignment.courseName,
    learningJourneyName = _props$assignment.learningJourneyName,
    stepsCompleted = _props$assignment.stepsCompleted,
    stepsCount = _props$assignment.stepsCount,
    dueDate = _props$assignment.dueDate,
    currentAssignmentUnavailableForStudent = _props$assignment.currentAssignmentUnavailableForStudent;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var selectedAssignmentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.currentAssignmentsModalReducer.selectedAssignmentIds;
  });
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var isNotAttempted = stepsCompleted === 0;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["b" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__checkbox__["a" /* default */], {
    checkboxHandler: function checkboxHandler() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__redux_actions__["l" /* toggleAssignmentIds */])(assignmentId));
    },
    state: selectedAssignmentIds.includes(assignmentId) ? __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__["a" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__["b" /* UNCHECKED */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["c" /* Text */], {
    width: "40%",
    alignHorizontal: "flex-start"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["d" /* EllipsisText */], null, learningJourneyName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["c" /* Text */], {
    width: "35%",
    alignHorizontal: "flex-start"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["d" /* EllipsisText */], null, courseName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["c" /* Text */], null, isNotAttempted ? i18n._("Not attempted") : "".concat(accuracy, " %")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["c" /* Text */], null, isNotAttempted ? i18n._("Not attempted") : "".concat(stepsCompleted, "/").concat(stepsCount)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["c" /* Text */], null, __WEBPACK_IMPORTED_MODULE_4_moment___default()(assigned).format('DD.MM.YYYY')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["e" /* DueDate */], {
    currentAssignmentUnavailableForStudent: currentAssignmentUnavailableForStudent
  }, __WEBPACK_IMPORTED_MODULE_4_moment___default()(dueDate).format('DD.MM.YYYY')));
};
Assignment.propTypes = {
  assignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Assignment);

/***/ }),

/***/ "j7wZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterOptionsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilterOptionsHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var FilterOptionsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  color: white;\n  height: 160px;\n  padding-left: 8px;\n"])));
var FilterOptionsHeading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: white !important;\n  font-size: 13px;\n"])));

/***/ }),

/***/ "jYuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* unused harmony export EmptyWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n   ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n    position: relative;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    border-top: 1px solid ").concat(colours.grey[400], ";\n    height: fit-content;\n\n    &::-webkit-scrollbar {\n      height: 0.05px !important;\n      scrollbar-width: 0.05px !important;\n    }\n\n    &::-ms-scrollbar {\n      height: 0.05px !important;\n      scrollbar-width: 0.05px !important;\n    }\n");
});
var EmptyWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n    width: 100%;\n    height: 188px;\n    position: relative;\n    left: 260px;\n    border-top: 1px solid ".concat(colours.grey[400], ";\n    border-right: 1px solid ").concat(colours.grey[400], ";\n");
});
var LoaderContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  flex: 1;\n  margin-top: 200px;\n  margin-left: 25%;\n  position: fixed;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('baseline'));
var GridContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n\n        width: 100%;\n        height: fit-content;\n\n        .cell {\n            width: 82px;\n            height: 40px;\n            background: ").concat(colours.grey[300], ";\n          }\n    ");
});


/***/ }),

/***/ "jgHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");

var useGetSelectedPublication = function useGetSelectedPublication() {
  var selectedPublication = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedPublication;
  }, __WEBPACK_IMPORTED_MODULE_0_react_redux__["d" /* shallowEqual */]);
  return {
    selectedPublication: selectedPublication
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useGetSelectedPublication);

/***/ }),

/***/ "jnaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    ASSIGNED_TEXT: i18n._("Assigned"),
    CLASS_TEXT: i18n._("Class"),
    CURRENTLY_TEXT: i18n._("Currently"),
    CURRENT_ASSIGNMENTS_TEXT: i18n._("Current Assignments"),
    GROUP_TEXT: i18n._("Group"),
    SELECT_STUDENT_TEXT: i18n._("Select Student"),
    STUDENTS_TEXT: i18n._("Students"),
    CURRENTLY_ASSIGNED_TEXT: i18n._("Currently Assigned")
  };
});

/***/ }),

/***/ "lAS/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("EVvD");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./upf-assign.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./upf-assign.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "lS1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PortalCommunication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service__ = __webpack_require__("UTT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var PortalCommunication = /*#__PURE__*/function () {
  function PortalCommunication() {
    _classCallCheck(this, PortalCommunication);
  }
  return _createClass(PortalCommunication, null, [{
    key: "loadingSpinnerOff",
    value: function loadingSpinnerOff() {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestLoadingSpinner(false);
    }

    // invoke this method to let the 3p-portal know
    // that we want to navigate to current module landing screen
  }, {
    key: "navigateToLandingScreen",
    value: function navigateToLandingScreen() {
      var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestNavigateToLanding(moduleName);
    }
  }, {
    key: "serverError",
    value: function serverError(error) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestServerError(error);
    }
  }, {
    key: "informModuleChange",
    value: function informModuleChange(moduleId) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.informModuleChange(moduleId);
    }
  }, {
    key: "requestLoadingSpinner",
    value: function requestLoadingSpinner(bool) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestLoadingSpinner(bool);
    }
  }, {
    key: "requestInfoModal",
    value: function requestInfoModal(girlIds) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestDucsModal(girlIds);
    }
  }]);
}();


/***/ }),

/***/ "lz7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CURRENTLY_ASSIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACCURACY0TO50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACCURACY51TO84; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACCURACY85TO100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMPLETED1TO20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMPLETED21TO40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPLETED41TO60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMPLETED61TO80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMPLETED81TO100; });
var SELECT_ALL = 'selectAll';
var CURRENTLY_ASSIGNED = 'currentlyAssigned';
var CLEAR_SELECTION = 'clearSelection';

// Accuracy constants
var ACCURACY0TO50 = 'accuracy0to50';
var ACCURACY51TO84 = 'accuracy51to84';
var ACCURACY85TO100 = 'accuracy85to100';

// Progress constants
var COMPLETED1TO20 = 'completed1to20';
var COMPLETED21TO40 = 'completed21to40';
var COMPLETED41TO60 = 'completed41to60';
var COMPLETED61TO80 = 'completed61to80';
var COMPLETED81TO100 = 'completed81to100';

/***/ }),

/***/ "m4hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Standards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleStandardCollapse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("jYuT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__strandard_item__ = __webpack_require__("Qipw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pulse_loader__ = __webpack_require__("oWNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__empty_state__ = __webpack_require__("nS47");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }








/* eslint-disable */
var toggleStandardCollapse = null;
var Standards = function Standards(_ref) {
  var handleOnScroll = _ref.handleOnScroll,
    i18n = _ref.i18n;
  /**
   * STORE
   */
  var selectedLearningJourneyIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedLearningJourneyIds;
  });
  var selectedTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedTopics;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var showGridLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.showGridLoader;
  });
  var genericCourses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.genericCourses;
  });
  var selectedClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedClass;
  });
  var sortedStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudents;
  });
  var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortedStudentIds;
  });
  var isLoadingGenericCourses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.isLoadingGenericCourses;
  });

  /**
   * STATE
   */
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isStandardsCollapsed = _useState2[0],
    setIsStandardsCollapsed = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isStandardDirty = _useState4[0],
    setIsStandardDirty = _useState4[1];

  /**
   * FUNCTIONS
   */
  toggleStandardCollapse = function toggleStandardCollapse(collapsedState) {
    setIsStandardsCollapsed(collapsedState);
    setIsStandardDirty(false);
  };

  /**
   * Local variables
   */
  var studentsCount = sortedStudentIds.length;
  var showEmptyState = !selectedLearningJourneyIds.length && !studentsCount;

  /**
   * RENDER
   */
  if (showGridLoader || isLoadingGenericCourses) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* GridContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* LoaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pulse_loader__["a" /* default */], null)));
  }
  if (showEmptyState) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* GridContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* LoaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__empty_state__["a" /* default */], {
      i18n: i18n
    })));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Wrapper */], {
    id: "standards",
    onScroll: handleOnScroll
  }, selectedTopics.map(function (topic) {
    return topic.childTopics.map(function (childTopic) {
      if (!childTopic.selected) return null;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__strandard_item__["a" /* default */], {
        key: childTopic.displayName,
        externalKey: childTopic.externalKey,
        learningJourney: childTopic.childTopics,
        topicName: childTopic.name,
        description: childTopic.description,
        id: childTopic.id,
        i18n: i18n,
        collapseAllStandards: isStandardsCollapsed,
        isStandardDirty: isStandardDirty,
        setIsStandardDirty: setIsStandardDirty,
        selectedClass: selectedClass,
        genericCourses: genericCourses
      });
    });
  }));
};
Standards.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  handleOnScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Standards.defaultProps = {
  handleOnScroll: function handleOnScroll() {}
};


/***/ }),

/***/ "mAO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("yygr");




var FooterPopup = function FooterPopup(_ref) {
  var isOpen = _ref.isOpen,
    options = _ref.options;
  if (isOpen) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Root */], null, options.map(function (option) {
      var optionKey = "".concat(option.title, "_").concat(option.description);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* ListItem */], {
        key: optionKey,
        onClick: function onClick() {
          return option.onClickHandler();
        },
        disabled: option.disabled
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__svg_icon_svg_icon__["a" /* default */], {
        icon: option.icon
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* ItemText */], {
        large: true
      }, option.title, option.description && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* ItemText */], {
        small: true
      }, option.description))));
    })));
  }
  return null;
};
FooterPopup.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    icon: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    onClickHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  })).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FooterPopup);

/***/ }),

/***/ "mO2z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterNeedAttentionStudentsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__status_cell_helpers__ = __webpack_require__("clGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_selectors_common__ = __webpack_require__("8qms");



var filterNeedAttentionStudentsSelector = function filterNeedAttentionStudentsSelector(learningJourneyId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_2__helpers_selectors_common__["a" /* getAssignments */], __WEBPACK_IMPORTED_MODULE_2__helpers_selectors_common__["b" /* getStudents */], __WEBPACK_IMPORTED_MODULE_2__helpers_selectors_common__["c" /* getSortedStudentIds */]], function (assignments, students, studentIds) {
    var filteredStudentIds = studentIds.filter(function (studentId) {
      var assignmentHashKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__status_cell_helpers__["d" /* getAssignmentHashKey */])(studentId, learningJourneyId);
      var assignment = assignments[assignmentHashKey];
      return !!(assignment !== null && assignment !== void 0 && assignment.studentNeedsAttention);
    });
    return filteredStudentIds.map(function (id) {
      return students[id];
    });
  });
};
/* unused harmony default export */ var _unused_webpack_default_export = (filterNeedAttentionStudentsSelector);

/***/ }),

/***/ "mPf8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".header---3NjFG {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  background-color: #dbe3e9;\n  height: 60px; }\n  .header---3NjFG h1 {\n    font-size: 20px;\n    font-size: 1.25rem; }\n  .header---3NjFG [class*=\"TitleContainer\"] {\n    padding: 0 20px; }\n  .header---3NjFG [class*=\"SubHeader\"] {\n    background-color: #dbe3e9;\n    padding: 0 10px 0 0; }\n  .buttonsContainer---2nLON {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"header": "header---3NjFG",
	"buttonsContainer": "buttonsContainer---2nLON"
};

/***/ }),

/***/ "mr6W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_student_restrict_access__ = __webpack_require__("i68Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__("KH1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_locale__ = __webpack_require__("ZhO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utils__ = __webpack_require__("6QRH");








var StudentOnTaskLock = function StudentOnTaskLock(_ref) {
  var i18n = _ref.i18n;
  var localeCdnBaseUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["b" /* getConfiguration */])('localeCdnBaseUrl');
  var activeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    var _state$UPFAssignReduc;
    return (_state$UPFAssignReduc = state.UPFAssignReducer) === null || _state$UPFAssignReduc === void 0 || (_state$UPFAssignReduc = _state$UPFAssignReduc.selectedClass) === null || _state$UPFAssignReduc === void 0 ? void 0 : _state$UPFAssignReduc.value;
  });
  var activeGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    var _state$UPFAssignReduc2;
    return (_state$UPFAssignReduc2 = state.UPFAssignReducer) === null || _state$UPFAssignReduc2 === void 0 || (_state$UPFAssignReduc2 = _state$UPFAssignReduc2.selectedGroup) === null || _state$UPFAssignReduc2 === void 0 ? void 0 : _state$UPFAssignReduc2.value;
  });
  return localeCdnBaseUrl !== '' && activeClass && activeGroup && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_student_restrict_access__["a" /* default */], {
    classId: activeClass,
    groupId: activeGroup,
    i18n: i18n,
    locale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_locale__["a" /* getLocale */])(),
    localeCdnBaseUrl: localeCdnBaseUrl,
    Resources: __WEBPACK_IMPORTED_MODULE_5__helpers_resources__["a" /* default */],
    theme: __WEBPACK_IMPORTED_MODULE_4__themes__["a" /* default */]
  });
};
StudentOnTaskLock.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (StudentOnTaskLock);

/***/ }),

/***/ "nIya":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Tj2k");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nS47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("aFup");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");





var EmptyState = function EmptyState(_ref) {
  var i18n = _ref.i18n;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["y" /* QuestionMarkLeft */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Text */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Heading */], null, i18n._("Nothing to see?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* Description */], null, i18n._("Select some topics and standards in the search bar above, and get ready to assign your heart out!"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["z" /* QuestionMarkRight */]
  }));
};
EmptyState.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EmptyState);

/***/ }),

/***/ "ngKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_class_group_filters__ = __webpack_require__("vvu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_standards__ = __webpack_require__("m4hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_student_list__ = __webpack_require__("b3EP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_toast__ = __webpack_require__("xfNU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_course_filters__ = __webpack_require__("uSsC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_searchable_dropdownlist__ = __webpack_require__("FQuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_footer__ = __webpack_require__("5ttS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_grid_actions__ = __webpack_require__("+vac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_hooks_use_polling_v2__ = __webpack_require__("KtId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__error_boundary__ = __webpack_require__("whwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss__ = __webpack_require__("lAS/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__upf_assign_scss__);
















var UpfAssign = function UpfAssign(_ref) {
  var i18n = _ref.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_hooks_use_polling_v2__["a" /* default */])();
  var toastProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.toastReducer;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var previewModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.modalContainerReducer;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var previewModalTheme = {
    overrides: {
      modal: {
        width: '100%',
        maxWidth: '900px'
      }
    }
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default.a.filterBar
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default.a.courseFilter
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__error_boundary__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_course_filters__["a" /* default */], null))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default.a.search
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_searchable_dropdownlist__["a" /* default */], {
    id: "SearchableDropDownList",
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_grid_actions__["a" /* default */], {
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default.a.component
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default.a.leftSection
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__error_boundary__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_class_group_filters__["a" /* default */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__error_boundary__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_student_list__["a" /* default */], {
    i18n: i18n
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default.a.rightSection,
    onScroll: function onScroll(e) {
      if (document.getElementById('studentList')) {
        document.getElementById('studentList').scrollTop = e.target.scrollTop;
      }
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__error_boundary__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_standards__["a" /* Standards */], {
    i18n: i18n
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__upf_assign_scss___default.a.footer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__error_boundary__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_toast__["a" /* default */], toastProps))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_footer__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["ThemeProvider"], {
    theme: previewModalTheme
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__error_boundary__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["ModalManager"], {
    modals: previewModal,
    onClose: function onClose() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__modal_manager_modal_manager_actions__["c" /* dismissModal */])());
    }
  }))));
};
UpfAssign.propTypes = {
  filteredStudents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  selectedStudentIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  selectedPSRs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  selectedCells: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  playLists: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  pausePolling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedPlaylistId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  classrooms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
UpfAssign.whyDidYouRender = false;
/* harmony default export */ __webpack_exports__["a"] = (UpfAssign);

/***/ }),

/***/ "oWNv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss__ = __webpack_require__("1IMA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_scss__);


var PulseLoader = function PulseLoader() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__index_scss___default.a.pulseLoader
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null));
};
/* harmony default export */ __webpack_exports__["a"] = (PulseLoader);

/***/ }),

/***/ "qmGw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".modal-override---2Hu5_ > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 260px !important;\n  padding: 30px 40px 5px; }\n\n.modal-override---2Hu5_ [class*=\"ButtonContainer\"] {\n  margin-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"modal-override": "modal-override---2Hu5_"
};

/***/ }),

/***/ "qmda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckboxContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HiddenCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CustomCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IconIntermediate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IconUnchecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IconDisabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var CheckboxContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["d" /* inlineFlexbox */])());
var HiddenCheckbox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].input.attrs({
  type: 'checkbox'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    clippath: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"])));
var CustomCheckbox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme.palette;
  var primary = palette.primary;
  var currentState = props.currentState;
  return "\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border-radius: 3px;\n    transition: all 150ms;\n    background: ".concat(currentState === 'checked' ? '#00a5ff' : 'white', ";\n    border: 1px solid ").concat(primary.light, ";\n    cursor: pointer;\n\n    ").concat(HiddenCheckbox, ":focus + & {\n        box-shadow: 0 0 0 3px ").concat(primary.light, ";\n    }\n  ");
});
var IconChecked = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fill: none;\n  stroke: white;\n  stroke-width: 3px;\n"])));
var IconIntermediate = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].svg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: #00a5ff;\n  fill: white;\n  stroke: white;\n"])));
var IconDisabled = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].svg(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n  background: ".concat(colours.grey[200], ";\n  fill: ").concat(colours.grey[200], ";\n  stroke: ").concat(colours.grey[200], ";\n  cursor: default;\n");
});
var IconUnchecked = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].svg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));


/***/ }),

/***/ "r+Ri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PanelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CollapsedPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ExpandedPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var collapsedStyles = "\n  left: 85%;\n  margin: 0;\n  width: auto;\n  transition: all 0.3s ease-out;\n  padding: 3px 30px;\n  min-width: 8.5rem;\n";
var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var isCollapsed = props.isCollapsed;
  return "\n    position: fixed;\n    left: 50%;\n    bottom: 0;\n    z-index: 4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px 2.25rem;\n    min-height: 2rem;\n    min-width: 25.5rem;\n    background: #94b4c9;\n    border-radius: 10px 10px 0 0;\n    font-size: 0.75rem;\n    transform: translateX(-50%);\n    transition: all 0.3s ease-out;\n\n    ".concat(isCollapsed && collapsedStyles, "\n  ");
});
var PanelWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: #94b4c9;\n  padding: 0 5px;\n  border-radius: 10px 10px 0 0;\n"])));
var CollapsedPanel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: auto;\n  padding: 0;\n  font-weight: 700;\n"])));
var ExpandedPanel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n\n  .button {\n    height: 30px;\n  }\n"])));

/***/ }),

/***/ "rkBr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignmentFiltersWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FilterLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilerRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var AssignmentFiltersWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: start;\n\n  width: 100%;\n  margin: 0 10px;\n\n  .close-btn,\n  .filter-btn {\n    font-weight: bold;\n    background-color: transparent;\n    border: 0;\n    color: white;\n\n    .isvg {\n      color: #425464;\n      padding: 0;\n    }\n  }\n\n  .close-btn {\n    padding: 0 8px;\n  }\n"])));
var FilterLabel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 11.5px;\n  border-radius: 10px;\n  background-color: #f4f4f4;\n  padding: 2px 10px;\n"])));
var FilerRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  margin-top: 3px;\n"])));
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 21px;\n\n  [class^='svgIconComponent'] {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n  }\n"])));

/***/ }),

/***/ "s4Vw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3gQ+");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sOLJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_GROUP_ID; });
var DEFAULT_GROUP_ID = -1;
/* unused harmony default export */ var _unused_webpack_default_export = (DEFAULT_GROUP_ID);

/***/ }),

/***/ "sWyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    CURRENTLY_ASSIGNED_TEXT: i18n._("Currently Assigned"),
    SELECT_CELL_TEXT: i18n._("Select Cell"),
    UNSELECT_CELL_TEXT: i18n._("Unselect Cell"),
    UNASSIGN_FROM_STUDENT_TEXT: i18n._("Unassign from student"),
    REASSIGN_TEXT: i18n._("Reassign"),
    ASSIGN_AND_REVIEW_TEXT: i18n._("Assigned via Assign & Review"),
    LEARNING_GAPS_TEXT: i18n._("Assigned via Learning Gaps"),
    VOLUNTARY_TEXT: i18n._("Voluntarily attempted"),
    ATTEMPTS_TEXT: i18n._("Attempts"),
    OVERDUE_ASSIGNMENT_REMOVED: i18n._("StatusCell - Overdue assignment removed")
  };
});

/***/ }),

/***/ "spZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILTERED_STUDENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ERROR_DETECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STUDENTS_ASSIGNMENTS_STATUSES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SORTED_STUDENTS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PUBLICATIONS_ACQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GENERIC_COURSES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GENERIC_COURSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SHOW_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLASSROOMS_ACQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_STRANDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_SORT_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return APPLY_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_SELECTED_COURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SHOW_HIDE_SEARCH_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DISPLAY_MODAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return HIDE_STANDARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_STUDENT_ASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ASSIGN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ASSIGN_SUCCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ASSIGN_FAILURE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GRID_CELL_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UNASSIGN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UNASSIGN_SUCCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UNASSIGN_FAILURE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EXPAND_COLLAPSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_SELECTED_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_SELECTED_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_SELECTED_PUBLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_SELECTED_COURSE_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return RESTRICT_ACCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return RESTRICT_ACCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RESTRICT_ACCESS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_ASSIGNMENT_FILTER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SELECT_ACCURACY_PROGRESS_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SELECT_ACCURACY_SUB_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SELECT_PROGRESS_SUB_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return QUICK_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SELECT_ASSIGNMENT_HASH_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SELECT_ASSIGNMENT_HASH_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return UNSELECT_ASSIGNMENT_HASH_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return RESET_SELECTED_ASSIGNMENT_HASH_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return DISABLE_SHOW_GRID_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return UPDATE_SORTED_STUDENT_IDS; });
/* unused harmony export SET_DATE_CONFIGURATION */
var FILTERED_STUDENTS = 'FILTERED_STUDENTS';
var ERROR_DETECTED = 'ERROR_DETECTED';
var STUDENTS_ASSIGNMENTS_STATUSES_REQUEST = 'STUDENTS_ASSIGNMENTS_STATUSES_REQUEST';
var STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS = 'STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS';
var UPDATE_SORTED_STUDENTS_LIST = 'UPDATE_SORTED_STUDENTS_LIST';
var PUBLICATIONS_ACQUIRED = 'PUBLICATIONS_ACQUIRED';
var GENERIC_COURSES_REQUEST = 'GENERIC_COURSES_REQUEST';
var GENERIC_COURSES_SUCCESS = 'GENERIC_COURSES_SUCCESS';
var SHOW_TOAST = 'SHOW_TOAST';
var CLASSROOMS_ACQUIRED = 'CLASSROOMS_ACQUIRED';
var UPDATE_STRANDS = 'UPDATE_STRANDS';
var UPDATE_SORT_PROPERTIES = 'UPDATE_SORT_PROPERTIES';
var APPLY_FILTER = 'APPLY_FILTER';
var UPDATE_SELECTED_COURSE = 'UPDATE_SELECTED_COURSE';
var SHOW_HIDE_SEARCH_PANEL = 'SHOW_HIDE_SEARCH_PANEL';
var DISPLAY_MODAL_INFORMATION = 'DISPLAY_MODAL_INFORMATION';
var HIDE_STANDARD = 'HIDE_STANDARD';
var UPDATE_STUDENT_ASSIGNMENT = 'UPDATE_STUDENT_ASSIGNMENT';
var ASSIGN_REQUEST = 'ASSIGN_REQUEST';
var ASSIGN_SUCCESS_REQUEST = 'ASSIGN_SUCCESS_REQUEST';
var ASSIGN_FAILURE_REQUEST = 'ASSIGN_FAILURE_REQUEST';
var GRID_CELL_SELECTION = 'GRID_CELL_SELECTION';
var UNASSIGN_REQUEST = 'UNASSIGN_REQUEST';
var UNASSIGN_SUCCESS_REQUEST = 'UNASSIGN_SUCCESS_REQUEST';
var UNASSIGN_FAILURE_REQUEST = 'UNASSIGN_FAILURE_REQUEST';
var EXPAND_COLLAPSE_REQUEST = 'EXPAND_COLLAPSE_REQUEST';
var SET_SELECTED_CLASS = 'SET_SELECTED_CLASS';
var SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
var SET_SELECTED_PUBLICATION = 'SET_SELECTED_PUBLICATION';
var SET_SELECTED_COURSE_OPTION = 'SET_SELECTED_COURSE_OPTION';
var RESTRICT_ACCESS_REQUEST = 'RESTRICT_ACCESS_REQUEST';
var RESTRICT_ACCESS_SUCCESS = 'RESTRICT_ACCESS_SUCCESS';
var RESTRICT_ACCESS_FAILURE = 'RESTRICT_ACCESS_FAILURE';
var SET_ASSIGNMENT_FILTER_TYPE = 'SET_ASSIGNMENT_FILTER_TYPE';
var SELECT_ACCURACY_PROGRESS_TOGGLE = 'SELECT_ACCURACY_PROGRESS_TOGGLE';
var SELECT_ACCURACY_SUB_FILTER = 'SELECT_ACCURACY_SUB_FILTER';
var SELECT_PROGRESS_SUB_FILTER = 'SELECT_PROGRESS_SUB_FILTER';
var QUICK_SELECTION = 'QUICK_SELECTION';
var SELECT_ASSIGNMENT_HASH_KEY = 'SELECT_ASSIGNMENT_HASH_KEY';
var SELECT_ASSIGNMENT_HASH_KEYS = 'SELECT_ASSIGNMENT_HASH_KEYS';
var UNSELECT_ASSIGNMENT_HASH_KEYS = 'UNSELECT_ASSIGNMENT_HASH_KEYS';
var RESET_SELECTED_ASSIGNMENT_HASH_KEYS = 'RESET_SELECTED_ASSIGNMENT_HASH_KEYS';
var DISABLE_SHOW_GRID_LOADER = 'DISABLE_SHOW_GRID_LOADER';
var UPDATE_SORTED_STUDENT_IDS = 'UPDATE_SORTED_STUDENT_IDS';
var SET_DATE_CONFIGURATION = 'SET_DATE_CONFIGURATION';

/***/ }),

/***/ "t+mt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OutsideClickHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


function OutsideClickHandler(props) {
  var children = props.children,
    callback = props.callback,
    forButton = props.forButton;
  var wrapperRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  useOutsideAlerter(wrapperRef, callback, forButton);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: wrapperRef
  }, children);
}
OutsideClickHandler.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  callback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
function useOutsideAlerter(ref, callback, forButton) {
  function handleClickOutside(event) {
    var target = event.target;
    if (ref.current && !ref.current.contains(target) && !isIgnoredItem(target)) {
      callback();
    }
    function isIgnoredItem(t) {
      var parent = t.parentNode;
      return forButton === t.id || parent && isIgnoredItem(parent);
    }
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
}

/***/ }),

/***/ "tCg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__local_storage__ = __webpack_require__("//jD");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




/**
 *
 * @param {function} checkShouldUpdateValueFromLocalStorage - For checking difference between value and localStorage
 * @param {any} defaultValue - default value
 * @param {boolean} enable - Allows you run the hook when it ready (async)
 * @param {string} key - localStorage key
 * @param {boolean} prefixCountryCodeFromParam - Add prefix countryCode from URL params
 * @param {function} updateValueFromLocalStorage - Allows you callback update value from localStorage or defaultValue
 * @param {any} value - dynamic value for trigger set value to localStorage
 */

var useManageLocalStorage = function useManageLocalStorage(_ref) {
  var checkShouldUpdateValueFromLocalStorage = _ref.checkShouldUpdateValueFromLocalStorage,
    defaultValue = _ref.defaultValue,
    _ref$enable = _ref.enable,
    enable = _ref$enable === void 0 ? true : _ref$enable,
    key = _ref.key,
    _ref$prefixCountryCod = _ref.prefixCountryCodeFromParam,
    prefixCountryCodeFromParam = _ref$prefixCountryCod === void 0 ? false : _ref$prefixCountryCod,
    updateValueFromLocalStorage = _ref.updateValueFromLocalStorage,
    value = _ref.value;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isReadyForSetItem = _useState2[0],
    setIsReadyForSetItem = _useState2[1];
  var stringifyValue = JSON.stringify(value);
  var stringifyDefaultValue = JSON.stringify(defaultValue);
  var countryCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* findCountryCodeFromQueryParams */])();
  var localStorageKey = prefixCountryCodeFromParam && countryCode ? "".concat(countryCode, "_").concat(key) : key;

  /**
   * Effect for getting initial localStorage value and return the update callback
   */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!key || !enable) return;
    var localStorageValue = __WEBPACK_IMPORTED_MODULE_2__local_storage__["a" /* default */].getItem(localStorageKey);
    if (defaultValue && updateValueFromLocalStorage) {
      var isDifferent = checkShouldUpdateValueFromLocalStorage ? checkShouldUpdateValueFromLocalStorage(localStorageValue) : stringifyDefaultValue !== JSON.stringify(localStorageValue);
      var updatedValue = isDifferent ? localStorageValue : defaultValue;
      updateValueFromLocalStorage(updatedValue);
      setIsReadyForSetItem(true);
    }
  }, [enable]);

  /**
   * Effect for detect value changes and set back to localStorage value
   */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!key || !enable || !isReadyForSetItem) return;
    var localStorageValue = __WEBPACK_IMPORTED_MODULE_2__local_storage__["a" /* default */].getItem(localStorageKey);
    if (stringifyValue !== JSON.stringify(localStorageValue)) {
      __WEBPACK_IMPORTED_MODULE_2__local_storage__["a" /* default */].setItem(localStorageKey, value);
    }
  }, [value, enable, isReadyForSetItem]);
};
/* harmony default export */ __webpack_exports__["a"] = (useManageLocalStorage);

/***/ }),

/***/ "u3TQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources__ = __webpack_require__("viEY");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



/**
 * USE EXPLICIT SERVICE REQUEST
 * ------------------------------
 * We are occasionally unable to use the resource manager. This hook holds gateway and auth data
 * to allow for custom, explicit service requests.
 */
var useExplicitServiceRequest = function useExplicitServiceRequest() {
  /**
   * VARIABLES
   */
  var UPF_ASSIGN_GATEWAY = 'UpfAssignGateway';

  /**
   * STATE
   */
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState2 = _slicedToArray(_useState, 2),
    gateway = _useState2[0],
    setGateway = _useState2[1];

  /**
   * FUNCTIONS
   */
  var manageGateway = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2, __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* default */].getConfigurationItem(UPF_ASSIGN_GATEWAY));
        }
      }, _callee);
    }));
    return function manageGateway() {
      return _ref.apply(this, arguments);
    };
  }();
  var getExplicitRequestUrl = function getExplicitRequestUrl(_ref2) {
    var urlPath = _ref2.urlPath;
    var authToken = __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* default */].env.authToken;
    if (authToken && gateway) {
      return "".concat(gateway).concat(urlPath, "?authToken=").concat(authToken);
    }
    return null;
  };

  /**
   * EFFECT
   */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    manageGateway().then(function (updatedGateway) {
      return setGateway(updatedGateway);
    });
  }, []);
  return {
    getExplicitRequestUrl: getExplicitRequestUrl
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useExplicitServiceRequest);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "u8BE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss__ = __webpack_require__("/A+b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assign_date_modal__ = __webpack_require__("R8DK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("LZW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_hooks_use_manage_assignments__ = __webpack_require__("9mrv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__("74Tg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors__ = __webpack_require__("ef/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations__ = __webpack_require__("dEfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__footer_popup__ = __webpack_require__("mAO4");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }















var assignPopupOpenDefaultState = false;
var assignButtonId = 'assignButton';
var AssignButton = function AssignButton() {
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__translations__["a" /* default */])({
      i18n: i18n
    }),
    ASSIGN_BUTTON_TEXT = _getTranslations.ASSIGN_BUTTON_TEXT,
    ASSIGN_LATER_TEXT = _getTranslations.ASSIGN_LATER_TEXT,
    MODIFY_ASSIGN_DATES_TEXT = _getTranslations.MODIFY_ASSIGN_DATES_TEXT,
    ASSIGN_NOW_TEXT = _getTranslations.ASSIGN_NOW_TEXT;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(assignPopupOpenDefaultState),
    _useState2 = _slicedToArray(_useState, 2),
    assignPopupOpen = _useState2[0],
    setAssignPopupOpen = _useState2[1];
  var isAssigningOrUnAssigning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_12__selectors__["b" /* selectIsAssigningOrUnAssigning */]);
  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_12__selectors__["a" /* groupAssignAndUnAssignAssignmentsSelector */]),
    assignmentsToAssign = _useSelector.assignmentsToAssign;
  var previewModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.modalContainerReducer;
  }, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);
  var assignAssignmentCount = assignmentsToAssign.length;
  var _useManageAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_hooks_use_manage_assignments__["a" /* default */])(),
    assignAssignments = _useManageAssignments.assignAssignments;
  var onAssignClickHandler = function onAssignClickHandler() {
    return setAssignPopupOpen(function (prevState) {
      return !prevState;
    });
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var startDate,
        dueDate,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            startDate = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
            dueDate = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            _context.n = 1;
            return assignAssignments({
              studentAssignments: assignmentsToAssign,
              startDate: startDate,
              dueDate: dueDate
            });
          case 1:
            setAssignPopupOpen(false);
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__containers_modal_manager_modal_manager_actions__["c" /* dismissModal */])());
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmit() {
      return _ref.apply(this, arguments);
    };
  }();
  var onOutsideClickHandlerCallback = function onOutsideClickHandlerCallback() {
    var isDisplayingModal = previewModal.length > 0 && previewModal[0].id === __WEBPACK_IMPORTED_MODULE_11__helpers__["a" /* ASSIGN_DATE_MODAL_ID */];
    if (!isDisplayingModal) setAssignPopupOpen(assignPopupOpenDefaultState);
  };
  var options = [{
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["a" /* IconAssignLater */],
    title: ASSIGN_LATER_TEXT,
    description: MODIFY_ASSIGN_DATES_TEXT,
    onClickHandler: function onClickHandler() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])({
        content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assign_date_modal__["a" /* default */], {
          callback: onSubmit
        }),
        id: __WEBPACK_IMPORTED_MODULE_11__helpers__["a" /* ASSIGN_DATE_MODAL_ID */],
        buttons: [],
        className: __WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss___default.a['modal-override']
      }));
    },
    disabled: false
  }, {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["b" /* AssignIcon */],
    title: ASSIGN_NOW_TEXT,
    description: null,
    onClickHandler: function onClickHandler() {
      return onSubmit();
    },
    disabled: false
  }];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return onOutsideClickHandlerCallback();
    },
    forButton: assignButtonId
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    className: "button",
    id: assignButtonId,
    disabled: assignAssignmentCount === 0 || isAssigningOrUnAssigning,
    primary: true,
    text: ASSIGN_BUTTON_TEXT(assignAssignmentCount),
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      return onAssignClickHandler();
    },
    alignIcon: "LEFT",
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["b" /* AssignIcon */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__footer_popup__["a" /* default */], {
    isOpen: assignPopupOpen,
    onSubmit: onSubmit,
    options: options
  }))));
};
/* harmony default export */ __webpack_exports__["a"] = (AssignButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "uG5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ExternalKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TopicName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StandardWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LearningJourneyWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FixedWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsedWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n\n    border-right: 1px solid ").concat(colours.grey[500], ";\n    box-sizing: border-box;\n    font-size: 12px;\n    position: relative;\n    height: fit-content;\n");
});
var FixedWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n  position: sticky;\n  top: 1px;\n  z-index: 3;\n  border-top: 1px solid ".concat(colours.grey[400], ";\n");
});
var StandardWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var LEARNING_JOURNEY_WIDTH = 54;
  var lj = props.lj;
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('space-between'), ";\n\n    width: ").concat(lj * LEARNING_JOURNEY_WIDTH, "px;\n    min-height: 40px;\n    height: 40px;\n    background-color: #c3d5e1\n    border: ").concat(lj > 0 ? "1px solid ".concat(colours.grey[400]) : 'none', ";\n    border-right: ").concat(lj > 0 ? "1px solid ".concat(colours.grey[500]) : 'none', ";\n    border-top: none;\n    box-sizing: border-box;\n    font-size: 12px;\n    overflow: hidden;\n    cursor: pointer;\n");
});
var LearningJourneyWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme4 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme4.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n    height: 150px;\n    font-size: 12px;\n    background-color: #eaf9f9;\n    color: ").concat(colours.grey[800], ";\n");
});
var CollapsedWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme5 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme5.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n\n    width: 54px;\n    border-right: 1px solid ").concat(colours.grey[500], ";\n");
});
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme6 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme6.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n\n    width: calc(100% - 23px);\n    color: ").concat(colours.grey[800], ";\n");
});
var TopicName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme7 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme7.palette;
  return "\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    color: ".concat(palette.primary.dark, ";\n");
});
var ExternalKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(TopicName)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    text-transform: uppercase;\n"])));
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    cursor: pointer;\n    height: 40px;\n\n    [class^=\"svgIconComponent\"] {\n      width: 15px !important;\n    }\n\n    &:hover {\n      path {\n        fill: #3b4e5e !important;\n      }\n    }\n\n    &:active {\n      path {\n        fill: #000 !important;\n      }\n    }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var Info = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  width: calc(100% - 15px);\n  padding: 1px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('space-between'));


/***/ }),

/***/ "uSsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_entities_helpers__ = __webpack_require__("QR7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_explicit_service_request__ = __webpack_require__("u3TQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_manage_local_storage__ = __webpack_require__("tCg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_hooks_use_get_default_upf_course_id__ = __webpack_require__("ztQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks_use_get_selected_publication__ = __webpack_require__("jgHW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hooks_use_get_default_course__ = __webpack_require__("ShnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_use_get_sorted_course__ = __webpack_require__("/vox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__translations__ = __webpack_require__("Avnq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styled__ = __webpack_require__("/x5I");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


















var CourseFilters = function CourseFilters() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCurriculumOrCourseChanged = _useState2[0],
    setIsCurriculumOrCourseChanged = _useState2[1];
  var selectedClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedClass;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var selectedGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedGroup;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  /**
   * Store
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var publications = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.publications;
  });
  var courses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.courses;
  });
  var selectedCourseOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedCourseOption;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var defaultUpfCourseId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_hooks_use_get_default_upf_course_id__["a" /* default */])();
  var _useGetSelectedPublic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__hooks_use_get_selected_publication__["a" /* default */])(),
    selectedPublication = _useGetSelectedPublic.selectedPublication;
  /**
   * Local variables
   */
  var _ref = publications[selectedPublication === null || selectedPublication === void 0 ? void 0 : selectedPublication.value] || {},
    _ref$courses = _ref.courses,
    courseIds = _ref$courses === void 0 ? [] : _ref$courses;
  var _ref2 = courses[selectedCourseOption === null || selectedCourseOption === void 0 ? void 0 : selectedCourseOption.value] || {},
    isDocumentFileAvailable = _ref2.isDocumentFileAvailable,
    masterCourseId = _ref2.masterCourseId;
  var publicationCourses = courseIds.map(function (courseId) {
    return courses[courseId];
  });
  var publicationOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__containers_entities_helpers__["d" /* mapEntitiesToOptions */])(publications);
  var courseOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__hooks_use_get_sorted_course__["a" /* default */])(selectedPublication, publicationCourses);
  var _useExplicitServiceRe = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_explicit_service_request__["a" /* default */])(),
    getExplicitRequestUrl = _useExplicitServiceRe.getExplicitRequestUrl;

  // Derives the publication that contains the classroom's defaultUpfCourseId from the
  // BE response. Passed as defaultValue to useManageLocalStorage so it is the single
  // source of truth. Use stored value if valid, fall back to this.
  var defaultPublication = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    for (var key in publications) {
      if (publications[key].courses.includes(defaultUpfCourseId)) {
        return {
          value: publications[key].id,
          label: publications[key].name
        };
      }
    }
    return null;
  }, [publications, defaultUpfCourseId]);

  // Resolves the course matching the classroom's defaultUpfCourseId from the BE response.
  var defaultCourseOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__hooks_use_get_default_course__["a" /* default */])({
    courseOptions: courseOptions,
    defaultUpfCourseId: defaultUpfCourseId,
    selectedClass: selectedClass,
    selectedGroup: selectedGroup,
    isCurriculumOrCourseChanged: isCurriculumOrCourseChanged
  });

  /**
   * Functions
   */
  var onPublicationChange = function onPublicationChange(selectedOption) {
    setIsCurriculumOrCourseChanged(true);
    var selectedPublicationCourseIds = publications[selectedOption.value].courses;
    var firstCourseId = selectedPublicationCourseIds[0];
    var updatedSelectedCourse = courses[firstCourseId] || {};
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["q" /* setSelectedPublication */])(selectedOption));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["r" /* setSelectedCourseOption */])({
      label: updatedSelectedCourse.courseName,
      value: updatedSelectedCourse.id
    }));
  };
  var onPublicationDownload = function onPublicationDownload() {
    var urlPath = "master-courses/".concat(masterCourseId, "/file");
    var explicitUrl = getExplicitRequestUrl({
      urlPath: urlPath
    });
    if (explicitUrl) {
      window.location.assign(explicitUrl);
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setIsCurriculumOrCourseChanged(false);
  }, [selectedClass]);
  var onCourseChange = function onCourseChange(selectedOption) {
    setIsCurriculumOrCourseChanged(true);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["r" /* setSelectedCourseOption */])(selectedOption));
  };

  /**
   * Hooks
   */
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_manage_local_storage__["a" /* default */])({
    checkShouldUpdateValueFromLocalStorage: function checkShouldUpdateValueFromLocalStorage(localStorageValue) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_utils__["f" /* findOption */])(publicationOptions, localStorageValue);
    },
    defaultValue: defaultPublication || publicationOptions[0],
    enable: !!publicationOptions[0],
    key: __WEBPACK_IMPORTED_MODULE_9__helpers_constants__["l" /* LOCAL_STORAGE_KEYS */].LAST_USED_PUBLICATION,
    updateValueFromLocalStorage: function updateValueFromLocalStorage(updatedValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["q" /* setSelectedPublication */])(updatedValue));
    },
    value: selectedPublication || publicationOptions[0]
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_hooks_use_manage_local_storage__["a" /* default */])({
    checkShouldUpdateValueFromLocalStorage: function checkShouldUpdateValueFromLocalStorage(localStorageValue) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_utils__["f" /* findOption */])(courseOptions, localStorageValue);
    },
    defaultValue: defaultCourseOption || courseOptions[0],
    enable: !!(courseOptions[0] && selectedPublication !== null && selectedPublication !== void 0 && selectedPublication.value && selectedClass !== null && selectedClass !== void 0 && selectedClass.value && selectedGroup !== null && selectedGroup !== void 0 && selectedGroup.value),
    key: __WEBPACK_IMPORTED_MODULE_9__helpers_constants__["l" /* LOCAL_STORAGE_KEYS */].LAST_USED_COURSE,
    updateValueFromLocalStorage: function updateValueFromLocalStorage(updatedValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["r" /* setSelectedCourseOption */])(updatedValue));
    },
    value: selectedCourseOption || courseOptions[0]
  });

  // When the user switches curriculum, dispatch the course matching the defaultUpfCourseId
  // for the new curriculum. On page refresh this effect is skipped (isCurriculumOrCourseChanged
  // is false), leaving useManageLocalStorage as the source of truth for restoring state.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isCurriculumOrCourseChanged && defaultCourseOption !== null && defaultCourseOption !== void 0 && defaultCourseOption.value) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["r" /* setSelectedCourseOption */])(defaultCourseOption));
    }
  }, [defaultCourseOption === null || defaultCourseOption === void 0 ? void 0 : defaultCourseOption.value]);

  /**
   * Translations
   */
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__translations__["a" /* default */])({
      i18n: i18n
    }),
    CURRICULUM_TEXT = _getTranslations.CURRICULUM_TEXT,
    COURSE_TEXT = _getTranslations.COURSE_TEXT,
    PDF_TEXT = _getTranslations.PDF_TEXT;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["a" /* Root */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["b" /* TopFiltersWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["c" /* FilterList */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "publications"
  }, CURRICULUM_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["DropdownMenu"], {
    className: "dropdown",
    "data-name": "publications",
    key: "publications",
    onSelectOption: onPublicationChange,
    options: publicationOptions,
    selectedOption: selectedPublication
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["c" /* FilterList */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "courses"
  }, COURSE_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["DropdownMenu"], {
    className: "dropdown",
    "data-name": "courses",
    disabled: !(selectedPublication !== null && selectedPublication !== void 0 && selectedPublication.value),
    key: "courses",
    onSelectOption: onCourseChange,
    options: courseOptions,
    selectedOption: selectedCourseOption
  }))), isDocumentFileAvailable && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["d" /* AlignmentPdfWrapper */], {
    onClick: function onClick() {
      return onPublicationDownload();
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["O" /* PdfIcon */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["e" /* AlignmentPdfText */], null, PDF_TEXT)));
};
/* harmony default export */ __webpack_exports__["a"] = (CourseFilters);

/***/ }),

/***/ "uXqa":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("mPf8");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./app-heading.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./app-heading.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "umfI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_entities_entities_reducer__ = __webpack_require__("0dbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss__ = __webpack_require__("/A+b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__("6dLk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors__ = __webpack_require__("ef/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__translations__ = __webpack_require__("dEfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__("74Tg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_hooks_use_manage_assignments__ = __webpack_require__("9mrv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__footer_popup__ = __webpack_require__("mAO4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__unassign_warning_modal__ = __webpack_require__("T5O/");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
















var unassignPopupOpenDefaultState = false;
var unassignButtonId = 'unassignButton';
var UnassignButton = function UnassignButton() {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__translations__["a" /* default */])({
      i18n: i18n
    }),
    UNASSIGN_BUTTON_TEXT = _getTranslations.UNASSIGN_BUTTON_TEXT,
    UNASSIGN_TEXT = _getTranslations.UNASSIGN_TEXT,
    UNASSIGN_POPUP_TEXT = _getTranslations.UNASSIGN_POPUP_TEXT,
    UNASSIGN_ALL_TEXT = _getTranslations.UNASSIGN_ALL_TEXT,
    UNASSIGN_ALL_POPUP_TEXT = _getTranslations.UNASSIGN_ALL_POPUP_TEXT,
    UNASSIGN_ALL_CONFIRMATION_TEXT = _getTranslations.UNASSIGN_ALL_CONFIRMATION_TEXT;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(unassignPopupOpenDefaultState),
    _useState2 = _slicedToArray(_useState, 2),
    unassignPopupOpen = _useState2[0],
    setUnassignPopupOpen = _useState2[1];
  var allAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_8__selectors__["c" /* selectAllAssignments */]);
  var hasAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_8__selectors__["d" /* selectHasAssignments */]);
  var isAssigningOrUnAssigning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_8__selectors__["b" /* selectIsAssigningOrUnAssigning */]);
  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(__WEBPACK_IMPORTED_MODULE_8__selectors__["a" /* groupAssignAndUnAssignAssignmentsSelector */]),
    assignmentsToUnAssign = _useSelector.assignmentsToUnAssign;
  var previewModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.modalContainerReducer;
  }, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);
  var _useManageAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_hooks_use_manage_assignments__["a" /* default */])(),
    unassignAssignments = _useManageAssignments.unassignAssignments;
  var onSubmitUnassignAll = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return unassignAssignments(allAssignments, UNASSIGN_ALL_CONFIRMATION_TEXT);
          case 1:
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__containers_modal_manager_modal_manager_actions__["c" /* dismissModal */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__containers_entities_entities_reducer__["e" /* resetEntitiesAssignments */])());
            setUnassignPopupOpen(false);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmitUnassignAll() {
      return _ref.apply(this, arguments);
    };
  }();
  var onUnassignClickHandler = function onUnassignClickHandler() {
    return setUnassignPopupOpen(function (prevState) {
      return !prevState;
    });
  };
  var onUnassignAllClickHandler = function onUnassignAllClickHandler() {
    setUnassignPopupOpen(false);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])({
      content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__unassign_warning_modal__["a" /* default */], {
        callback: onSubmitUnassignAll
      }),
      id: __WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* UNASSIGN_WARNING_MODAL_ID */],
      buttons: [],
      className: __WEBPACK_IMPORTED_MODULE_5__footer_popup_footer_popup_scss___default.a['modal-override']
    }));
  };
  var onOutsideClickHandlerCallback = function onOutsideClickHandlerCallback() {
    var isDisplayingModal = previewModal.length > 0 && previewModal[0].id === __WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* UNASSIGN_WARNING_MODAL_ID */];
    if (!isDisplayingModal) setUnassignPopupOpen(unassignPopupOpenDefaultState);
  };
  var unassignAssignmentCount = assignmentsToUnAssign.length;
  var options = [{
    icon: __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__["c" /* UnAssignIcon */],
    title: UNASSIGN_TEXT,
    description: UNASSIGN_POPUP_TEXT,
    onClickHandler: function onClickHandler() {
      return unassignAssignments(assignmentsToUnAssign);
    },
    disabled: unassignAssignmentCount === 0 || isAssigningOrUnAssigning
  }, {
    icon: __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__["d" /* UnassignAll */],
    title: UNASSIGN_ALL_TEXT,
    description: UNASSIGN_ALL_POPUP_TEXT,
    onClickHandler: function onClickHandler() {
      return onUnassignAllClickHandler();
    },
    disabled: !hasAssignments
  }];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return onOutsideClickHandlerCallback();
    },
    forButton: unassignButtonId
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    className: "button",
    primary: true,
    text: UNASSIGN_BUTTON_TEXT(unassignAssignmentCount),
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      return onUnassignClickHandler();
    },
    alignIcon: "LEFT",
    icon: __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__["c" /* UnAssignIcon */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__footer_popup__["a" /* default */], {
    isOpen: unassignPopupOpen,
    options: options
  }))));
};
/* harmony default export */ __webpack_exports__["a"] = (UnassignButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v46A":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ISnF");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../../../node_modules/postcss-loader/lib/index.js!../../../../../../../node_modules/sass-loader/index.js!./due-date-info-icon.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../../../node_modules/postcss-loader/lib/index.js!../../../../../../../node_modules/sass-loader/index.js!./due-date-info-icon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vAAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sortAscToDesc */
/* unused harmony export sortDescToAsc */
/* unused harmony export sortActivityDescToAsc */
/* unused harmony export sortActivityAscToDesc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customSort; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__);

var sortAscToDesc = function sortAscToDesc(x, y) {
  var a = x.firstName.toUpperCase();
  var b = y.firstName.toUpperCase();
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
var sortDescToAsc = function sortDescToAsc(x, y) {
  var a = x.firstName.toUpperCase();
  var b = y.firstName.toUpperCase();
  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};
var sortActivityDescToAsc = function sortActivityDescToAsc(x, y) {
  var a = parseInt(x.assignmentCount, 10);
  var b = parseInt(y.assignmentCount, 10);
  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};
var sortActivityAscToDesc = function sortActivityAscToDesc(x, y) {
  var a = parseInt(x.assignmentCount, 10);
  var b = parseInt(y.assignmentCount, 10);
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
var customSort = function customSort() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var primaryField = arguments.length > 1 ? arguments[1] : undefined;
  var sortDirection = arguments.length > 2 ? arguments[2] : undefined;
  var orderedList = __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default()(list, function (item) {
    return isNaN(item[primaryField]) ? item[primaryField].toLowerCase() : item[primaryField];
  }, [sortDirection]);
  return orderedList;
};

/***/ }),

/***/ "vFbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HeaderTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CheckboxWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SortableHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* unused harmony export SvgWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LoaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Body; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IconContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var HeaderTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? '20%' : _props$width;
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: ".concat(width, ";\n    padding: 3px;\n    margin: 0px 5px;\n    border-bottom: 2px solid ").concat(colours.grey[200], ";\n    font-weight: 600;\n    font-size: 14px;\n    white-space: nowrap;\n  ");
});
var Header = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  position: sticky;\n  top: 0;\n\n  box-sizing: border-box;\n  background-color: white;\n  padding-bottom: 5px;\n  width: 100%;\n"])));
var CheckboxWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n      padding: 1px 8px;\n      margin: 0px 5px;\n      border-bottom: 2px solid ".concat(colours.grey[200], ";\n\n      div {\n        border: 1px solid ").concat(colours.grey[200], ";\n        border-radius: 2px;\n      }\n  ");
});
var SortableHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(HeaderTitle)(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours;
  return "\n    width: 40%;\n    user-select: none;\n    cursor: pointer;\n\n    svg {\n      path {\n        fill: ".concat(colours.grey[700], ";\n      }\n    }\n  ");
});
var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var SvgWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme4 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme4.colours;
  return "\n    path {\n      fill: ".concat(props.status ? colours.grey[1000] : 'black', " !important;\n    }\n  ");
});
var LoaderContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 245px;\n"])));
var Body = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  height: 245px;\n  overflow-y: auto;\n"])));
var IconContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-left: 10px;\n\n  > div {\n    height: 20px;\n  }\n"])));

/***/ }),

/***/ "vIo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg__ = __webpack_require__("3TsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_3p_teacheradmin_assets_assets_icons_ico_rocket_svg__ = __webpack_require__("qfDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_3p_teacheradmin_assets_assets_icons_ico_rocket_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_3p_teacheradmin_assets_assets_icons_ico_rocket_svg__);
/* unused harmony reexport Rocket */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg__ = __webpack_require__("/4Ah");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg__ = __webpack_require__("kTqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_svg__ = __webpack_require__("i+Fm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_svg__);
/* unused harmony reexport Question */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_3p_teacheradmin_assets_assets_icons_ico_dot_svg__ = __webpack_require__("ODC2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_3p_teacheradmin_assets_assets_icons_ico_dot_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__3plearning_3p_teacheradmin_assets_assets_icons_ico_dot_svg__);
/* unused harmony reexport Submitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__3plearning_3p_teacheradmin_assets_assets_icons_ico_tick_svg__ = __webpack_require__("Z1mS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__3plearning_3p_teacheradmin_assets_assets_icons_ico_tick_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__3plearning_3p_teacheradmin_assets_assets_icons_ico_tick_svg__);
/* unused harmony reexport Reviewed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg__ = __webpack_require__("g1H5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__3plearning_3p_teacheradmin_assets_assets_icons_icon_forward_svg__ = __webpack_require__("FP8j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__3plearning_3p_teacheradmin_assets_assets_icons_icon_forward_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__3plearning_3p_teacheradmin_assets_assets_icons_icon_forward_svg__);
/* unused harmony reexport Forward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__3plearning_3p_teacheradmin_assets_assets_icons_icon_back_svg__ = __webpack_require__("0dCu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__3plearning_3p_teacheradmin_assets_assets_icons_icon_back_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__3plearning_3p_teacheradmin_assets_assets_icons_icon_back_svg__);
/* unused harmony reexport Back */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__3plearning_3p_teacheradmin_assets_assets_icons_icon_present_svg__ = __webpack_require__("0UoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__3plearning_3p_teacheradmin_assets_assets_icons_icon_present_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__3plearning_3p_teacheradmin_assets_assets_icons_icon_present_svg__);
/* unused harmony reexport PreviewIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__3plearning_3p_teacheradmin_assets_assets_icons_icon_teach_notes_svg__ = __webpack_require__("DfRv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__3plearning_3p_teacheradmin_assets_assets_icons_icon_teach_notes_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__3plearning_3p_teacheradmin_assets_assets_icons_icon_teach_notes_svg__);
/* unused harmony reexport NotesIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__3plearning_3p_teacheradmin_assets_assets_icons_icon_dropdown_svg__ = __webpack_require__("z7ov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__3plearning_3p_teacheradmin_assets_assets_icons_icon_dropdown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__3plearning_3p_teacheradmin_assets_assets_icons_icon_dropdown_svg__);
/* unused harmony reexport DropdownIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__3plearning_3p_teacheradmin_assets_assets_icons_icon_search_svg__ = __webpack_require__("koc0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__3plearning_3p_teacheradmin_assets_assets_icons_icon_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__3plearning_3p_teacheradmin_assets_assets_icons_icon_search_svg__);
/* unused harmony reexport SearchIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg__ = __webpack_require__("vMm+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg__ = __webpack_require__("wSIX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg__ = __webpack_require__("7YQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg__ = __webpack_require__("VO0O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__3plearning_3p_teacheradmin_assets_assets_icons_ico_participation_svg__ = __webpack_require__("Ryuq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__3plearning_3p_teacheradmin_assets_assets_icons_ico_participation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__3plearning_3p_teacheradmin_assets_assets_icons_ico_participation_svg__);
/* unused harmony reexport ParticipationIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__3plearning_3p_teacheradmin_assets_assets_UPF_icons_filter_default_svg__ = __webpack_require__("j7uT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__3plearning_3p_teacheradmin_assets_assets_UPF_icons_filter_default_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__3plearning_3p_teacheradmin_assets_assets_UPF_icons_filter_default_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_19__3plearning_3p_teacheradmin_assets_assets_UPF_icons_filter_default_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__3plearning_3p_teacheradmin_assets_assets_icons_ico_voluntary_svg__ = __webpack_require__("NWai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__3plearning_3p_teacheradmin_assets_assets_icons_ico_voluntary_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__3plearning_3p_teacheradmin_assets_assets_icons_ico_voluntary_svg__);
/* unused harmony reexport Voluntary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__3plearning_3p_teacheradmin_assets_assets_icons_ico_learninggaps_svg__ = __webpack_require__("YFtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__3plearning_3p_teacheradmin_assets_assets_icons_ico_learninggaps_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__3plearning_3p_teacheradmin_assets_assets_icons_ico_learninggaps_svg__);
/* unused harmony reexport LearningGaps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_icons_icon_pdf_svg__ = __webpack_require__("hlvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_icons_icon_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_icons_icon_pdf_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_icons_icon_pdf_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_visible_svg__ = __webpack_require__("+wqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_visible_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_visible_svg__);
/* unused harmony reexport Visible */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_svg__ = __webpack_require__("W5D1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_svg__);
/* unused harmony reexport Crown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_medium_svg__ = __webpack_require__("Kc/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_medium_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_medium_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_medium_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg__ = __webpack_require__("9wCb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg__ = __webpack_require__("bC5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg__ = __webpack_require__("6ywA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg__ = __webpack_require__("XP6K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg__ = __webpack_require__("sO5X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg__ = __webpack_require__("A0HV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg__ = __webpack_require__("sY2n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_32__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg__ = __webpack_require__("hjwG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg__ = __webpack_require__("11tP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_34__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg__ = __webpack_require__("eXo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_35__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg__ = __webpack_require__("kmmW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_36__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_collapse_dark_svg__ = __webpack_require__("8u+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_collapse_dark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_collapse_dark_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_37__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_collapse_dark_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg__ = __webpack_require__("NaYz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_38__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg__ = __webpack_require__("vvfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_39__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_icons_icon_cross_svg__ = __webpack_require__("PTng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_icons_icon_cross_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_icons_icon_cross_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_icons_icon_cross_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_1_svg__ = __webpack_require__("JXZx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_1_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_1_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_2_svg__ = __webpack_require__("l+aX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_2_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_42__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_2_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_3_svg__ = __webpack_require__("nIML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_3_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_43__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_3_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_4_svg__ = __webpack_require__("dj9Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_4_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_44__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_4_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_5_svg__ = __webpack_require__("MQpP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_5_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_5_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_preview_svg__ = __webpack_require__("ibnS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_preview_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_preview_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_preview_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg__ = __webpack_require__("gOC2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_47__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg__ = __webpack_require__("8oBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg__ = __webpack_require__("ysx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg__ = __webpack_require__("xUnp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_reassign_svg__ = __webpack_require__("bD59");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_reassign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_reassign_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_reassign_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg__ = __webpack_require__("5i2N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_vidhelp_svg__ = __webpack_require__("F0TD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_vidhelp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_vidhelp_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_vidhelp_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__3plearning_3p_teacheradmin_assets_assets_icons_icon_locked_color_svg__ = __webpack_require__("TgKa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__3plearning_3p_teacheradmin_assets_assets_icons_icon_locked_color_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__3plearning_3p_teacheradmin_assets_assets_icons_icon_locked_color_svg__);
/* unused harmony reexport IconLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlocked_color_svg__ = __webpack_require__("FXiH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlocked_color_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlocked_color_svg__);
/* unused harmony reexport IconUnlocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__3plearning_3p_teacheradmin_assets_assets_icons_icon_lock_svg__ = __webpack_require__("ytev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__3plearning_3p_teacheradmin_assets_assets_icons_icon_lock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__3plearning_3p_teacheradmin_assets_assets_icons_icon_lock_svg__);
/* unused harmony reexport LockIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlock_svg__ = __webpack_require__("h4lv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlock_svg__);
/* unused harmony reexport UnlockIcon */
























// UPF specific icons






































/***/ }),

/***/ "vZCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StudentDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StudentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CourseDetails; });
/* unused harmony export AssignedWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TabHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ResultsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__ = __webpack_require__("ZmnC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }




var ModalBody = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    min-width: 450px;\n    min-height: 400px;\n\n    color: ").concat(palette.primary.dark, ";\n  ");
});
var StudentDetails = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  margin-bottom: 10px;\n  user-select: none;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'));
var StudentName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 31px;\n"])));
var CourseDetails = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 16px;\n  line-height: 25px;\n  margin: 0 10px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* inlineFlexbox */])());
var AssignedWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    typography = _ThemeHelper$getTheme2.typography;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), "\n\n    position: -webkit-sticky;\n    position: sticky;\n    left: 0;\n    width: auto;\n    height: 100%;\n    font-size: 14px;\n    font-family: ").concat(typography.family, ";\n");
});
var TabHeading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours,
    palette = _ThemeHelper$getTheme3.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* inlineFlexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    \n    z-index: 2;\n    padding: 5px 10px;\n    box-sizing: border-box;\n    height: 35px;\n    min-width: 125px;\n    font-size: 16px;\n\n    background-color: ").concat(palette.primary.text, ";\n    border: 1px solid ").concat(colours.grey[400], ";\n    border-bottom: none;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n\n    div[class*='svgIconComponent--'] {\n      width: auto;\n      margin-right: 5px;\n      \n      path {\n        fill: #3C4E5E;\n      }\n    }\n  ");
});
var ResultsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme4 = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme4.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["f" /* flexGrow */])('1'), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__["a" /* widthFillAvailable */])(), "\n  \n    margin-top: -1px;\n    border: 1px solid ").concat(colours.grey[300], ";\n    border-radius: 15px;\n    padding: 25px 10px 10px 20px;\n    min-height: 0;\n  ");
});
var Footer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  \n  margin-top: 10px;\n  width: 100%;\n\n  div {\n    width: 120px;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('space-between'));

/***/ }),

/***/ "viEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basic_resources__ = __webpack_require__("iV3T");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Resources = /*#__PURE__*/function () {
  function Resources() {
    _classCallCheck(this, Resources);
  }
  return _createClass(Resources, null, [{
    key: "createResources",
    value: function createResources(parentEnv) {
      var env = parentEnv || Resources.env;
      var BASE_URL_UPF_ASSIGN = '@UpfAssignGateway';

      /* Config */
      Resources.getConfigurationItem = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(key) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                return _context.a(2, env.getConfigurationItem(key));
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();

      /* Filters */
      Resources.genericCourses = env.resource('genericcourse').baseUrl(BASE_URL_UPF_ASSIGN).service('courses/genericcourse/{courseId}');
      Resources.studentassignments = env.resource('studentassignments').baseUrl(BASE_URL_UPF_ASSIGN).service('getStudentsAssignments');
      Resources.assignmentsByStudent = env.resource('getStudentAssignments').baseUrl(BASE_URL_UPF_ASSIGN).service('getStudentAssignments');
      Resources.assign = env.resource('assign').baseUrl(BASE_URL_UPF_ASSIGN).service('assign');
      Resources.unassign = env.resource('unassign').baseUrl(BASE_URL_UPF_ASSIGN).service('unassign');
      Resources.restrictActivities = Resources.env.resource('restrictActivities').baseUrl(BASE_URL_UPF_ASSIGN).service('restrict/{isRestricted}/classroom/{classId}/group/{groupId}');
      Resources.previewAssignment = env.resource('previewAssignment').baseUrl(BASE_URL_UPF_ASSIGN).service('assign/preview');
      Resources.assignments = env.resource('assignments').baseUrl(BASE_URL_UPF_ASSIGN).service('assignment-management/products/{productId}/classes/{classId}/courses/{courseId}/versions/{version}/assignments');
      Resources.studentAssignmentsHistory = env.resource('studentAssignmentsHistory').baseUrl(BASE_URL_UPF_ASSIGN).service(// eslint-disable-next-line max-len
      "assignment-management/products/{productId}/classes/{classId}/students/{studentUserProfileId}/courses/{courseId}/versions/{courseVersion}/learning-journeys/{learningJourneyId}/assignments");
      Resources.getAssignmentInitData = env.resource('getAssignmentInitData').baseUrl(BASE_URL_UPF_ASSIGN).service('assignment-management/products/{productId}/data');
    }
  }, {
    key: "initialise",
    value: function initialise(envName, credentials) {
      Resources.env = __WEBPACK_IMPORTED_MODULE_0__basic_resources__["a" /* default */].initialise(envName, credentials);
      Resources.createResources();
      return Resources.env;
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (Resources);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("py1Q")))

/***/ }),

/***/ "vvu7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_course_version__ = __webpack_require__("7QyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__ = __webpack_require__("2l37");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assignment_filters_assignment_filters__ = __webpack_require__("F50Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pulse_loader__ = __webpack_require__("oWNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_entities_helpers__ = __webpack_require__("QR7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_hooks_use_manage_local_storage__ = __webpack_require__("tCg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_constants__ = __webpack_require__("1QGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers__ = __webpack_require__("KgEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__("sOLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__translations__ = __webpack_require__("SDtc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__class_filters__ = __webpack_require__("QBF2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styled__ = __webpack_require__("1lkb");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


















var ClassGroupFilter = function ClassGroupFilter() {
  /**
   * Store
   */
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var selectedProduct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.product;
  }, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);
  var groups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.groups;
  });
  var students = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.students;
  });
  var classrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.classrooms;
  });
  var isLoadingClassrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.gatewaysReducer.isLoadingClassrooms;
  });
  var sortDirection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortDirection;
  });
  var sortValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.sortValue;
  });
  var selectedClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedClass;
  }, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);
  var selectedGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedGroup;
  }, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);

  /**
   * Translation
   */
  var _useLocalisation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__3plearning_lingui_cdn__["useLocalisation"])(),
    i18n = _useLocalisation.i18n;
  var _getTranslations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__translations__["a" /* default */])({
      i18n: i18n
    }),
    CLASS_LABEL_TEXT = _getTranslations.CLASS_LABEL_TEXT,
    GROUP_LABEL_TEXT = _getTranslations.GROUP_LABEL_TEXT,
    WHOLE_CLASS_TEXT = _getTranslations.WHOLE_CLASS_TEXT;

  /**
   * Local variables
   */
  var _ref = classrooms[selectedClass.value] || {},
    _ref$groups = _ref.groups,
    selectedClassroomGroupIds = _ref$groups === void 0 ? [] : _ref$groups;
  var classRoomGroups = selectedClassroomGroupIds.map(function (groupId) {
    return groups[groupId];
  });
  var defaultGroupOption = {
    value: __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* DEFAULT_GROUP_ID */],
    label: WHOLE_CLASS_TEXT
  };
  var classroomOptions = __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_entities_helpers__["d" /* mapEntitiesToOptions */])(classrooms), [function (option) {
    return option.label.toLowerCase();
  }], ['asc']);
  var groupOptions = [defaultGroupOption].concat(_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_entities_helpers__["d" /* mapEntitiesToOptions */])(classRoomGroups)));
  var _useCourseVersion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_hooks_use_course_version__["a" /* default */])(),
    selectedClassroomId = _useCourseVersion.selectedClassroomId,
    selectedCourseId = _useCourseVersion.selectedCourseId,
    selectedCourseVersion = _useCourseVersion.selectedCourseVersion;

  /**
   * Functions
   */
  var findStudentIdsFromSelectedGroup = function findStudentIdsFromSelectedGroup() {
    var isDefaultGroup = selectedGroup.value === __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* DEFAULT_GROUP_ID */];
    var groupKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_entities_helpers__["a" /* getGroupHashKey */])({
      classroomId: selectedClassroomId,
      groupId: selectedGroup.value
    });
    var _ref2 = groups[groupKey] || {},
      _ref2$students = _ref2.students,
      studentIds = _ref2$students === void 0 ? [] : _ref2$students;
    return isDefaultGroup ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers__["a" /* mapStudentIdsFromGroups */])(classRoomGroups) : studentIds;
  };
  var onGroupChange = function onGroupChange(selectedOption) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["j" /* setSelectedGroup */])(selectedOption));
  };
  var onClassroomChange = function onClassroomChange(selectedOption) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["k" /* setSelectedClass */])(selectedOption));
    onGroupChange(defaultGroupOption);
  };

  /**
   * Hooks
   */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_hooks_use_manage_local_storage__["a" /* default */])({
    checkShouldUpdateValueFromLocalStorage: function checkShouldUpdateValueFromLocalStorage(localStorageValue) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_utils__["f" /* findOption */])(classroomOptions, localStorageValue);
    },
    defaultValue: classroomOptions[0],
    enable: !!classroomOptions[0],
    key: __WEBPACK_IMPORTED_MODULE_11__helpers_constants__["l" /* LOCAL_STORAGE_KEYS */].LAST_USED_CLASSROOM,
    updateValueFromLocalStorage: function updateValueFromLocalStorage(updatedValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["k" /* setSelectedClass */])(updatedValue));
    },
    value: selectedClass
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_hooks_use_manage_local_storage__["a" /* default */])({
    checkShouldUpdateValueFromLocalStorage: function checkShouldUpdateValueFromLocalStorage(localStorageValue) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_utils__["f" /* findOption */])(groupOptions, localStorageValue);
    },
    defaultValue: groupOptions[0],
    enable: !!(selectedClass !== null && selectedClass !== void 0 && selectedClass.value && groupOptions[1]),
    key: __WEBPACK_IMPORTED_MODULE_11__helpers_constants__["l" /* LOCAL_STORAGE_KEYS */].LAST_USED_GROUP,
    updateValueFromLocalStorage: function updateValueFromLocalStorage(updatedValue) {
      return onGroupChange(updatedValue);
    },
    value: selectedGroup
  });

  /**
   * Effects
   */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (selectedClassroomId && selectedCourseId) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["l" /* getGenericCoursesV2 */])({
        productId: selectedProduct.id,
        courseId: selectedCourseId,
        courseVersion: selectedCourseVersion
      }));
    }
  }, [selectedClassroomId, selectedCourseId, selectedCourseVersion]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (selectedGroup.value !== '' && !isLoadingClassrooms) {
      var updatedStudentIds = findStudentIdsFromSelectedGroup();
      var sortedStudentIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_entities_helpers__["c" /* sortEntitiesByIds */])({
        entities: students,
        ids: updatedStudentIds,
        direction: sortDirection,
        sortKey: sortValue
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_upf_assign_upf_assign_actions__["h" /* updateSortedStudentIds */])(sortedStudentIds));
    }
  }, [selectedClassroomId, selectedGroup.value, isLoadingClassrooms]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["a" /* Root */], null, isLoadingClassrooms && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["b" /* LoadingWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pulse_loader__["a" /* default */], null)), !isLoadingClassrooms && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["c" /* FilterWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["d" /* DropdownTitle */], null, CLASS_LABEL_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__class_filters__["a" /* default */], {
    classroomOptions: classroomOptions,
    selectedClass: selectedClass,
    onClassroomChange: onClassroomChange
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styled__["c" /* FilterWrapper */], {
    "data-name": "group-selector"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, GROUP_LABEL_TEXT), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["DropdownMenu"], {
    options: groupOptions,
    selectedOption: selectedGroup,
    onSelectOption: onGroupChange
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__assignment_filters_assignment_filters__["a" /* default */], {
    i18n: i18n
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (ClassGroupFilter);

/***/ }),

/***/ "wL8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ToggleButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModalContentRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ModalContentHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AllCellsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ColorBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _colours$upf;
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    width: 40px;\n    height: 100%;\n\n    &:hover {\n      path {\n        fill: ".concat((_colours$upf = colours.upf) === null || _colours$upf === void 0 ? void 0 : _colours$upf[500], " !important;\n      }\n  }\n");
});
var ToggleButton = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].button(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme2.colours;
  return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background-color: ".concat(colours.grey[200], ";\n    border: none;\n    width: 100%;\n    height: 100%;\n  ");
});
var ModalContentRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours;
  return "\n    display: flex;\n    align-items: center;\n    padding-left: 10px;\n    height: 32px;\n    border-bottom: 1px solid ".concat(colours.grey[400], ";\n    color: ").concat(colours.grey[800], ";\n    cursor: pointer;\n\n    &:hover {\n      font-weight: 900;\n    }\n\n    &::nth-last-child(1) {\n      border: none;\n    }\n  ");
});
var ModalContentHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(ModalContentRow)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 700;\n  cursor: default;\n\n  &:hover {\n    background-color: white;\n  }\n"])));
var AllCellsIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-right: 10px;\n  padding-top: 5px;\n  width: 20px;\n  height: 20px;\n"])));
var ColorBlock = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var bgColor = props.bgColor;
  return "\n    box-sizing: border-box;\n    padding-left:3px;\n    margin-right: 10px;\n    height: 20px;\n    width: 20px;\n    background-color: ".concat(bgColor, ";\n\n    [class^='svgIconComponent'] {\n      svg {\n        background-color: transparent;\n      }\n    }\n  ");
});

/***/ }),

/***/ "wfv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SearchableListWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SelectPanelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SearchContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FilterWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FilteredListWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var SearchContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   ", "\n   \n   .clear {\n     padding: 0px 0px 0px 10px;\n     align-self: flex-end;\n   }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])());
var SearchableListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours,
    typography = _ThemeHelper$getTheme.typography;
  return "   \n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), "\n        border: 1px solid ").concat(colours.grey[400], ";\n        border-radius: 5px;\n        width: 500px;\n        height: 34px;\n        font-family: ").concat(typography.family, ";\n        font-size: 15px;\n        outline: none;\n\n        @media(max-width: 1220px) {\n          width: 400px;\n        }\n        \n        .searchText {\n          width: 92%;\n          margin: auto 4px;\n        }\n        \n        .searchLogo {\n               width: 8%;\n               height: 36px;\n               display: flex;\n               justify-content: center;\n               align-items: center;\n               cursor: pointer;\n               \n               [class*=\"svgIconComponent\"] {\n                   width: 18px;\n               }\n        }\n      ");
});
var InputWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].input(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    typography = _ThemeHelper$getTheme2.typography;
  return " \n        height: 25px;\n        border: none;\n        font-family: ".concat(typography.family, ";\n        font-size: 15px;\n        outline: none;\n        padding-left: 4px;\n        width: 97%;\n\n        &::-webkit-input-placeholder {\n            color: lightgray;\n            font-weight: 600;\n        }\n\n        &:-ms-input-placeholder {\n            color: lightgray;\n            font-weight: 600;\n        }\n    ");
});
var SelectPanelWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme3.colours,
    typography = _ThemeHelper$getTheme3.typography;
  return "  \n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* flexDirection */])('column'), "\n    z-index: 10;\n    position: absolute; \n    background-color: white;\n    width: 500px;\n    height: 400px;\n    border: 1px solid ").concat(colours.grey[200], ";\n    border-top: none;\n\n    @media(max-width: 1220px) {\n      width: 400px;\n    }\n    \n    .panelFooter {\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), "\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["b" /* alignItems */])('center'), "\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["e" /* justifyContent */])('space-between'), "\n       \n       height: 60px;\n       background: #cfd2d4;\n       width: 100%;\n       \n       .uncheck {\n         margin-left: 10px;\n       }\n       \n       .apply {\n         margin-right: 10px;\n       }\n    }\n\n    .panelBody {\n       height: 340px;\n       overflow-y: scroll;\n       \n       .strand {\n         padding: 10px;\n         \n         .wrapper {\n           ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), "\n           \n           .Description {\n             width: 96%;\n           }\n           \n           .icon {\n              cursor: pointer;\n           }\n         }\n         \n         svg {\n          path {\n            fill: ").concat(colours.grey[700], " !important;\n          }\n         }\n         \n         [class*=\"svgIconComponent\"] {\n                   width: 16px;\n         }\n       }\n       \n        .line {\n           width: 95%;\n           border-top: 2px solid ").concat(colours.grey[400], ";\n         }\n       \n       .spacer {\n        padding-left: 15px;\n       }\n    }\n    \n     .unCheckAllButton {\n      width: max-content;\n      height: 30px;\n      font-family: ").concat(typography.family, ";\n      font-size: 14px;\n      font-weight: 600;\n     }\n     \n     .applyButton {\n      width: max-content;\n      height: 30px;\n     }\n    ");
});
var showElement = function showElement(bool) {
  return {
    display: bool ? '' : 'none'
  };
};
var FilterWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  font-size: 14px\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* flexDirection */])('column'));
var FilteredListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme4 = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme4.colours;
  return "\n    path {\n      fill: ".concat(colours.grey[600], " !important;\n    }\n  ");
});


/***/ }),

/***/ "whwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        hasError: true
      });
      // eslint-disable-next-line no-console
      console.log("Error: ".concat(error));
      // eslint-disable-next-line no-console
      console.log('Component stack trace: ', info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        // render any fallback UI
        return null;
      }
      return this.props.children;
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
ErrorBoundary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),

/***/ "x4K0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EntryApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("KXFW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("e5rB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lingui_react__ = __webpack_require__("QruM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lingui_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lingui_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__themes__ = __webpack_require__("KH1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_core_scss__ = __webpack_require__("nIya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_core_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_core_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__upf_assign_upf_assign__ = __webpack_require__("ngKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__themes_upf_theme_overrides__ = __webpack_require__("//52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__ = __webpack_require__("//jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__entry_app_scss__ = __webpack_require__("B7He");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__entry_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__basic_app__ = __webpack_require__("SgkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__preserve_query_parameters__ = __webpack_require__("CWg8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_heading_app_heading__ = __webpack_require__("HKwf");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }















__WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__["a" /* default */].namespace = 'upf-assign';
var EntryApp = /*#__PURE__*/function (_BasicApp) {
  function EntryApp() {
    _classCallCheck(this, EntryApp);
    return _callSuper(this, EntryApp, arguments);
  }
  _inherits(EntryApp, _BasicApp);
  return _createClass(EntryApp, [{
    key: "render",
    value: function render(store, i18n) {
      if (!i18n) return null;
      var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__preserve_query_parameters__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */], ['username', 'password', 'userToken'])();
      var BASE_NAME = window._env_.BaseName || '';
      var theme = _extends({}, __WEBPACK_IMPORTED_MODULE_6__themes__["a" /* default */], {
        overrides: {
          header: __WEBPACK_IMPORTED_MODULE_9__themes_upf_theme_overrides__["header"],
          button: __WEBPACK_IMPORTED_MODULE_9__themes_upf_theme_overrides__["button"]
        }
      });

      // NOTE: We have used a "render" attribute, rather than "component" to specify what
      //       should be rendered.  This allows us to pass options to the component. You
      //       can obviously simplify things if your components don't need any.

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__lingui_react__["I18nProvider"], {
        i18n: i18n
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */], {
        store: store
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__3plearning_react_components__["ThemeProvider"], {
        theme: theme
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* BrowserRouter */], {
        history: history,
        basename: BASE_NAME
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default.a.app
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_app_heading_app_heading__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__3plearning_react_components__["Container"], {
        className: __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default.a['container-wrapper']
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Switch */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */], {
        path: "/",
        render: function render() {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__upf_assign_upf_assign__["a" /* default */], {
            i18n: i18n
          });
        }
      }))))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_12__basic_app__["a" /* default */]);

window.EntryApp = EntryApp;

/***/ }),

/***/ "xazg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Collapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ExternalKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TopicName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    box-sizing: border-box;\n    font-size: 12px;\n    position: sticky;\n    top: 2px;\n    background-color: #c3d5e1;\n    width: 54px;\n    min-width: 54px;\n    min-height: 190px;\n    max-height: 190px;\n    z-index: 2;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'));
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n\n    cursor: pointer;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('center'));
var Collapse = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n\n    cursor: pointer;\n    height: 40px;\n\n    [class^=\"svgIconComponent\"] {\n      width: 23px !important;\n    }\n\n    &:hover {\n      path {\n        fill: #3b4e5e !important;\n      }\n    }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('center'));
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  return "\n      ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'), ";\n  \n      color: ").concat(colours.grey[800], ";\n      width: 120px;\n      height: 100px;\n      transform: rotate(270deg);\n      margin-top: 10px;\n      cursor: pointer;\n  ");
});
var TopicName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    palette = _ThemeHelper$getTheme2.palette;
  return "\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      color: ".concat(palette.primary.dark, ";\n  ");
});
var ExternalKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(TopicName)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    text-transform: uppercase;\n"])));
var Info = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n\n    height: 150px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* justifyContent */])('space-between'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* flexDirection */])('column'));


/***/ }),

/***/ "xfNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss__ = __webpack_require__("s4Vw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toast_action__ = __webpack_require__("fbOh");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }





var Toast = function Toast(props) {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState2 = _slicedToArray(_useState, 2),
    timeoutInstance = _useState2[0],
    setTimeoutInstance = _useState2[1];
  var isToastVisible = props.isToastVisible;
  var startTimer = function startTimer() {
    if (isToastVisible) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toast_action__["d" /* hideToast */])());
      clearTimeout(timeoutInstance);
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setTimeoutInstance(setTimeout(startTimer, 7000));
  }, [isToastVisible]);
  var hide = function hide() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toast_action__["d" /* hideToast */])());
    clearTimeout(timeoutInstance);
  };
  var setToastColor = function setToastColor() {
    var messageType = props.messageType;
    var color = '';
    switch (messageType) {
      case 'success':
        color = '#5cb85c';
        break;
      case 'warning':
        color = '#e07e02';
        break;
      default:
        color = '#c53902';
        break;
    }
    return color;
  };
  if (isToastVisible) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.toast,
      style: {
        background: setToastColor()
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.message,
      onClick: hide,
      role: "button",
      tabIndex: 0
    }, props.message));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.empty
  });
};
Toast.propTypes = {
  message: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  isToastVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  messageType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
Toast.defaultProps = {
  isToastVisible: false,
  message: ''
};
/* harmony default export */ __webpack_exports__["a"] = (Toast);

/***/ }),

/***/ "xnkI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gdXn");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yHtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACCURACY_PROGRESS_FILTER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCURACY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROGRESS; });
var ACCURACY_PROGRESS_FILTER = 'ACCURACY_PROGRESS_FILTER';
var ACCURACY = 'accuracy';
var PROGRESS = 'progress';

/***/ }),

/***/ "yumT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var i18n = _ref.i18n;
  return {
    HIGHEST_ATTEMPT_TEXT: i18n._(
    /*i18n*/
    {
      id: "AssignmentFilters.highestAttempts",
      defaults: "Showing highest attempts"
    }),
    ASSIGNED_ATTEMPT_TEXT: i18n._(
    /*i18n*/
    {
      id: "AssignmentFilters.assignedAttempts",
      defaults: "Showing assigned attempts"
    }),
    VOLUNTARY_ATTEMPT_TEXT: i18n._(
    /*i18n*/
    {
      id: "AssignmentFilters.voluntaryAttempts",
      defaults: "Showing voluntary attempts"
    }),
    FILTER_ATTEMPTS_HEADING_TEXT: i18n._(
    /*i18n*/
    {
      id: "FilterOptions.filterStudentAttemps",
      defaults: "Filter student attempts by"
    }),
    FILTER_ALL_HIGHEST_TEXT: i18n._(
    /*i18n*/
    {
      id: "FilterOptions.highestAttempt",
      defaults: "All highest"
    }),
    FILTER_TEACHER_ASSIGNED_TEXT: i18n._(
    /*i18n*/
    {
      id: "FilterOptions.latestAssigned",
      defaults: "Teacher assigned"
    }),
    FILTER_VOLUNTARY_ATTEMPT_TEXT: i18n._(
    /*i18n*/
    {
      id: "FilterOptions.voluntaryAttempt",
      defaults: "Voluntary attempt"
    }),
    FILTER_INFO_HIGHEST_TEXT: i18n._("FilterInfo.Highest"),
    FILTER_INFO_LATEST_TEXT: i18n._("FilterInfo.Latest"),
    FILTER_INFO_VOLUNTARY_TEXT: i18n._("FilterInfo.Voluntary"),
    FILTER_LABEL_HOVER_TEXT: i18n._("Filter student attempts by scenario")
  };
});

/***/ }),

/***/ "yygr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ItemText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var Root = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  background: #415667 !important;\n  color: #fff !important;\n  border-radius: 0.6em;\n  z-index: 99;\n  right: -25%;\n  bottom: 36px;\n  margin-top: 5px;\n  width: auto;\n  min-width: 184px;\n  overflow: hidden;\n"])));
var ListItem = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].li(function (props) {
  return "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-height: 28px;\n    cursor: pointer;\n    padding: 8px;\n    border-bottom: 1px solid #999b9d;\n    ".concat(props.disabled && "\n        pointer-events: none;\n        opacity: 0.6;\n      ", "\n    \n    svg {\n    width: 22px !important;\n    height: 22px !important;\n    }\n    \n    div[class*=\"svgIconComponent---\"] {\n    width: 22px !important;\n    height: 22px !important;\n    }\n    \n    &:last-child {\n    border: none;\n    }\n    \n    &:hover {\n    background-color: #c3d5e1 !important;\n    color: #415667 !important;\n    \n      * {\n      fill: #415667 !important;\n      }\n    }\n    ");
});
var ItemText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].span(function (props) {
  return "\n    margin-left: ".concat(props.large ? '14px' : '0', "\n    font-size: ").concat(props.large ? '14px' : '12px', ";\n  ");
});

/***/ }),

/***/ "zNkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAssignmentPreviewUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_locale__ = __webpack_require__("ZhO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_resources__ = __webpack_require__("viEY");



var getAssignmentPreviewUrl = function getAssignmentPreviewUrl(assignmentId) {
  var baseUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["b" /* getConfiguration */])('UPFBaseUrl');
  var authToken = __WEBPACK_IMPORTED_MODULE_2__helpers_resources__["a" /* default */].env.authToken;
  var locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_locale__["a" /* getLocale */])();
  var url = new URL(baseUrl);
  url.searchParams.set('authToken', authToken);
  url.searchParams.set('assignmentId', assignmentId);
  url.searchParams.set('locale', locale.toString());
  url.searchParams.set('isPreview', 'true');
  url.searchParams.set('newContent', 'true');
  return url.toString();
};
/* unused harmony default export */ var _unused_webpack_default_export = (getAssignmentPreviewUrl);

/***/ }),

/***/ "zQTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__portal_comms__ = __webpack_require__("lS1M");


var showConnectionError = function showConnectionError() {
  var message = 'Oops an error has occurred. '.concat("\n  ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "http://www.3plearning.com/contact/"
  }, "Please contact Tech Support"), "\n  ", ' with details of what happened and we will work to get you back on track.');
  __WEBPACK_IMPORTED_MODULE_1__portal_comms__["a" /* default */].serverError(message);
};
/* harmony default export */ __webpack_exports__["a"] = (showConnectionError);

/***/ }),

/***/ "ztQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_entities_helpers__ = __webpack_require__("QR7b");



var useGetDefaultUpfCourseId = function useGetDefaultUpfCourseId() {
  var classrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.classrooms;
  });
  var groups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.entitiesReducer.groups;
  });
  var selectedClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedClass;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var selectedGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.UPFAssignReducer.selectedGroup;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var _groups$groupKey, _classrooms$selectedC;
    var groupKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__containers_entities_helpers__["a" /* getGroupHashKey */])({
      classroomId: selectedClass === null || selectedClass === void 0 ? void 0 : selectedClass.value,
      groupId: selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.value
    });
    return ((_groups$groupKey = groups[groupKey]) === null || _groups$groupKey === void 0 ? void 0 : _groups$groupKey.defaultUpfCourseId) || ((_classrooms$selectedC = classrooms[selectedClass === null || selectedClass === void 0 ? void 0 : selectedClass.value]) === null || _classrooms$selectedC === void 0 ? void 0 : _classrooms$selectedC.defaultUpfCourseId);
  }, [classrooms, groups, selectedClass === null || selectedClass === void 0 ? void 0 : selectedClass.value, selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.value]);
};
/* harmony default export */ __webpack_exports__["a"] = (useGetDefaultUpfCourseId);

/***/ })

},[2]);


// WEBPACK FOOTER //
// entry-app.ec6a675f26ca161968bc.js